module.exports = {
  Cargo_CreatBy: '見積担当者',
  Cargo_TrunkLine: '幹線',
  Cargo_Inquiry_MissingBusinessCannotSubmit: '{0}タイプは担当営業が未選択のため送信できません',
  Cargo_100Million: '億',
  Cargo_10Cents: '角',
  Cargo_1St: '1枚目',
  Cargo_1StInvoiceNo: '最初の請求書番号',
  Cargo_1Year: '1年',
  Cargo_2NdDispatch: '二次送出',
  Cargo_2NdDispatchTime: '二次送出時間',
  Cargo_2NdReleaseTime: '二次リリース時間',
  Cargo_2NdTransitAirportAir: '中継二程（空港）',
  Cargo_2StUnit: '第二単位',
  Cargo_2Years: '2年',
  Cargo_30DaysShpt: '30日（チケット）',
  Cargo_3RdParty: 'サードパーティー',
  Cargo_3RdTransitAirportAir: 'トランジット三路（空港）',
  Cargo_3Years: '3年',
  Cargo_60DaysShpt: '60日（チケット）',
  Cargo_90DaysShpt: '90日（チケット）',
  Cargo_AAPACRIG: '前払金として、該当するレコードを生成！',
  Cargo_AbandonThisVoucher: 'この資格証明の放棄を確認しますか？',
  Cargo_Abbreviation: '略称',
  Cargo_AbbreviationOfConsignor: '委託先（略称）',
  Cargo_ABCDC: '確認中、{0}は確認済みです。',
  Cargo_MessageTip1: '【があります。',
  Cargo_MessageTip2: '】未読メッセージ.',
  Cargo_Abstract: '要約',
  Cargo_AbstractRuleOfJournalEntry: '入力要約ルール',
  Cargo_ABYBPSTCI23M: 'AA-毎年入札を募集し、状況によっては2~3ヶ月以内に見ることができます。',
  Cargo_Accepted: '受け入れました',
  Cargo_AccordingBillExchangeRate: '請求レート別',
  Cargo_AccordingForStatementFxRate: '取引明細書レート別',
  Cargo_AccountClosedSuccessfully: '会計が完了しました。',
  Cargo_AccountInForeignCurrency: '元の通貨で計算しますか？',
  Cargo_AccountingMethod: '記帳方法',
  Cargo_AccountingOrganizationCode: '会計組織コード',
  Cargo_AccountingQuantity: '数量計算',
  Cargo_AccountingVoucher: '会計証憑',
  Cargo_AccountPeriod: '支払サイト',
  Cargo_AccountPeriodDay: '会計期間（日）',
  Cargo_AccountQuantityOrNot: '数量で会計しますか？',
  Cargo_AccountsReconciliation: '取引照合',
  Cargo_AccountsReconciliation2: '取引照合2',
  Cargo_AccountStatement: '取引明細書',
  Cargo_AccountStatementNo: '取引明細書番号',
  Cargo_AccountStatementNoP: '取引明細書番号: ',
  Cargo_AccountTitle: '科目',
  Cargo_AccountTitle2: '科目2',
  Cargo_AccountTitleCanTBeEmpty: '勘定は空にできません',
  Cargo_AccountTitleCategory: '勘定カテゴリ',
  Cargo_AccountTitleClassification: '勘定クラス分け',
  Cargo_AccountTitleClassificationRule: '勘定分類規則',
  Cargo_AccountTitleCode: '勘定コード',
  Cargo_AccountTitleCodeCanTBeEmpty: '勘定コードは空にできません。',
  Cargo_AccountTitleCodeP: '勘定コード: ',
  Cargo_AccountTitleGroupingCondition1: '勘定科目グループ化条件1',
  Cargo_AccountTitleGroupingCondition2: '勘定科目グループ化条件2',
  Cargo_AccountTitleGroupingCondition3: '勘定科目グループ化条件3',
  Cargo_AccountTitleGroupingCondition4: '勘定科目グループ化条件4',
  Cargo_AccountTitleGroupingCondition5: '勘定科目グループ化条件5',
  Cargo_AccountTitleGroupingCondition6: '勘定科目グループ化条件6',
  Cargo_AccountTitleLevel: '勘定レベル',
  Cargo_AccountTitleMapping: '勘定マッピング',
  Cargo_AccountTitleName: '勘定科目名',
  Cargo_AccountTitleNameCanTBeEmpty: '勘定名は空にできません',
  Cargo_AccountTitleNameP: '勘定科目名: ',
  Cargo_AccountTitleOfProfitNotAllocated: '未割当ての利益勘定',
  Cargo_AccountTitleOfProfitNotAllocatedP: '未割当ての利益勘定: ',
  Cargo_AccrualDate: '発生日',
  Cargo_JobAccrualDate: 'ビジネス見越日',
  Cargo_AccrualReview: '見越監査',
  Cargo_AccrualStatus: '発生状況',
  Cargo_Accrue: '見越計上',
  Cargo_Accrued: '計上済み',
  Cargo_UsersAlreadyProvisionedToday: '今日すでに予定されているユーザーが存在しますので、確認してください',
  Cargo_AccumulatedCommissionProfit: '累計歩合給利益',
  Cargo_AConsiderChangeIfOffersCheap: 'A-安ければ考える。',
  Cargo_ACPCOIM: 'システムはチェックアウト中です。しばらくお待ちください。後で再試行します~',
  Cargo_Acquired: '受け取りました',
  Cargo_AcquireFilteredExpenseList: 'フィルタ費用リストの取得',
  Cargo_Acquirer: '受取人',
  Cargo_AcquirerCanTBeEmpty: '受取人は空にできません。',
  Cargo_AcquireSelectedItems: '選択したオブジェクトを取得します',
  Cargo_AcquireTotalAROrAPAmount: '売掛金と買掛金の合計を取得します',
  Cargo_Acquisition: '受け取る',
  Cargo_AcquisitionRecord: '受領記録',
  Cargo_AcquisitionTime: '受領時間',
  Cargo_AcquisitionTimeCanTBeEmpty: 'リードタイムは空にできません。',
  Cargo_ACSWASRATBTSWEAC: '確認後、システムは自動的に決済金額を費用金額と同じに設定します。続行しますか？',
  Cargo_ACSWASRATBTSWEANCOWOEWNBPC: 'すべての決済金額は費用金額に基づいて設定されます。確認済または消込済の費用は無視されます。続行しますか？',
  Cargo_ThereAreAlreadyExportedVouchers: 'There are already exported vouchers',
  Cargo_ActualChargedWeight: '実請求重量',
  Cargo_ActualGrossWeight: '実際の総重量',
  Cargo_ActualQuantity: '実績件数',
  Cargo_ActualReceiptAmount: '実収金額',
  Cargo_ActualReceiptAndPayment: '実際の受領と支払い',
  Cargo_ActualVolume: '実際のボリューム',
  Cargo_ActualWeight: '実際の重量',
  Cargo_ActualWriteOffAmountRequired: '実際に転記が必要な金額',
  Cargo_OnlyImportedCurrentBranch: '導入支店のみ現在支店の費用となります。',
  Cargo_Add: '新規作成',
  Cargo_AddAdjustBill: '追加調整（請求書）',
  Cargo_AddAirBooking: 'エアブッキングの追加',
  Cargo_AddRailwayBooking: '新規鉄道予約クラス',
  Cargo_RailwayBooking: '鉄道予約クラス',
  Cargo_AddAirFreightServiceItems: '新規航空運賃サービス項目',
  Cargo_AddAssetAccountTitle: '新規資産クラス勘定',
  Cargo_AddAssociatedPort: '新しい関連ポート',
  Cargo_AddAwbSurcharge: '追加の航空運送状の雑費',
  Cargo_AddBasePort: 'ベースポートの追加',
  Cargo_AddBill: '請求書の追加',
  Cargo_AddBillCharge: '加入料金',
  Cargo_AddBLType: '新しい船荷証券タイプ',
  Cargo_AddCashFlowItem: '新規キャッシュフロー項目',
  Cargo_AddCharges: '追加料金',
  Cargo_AddCostType: '費用タイプを追加',
  Cargo_EditFeeType: '費用タイプの編集',
  Cargo_DeleteFeeType: '費用タイプの削除',
  Cargo_ImportFeeType: '費用タイプのインポート',
  Cargo_SelectBusinessOperation: '正しい操作の業務を選択してください',
  Cargo_SelectSameDelegateUnit: '同じ委託単位の業務を選択してください',
  Cargo_SelectSameBusinessType: '同じ業務タイプの業務を選択してください',
  Cargo_SelectSameFbaStatus: '同じFBA状態の業務を選択してください',
  Cargo_SelectSameBusinessTypeWithJobNo: '業務タイプが一致しません：{baseJobNo} と {currentJobNo}。同じ業務タイプの業務を選択してください',
  Cargo_SelectSameFbaStatusWithJobNo: 'FBA状態が一致しません：{baseJobNo} と {currentJobNo}。同じFBA状態の業務を選択してください',
  Cargo_SelectFeeType: '費用タイプを選択してください！',
  Cargo_ReceivablePayableLocked: '選択した業務には受取と支払いがロックされており、この操作は実行できません！',
  Cargo_ReceivableLocked: '選択した業務には受取がロックされており、この操作は実行できません！',
  Cargo_PayableLocked: '選択した業務には支払いがロックされており、この操作は実行できません！',
  Cargo_PleaseSelectTheManifestYouWishToDelete: 'Please select the manifest you wish to delete',
  Cargo_TheManifestYouWishToDeleteTips: '*Tips: LCL deletion must be deleted together with the manifest in the box, not separately!',
  Cargo_ConfirmDelete: 'Confirm the deletion',
  Cargo_AddCirculationDocumentType: '新しいストリームファイルタイプ',
  Cargo_AddClientType: '新規顧客タイプ',
  Cargo_AddCollectionRecord: '新規受託登録',
  Cargo_AddCommissionRules: '歩合給ルールの追加',
  Cargo_AddContinent: '新しい大陸',
  Cargo_AddContract: '新規契約',
  Cargo_AddCustomizedServiceType: '新規カスタム取引タイプ ',
  Cargo_AddedAlreadyDoNotRepeat: '{0}が追加されました。重複して追加することはできません。',
  Cargo_AddedSuccessfully: '新規追加に成功しました。',
  Cargo_AddFees: '費用を追加します',
  Cargo_AddHeadquartersToTheList: '本部を追加する',
  Cargo_AddJournalEntry: 'エントリの追加',
  Cargo_AddKeyword: '新しいデリケートな単語',
  Cargo_AddMscService: '新規MSCサービス',
  Cargo_AddNewSoaOrNot: '取引明細書を追加しますか',
  Cargo_AddRailwayStation: '鉄道駅を追加します',
  Cargo_AddressTelNo: '住所/電話番号',
  Cargo_AddressTelNoP: '住所、電話番号: ',
  Cargo_AddRoute: '新規ルート',
  Cargo_AddSave: '追加保存',
  Cargo_AddSeaBooking: '海上予約の追加',
  Cargo_IntelligentDocumentRecognition: 'インテリジェントなブックの識別',
  Cargo_AddSoa: '新規取引明細書',
  Cargo_AddToBlackList: 'ブラックリストに追加',
  Cargo_AdjustBillDate: '請求日の調整',
  Cargo_AdjustDate: '調整日',
  Cargo_AdjustedItem: '調整項目',
  Cargo_AdjustedOrNot: '調整しますか',
  Cargo_AdjustedSuccessfully: '調整が成功しました。',
  Cargo_AdjustedValue: '調整値',
  Cargo_AdjustExpenseOrNot: '費用調整要否',
  Cargo_AdjustFxRateEndOfPeriod: '調整為替レート（期末）',
  Cargo_AdjustmentDateCanTBeEmpty: '調整日は空にできません。',
  Cargo_AdjustmentExpense: '調整費用',
  Cargo_AdjustmentExpenseState: '調整状態',
  Cargo_Advance: '前払い',
  Cargo_AdvanceAP: '前払い買掛金',
  Cargo_AdvanceAPDifferential: '差額の前払い',
  Cargo_AdvanceChargeInfo: '立て替え払い代行',
  Cargo_AdvancedSearch: '高度な検索',
  Cargo_AdvanceMoneyForAnotherOrNot: '代替するかどうか',
  Cargo_AdvanceOrNot: '立替かどうか',
  Cargo_AdvancePayment: '前払い',
  Cargo_AdvancePaymentAmount: '前払い金額',
  Cargo_AdvancePaymentItem: '立替金',
  Cargo_AdvanceReceiptOrNot: '前受するかどうか',
  Cargo_AdvanceReceivedAmount: '前受金額',
  Cargo_AdvanceReceivedAmountIs: '前受金: ',
  Cargo_AEBPWTCW1Y: 'AAA-固定提携エージェント内部関係があり1年以内に交換しない',
  Cargo_AEFTSIST: '上海空輸輸出は類似しています',
  Cargo_AEIMBOUF: '更新に失敗しました。料金は他の人によって変更されました。',
  Cargo_AEIMBOUFM: '{0}件の更新に失敗しました。料金は他の人によって変更されました。',
  Cargo_AGEBDAWI: '請求時に差額を調整すると自動的に発生する費用。',
  Cargo_AgentBillNo: '相手方請求書番号',
  Cargo_Aging: 'エイジング（日）',
  Cargo_AgingOfCurrentBill: '当票の年齢調べ',
  Cargo_Agree: '同意する',
  Cargo_AILCNETOCERCTS: '基本通貨金額は元の通貨*為替レートと等しくありません。保存しますか？',
  Cargo_Air: '空輸',
  Cargo_AirExport: '空輸輸出',
  Cargo_AirImport: '空輸輸入',
  Cargo_AirImportExport: '航空機の出入り',
  Cargo_Airline: '航路コード／航路名',
  Cargo_AirlineCode: '路線コード',
  Cargo_AirlineCompany: '航空会社',
  Cargo_ShippingCompanyName: '船会社中/英語名',
  Cargo_ShippingCompanyCode: '船会社コード',
  Cargo_ShippingCompanyScacCode: '船会社SCAC CODE',
  Cargo_ShippingCompanyChineseName: '船会社中国語名称',
  Cargo_ShippingCompanyEnglishName: '船会社英文名称',
  Cargo_DataDuplication: 'データはすでに存在します。重複して追加しないでください',
  Cargo_AdditionFailed: '新規失敗',
  Cargo_DeleteShipCompany: '選択した情報を削除しますか？<br>お知らせ：削除後にテナントから関連削除された船司デフォルトクリア',
  Cargo_AssociatedPlatformShippingCompany: '関連プラットフォーム船会社',
  Cargo_ShipCompanyThirdPartyCode: '船会社サードパーティコード',
  Cargo_MblCode: '船荷証券コード',
  Cargo_AirlinePerson: '航路担当者',
  Cargo_Airport: '空港',
  Cargo_AirportOfDischarge: '荷揚げ港（空港）',
  Cargo_AirService: '空輸運賃サービス項目',
  Cargo_AlertConfiguration: 'アラート設定',
  Cargo_AlertDaysPriorToExpiryDate: '有効期限まで*日残っているアラーム',
  Cargo_All: '全て',
  Cargo_AllB: '（すべて）',
  Cargo_AllP: '【すべて】',
  Cargo_AllAmount: '総数',
  Cargo_AllAmountP: '合計数: ',
  Cargo_AllCurrencies: 'すべての通貨',
  Cargo_AllForeignCurrencies: 'すべての外貨',
  Cargo_AllSelectedBillsWrittenOff: '選択した請求書はすべて消し込まれました。',
  Cargo_AllSelectedRecordsConfirmed: '選択したレコードはすべて確認されました。',
  Cargo_AllSelectedSoaWrittenOff: '選択した取引明細書はすべて消し込まれました。',
  Cargo_WithoutDiscrepancies: '差異なし',
  Cargo_AllWithWithoutDiscrepancies: 'すべて差異あり/差異なし',
  Cargo_AllWrittenOff: '売り切れです',
  Cargo_AlreadyAddedOrNot: '追加されたかどうか',
  Cargo_AmendmentFee: '変更料',
  Cargo_Amount: '金額',
  Cargo_AmountF: '金額です。',
  Cargo_AmountCanTBeEmpty: '金額は空にできません',
  Cargo_AmountCanTBeZero: '金額はゼロにできません。',
  Cargo_AmountCNY: '金額（CNY）',
  Cargo_AmountCNYP: 'CNY金額: ',
  Cargo_AmountEnteredForReconciliation: '入力された決済金額',
  Cargo_AmountIncurredOfCurrentPeriod: '当期発生額',
  Cargo_AmountInOriginalCurrency: '元の通貨金額',
  Cargo_AmountNotWrittenOff: '売上金なし',
  Cargo_AmountNumber: '数量',
  Cargo_AmountNumberP: '数量: ',
  Cargo_AmountOfActualCollectionPayment: '実際の入金額',
  Cargo_AmountOfCurrentMonth: '今月の金額',
  Cargo_AmountOfPaidInOutOfPocket: '実際の入出金額',
  Cargo_AmountOfPaymentApplication: '請求金額',
  Cargo_AmountRange: '金額の範囲',
  Cargo_AmountRemark: '費用備考',
  Cargo_AmountSum: '合計金額',
  Cargo_AmountTo: '合計',
  Cargo_AmountToDetail: '詳細の合計',
  Cargo_CurrentMonthAmountTo: '今月の合計',
  Cargo_CurrentYearAmountTo: 'この年の合計',
  Cargo_TotalReportingCurrencyOfThisMonth: '今月の基本通貨合計',
  Cargo_TotalReportingCurrencyOfThisYear: 'この年の基本通貨の合計',
  Cargo_AmountToCNY: '合計（CNY）',
  Cargo_AmountToP: '合計: ',
  Cargo_AmountToUSD: '合計（USD）',
  Cargo_AmountUSD: 'USDの金額',
  Cargo_AmountUSDP: 'USD金額: ',
  Cargo_AmsEnsCyCutOffDate: 'AMS/ENS締切日',
  Cargo_Annual: '年度',
  Cargo_AolAir: '出発空港',
  Cargo_AOPLVCTBE: '損益伝票の要約は空にできません',
  Cargo_APAR: '売掛金/未収金',
  Cargo_APBill: '買掛伝票',
  Cargo_APEOFINNPPARFV: '次の請求書番号の買掛金が支払承認を完了していないことを確認してください: \\n',
  Cargo_APInclusive: '買掛金を含むかどうか',
  Cargo_APInvoice: '買掛伝票',
  Cargo_Appendix: '別紙',
  Cargo_Applicant: '申請者',
  Cargo_ApplicationDateApplicationDate: '申請日申請日',
  Cargo_ApplicationDateBusinessDate: '申請日業務日',
  Cargo_ApplicationFormSavedSuccessfully: '申請書の保存に成功しました！',
  Cargo_ApplicationNo: '申請書番号',
  Cargo_ApplicationNoBill: '{0}番の申請書の費用は請求書がなく、業務番号は{1}',
  Cargo_ApplicationPermission: 'アプリケーション権限',
  Cargo_ApplicationStatus: '申請処理状況',
  Cargo_AppliedForPaymentOrNot: '支払が要求されたかどうか',
  Cargo_ApplyForPayment: '支払要求',
  Cargo_Approval: '承認済み',
  Cargo_ApprovalStatus: '承認処理状況',
  Cargo_Approved: '承認済み',
  Cargo_ApprovedBy: 'レビュー担当者',
  Cargo_ApprovedStatue: 'レビュー処理状況',
  Cargo_April: '4月',
  Cargo_APWriteOff: '買掛金勘定',
  Cargo_APWriteOffAmount: '買掛金金額',
  Cargo_APWrittenOff: '買掛金はすでに販売されています',
  Cargo_APWrittenOffP: '売掛金: ',
  Cargo_ARAges: 'エイジング',
  Cargo_ARAmountCanTExceedAPAmount: '売掛金は買掛金より大きくできません。',
  Cargo_ARAP: '売掛金と買掛金',
  Cargo_ARAPItemsMustBeComplete: '売掛金と買掛金は完全に入力する必要があります。',
  Cargo_ARBill: '売掛金の請求書',
  Cargo_ARegularExportVolume20TeuMonthly: 'A.貨物の輸出は毎月安定している。20TEU。',
  Cargo_ARInvoice: '受取請求書',
  Cargo_ARIPFCSC: 'Siri売掛/未収金請求書のプッシュに失敗しました: ',
  Cargo_ARNotWrittenOff: '売掛/未収金は取り消されていません',
  Cargo_ARNotWrittenOffP: '売掛/未収金: ',
  Cargo_AROrNot: '売掛金かどうか',
  Cargo_InvoiceAROrNot: '請求書が売掛金かどうか',
  Cargo_ArrivalDate: '到着日',
  Cargo_ArrivalTime: '到着時刻',
  Cargo_ARWriteOffAmount: '売掛金/未収金金額',
  Cargo_ARWrittenOff: '売掛金が取り消されました',
  Cargo_ARWrittenOffP: '売上債権回転: ',
  Cargo_ASRCCTD: '選択したレコードはすべて確認済みで、拒否できません',
  Cargo_AssessedClientLevel: '顧客評価レベル',
  Cargo_AssignedClientsSuccessfully: '{0}個の顧客が割り当てられました',
  Cargo_AssignmentDate: '割り当て日',
  Cargo_AssignToMe: '私に割り当てます',
  Cargo_AssociatedPort: '関連するポート',
  Cargo_ATCIJECTBE: '入力勘定コードは空にできません。',
  Cargo_AttachedDocuments: '添付ドキュメント',
  Cargo_Attachment: '添付ファイル',
  Cargo_AttachmentP: '添付ファイル: ',
  Cargo_AttachmentInvoice: '請求書添付ファイル',
  Cargo_AttachmentStorage: '添付ファイルストレージ',
  Cargo_Audit: 'レビュー',
  Cargo_AuditDate: '承認日',
  Cargo_Auditor: '承認者',
  Cargo_AuditorP: 'レビュー担当者: ',
  Cargo_AuditStatus: '承認処理状況',
  Cargo_AuditSuccessfully: '監査が成功しました',
  Cargo_AuditSuccessfullyF: '監査が成功しました。',
  Cargo_Guarantee: '保証書です',
  Cargo_GuaranteeName: '手紙の名前です',
  Cargo_GuaranteeType: '保証書タイプです',
  Cargo_August: '8月',
  Cargo_AuthorizedClient: '委託先コード／名称',
  Cargo_AvailableBranch: '利用可能支社',
  Cargo_AuthorizedCubage: '委託体積',
  Cargo_AuthorizedQuantity: '依頼件数',
  Cargo_AutomaticallyEnterInvoiceNumber: '請求書番号の自動入力',
  Cargo_AutomaticGenerated: '自動生成',
  Cargo_AvailableOrNot: '使用可能かどうか',
  Cargo_AverageMonthlyCargoVolume: '月平均出荷量',
  Cargo_AwaitBusinessApproval: 'ビジネス承認待ち',
  Cargo_AwaitFinancialApproval: '財務承認待ち',
  Cargo_Back: '戻る',
  Cargo_BackgroundParameter: 'バックグラウンドパラメータ',
  Cargo_BackgroundProcessing: 'バックグラウンド処理中',
  Cargo_BackgroundReturnedErrorStatus: 'バックグラウンドでエラー状態が返されました',
  Cargo_BackToCancel: 'キャンセルに戻る',
  Cargo_BackToInvoicingStatus: '請求処理状況を返します',
  Cargo_BackToProcessingMethod: '処理メソッドを返す',
  Cargo_BackToSearchResults: 'クエリの結菓を返す',
  Cargo_BaiwangInvoiceExport: 'InvoiceExport(Baiwang).xml',
  Cargo_Balance: '残高',
  Cargo_BalanceCalculation: '残高計算',
  Cargo_BalanceCNY: '残高（人民元）',
  Cargo_BalanceDirection: '残高の方向',
  Cargo_BalanceOfActualCollectionPayment: '実績残高',
  Cargo_BalanceSheet: '貸借対照表',
  Cargo_BalanceSheet2: '貸借対照表2',
  Cargo_BalancesOfAccountTitle: '勘定残高テーブル',
  Cargo_BalancesOfAccountTitle2: '勘定残高テーブル2',
  Cargo_BalanceUSD: '残高（米ドル）',
  Cargo_BangPic: '倉庫に入る写真',
  Cargo_Bank: '銀行',
  Cargo_BankAccount: '銀行口座番号',
  Cargo_BankAccountBalance: '銀行残高',
  Cargo_BankAccountNo: '銀行口座番号',
  Cargo_BankOfPayment: '支払銀行',
  Cargo_BankReceiptDetails: '水票の詳細',
  Cargo_BankReceiptNo: '銀行の水票番号',
  Cargo_ReceiptNo: '水単号',
  Cargo_BankReceiptRecord: '水票登録',
  Cargo_BankReceiptStatus: '水リストの状態',
  Cargo_BaseCurrency: '基準通貨',
  Cargo_BasePort: 'ベースポート',
  Cargo_Basic: '基本',
  Cargo_ExternalInterface: '外部インタフェース',
  Cargo_Blacklisted: 'ブラックリストに追加されました！',
  Cargo_BasicInfo: '基本情報',
  Cargo_BasicInformation: '基本情報',
  Cargo_BasisForGrouping: 'グループ化の条件',
  Cargo_BatchAudit: '一括承認レビュー',
  Cargo_BatchCancelAudit: '一括監査取消',
  Cargo_BatchCancelConfirmation: '一括キャンセルの確認',
  Cargo_BatchConfirm: '一括確認',
  Cargo_BatchDelete: '一括削除',
  Cargo_BatchDownload: '一括ダウンロード',
  Cargo_BatchEnterModifyBusinessOrderNo: '一括入力修正業務伝票番号',
  Cargo_BatchNo: 'ロット番号',
  Cargo_BatchNoOfCollection: '受託ロット番号',
  Cargo_BatchNoP: 'ロット番号: ',
  Cargo_BatchPrint: '一括印刷',
  Cargo_BatchProcessing: '一括処理',
  Cargo_BatchRetrieval: '一括取得',
  Cargo_BatchRetrievalButtonTrigger: '一括取得ボタントリガー',
  Cargo_BatchRevokeRetrieval: '一括取り消し取得',
  Cargo_BatchTransfer: '一括送信',
  Cargo_BelowBillingAmountsIncorrect: '次の請求金額が間違っています: ',
  Cargo_Bill: '請求書',
  Cargo_BillCanTBeEmpty: '請求書は空にできません。',
  Cargo_BillConfirmed: '請求書が確認されました。',
  Cargo_BillConfirmedM: '【{0}】請求書が確認されました。',
  Cargo_BillDate: '請求日',
  Cargo_DueDate: '請求書発行日',
  Cargo_BillDeleteAdjustment: '請求書-削除調整',
  Cargo_BillDeletedSuccessfully: '{0}件の請求書が削除されました',
  Cargo_BilledOrNot: '請求済みかどうか',
  Cargo_BillingAmount: '請求金額',
  Cargo_BillingCurrency: '請求通貨',
  Cargo_BillingData: '請求データ',
  Cargo_BillingDetails: '請求書の詳細',
  Cargo_BillingExpenditure: '請求書の支出',
  Cargo_BillingExpenditureDetails: '請求書支出費用の詳細',
  Cargo_BillingExpense: '請求費用',
  Cargo_BillingMethod: '課金方法',
  Cargo_BillingRevenue: '請求書の収益',
  Cargo_BillingRevenueExpenseDetails: '請求書収益費用の詳細',
  Cargo_BillInvoiced: '【{0}】請求書が請求されました',
  Cargo_BillIssued: '請求済み',
  Cargo_BillList: '請求リスト',
  Cargo_BillNo: '請求書番号',
  Cargo_BillNoP: '請求番号: ',
  Cargo_BillNotSelected: '請求書が選択されていません。',
  Cargo_BillPaidInFullCanTRepeatWriteOff: '請求書はすべて支払われたので、再請求はできません。',
  Cargo_BillStatus: '請求書処理状況',
  Cargo_BillTo: '請求先オブジェクト',
  Cargo_BillType: '請求書タイプ',
  Cargo_BillWrittenOff: '【{0}】請求書が消し込まれました',
  Cargo_Blacklist: 'ブラックリスト',
  Cargo_BLControl: '船荷証券管理',
  Cargo_BLMAEONRS: '請求方法が存在するか、レコードが選択されていません',
  Cargo_BLMethodMaintenance: '請求方法登録/変更',
  Cargo_BLMode: '請求モード',
  Cargo_BLNo: '船荷証券番号',
  Cargo_BLReleaseManagement: 'リリース管理',
  Cargo_MBLReleaseManagement: 'マスタ船荷証券管理',
  Cargo_HBLReleaseManagement: '個別の船荷証券管理',
  Cargo_BLReleaseReview: 'リリースレビュー',
  Cargo_MBLReleaseReview: 'マスタリリースレビュー',
  Cargo_HBLReleaseReview: '分割リリースレビュー',
  Cargo_BLReleaseReviewStatus: 'リリースレビュー処理状況',
  Cargo_BlReleasingNo: '注文番号を入れます',
  Cargo_BlReleasingNoP: '注文番号を入れる: ',
  Cargo_BLRemoteReleaseFee: 'オフサイト料金',
  Cargo_BLRetrieved: '船荷証券が回収されたかどうか',
  Cargo_BLType: '船荷証券タイプ',
  Cargo_HBLType: 'HBL船荷証券タイプ',
  Cargo_BNASPCTBBE: '業務番号と決済対象を両方とも空にすることはできません',
  Cargo_BNTTPRS: 'ロット番号{0}の前払い登録への移行に成功しました',
  Cargo_BOECTBCIWBII: '国内/海外の費用を一括して選択して請求書を作成してください',
  Cargo_Booking: '予約クラス',
  Cargo_BookingAgent: 'ブッキング代理店',
  Cargo_BookingAgentAbbreviation: '予約エージェント（略称）',
  Cargo_BookingAgentCode: '予約エージェント（コード）',
  Cargo_BookingNo: 'ブッキング番号',
  Cargo_BookingOrderNotExistCanTBeAdded: '新規追加に失敗しました。注文書は存在しません。',
  Cargo_BookingWindow: '注文/変更ウィンドウ',
  Cargo_BookKeeper: '記帳者',
  Cargo_BookKeepingDate: '記帳日',
  Cargo_BookKeepingMethod: '記帳方法',
  Cargo_BookKeepingVoucher: '記帳証憑',
  Cargo_BOPIOOPCTBLT: '実際の入金残高は{0}より小さくできません',
  Cargo_BOPIOOPCTBLTCWOA: '実際の入金残高は、この消込済金額より小さくすることはできません。',
  Cargo_BPHCCTBWO: '請求書{0}は本部の消込を待っています。現在は消込できません。',
  Cargo_BranchBill: '支社請求書',
  Cargo_BranchCMP: 'ブランチオフィス',
  Cargo_BranchCMPP: '支社: ',
  Cargo_BranchCompany: '所属支社',
  Cargo_BranchConfirmation: '支社の確認',
  Cargo_BranchConfirmed: '支社が確認されました',
  Cargo_BranchFilter: '支社フィルタ',
  Cargo_BREVB20TM: 'B.輸出は安定しています20TEU下',
  Cargo_BRNPNACW: '業務参照番号/プロジェクト番号/実際の請求重量',
  Cargo_BrokenDesc: '貨物損失の説明',
  Cargo_BrokenNumberDetection: '欠番を検出します',
  Cargo_Browse: '参照...',
  Cargo_BRTSIOC: 'B-安ければボスに推薦することを考える',
  Cargo_BSNMIR: 'ビジネス状態は請求要件を満たしていません',
  Cargo_BSNMPCR: 'ビジネス状態は支払要求の要件を満たしていません。',
  Cargo_BSNMWOR: '業務状態が帳消しの要求に合わない',
  Cargo_BulkCargo: 'ばら雑貨',
  Cargo_BURCNBE: 'レビュー対象のビジネスは編集できません',
  Cargo_Business: 'ビジネス',
  Cargo_BusinessAdjustment: 'ビジネス調整',
  Cargo_BusinessAdjustmentLog: 'ビジネス調整ログ',
  Cargo_BusinessApproval: 'ビジネス承認',
  Cargo_BusinessApprovalDate: 'ビジネス承認日',
  Cargo_BusinessApproved: 'ビジネス承認済み',
  Cargo_OfficeApproved: 'ビジネス承認済み',
  Cargo_BusinessCategory: '業務の種類',
  Cargo_BusinessCharacteristic: 'ビジネス特性',
  Cargo_BusinessCommission: 'ビジネス・リベート',
  Cargo_BusinessCreateDate: '取引作成日（起票日）',
  Cargo_BusinessCreator: '取引登録者',
  Cargo_BusinessDate: '取引日',
  Cargo_BusinessDateBusinessDate: '取引日取引日',
  Cargo_BusinessDateP: '取引日: ',
  Cargo_BusinessDocNo: 'ビジネス文書番号',
  Cargo_BusinessDocNo2: 'ビジネス文書番号2',
  Cargo_BusinessDocNoP: 'ビジネス文書番号: ',
  Cargo_BusinessHappenDate: 'ビジネスが発生した日付',
  Cargo_BusinessHappenDateP: 'ビジネス発生日: ',
  Cargo_BusinessInformation: 'ビジネス情報',
  Cargo_BusinessModel: 'ビジネスモデル',
  Cargo_BusinessNo: 'ビジネス番号',
  Cargo_BusinessNoInBill: '（請求書）業務番号',
  Cargo_BusinessNotSelected: 'ビジネスが選択されていません。',
  Cargo_BusinessReferenceNo: '参照番号',
  Cargo_GenerateNumberOfBusiness: 'Generate Number of Business Copies',
  Cargo_UpdateBusinessAgain: 'Modify and Generate Business Again',
  Cargo_Business_CustomerRefNo: 'Business/Customer Ref No',
  Cargo_BusinessStatus: 'ビジネス処理状況',
  Cargo_BusinessStatusChangeLog: 'ビジネス状態の変更ログ',
  Cargo_DataPushResultRecords: 'データプッシュ結菓レコード',
  Cargo_SendType: '送信タイプ',
  Cargo_ReissueFees: '再送料金',
  Cargo_ReissueFeesTips: 'このボタンをクリックすると、送信に失敗したすべての料金が再送信されます。',
  Cargo_BusinessType: '業務種別',
  Cargo_BusinessTypeP: '取引タイプ : ',
  Cargo_BusinessTypeCanTBeEmpty: '取引タイプ は空にできません',
  Cargo_BusinessTypeInconsistent: '取引タイプ が一緻しません',
  Cargo_ButtonPermissionControl: 'ボタン権限製御',
  Cargo_BuyingPrice: '買値',
  Cargo_BWNBCAED: '契約の期限が切れると、ビジネスは作成できなくなります',
  Cargo_ByBill: '請求書別',
  Cargo_ByDetail: '内訳別',
  Cargo_ByInvoice: '請求書別',
  Cargo_ByInvoiceFxRate: '請求レート別',
  Cargo_ByJob: '業務別',
  Cargo_ByJobNo: '業務番号別',
  Cargo_ByPaymentRequestFxRate: '支払要求レート別',
  Cargo_BySettlementAgent: '決済代行で',
  Cargo_SettlementAgentError: '決済エージェントエラー、再選択してください！',
  Cargo_CAEONRS: '通貨が存在するか、レコードが選択されていません',
  Cargo_CAIFCINFCAUU: '外貨計算をチェックします。外貨がない場合はドルで判断します。',
  Cargo_CAIOCPCRY: '当期発生額貸方（人民元）',
  Cargo_CAIOCPUSD: '当期発生額貸方（米ドル）',
  Cargo_CalculateBalance: '残高の計算',
  Cargo_CalculateBalanceTotalToWriteOff: '売上可能残高合計の計算',
  Cargo_CalculateBillingAmount: '請求金額の計算',
  Cargo_CalculatedInOriginalCurrency: '元の通貨で計算',
  Cargo_CalculateTaxRate: '税率の計算',
  Cargo_CallbackFunction: 'コールバック関数',
  Cargo_CanBeConfirmedOrNot: '確認できますか',
  Cargo_CanBeDeletedOrNot: '削除可',
  Cargo_CanBePrintedOrNot: '印刷可能かどうか',
  Cargo_CanBeVoidedOrNot: '無効化可能かどうか',
  Cargo_CANCA: '代収立替金非代収立替金',
  Cargo_Cancel: 'キャンセル',
  Cargo_CancelAccrue: '計上の取り消し',
  Cargo_CancelAudit: ' 監査取消',
  Cargo_NewCustomerApplication: '新規顧客申請',
  Cargo_NewSupplierApplication: '新規サプライヤー申請',
  Cargo_RequiredFields: 'フォームの必須項目に記入してください',
  Cargo_SelectTradeType: '貿易タイプを選択してください',
  Cargo_CancelCheckOfSelectedRecord: '選択したレコードのキャンセルを確認しますか？',
  Cargo_CancelClosure: 'シャットダウンをキャンセルします',
  Cargo_CancelConfirm: 'キャンセルの確認',
  Cargo_CancelCurrentModification: '現在の変更情報をキャンセルします',
  Cargo_CancelDefaultsInBatch: '一括デフォルト解除',
  Cargo_CancelEditing: '編集の取り消し',
  Cargo_CancelGetBack: '回収を取り消します',
  Cargo_CancelIgnore: '無視をキャンセルします',
  Cargo_CancelMark: 'マーク解除',
  Cargo_CancelMerging: 'マージをキャンセルします',
  Cargo_CancelModification: '現在の変更をキャンセルしますか？',
  Cargo_CancelPublishment: 'パブリッシュのキャンセル',
  Cargo_DownloadImportTemplate: '導入モデルをダウンロードします',
  Cargo_CancelReconciliation: '消込済',
  Cargo_CancelReturn: 'キャンセルリターン',
  Cargo_CancelSuccessfully: 'キャンセルに成功しました。',
  Cargo_CancelTheChargesAudit: '費用の監査をキャンセルします',
  Cargo_CancelWriteOff: '帳消し取消',
  Cargo_CanNotProcessUnsavedNewExpense: '新規未保存の費用は処理できません。',
  Cargo_CanNotRedoCancellation: '繰り返しログアウトできません。',
  Cargo_CanNotRemoveAllBills: 'すべての請求書を削除できません。',
  Cargo_CanOnlyRetrieveAfterDelivered: '取り返すために発送しました！',
  Cargo_CanTDeleteItemsWithInvoiceNo: '請求書番号が入力されました。削除できません。',
  Cargo_CanTDeleteWrittenOffItem: '消込済、削除できません',
  Cargo_CanTEditClosedItem: '決済済みで編集できません。',
  Cargo_CanTRepeatVoiding: '【{0}】はすでに無効になっているので、これ以上無効にすることはできません',
  Cargo_CanTSelectInvoiceNoForEInvoice: '電子請求書は請求書番号を選択できません。',
  Cargo_CanTSplitInvoicedItem: '請求済み、分割できません！',
  Cargo_CanTVoidInvoiceWithoutInvoiceNo: '請求書番号がないので、請求書を無効にできません！',
  Cargo_CanTVoidWrittenOffItem: '【{0}】はすでに適用されているので、無効にできません。',
  Cargo_CAOPWWT: '税抜き価格の計算',
  Cargo_Cargo: '貨物',
  Cargo_Remark: '貨物備考',
  Cargo_Remark_Check: '貨物備考には3999文字までの大小文字、数字、特殊記号（!"#%&\'()*+,-./:;<=>?@_0-9a-zA-Z\n\s）のみ入力可能です',
  Cargo_CargoDetention: '差し押さえ',
  Cargo_CargoInfo: '貨物情報',
  Cargo_CargoName: '商品名',
  Cargo_CargoNature: '貨物の属性',
  Cargo_CargoType: '貨物分類コード',
  Cargo_CAROJE: '入力要約規則の構成',
  Cargo_CarriedOver: '繰り越されました',
  Cargo_Carrier: 'キャリア',
  Cargo_Carrier_Ship: '輸送業者（船会社）',
  Cargo_Carrier_Air: '輸送業者（航空会社）',
  Cargo_Carrier_Railway: '輸送業者（ポートエージェント）',
  Cargo_CarrierAgent: '船社代理',
  Cargo_CarrierShip: '船会社',
  Cargo_CarryOverForeignExchange: '繰越為替',
  Cargo_CarryOverInitialized: '繰越が初期化されました',
  Cargo_CarryOverProfitLoss: '損益の繰越',
  Cargo_CarryOverProfitLoss2: '損益の繰越2',
  Cargo_CarryOverToNextPeriod: '次の期間に繰り越す',
  Cargo_CartonQuantity: '箱型の量',
  Cargo_TicketCount: '票数',
  Cargo_Cash: '現金',
  Cargo_CasualClientNonCasualClient: '個人客/非個人客',
  Cargo_NonCasualClient: '非個人客',
  Cargo_CasualClientOrNot: '個人客かどうか',
  Cargo_Category: 'カテゴリ',
  Cargo_CategoryOfPartner: 'パートナータイプ',
  Cargo_CATISExport: 'ゴールデン税エクスポート',
  Cargo_CATISInvalid: 'ゴールデン税無効',
  Cargo_CATISPrint: 'ゴールデン税印刷',
  Cargo_CBEIPCPTSINACSRANMPC: '現在の支社電子請求書: プラットフォームコード/パスワード/納税者識別番号/承認コード/サービス要求アドレスがメンテナンスされていないので、チェックしてください。',
  Cargo_CBEIPCTSINACSRANMPC: '現在の支社電子請求書: プラットフォームコード/納税者識別番号/承認コード/サービス要求アドレスがメンテナンスされていないので、チェックしてください。',
  Cargo_CBFCEBD: '確認済請求書はデフォルトで作成されます',
  Cargo_CBISAWTSNM: '現在の支社税システムインタフェースサービス所在地は登録/変更されていません。',
  Cargo_CBTSINNM: '現在の支社納税者識別番号はメンテナンスされていません。',
  Cargo_CCOCM: '現在の変更をキャンセルしますか？',
  Cargo_CCOPLV: '繰越損益伝票の生成に成功しました: ',
  Cargo_CCRAIOC: 'C-安いなら代理店を変えることを考えています',
  Cargo_CCS: 'キャンセルの確認に成功しました。',
  Cargo_CDOPRI: '支払拒否申請情報の確定',
  Cargo_Cent: '分',
  Cargo_AndTo: 'And {0} to {1}',
  Cargo_AlreadyHere: 'It\'s already here',
  Cargo_IsOver: '{0} is over{1}',
  Cargo_CERNM: '通貨（{0}）為替レートが維持されていません',
  Cargo_CFCNAPM: '勘定は現在の外貨を計算しません: {0}、修正してください。',
  Cargo_CGS1RV: '販売は顧客を奪うことに成功した！{0}レコードの監査に成功しました。',
  Cargo_ChangeContent: '変更内容',
  Cargo_ChangeInvoiceTitle: '請求書ヘッダーの変更',
  Cargo_ChangeInvoiceTitleP: '請求書ヘッダーの変更: ',
  Cargo_ChangeSob: '会計帳簿の変更',
  Cargo_ChangeTo: '次へ変更',
  Cargo_ChangeToP: '次へ変更: ',
  Cargo_Charge: '受け取る',
  Cargo_Chargeback: 'キャンセル',
  Cargo_ChargebackFile: 'キャンセルファイル',
  Cargo_ChargeDetails: '費用明細',
  Cargo_ChargedWeight: '請求重量',
  Cargo_ChargeName: '費目名',
  Cargo_ChargeOriginalAmount: 'チャージ元金額',
  Cargo_ChargeOriginalCurrency: '費用の元の通貨',
  Cargo_ChargeOriginalExchangeRate: 'チャージ元為替レート',
  Cargo_ChargesAudit: '費用の監査',
  Cargo_ChargesContactPerson: '費用の連絡先',
  Cargo_ChargesReject: '費用却下',
  Cargo_ChargeStatus: 'チャージ処理状況',
  Cargo_ChargesTotalAmount: '費用の合計金額',
  Cargo_ChargeType: 'チャージタイプ',
  Cargo_ChargeTypeP: 'チャージタイプ: ',
  Cargo_CHBRNFOA: '契約は更新されました。操作は禁止されています',
  Cargo_CheckAccountInForeignCurrency: '外貨会計のチェック',
  Cargo_CheckChargeDetailBranch: '操作中のデータは、現在のブランチオフィスまたは1つ上のブランチオフィスに属していません。',
  Cargo_CheckCreateBillWay: 'The settlement object or settlement agent must meet one of the same criteria',
  Cargo_CheckInvoiceQueryBranch: '現在操作中の支社とデータの帰属支社が一緻しません。データを再検索してから処理してください。',
  Cargo_CheckClientToExtendValidPeriod: '期限を延長する必要があるお客様を最初にチェックしてください。',
  Cargo_CheckIfSoaFullyWrittenOff: '取引明細書が完全に消し込まれたかどうかをチェックします',
  Cargo_CheckingStatus: '船荷証券処理状況',
  Cargo_HblCheckingStatus: 'HBL船荷証券処理状況',
  Cargo_CheckingURLStatus: 'チェック状態',
  Cargo_CheckInvoice: '請求先請求書',
  Cargo_CheckWriteOffDetails: '売上明細の照会',
  Cargo_ChineseCargoName: '中国語品名',
  Cargo_StatusUpdateTime: '船荷証券処理状況変更時間',
  Cargo_StatusUpdateUser: '船荷証券処理状況変更者',
  Cargo_ChineseFirstVesselName: '船名',
  Cargo_ChineseName: '氏名',
  Cargo_ChineseNameCanTBeEmpty: '氏名は空にできません',
  Cargo_ChineseNameOfSettlingParty: '決済対象の氏名',
  Cargo_Choose0P: '0を選択: ',
  Cargo_ChooseByText: 'テキストによる選択',
  Cargo_ChooseFee: '料金の選択',
  Cargo_ChooseFeeCNY: 'RMB料金を選択します',
  Cargo_ChooseFeeUSD: 'USDの費用を選択します',
  Cargo_ChooseInvoicedFee: '請求書費用が選択されています',
  Cargo_ChooseP: '選択{0}: ',
  Cargo_TicketCount: '件数: ',
  Cargo_CIIRSBATTB: '請求書に請求要件を追加すべきかどうかを確認します',
  Cargo_CIMJ: '宅配便情報必録判断',
  Cargo_CIMS: '回収情報の変更に成功しました。',
  Cargo_City: '所属する都市',
  Cargo_CityCode: '都市コード',
  Cargo_CityMaintenance: '都市のメンテナンス',
  Cargo_CityName: '都市名',
  Cargo_CityNotSelected: '都市が選択されていません',
  Cargo_CityP: '都市',
  Cargo_Claim: '受け取ります',
  Cargo_ClaimAdvanceReceipt: '前受/預り金受領確認',
  Cargo_ClaimAR: '売掛金の受領',
  Cargo_ClaimBankReceipt: '水票受領',
  Cargo_ClaimDate: '受領日',
  Cargo_ClaimedBy: '受取人',
  Cargo_ClaimInformation: '受領情報',
  Cargo_ClaimOrNot: '受け取りますか',
  Cargo_ClaimState: '受領処理状況',
  Cargo_ClaimStatusOfAdvanceReceipt: '受領処理状況（前受）',
  Cargo_ClaimStatusOfAR: '受領処理状況（受取）',
  Cargo_Clear: 'クリア',
  Cargo_ClearData: 'データをクリアします',
  Cargo_ClearFilter: 'フィルタのクリア',
  Cargo_ClickToFilter: 'クリックによるフィルタリング',
  Cargo_ClickToLoadParameter: 'ボタンをクリックしてクエリパラメータをロードします',
  Cargo_ClickToQuery: 'ボタンをクリックしてクエリを実行します',
  Cargo_ClientAllocationStatus: '顧客割り当て処理状況',
  Cargo_CLientCantBeEmpty: '顧客は空にできません',
  Cargo_ClientContract: '顧客契約',
  Cargo_ClientEventNotSelected: 'クライアントイベントが選択されていません',
  Cargo_ClientList: '顧客リスト',
  Cargo_ClientMovedToRecycleBin: 'この顧客は顧客のごみ箱に移動されました',
  Cargo_ClientNo: '顧客番号',
  Cargo_ClientOverseasAgent: '顧客/海外エージェント',
  Cargo_ClientStatus: '顧客処理状況',
  Cargo_ClientSVisit: '顧客の訪問',
  Cargo_ClientVendor: '顧客/仕入先',
  Cargo_Close: '閉じる',
  Cargo_Close2: '閉じる',
  Cargo_CloseAccount: '決算します',
  Cargo_CloseAccount2: '決算2',
  Cargo_CloseAccountOrNot: '決算するかどうか',
  Cargo_CloseDateOfContainerReturn: 'キャビネット返却終了日',
  Cargo_CloseDetailWindow: '詳細ウィンドウを閉じる',
  Cargo_CloseWindow: 'ウィンドウを閉じる',
  Cargo_ClosureNo: '終了番号',
  Cargo_ClosureTimeSelection: '終了時間の選択',
  Cargo_ClosureTitleOfAccount: '勘定科目の終了',
  Cargo_CNY: '人民元',
  Cargo_CNYHKD: '人民元/香港ドル',
  Cargo_CNYInvoiceNo: '人民元請求書番号',
  Cargo_CNYP: '人民元: ',
  Cargo_COACP: '払込通貨',
  Cargo_Code: 'コード',
  Cargo_CodeCanTBeEmpty: 'コードは空にできません',
  Cargo_DuplicateCode: 'コードが重複しています。再入力してください。',
  Cargo_CodeNotMaintained: 'コードはメンテナンスされていません。',
  Cargo_CodeOfExpenseDescription: '費用名コード',
  Cargo_CodeSearching: 'コード検索',
  Cargo_CodeType: 'エンコードタイプ',
  Cargo_CodeTypeP: 'エンコードタイプ: ',
  Cargo_Coding: 'エンコード',
  Cargo_ApCoding: '対応コード',
  Cargo_ArCoding: '受取エンコード',
  Cargo_CodingMapping: 'コードマッピング',
  Cargo_CodingP: 'エンコード: ',
  Cargo_Collect: '受け取る',
  Cargo_CollectAndPrepaidOrNot: '立替金を受け取るかどうか',
  Cargo_CollectedExpenseDetails: '回収費用の詳細',
  Cargo_CollectedExpenseDetailsP: '委託手数料明細: ',
  Cargo_CollectedInFull: '収集済み',
  Cargo_CollectedNotCollectedInFull: '収集済み/未収集',
  Cargo_CollectFormation: '入金情報',
  Cargo_CollectInvoice: 'チケットを受け取ります',
  Cargo_Collection: 'コレクション',
  Cargo_CollectionCNY: '回収CNY',
  Cargo_CollectionDetails: '回収費用の詳細',
  Cargo_CollectionDifference: '回収差異',
  Cargo_CollectionInformation: '回収情報',
  Cargo_CollectionPayment: '受取支払',
  Cargo_CollectionPaymentCleared: '入金が決済されました',
  Cargo_CollectionPaymentDate: '受取支払日',
  Cargo_CollectionPaymentInformation: '受取支払情報',
  Cargo_CollectionPaymentMethod: '受取支払方法',
  Cargo_CollectionPaymentTypeFilter: '入金タイプフィルタ',
  Cargo_CollectionRecordByCarrier: '船会社受託記録',
  Cargo_CollectionSituation: '入金状況',
  Cargo_CollectionStatus: '回収処理状況',
  Cargo_CollectionUSD: '預入USD',
  Cargo_CoLoadConsol: '委託箱詰め',
  Cargo_ColorOfControllingRow: 'コントロール行の色',
  Cargo_CombinedInvoicing: '統合請求書',
  Cargo_CombinedListNo: 'チケットリスト番号',
  Cargo_Commission: 'コミッション',
  Cargo_CommissionAmount: '歩合給金額',
  Cargo_CommissionedGrossWeight: '委託総重量',
  Cargo_CommissionItems: '手数料アイテム',
  Cargo_CommissionOrNot: '手数料はかかりますか',
  Cargo_CommissionPercentage: '歩合給の割合',
  Cargo_CommissionRules: '歩合給ルール',
  Cargo_CommodityCode: '商品コード',
  Cargo_CommodityInspection: '商品検査',
  Cargo_CommonlyUsedTradeTerms: '一般的な取引条件',
  Cargo_Company: '会社',
  Cargo_CompanySelfRelease: '自社発注',
  Cargo_CompanySReceivingAccountNumber: '会社の入金口座番号',
  Cargo_CompanySReceivingBank: '会社の受取銀行',
  Cargo_Competitor: '競合会社',
  Cargo_Completed: '完了',
  Cargo_CompleteDate: '終了日',
  Cargo_CompletedOrNot: '完了したかどうか',
  Cargo_CompleteWriteOff: '完全消去',
  Cargo_CompletionTime: '完了時間',
  Cargo_ConditionOfSearch: '検索条件',
  Cargo_ConditionType: '条件タイプ',
  Cargo_ConfiCNYill: '請求書の確認',
  Cargo_ConfigureAccountTitle: 'アカウント設定',
  Cargo_Confirm: 'OK',
  Cargo_AMSEnsChannel: '対テロシートENS識別サプライヤーです',
  Cargo_SkipAll: '全部飛ばします',
  Cargo_SecondFlightSchedule: '二次フライト時刻',
  Cargo_TwoWayFreighter: '二程貨物機',
  Cargo_EmailFormatError: 'メールボックスのフォーマットが間違っています',
  Cargo_CountryOfShipment: '出荷国',
  Cargo_AirFreightRateDetails: '航空運賃の詳細',
  Cargo_ConfirmAndCheckSelectedRecord: '選択したレコードを確認しますか？',
  Cargo_ConfirmAP: '買掛金を確認します',
  Cargo_ConfirmCancellationOfRecord: 'レコードを削除してもよろしいですか？',
  Cargo_ConfirmCombinedInvoice: '連結請求を確定します',
  Cargo_ConfirmDate: '確認日',
  Cargo_Confirmed: '確認しました',
  Cargo_ConfirmedSuccessfully: '成功を確認します。',
  Cargo_ConfirmExpenses: '費用の確認',
  Cargo_ConfirmNotification: 'リマインダの確認',
  Cargo_ConfirmOffset: '相殺の確認',
  Cargo_ConfirmOrNot: '確認しますか',
  Cargo_ConfirmPartial: '部分的に確認しますか',
  Cargo_ConfirmR: '確定',
  Cargo_ConfirmRQ: '確定？',
  Cargo_ConfirmRemarks: 'コメントの確認',
  Cargo_ConfirmSelectedItem: '選択項目の確認',
  Cargo_ConfirmStatus: '処理状況の確認',
  Cargo_ConfirmSubmissionOfPaymentOrder: '支払通知を送信しますか？',
  Cargo_ConfirmWriteOff: '消込確定',
  Cargo_ConfirmWriteOffQ: '帳消しを確認しますか？',
  Cargo_ConfirmWrittenOffExpense: '消込済費用の確認',
  Cargo_ConflictExpenseDetails: '競合する費用の詳細',
  Cargo_Consignation: '委任する',
  Cargo_ConsignationCompanyCannotBeNull: '委任先は空にできません',
  Cargo_Consignee: '荷受人',
  Cargo_ConsigneeId: '荷受人コード',
  Cargo_ConsigneeInfo: '荷受人情報',
  Cargo_ConsigneeSName: '荷受人の名前',
  Cargo_ConsignorSCode: '委託先（コード）',
  Cargo_ConsolidatedCNY: '総合（人民元）',
  Cargo_ConsolidatedCurrency: '連結通貨',
  Cargo_ConsolidatedLocalCurrency: '連結基本通貨',
  Cargo_ConsolidatedLocalCurrencyCNY: '連結基本通貨（人民元）',
  Cargo_ConsolidatedProfitLossIs: '為替差損益: ',
  Cargo_ConsolidateOrNot: 'マージするかどうか',
  Cargo_Contact: '連絡先',
  Cargo_ContactNumber: '連絡先電話番号',
  Cargo_ContainerAmount: '箱の量',
  Cargo_ContainerDescription: 'コンテナの説明',
  Cargo_ContainerInfo: '梱包情報',
  Cargo_ContainerNo: '箱番号',
  Cargo_ContainerSize: 'コンテナ型',
  Cargo_ContainerType: 'コンテナ種別',
  Cargo_ContainerRule: '箱尺',
  Cargo_ContainerTypeCanTBeEmpty: '箱型は空にできません',
  Cargo_ContainerTypeMaintenance: 'コンテナタイプのメンテナンス',
  Cargo_ContainerTypeSea: 'コンテナタイプ（海上輸送）',
  Cargo_ContentDescription: 'コンテンツの説明',
  Cargo_ContentFailedToLoad: 'コンテンツのロードに失敗しました',
  Cargo_ContentFailedToLoadP: 'コンテンツのロードに失敗しました: ',
  Cargo_ContentOfAmount: '金額の内容',
  Cargo_ContentOfExpenseDescription: '費用名の内容',
  Cargo_ContentPreviewOfPaymentNotice: '入金通知内容のプレビュー',
  Cargo_Continent: '大陸',
  Cargo_ContinueToAddData: 'データの追加を続行します',
  Cargo_ContinueToSave: '保存を続行します',
  Cargo_ContinuousFilter: '連続フィルタ',
  Cargo_Contra: 'カウンターピン',
  Cargo_ContraAmount: '相殺金額',
  Cargo_ContraAmountP: '相殺金額: ',
  Cargo_ContraBalance: '相殺残高',
  Cargo_ContractAdministrator: '契約管理者',
  Cargo_ContractConfiguration: '契約設定',
  Cargo_Contracted: '契約済み',
  Cargo_ContractedClientInformation: '契約顧客情報',
  Cargo_ContractExpired: '契約の失効',
  Cargo_ContractNumber: '契約番号',
  Cargo_ContractNumberCanTBeEmpty: '契約番号は空にできません',
  Cargo_ContractRateProperty: '契約価格情報',
  Cargo_ContractSignedSuccessfully: 'サインが成功しました',
  Cargo_ContractStatus: '契約処理状況',
  Cargo_RiskReason: '与信管理理由',
  Cargo_ContractValidStatus: '契約が有効かどうか',
  Cargo_ContractTerms: '契約条件',
  Cargo_CurrentCredit: '現状の情報管理',
  Cargo_ContractCredit: '契約与信管理',
  Cargo_ContractType: '契約タイプ',
  Cargo_ConversionAmountContent: '換算金額の内容',
  Cargo_ConversionAmountInCNY: '人民元に換算した金額',
  Cargo_ConversionRMB: 'RMBに換算',
  Cargo_ConversionAP: '換算買掛金',
  Cargo_ConversionAPCNY: 'CNYに換算して支払う',
  Cargo_ConversionPaidCNY: 'CNY換算で払いました',
  Cargo_ConversionAPCurrency: '{0}に換算して支払う',
  Cargo_ConversionAR: '売掛金換算',
  Cargo_ConversionARCNY: 'CNY売掛金に換算',
  Cargo_ConversionReceivedCNY: 'CNY受信済みです',
  Cargo_ConversionARCurrency: '{0}売掛金に換算',
  Cargo_ConversionCurrencyAmount: '換算通貨金額',
  Cargo_ConversionOutstandingAR: '未回収に換算',
  Cargo_ConversionOutstandingARCNY: 'CNY未収に換算',
  Cargo_ConversionOutstandingARCurrency: '{0}未収に換算',
  Cargo_ConversionOutstandingReceivedCurrency: '{0}換算済みです。',
  Cargo_ConversionProfit: '換算利益',
  Cargo_ConversionProfitCNY: 'CNY利益に換算',
  Cargo_ConversionProfitCNYP: 'CNY利益換算: ',
  Cargo_ConversionWriteOffAmountInCNY: '売上勘定から人民元に換算した金額',
  Cargo_COPLOCP: '当期損益を繰り越す',
  Cargo_Copy: 'コピー',
  Cargo_CopyAndAddPoItems: 'COPY作成',
  Cargo_CopyExchangeRate: '為替レートのコピー',
  Cargo_CopyFromExisting: '既存の帳簿に基づいて新規作成',
  Cargo_InitializeLevelOneSubject: '一次科目の初期化',
  Cargo_InitializeReport: 'レポートの初期化',
  Cargo_Cost: '費用',
  Cargo_CostInvoiceNo: '原価請求書番号',
  Cargo_CounterpartySBankAccount: '相手のアカウント',
  Cargo_CounterpartySBillingNo: '相手方請求書番号',
  Cargo_Country: '国',
  Cargo_CountryMaintenance: '国のメンテナンス',
  Cargo_CountryRegion: '国・地域',
  Cargo_CountryRegionCode: '国コード',
  Cargo_CourierOrderNo: '宅配便番号',
  Cargo_CPIOOPRCCTBV: '現在の実収実付記録はすでに再検討されており、廃棄することはできません。',
  Cargo_CPIOOPRVCTBM: '現在の支払記録は無効になっており、変更できません！',
  Cargo_CPIOOPRWOCTBV: '現在の入金と支払の記録にはすでに消込記録があり、破棄できません。',
  Cargo_identifyTheResult: 'identify the result',
  Cargo_identifyTheResult2: 'Identifying bill of lading information',
  Cargo_SystemResult: 'System bill of lading information',
  Cargo_ContrastingSystem: 'Contrasting System',
  Cargo_SaveBillData: 'Save bill of lading information',
  Cargo_SaveBill2: 'Identification information directly overlays the bill of lading',
  Cargo_InAnalysis: 'Parsing, please wait',
  Cargo_UnopenedService: 'The service is not enabled and cannot be used',
  Cargo_F17Verify: 'F17送信にはMAWB番号とHAWB番号が一致している必要があります',
  Cargo_Will: 'will',
  Cargo_DFI: 'Drag here for identification, or',
  Cargo_seaFile: 'The consignment documents from the sea',
  Cargo_seaFile2: '海出荷委託状の識別',
  Cargo_siFile: 'Bill of lading documents for maritime entry',
  Cargo_siFile2: '海运进口提单识别の翻訳',
  Cargo_seBillFile: 'Maritime bill of lading documents',
  Cargo_seBillFile2: '海運輸出船荷証券の識別',
  Cargo_aeFile2: '空輸輸出委託書認識',
  Cargo_aiFile2: '空輸輸入提单認識',
  Cargo_GenerateSiBusiness: 'Generate sea import business',
  Cargo_MaritimeIdentification: 'Maritime identification',
  Cargo_ApplicationIdentificationType: 'Application identification type',
  Cargo_IdentificationType: 'Identification Type',
  Cargo_IdentificationChannel: 'Identification channel',
  Cargo_OriginalMessage: 'Original message',
  Cargo_DataSource: 'Data Source',
  Cargo_InvoiceExport: 'Invoice Export',
  Cargo_InvoiceNoImport: 'Import invoice number',
  Cargo_profitMargin: 'profit margin',
  Cargo_Payment1: 'Payer',
  Cargo_PaymentCode: 'Payer Code',
  Cargo_PaymentName1: 'Payer Contact Name',
  Cargo_PaymentName: 'Payer Name',
  Cargo_SelectPayment: 'Select the payer',
  Cargo_ShowTab: 'Display the supplementary tab',
  Cargo_MscBookingInfo: 'MSC booking supplementary information',
  Cargo_PaymentInfo: 'Payer Information',
  Cargo_PaymentInfo1: 'Formatted Payer',
  Cargo_PaymentEnterpriseCode: 'Payer Enterprise Code',
  Cargo_Payment2: 'Payer Enterprise Name',
  Cargo_Payment3: 'Payer Detailed Address',
  Cargo_Payment4: 'Payer Phone Number',
  Cargo_Payment5: 'Payer Email Address',
  Cargo_Payment6: 'Payer Telex Number',
  Cargo_Province1: 'Province/State',
  Cargo_GeneralFormat: 'General Format',
  Cargo_DetailFormat: 'Detail Format',
  Cargo_BringInData: 'Bring In Data',
  Cargo_DefaultInvoiceIssuer: 'デフォルトの請求書発行者',
  Cargo_checkCabinTip: 'There are data with and without cabin space serial numbers; they cannot be operated together.',
  Cargo_checkCabinTip2: 'The orders you have selected will undergo the cabin space withdrawal process.',
  Cargo_RecoverText: 'Recover the cabin space and directly register the cabin cancellation. Are you sure?',
  Cargo_RecoverRemark: 'Cabin Cancellation Explanation',
  Cargo_RecoverTips: 'Recover and Cancel Cabin',
  Cargo_LinesArAp: 'Lines receivable/lines payable',
  Cargo_RInPay: 'Receivables include payables',
  Cargo_market: 'market',
  Cargo_GPExplain: '粗利説明（GP理由）',
  Cargo_ServiceLockSetting1: 'Auto-Job Close',
  Cargo_ServiceLockSettings: 'Automatic service configuration',
  Cargo_OnlyServiceDataLocked: 'Only business data is locked, and the expense TAB can be edited',
  Cargo_AutomaticallyLocksServiceData: 'Automatically locks service data',
  Cargo_AutomaticallySubmitServiceData: 'Automatically submit service data',
  Cargo_SystemAutomaticExecution: 'System Automatic Execution',
  Cargo_ServicesNotSubmittedAutomaticallySubmitted: 'Services that are not submitted are automatically submitted',
  Cargo_LockTheNumberOfDeferredDays: 'The lockout delay days range from 3 to 120',
  Cargo_checkBillingGroup: '[{0}] Bill status is not "{1}"',
  Cargo_AutoLock: 'Auto-Close',
  Cargo_BusinessDate1: 'After Job create date of',
  Cargo_Days1: 'day(s)',
  Cargo_SendBookingFail: 'Sending booking failed',
  Cargo_uploadErr: 'fail to upload',
  Cargo_Create: '作成します',
  Cargo_CreateAndExportDirectly: '生成後に直接エクスポート',
  Cargo_CreateBill: '請求書作成',
  Cargo_BatchCreateBillTitle: 'データ範囲を選択してください',
  Cargo_BatchCreateBillBySame: '同じ決済対象の料金は1枚の請求書になります',
  Cargo_BatchCreateBillByAll: '検出されたすべてのレコード',
  Cargo_BatchCreateBillBySelected: '選択されたレコード',
  Cargo_BatchCreateBillSuccess: '操作が成功しました: 合計{0}ペン請求書が生成されました',
  Cargo_BatchCreateBill: '請求書の一括生成',
  Cargo_CreateBillQ: '請求書を作成しますか',
  Cargo_CreateCombination: '連結生成',
  Cargo_CreateCostInvoice: '原価請求書を生成するかどうか',
  Cargo_CreatedBy: '入力者',
  Cargo_CreatedDate: '作成日',
  Cargo_CreatedSuccessfully: '新規作成成功！',
  Cargo_CreateInvoice: '請求書を生成します',
  Cargo_CreateListOfCombinedInvoices: 'チケットリストを生成します',
  Cargo_CreateOffsetExpense: 'ヘッジ費用を生成します',
  Cargo_CreatePaymentRequest: '支払申請書の作成',
  Cargo_CreatePaymentRequestChooseFees: '支払要求の作成-費用の選択',
  Cargo_CreatePaymentRequestDetails: '支払要求の作成-詳細',
  Cargo_BasicPaymentRequest: '支払申請(基本版)',
  Cargo_PendingSupervisorApproval: '主管承認待ち',
  Cargo_PaymentRequestSettings: '支払申請設定',
  Cargo_EnableUICustomization: 'UIカスタム表示を有効化',
  Cargo_AdditionalApprovalNode: '追加承認ノード',
  Cargo_DepartmentApprovalTab: '部門承認（部門承認待ちタブを表示）',
  Cargo_SupervisorApprovalTab: '主管承認（主管承認待ちタブを表示）',
  Cargo_Settings: '設定',
  Cargo_PendingDepartmentApproval: '部門承認待ち',
  Cargo_PreApproval: '事前審査',
  Cargo_FinanceApproval: '財務審査',
  Cargo_OperationReview: '業務レビュー',
  Cargo_DepartmentReview: '部門レビュー',
  Cargo_SupervisorReview: '主管審査',
  Cargo_RuleBasedApproval: 'ルールに適合した書類のみ、このタブで追加審査を行います',
  Cargo_NonRuleBypass: '特定ルールに適合しない書類は主管承認を不要とする',
  Cargo_AllPaymentRequests: '支払申請(すべて)',
  Cargo_SupervisorReviewer: '主管審査者',
  Cargo_SupervisorReviewDate: '主管審査日',
  Cargo_SettlementUnitContractStatus: '決算単位契約状態',
  Cargo_ReturnToPreviousApprovalNode: '前の承認ノードに戻すかどうか',
  Cargo_CreateSoa: '請求書作成',
  Cargo_CreateVoucher: '証憑の生成',
  Cargo_Creator: '作成者',
  Cargo_Credit: '貸方',
  Cargo_CreditAmount: 'credit金額',
  Cargo_CreditAmount2: '貸方金額',
  Cargo_CreditAmountCNY: '貸方（人民元）',
  Cargo_CreditAmountOccurred: '貸方発生額',
  Cargo_CreditAmountOccurredCNY: '貸方発生額（人民元）',
  Cargo_CreditAmountOccurredP: '貸方発生額: ',
  Cargo_CreditAmountOccurredUSD: '貸方発生額（米ドル）',
  Cargo_CreditAmountTo: 'Credit合計',
  Cargo_CreditAmountToP: 'Credit合計: ',
  Cargo_CreditAmountUSD: '貸方（米ドル）',
  Cargo_CreditControlDetails: '与信管理の詳細',
  Cargo_CreditControlSettings: '信管設定',
  Cargo_CreditLimitExceeded: '与信限度額が超過しました',
  Cargo_CreditLimitRange: '与信限度額の範囲',
  Cargo_CreditLocalCurrency: '貸方基本通貨',
  Cargo_CreditNotWrittenOff: 'creditが販売されていません',
  Cargo_CreditOriginalAmount: 'Credit元の金額',
  Cargo_CreditSide: '貸方',
  Cargo_CreditUsed: '使用限度額',
  Cargo_CreditWriteOffAmount: 'Creditの消込済金額',
  Cargo_CREVB5TM: 'C.輸出は毎月安定しています5TEU以内',
  Cargo_CRPI: '登録前払いを確定しますか？',
  Cargo_CSNPM: '送受信情報メンテナンス',
  Cargo_CSR: 'オペレータ',
  Cargo_CSRGTIDDDI: '現在のクエリの結菓は表示数より大きく、データが不完全に表示されています。',
  Cargo_CSWTCSTR: 'このお客様は契約を締結しました。このお客様を選択して更新できます',
  Cargo_CTMCWOPCCF: '確認された帳簿は修正できません。まず確認をキャンセルしてください。',
  Cargo_CTOPR: '前払い登録に移行しますか？',
  Cargo_CTORI: '振替決済を確定しますか？',
  Cargo_CTRCWOPCCF: '確認された帳簿は取り消すことができません。まず確認を取り消してください。',
  Cargo_CTRLSPFCC: '顧客バインディングの販売のリリースを確認しますか',
  Cargo_Cubage: '体積',
  Cargo_Currency: '通貨',
  Cargo_CurrencyCanTBeEmpty: '通貨は空にできません',
  Cargo_CurrencyFXRateNoMaintained: '通貨【{0}】の為替レートが維持されていません！',
  Cargo_CurrencyInconsistent: '通貨が一緻しません。',
  Cargo_CurrencyMaintenance: '通貨のメンテナンス',
  Cargo_CurrencyOfPayment: '支払通貨',
  Cargo_CurrencyOfTotal: '合計通貨',
  Cargo_CurrencyP: '通貨: ',
  Cargo_CurrentClientIsContracted: '現在の顧客が署名しました',
  Cargo_CurrentExchangeRate: '現在の為替レート',
  Cargo_CurrentLoginUser: '現在のログインユーザー',
  Cargo_CurrentMonth: '現在の月',
  Cargo_CurrentSelected: '現在選択中',
  Cargo_Reefer: 'Reefer',
  Cargo_ShowCharacteristics: 'Show characteristics check box',
  Cargo_ShowCharacteristicsTip: 'When select current Cargo Type,show “Electric” “Magnetic” “Powder” “Liquid” check box in order basic page.',
  Electric: 'Electric',
  Magnetic: 'Magnetic',
  Powder: 'Powder',
  Liquid: 'Liquid',
  Cargo_CurrentSelectedExpense: '現在選択されている費用{0}',
  Cargo_CurrentSelectedSobIs: '現在選択されている帳簿は: {0}',
  Cargo_CurrentSettlingParty: '現在の決算対象',
  Cargo_CurrentWriteOffSerialNoCompleted: '今回の帳消しの通し番号は{0}で、帳消しは成功しました。',
  Cargo_CurrentYearAccumulatedAmount: '当年累計金額',
  Cargo_CurrentYearProfitAccount: '当年度の利益勘定',
  Cargo_CurrentYearProfitAccountP: '当年度の利益勘定: ',
  Cargo_CurrentYearTotal: 'この年の累計',
  Cargo_CurrentYearTotalAmout: '当年累計発生額',
  Cargo_CurrentYearTotalAmoutCreditCNY: '当年累計発生額貸方（人民元）',
  Cargo_CurrentYearTotalAmoutCreditUSD: '当年累計発生額貸方（米ドル）',
  Cargo_CurrentYearTotalAmoutDebitCNY: '本年累計発生額借方（人民元）',
  Cargo_CurrentYearTotalAmoutDebitUSD: '当年累計発生額借方（米ドル）',
  Cargo_CursorPointedInvoiceNo: 'カーソル位置の請求書番号',
  Cargo_Customer: 'お客様',
  Cargo_CustomerAddress: '顧客アドレス',
  Cargo_CustomerHasConfirm: '{0}番号、お客様が確認しました。',
  Cargo_CustomerLevel: '顧客ランク',
  Cargo_CustomerName: '顧客名',
  Cargo_CustomerP: '顧客: ',
  Cargo_CustomerProperty: '顧客の属性',
  Cargo_CustomerReferenceNumber: '顧客参照番号',
  Cargo_CustomerSelfRelease: 'お客様は自分で注文します',
  Cargo_CustomerService: 'カスタマーサービス担当',
  Cargo_CustomerSpace2: '指定品',
  Cargo_CustomerSpace3: 'カスタム',
  Cargo_CustomerType: '顧客種別',
  Cargo_Customized: 'カスタム',
  Cargo_CustomizedField1: '備考欄１',
  Cargo_CustomizedField2: '備考欄②',
  Cargo_CustomizedField3: '備考欄③',
  Cargo_CustomizedField4: '備考欄４',
  Cargo_CustomJobType: 'カスタム取引タイプ ',
  Cargo_CustomJobTypeP: 'カスタム取引タイプ ',
  Cargo_CustomsApproval: '税関承認',
  Cargo_CustomsBroker: '通関業者名／通関担当者',
  Cargo_CustomsBrokerFilter: '通関行フィルタ',
  Cargo_CustomsDeclaration: '通関',
  Cargo_CustomsDeclarationSearchFailed: '通関情報のクエリに失敗しました: ',
  Cargo_CustomsNo: '税関番号',
  Cargo_CWOIFCTTTEPRCOEA: '回収はすべて消し込まれたので、これ以上費用に振り込むことはできません。別の回収または費用の申請をしてください。',
  Cargo_CYCutOffDate: '締切日',
  Cargo_CYSPATIPLVCTBE: '損益計算書の当年度利益勘定は空にできません',
  Cargo_CYWRYTTPPATDWBMTRS: '【はい】をクリックすると印刷ページに移動し、ドキュメントの処理状況を【返却済み】に変更します',
  Cargo_CYWRYTTPPATRDWBCTRS: '【はい】をクリックすると印刷ページに移動し、取得したドキュメントは【返却済み】状態に変更されます',
  Cargo_DAIIUCTBD: '【差額調整】は業務で使用されているため削除できません',
  Cargo_DAIOCPCNY: '当期発生額借方（人民元）',
  Cargo_DAIOCPUSD: '当期発生額借方（米ドル）',
  Cargo_DataExport: 'エクスポート',
  Cargo_DataExportPDF: 'PDFのエクスポート',
  Cargo_DataSent: '送信済みデータ',
  Cargo_DataTransmissionStatus: 'データ送信状態',
  Cargo_DataType: 'データ型',
  Cargo_DataTypeP: 'データ型: ',
  Cargo_Date: '日付',
  Cargo_DateCanTBeEmpty: '日付は空にできません',
  Cargo_DateFrom: '開始日',
  Cargo_DateFunction: '日付関数',
  Cargo_DateNotInPeriod: '日付が期間内にありません',
  Cargo_DateOfApplication: '申請日',
  Cargo_DateOfCollectionCanTBeEmpty: '入金日は空にできません。',
  Cargo_DateOfDeclaration: '申告日',
  Cargo_DateOfDepartureCannotBeNull: '出発日は空にできません',
  Cargo_DateOfDocument: '作成日',
  Cargo_DateOfInvoicingList: '請求書の日付',
  Cargo_DateP: '日付: ',
  Cargo_DateType: '日付タイプ',
  Cargo_DateType2: '日付タイプ2',
  Cargo_Days: '日',
  Cargo_DaysFromContractSigned: 'サイン日数',
  Cargo_DaysOfSleep: '眠る日数',
  Cargo_DaysOverdue: '期限切れ日数',
  Cargo_DaysToContractExpiry: '期限切れまでの日数',
  Cargo_DBASBEICS: '現金を選択した場合、銀行口座はデフォルトで空にする必要があります',
  Cargo_Deadline: '締切日',
  Cargo_TempCredit: '一時的な信用管理',
  Cargo_EtdDays: '出発予定日数',
  Cargo_EtdExceedsDays: 'ETDが{0}日を超過しているため、番号を発行できません。',
  Cargo_EtdExceedsDaysOrder: 'ETDが{0}日を超過しているため、書類（B/L）をリリースできません。',
  Cargo_ShippingDocumentsNotBeReleased: '未払い運賃が清算されるまで、船積書類は引き渡されません。',
  Cargo_SpecialFeePaymentLimit: '専門費用支払い申請の制限',
  Cargo_PaymentOnlySpecificCosts: '専門費用の支払い申請には、当該専門費用のみを記載し、他の費用を含めてはなりません。',
  Cargo_ThePaymentNotSettled: '{0}月分の支払いが未清算です。',
  Cargo_UnconfirmedSum: '{0}+{1}+{2}+{3} 未確認、先に確認してください！',
  Cargo_SpecialApproval2: '特別承認',
  Application_Item: '申請事項',
  Application_Content: '申請内容',
  Application_Reason: '申請理由',
  Cargo_DomesticOverseas: '国内/海外',
  Cargo_IncludeOverseasWarehouse: '海外倉を含む',
  Cargo_SignContract2: '契約締結',
  Cargo_LatestContractDate: '最遅契約締結日',
  Cargo_CreditControlSelfAssessment: '与信管理自己評価表',
  Cargo_CustomerFile: '顧客ファイル',
  Cargo_CustomerConsignmentNote: '顧客託送状',
  Cargo_HasContract: '契約あり',
  Cargo_NoContract: '契約なし',
  Cargo_ContractStatus2: '契約の有無',
  Cargo_SupplierFile: 'サプライヤーファイル',
  Cargo_ApprovalSummary: '承認内容の概要',
  Cargo_AlreadyExistsCannotSubmit: '{0}はすでに存在します。申請を提出できません！',
  Action_AddAttachment: '添付ファイルを追加',
  Validation_ApplicationContentRequired: '申請内容は必須入力です。',
  Validation_ApplicationReasonRequired: '申請理由は必須入力です。',
  Cargo_AutoReceivablesWriteOff: '売掛金自動消込',
  Cargo_WhetherIgnore: '無視するかどうか',
  Cargo_TempCreditNotBeCross: '一時与信管理の有効期間は重複できません。',
  Cargo_TempCreditNotice: '注：一時与信管理の金額・口座期間は契約単位と同一（翌日から有効）となります。',
  Cargo_CurrentCreditNotice: '注: 現時点で条件を満たしているアカウント期間/限度額の場合、その日に維持されている一時的な与信管理は翌日パートナーに同期されます。',
  Cargo_CurrentAvailableNotEntered: '現在利用可能数が入力されていません',
  Cargo_Debit: '借ります',
  Cargo_DebitAmount: 'Debit金額',
  Cargo_DebitAmount2: '借方金額',
  Cargo_DebitAmountCNY: '借方金額（人民元）',
  Cargo_DebitAmountOccurred: '発生額の借方記帳',
  Cargo_DebitAmountOccurredCNY: '借方発生額（人民元）',
  Cargo_DebitAmountOccurredP: '発生金額の借方記帳: ',
  Cargo_DebitAmountOccurredUSD: '発生額の借方（米ドル）',
  Cargo_DebitAmountTo: 'Debit合計',
  Cargo_DebitAmountToP: 'Debit合計: ',
  Cargo_DebitAmountUSD: '借方金額（米ドル）',
  Cargo_DebitLocalCurrency: '借方基本通貨',
  Cargo_DebitNotWrittenOff: 'Debitは販売されていません',
  Cargo_DebitOriginalAmount: 'Debit元の金額',
  Cargo_DebitSide: '借方',
  Cargo_DebitSideCNY: '借方（人民元）',
  Cargo_DebitSideCreditSide: '借方/貸方',
  Cargo_DebitSideCreditSideP: '借方/貸方: ',
  Cargo_DebitSideUSD: '借方（米ドル）',
  Cargo_DebitWriteOffAmount: 'Debit消込済金額',
  Cargo_December: '12月',
  Cargo_DeclareWarehouseLoadingContainer: 'コンテナに梱包されたコンテナを通関するかどうか',
  Cargo_DeemedPrinted: '印刷とみなす',
  Cargo_VGMLog: 'VGMログ',
  Cargo_SendVGM: '送信VGM',
  Cargo_VGMChannel: 'VGMチャネル',
  Cargo_VGMBasicInfo: 'VGM基本情報',
  Cargo_FriendlyReminder: 'お知らせ: 追加するにはメイン番号を記入してください',
  Cargo_VGMCutOffDate: 'VGMの切り捨て日',
  Cargo_ContainerHolder: 'コンテナ所有者',
  Cargo_NotFilledIn: '未記入です。記入が完了したら送信してください。',
  Cargo_NotSelected: '選択されていません。記入が完了したら送信してください。',
  Cargo_PleaseMaintainCargoInfo: 'コンテナ情報を維持してください',
  Cargo_IfYouHaveSentPreStowageManifest: '海管家通路を通じてプロビジョニングハッチを送信した場合、プロビジョニング情報タブから情報を同期します；',
  Cargo_IfYouHaveNotSentPreStowageManifest: '海管家通路を通じてプロビジョニングハッチを送信しない場合、基本、予約ハッチから情報を同期します。',
  Cargo_FriendlyReminderWithPort: 'お知らせ: 上海港では、事前入力が完了してからVGM情報を送信することをお勧めします。はしけは大きな船を迎え、はしけの時間を基準にしています',
  Cargo_TerminalInfoForReferenceOnly: '埠頭の情報は参考にして、具体的には船室の予約を基準にしてください！',
  Cargo_TerminalInfoForReferenceWse: '船口埠頭の情報が私たちの参考埠頭の情報と合わない場合は、カスタマーサービスに連絡してください。ありがとうございます！',
  Cargo_IfBookingPortTerminalInfoDoesNotMatchPleaseContactCustomerService: '注文したハッチの埠頭情報が私たちの参考埠頭情報と一緻しない場合は、カスタマーサービスに連絡してください。',
  Cargo_FriendlyReminderWithCutOffTime: 'お知らせ: 正しい締め切り時間を記入してください。この日付に基づいて何度も送信します。情報の誤りによる遅延料金は、プラットフォームが負担しません。',
  Cargo_TheShipperDeclares: '本託送人声明: この書類資料に含まれる貨物コンテナの重量情報は「1974年国際海上人命安全条約」に記載された方法によって取得され、重点の計量器は計量技術機構が発行した計量検定証明書を取得した。重量を取得した日付は証明書の有効範囲内です。',
  Cargo_RepeatedlySendingVGMWithTheSameContainerTips: '同じボックス番号でVGMを繰り返し送信すると複数回課金されます。再送信する場合は{0}S後に送信してください。',
  Cargo_Send_VGM_Reminder: 'ボックス番号ごとにVGMを送信すると料金が引き落とされ、同じボックス番号を何度も送信すると料金が引き落とされます。VGM情報を修正するには、修正したボックスのVGM情報を送信するだけです。送信を続行するか確認してください？',
  Cargo_ContinueSending: '送信を続行します',
  Cargo_ResendAfterS: 's後に再送信',
  Cargo_ShippingCompanyReceiptStatus: '船会社入荷処理状況',
  Cargo_DeparturePortFieldNotFoundMatchingInfoWithSeaButlerPleaseCheck: '出荷港フィールドに海管家と一緻する情報が見つかりません。チェックしてください。',
  Cargo_ShippingCompanyFieldNotFoundMatchingInfoWithSeaButlerPleaseCheck: '船会社フィールドに海管家と一緻する情報が見つかりません。チェックしてください。',
  Cargo_CharLengthWithRange: '長さは{0}~{1}文字',
  Cargo_TheBoxNumberMustBe: '箱番号は4桁のアルファベット+7桁の数字でなければなりません',
  Cargo_LoadWharfTips: '埠頭の情報は参考にして、具体的には船室の予約を基準にしてください！もし注文したハッチの埠頭の情報が私たちの参考埠頭の情報と一緻しない場合は、カスタマーサービスに連絡してください。ありがとうございます。',
  Cargo_WhetherToContinueSendingVGM: 'VGMの送信を続行しますか？',
  Cargo_Default: 'デフォルト',
  Cargo_DefaultAPUnitPrice: 'デフォルトの単価',
  Cargo_DefaultARCurrency: 'デフォルト受取通貨',
  Cargo_DefaultAPCurrency: 'デフォルトの支払通貨',
  Cargo_DefaultARUnitPrice: 'デフォルト売掛単価',
  Cargo_DefaultDecimalPlaces: 'デフォルトの小数点以下の桁数',
  Cargo_DefaultLine: 'デフォルト行',
  Cargo_DefaultMenuItems: 'デフォルトのメニュー項目',
  Cargo_DefaultOrNot: 'デフォルトかどうか',
  Cargo_DefaultPayee: 'デフォルトの支払対象',
  Cargo_DefaultPayer: 'デフォルト受取人',
  Cargo_DefaultSearchCondition: 'デフォルトの検索条件',
  Cargo_DefaultValue: 'デフォルト値',
  Cargo_SeDefaultValue: '海のデフォルト値',
  Cargo_SiDefaultValue: '海進デフォルト値',
  Cargo_AeDfaultValue: 'デフォルト値を空ける',
  Cargo_AiDfaultValue: 'デフォルト値を空にする',
  Cargo_ReDfaultValue: '鉄のデフォルト値',
  Cargo_RiDfaultValue: '鉄進デフォルト値',
  Cargo_EditDefaultValue: 'デフォルト値の編集',
  Cargo_EditJobDefaultValueTip: `取引タイプ ごとにデフォルト値が異なる場合は、対応する取引タイプ テキストボックスで維持してください；
取引タイプ のテキストボックスとデフォルト値の両方に値がある場合は、取引タイプ に応じて対応する取引タイプ のテキストボックスの値を優先します；`,
  Cargo_DefaultWriteOffCurrency: 'デフォルトの売上通貨',
  Cargo_DelayedTaxRefund: '遅延税還付です',
  Cargo_DelegationTypeRailway: '委託タイプ（鉄道）',
  Cargo_Delete: '削除',
  Cargo_DeleteConfirmation: '選択したレコードを削除してもよろしいですか？',
  Cargo_DeleteBill: '請求書の削除',
  Cargo_DisplayRules: '表示ルール',
  Cargo_ViewAttachments: '添付ファイルの表示',
  Cargo_DeleteCollectionRecord: '回収登録の削除',
  Cargo_DeletedBillList: '請求書リストが削除されました',
  Cargo_DeletedSuccessfully: '削除に成功しました。',
  Cargo_WithdrawSuccessfully: '取り消しに成功しました。',
  Cargo_DeletedNotHavePermission: 'この見積書を削除する権限がありません。',
  Cargo_DeletedNotIntoBusiness: '見積書は業務の費用に持ち込まれたので、削除できません！',
  Cargo_DeleteEntry: 'エントリの削除',
  Cargo_DeleteFailed: '削除に失敗しました。',
  Cargo_DeleteFee: '料金の削除',
  Cargo_DeleteFeeConfirmedListSync: '料金確認票も削除します',
  Cargo_DeleteInvoice: '請求書の削除',
  Cargo_DeleteNotification: '削除のヒント',
  Cargo_DeleteOrNot: '削除しますか？',
  Cargo_DeleteVoucher: '資格証明の削除',
  Cargo_Delivered: '送信済み',
  Cargo_DeliveredButNotRetrieved: '送信済み（未回収）',
  Cargo_DeliveredSuccessfully: '送信に成功しました。',
  Cargo_DeliveredToBranch: '会社に送信するかどうか',
  Cargo_DeliverPartial: '部分送信するかどうか',
  Cargo_DeliverySigned: '受領確認済み',
  Cargo_DenialReason: '拒否理由',
  Cargo_DenialReasonP: '拒否理由: ',
  Cargo_Denied: '拒否されました',
  Cargo_DeniedSuccessfully: '拒否されました。',
  Cargo_DenyApplication: '申請を拒否します',
  Cargo_DenyPaymentApplication: '支払要求を拒否します',
  Cargo_Department: '部門',
  Cargo_DepartmentApproval: '部門承認',
  Cargo_DepartmentP: '部門: ',
  Cargo_DepartureTime: '出航時間',
  Cargo_DepositBank: '口座開設銀行',
  Cargo_DepositBankAccountNo: '口座開設銀行口座番号',
  Cargo_DepositBankAndAccountNo: '口座開設銀行および口座番号',
  Cargo_DepositBankAndAccountNoP: '口座開設銀行と口座番号: ',
  Cargo_DesCharge: '目的地の料金',
  Cargo_DescriptionCanTBeEmpty: 'コンテンツの説明は空にできません',
  Cargo_DescriptionOfCharge: '有料コンテンツ',
  Cargo_DescriptionOfExpenseItem: '費用項目名',
  Cargo_DescriptionOfExpenseItemCNY: 'CNY費用項目名',
  Cargo_DescriptionOfExpenseItemUSD: 'USDの費用項目名',
  Cargo_DescriptionOfExpenseItemJPY: 'JPYの費用項目名',
  Cargo_DescriptionOfExpenseItemEUR: 'EURの費用項目名',
  Cargo_DescriptionOfPlan: 'プラン説明',
  Cargo_DescriptionOfQuantity: '数量の内容',
  Cargo_DescriptionOfVoucherType: '買掛伝票タイプの説明',
  Cargo_DesignatedDepartment: '部門を指定します',
  Cargo_DesignSubTitlesOfAccount: 'デザイン補助科目',
  Cargo_Destination: '目的地',
  Cargo_ChargeItemMaintenance: 'チャージ品目メンテナンス',
  Cargo_ZeroTaxRate: '税率がゼロかどうか',
  Cargo_DestinationAgent: '仕向代理店',
  Cargo_DestinationAgent1: '海外エージェント',
  Cargo_DestinationChargeOrNot: '目的地料金かどうか',
  Cargo_DestinationPort: '到着港',
  Cargo_DestinationPortSea: '目的港（海運）',
  Cargo_DestinationPortAir: '目的港（空輸）',
  Cargo_OverseaWarehouse: '海外倉庫',
  Cargo_NoRestriction: '制限なし',
  Cargo_Details: '詳細',
  Cargo_DetailsOfOutOfPocketRecord: '実払い登録明細',
  Cargo_DetailsOfSingleWriteOff: '売上勘定の明細',
  Cargo_DetailsOfSingleWriteOffPDF: '売上明細.pdf',
  Cargo_DetailsOfSingleWriteOffXLS: '売上明細.xls',
  Cargo_DevelopedAtExhibitions: '展示会開発',
  Cargo_Difference: '差額',
  Cargo_DifferenceAdjustment: '差額調整',
  Cargo_DifferenceCNYCNY: '差額CNY',
  Cargo_DifferenceUSD: '差額USD',
  Cargo_DifferentialAdjustedSuccessfully: '差額調整が成功しました',
  Cargo_DifferentialIs: '差額は: {0}',
  Cargo_DifferentialProcessing: '差額処理',
  Cargo_DifficultyIndex: '攻略難易度指数',
  Cargo_DIITRLNLTSIT: '右側のリスト表示は選択した請求書タイプに関連付けられていません',
  Cargo_DirectAssign: '直接割り当て',
  Cargo_DirectBusiness: 'ダイレクトビジネス',
  Cargo_DirectConsol: '自分で箱詰めする',
  Cargo_DirectConsolContainerNo: '自動箱詰めボックス番号',
  Cargo_Direction: '方向',
  Cargo_DirectServiceOrNot: 'スルーするかどうか',
  Cargo_DiscrepancyExist: '差異あり',
  Cargo_DiscrepancyFound: '異なるものがあります',
  Cargo_DisplayAmountOfDifferential: '差額を表示するかどうか',
  Cargo_DisplayAmountOfReconciliation: '消込済金額を表示するかどうか',
  Cargo_DisplayBatchOperation: '一括操作内容を表示するかどうか',
  Cargo_DisplayCashFlowItems: 'キャッシュフロー項目かどうか',
  Cargo_DisplayExpenseDetails: '費用の詳細を表示するかどうか',
  Cargo_DisplayMonthSelector: '月セレクタを表示するかどうか',
  Cargo_DisplayOrder: '表示順序',
  Cargo_DisplayTotalCost: '合計コストを表示するかどうか',
  Cargo_DisplayTotalIncome: '総収入を表示するかどうか',
  Cargo_DisplayUnCodedRecordsOnly: 'コードが空の場合のみ',
  Cargo_DisplayUnInvoicedAmount: '未請求金額を表示するかどうか',
  Cargo_DistributedReconciliationAmount: '消込済金額の配賦',
  Cargo_DistributionCostOrNot: '費用を配賦しますか',
  Cargo_District: 'ゾーン',
  Cargo_DLCCLCCTBE: '借方基本通貨/貸方基本通貨は空にできません。',
  Cargo_DMROITE: '請求書タイプ{0}に重複するレコードがあります',
  Cargo_DNBTCBOHC: '操作しているデータの支社は現在の支社または1つ上の支社に属していません。続行しますか？',
  Cargo_DORMBGTTDOR: '返却日は回収日より大きくなければなりません。',
  Cargo_InvoiceNature: '税率ID',
  Cargo_InvoiceNatureTip: '税率は通常としてマークされている場合にのみ調整できます',
  Cargo_DOCOTS: '貨物または課税役務名',
  Cargo_DocReleaseAgainstPayment: '請求書を支払うかどうか',
  Cargo_DocumentationType: 'ドキュメントタイプ',
  Cargo_DocumentCirculation: 'ドキュメントの流れ',
  Cargo_Documents: '関連書類',
  Cargo_DOEICTBE: '経費項目名は空にできません',
  Cargo_Domestic: '国内',
  Cargo_DomesticBill: '国内請求書',
  Cargo_DomesticChargeInformation: '国内の料金状況',
  Cargo_DomesticCollection: '国内入金',
  Cargo_DomesticDirectClient: '国内直客',
  Cargo_DomesticDirectClientOrNot: '国内直客かどうか',
  Cargo_DomesticOrInternational: '国内/国外',
  Cargo_DomesticPayment: '国内支払',
  Cargo_DomesticTrade: '国内貿易',
  Cargo_DoNotSelectMultipleItems: '複数選択しないでください',
  Cargo_Door: 'ドアポイント',
  Cargo_DoorAddress: 'ゲートアドレス',
  Cargo_DoorLoadingDelivery: 'ドアポイント梱包/集荷',
  Cargo_DoorPickup: 'ドアポイント集荷',
  Cargo_DOPNCTBLTAC: '正の差額は1銭未満にできません。',
  Cargo_DoubleClickToView: 'ダブルクリックして表示',
  Cargo_DownloadCompleted: 'ダウンロードに成功しました！',
  Cargo_DownloadFailed: 'ダウンロードに失敗しました！',
  Cargo_DrawABillOrNot: 'すべての請求書を発行するか',
  Cargo_DRIRORIOCA: '受取配当金受取利息その他売掛金在庫その他流動資産',
  Cargo_DSAIM: '決済方法と請求方法を表示するかどうか',
  Cargo_DSCSDSCS: '借方貸方借方貸方',
  Cargo_Dues: '相殺',
  Cargo_DuesB: '（対応）',
  Cargo_DuesToCNY: 'CNY対応：',
  Cargo_EquivalentCNY: 'CNY換算控除金額：',
  Cargo_DuesCNY: 'CNY対応',
  Cargo_DuesEUR: 'EURで支払う',
  Cargo_DuesGBP: 'GBP対処',
  Cargo_DuesHKD: 'HKD対処',
  Cargo_DuesJPY: 'JPY対応',
  Cargo_DuesNGN: 'NGN対応',
  Cargo_DuesP: '対処: ',
  Cargo_DuesUSD: 'USDで支払う',
  Cargo_DuplicateCodePleaseTryItAgain: 'コードが重複しています。再入力してください。',
  Cargo_DuplicateContent: '内容をコピーします',
  Cargo_DutyFree: '免税',
  Cargo_Uncertain: '確かではありません',
  Cargo_DynamicCurrencyDisplayColumn: '通貨列を動的に表示',
  Cargo_ECDICA: '中央の表示をクリアします',
  Cargo_ECNETSFS: 'コード名などのキャリッジリターンあいまい検索を入力してください',
  Cargo_ECSNMIR: '費用確認処理状況が請求要件を満たしていません',
  Cargo_ECSNMPAR: '費用確認処理状況が支払要求を満たしていません',
  Cargo_ECSNMWOR: '費用確認処理状況が帳消し要件を満たしていません',
  Cargo_EdiCode: 'EDIコード',
  Cargo_EdiInterfaceTypeOfEInvocing: '外部電子請求インタフェースタイプ',
  Cargo_EdiInterfaceTypeOfInvoicing: '外部請求インタフェースタイプ',
  Cargo_Edit: '編集',
  Cargo_EditAdjustment: '調整の修正',
  Cargo_EditAirFreightServiceItems: '航空運賃サービス項目の編集',
  Cargo_EditAssociatedPort: '関連ポートの編集',
  Cargo_EditAwbSurcharge: '航空運送状の雑費の編集',
  Cargo_EditBill: '請求書の編集',
  Cargo_EditBLType: '船荷証券タイプの編集',
  Cargo_EditChargeFinancialDate: '費用会計処理日の変更',
  Cargo_EditCirculationDocumentType: 'ストリームファイルタイプの編集',
  Cargo_CirculationDocumentType: 'ストリームファイルタイプ',
  Cargo_EditClientType: '顧客タイプの編集',
  Cargo_EditCommissionRules: '歩合給ルールの編集',
  Cargo_EditContract: '契約の編集',
  Cargo_EditCustomizedServiceType: 'カスタム取引タイプ の編集',
  Cargo_EditedSuccessfully: '変更に成功しました。',
  Cargo_EditField: '編集フィールド',
  Cargo_EditFinancialDate: '会計処理日の変更',
  Cargo_EditFormula: '式の編集-',
  Cargo_EditKeyWord: 'デリケートな単語の編集',
  Cargo_EditMscService: 'MSCServiceの編集',
  Cargo_EditOppositeVoucherNo: '相手の買掛伝票番号を変更します',
  Cargo_EditOrNot: '編集するかどうか',
  Cargo_EditRemarks: 'コメントの変更',
  Cargo_EditRoute: 'ルートの編集',
  Cargo_EDTTTC: '預入費用明細に繰り越すことができます',
  Cargo_EDTTTCP: '預入費用明細への転入: ',
  Cargo_EffectiveDate: '有効開始日',
  Cargo_EffectiveMonth: '有効月',
  Cargo_EICCMBU: '\'列Column\'CURRENCYの入力値CURRENCYは一意性製約違反',
  Cargo_EINDWI: '請求書番号を直接入力するかどうか',
  Cargo_EInvoiceCanTBePrinted: '電子請求書は印刷できません。',
  Cargo_EInvoiceCanTBeVoided: '電子請求書は無効にできません。',
  Cargo_EInvoicePaperInvoice: '電子請求書紙請求書',
  Cargo_EmailAddress: 'メール',
  Cargo_EMailAlertForTestOnly: 'メールアラート（テスト専用）',
  Cargo_EmailSent: 'メッセージが送信されました。',
  Cargo_Empty: '空にする',
  Cargo_EmptyData: 'データを空にする',
  Cargo_EmptyEntries: '入力を空にする',
  Cargo_EmptyOriginalCurrency: '元の通貨をクリアします',
  Cargo_EMSSCM: 'メールが送信されました。ご査収ください',
  Cargo_EndDate: '締め切り日',
  Cargo_EnglishCargoName: '英語品名',
  Cargo_EnglishCommodityNameMsc: '英語品名（MSC）',
  Cargo_EnglishName: '英語名',
  Cargo_EnglishNameCanTBeEmpty: '英語名は空にできません',
  Cargo_CannotDeleteUsedCustomerType: '使用されている顧客タイプの削除は許可されていません',
  Cargo_CannotDeleteUsedCustomerContactChannel: '使用された顧客連絡チャネルの削除は許可されません',
  Cargo_Enter: '入力します',
  Cargo_EnterBusinessTypeToStartSearch: '取引タイプ クエリを入力してください',
  Cargo_EnterExpenseName: '費用名を入力',
  Cargo_EnterInvoiceNo: '請求書番号の入力',
  Cargo_EnterInvoiceNoDirectly: '請求書番号を直接入力するかどうか',
  Cargo_EnterKeyWordsToStartFuzzySearch: 'あいまい検索のために敏感な単語を入力してください',
  Cargo_EnterManually: '手動入力',
  Cargo_EnterSpecialInvoiceNo: '専用請求書番号入力',
  Cargo_EnterVoucherInformation: '資格情報の入力',
  Cargo_Entity: 'エンティティ',
  Cargo_EntryDate: '入力日',
  Cargo_EntryOfNumber: '番号の入力',
  Cargo_EqualTo: '等しい',
  Cargo_Error: 'エラーになりました。',
  Cargo_ErrorNoDataFound: 'エラーが発生しました。データがありません。',
  Cargo_ESNMIR: '費用処理状況が請求要件を満たしていません',
  Cargo_ESNMPAR: 'チャージ処理状況が支払要求条件を満たしていません',
  Cargo_ESNMWOR: '費用の処理状況が償却の要件を満たしていません',
  Cargo_EstTimeOfWarehouseIn: '予想入庫時間',
  Cargo_EventOfSettlingParty: '決済対象イベント',
  Cargo_EventRecord: 'イベントレコード',
  Cargo_EventTime: 'イベント時間',
  Cargo_EverCancelledWriteOff: 'キャンセル操作が行われたかどうか',
  Cargo_ExcelExport: 'Excelをエクスポート',
  Cargo_ExcessiveOrNot: ' 超過の有無',
  Cargo_ExchangeCode: '交換コード',
  Cargo_ExchangeCodeCanTBeEmpty: '交換コードは空にできません',
  Cargo_ExchangeCurrency: '通貨の換算',
  Cargo_ExchangeGainsAndLosses: '為替差損益',
  Cargo_ExchangeRate: '為替レート',
  Cargo_ExchangeRateAdjustmentTable: '為替レート調整テーブル',
  Cargo_ExchangeRateAdjustmentTableP: '為替レート調整テーブル: ',
  Cargo_ExchangeRateCanTBeEmpty: '為替レートは空にできません',
  Cargo_ExchangeRateDifference: '為替差',
  Cargo_ExchangeRateHKD: 'HKDレート',
  Cargo_ExchangeRateList: '為替レートリスト',
  Cargo_ExchangeRateOfHKD: '香港ドル為替レート',
  Cargo_ExchangeRateP: '為替レート: ',
  Cargo_ExchangeRateUSD: 'USD為替レート',
  Cargo_ExclusionFilter: '除外フィルタ',
  Cargo_ExecutionMethodOfWindowClosure: 'ウィンドウを閉じてメソッドを実行',
  Cargo_Existed: 'すでに存在します。',
  Cargo_ExpectedReviewDate: 'レビュー予定日',
  Cargo_Expenditure: '支出',
  Cargo_ExpenseAdjustment: '費用調整',
  Cargo_ExpenseAdjustmentOfCollection: '受託調整費用',
  Cargo_ExpenseApprovalProcedure: '費用承認プロセス',
  Cargo_ExpenseDescriptionCanTBeEmpty: '費用名は空にできません。',
  Cargo_ExpenseItemsCanTBeEmpty: '請求書内の費用は空にできません。',
  Cargo_ExpenseListNonEntity: '費用リスト非エンティティ',
  Cargo_ExpenseNotSelected: '費用が選択されていません。',
  Cargo_ExpenseRejectedSuccessfully: '費用却下成功',
  Cargo_ExpenseRelated: '費用に対応する',
  Cargo_ExpenseReviewedBy: '費用レビュー担当者',
  Cargo_ExpenseSearch: '費用照会',
  Cargo_ExpenseSelection: '費用の選択',
  Cargo_ExpenseSettlingParty: '経費精算対象',
  Cargo_ExpenseWriteOffCanTBeEmpty: '経費は空にできません。',
  Cargo_ExpenseWrittenOffCanTBeSplit: '費用はすでに計上されているので、分割できません！',
  Cargo_ExpiryDateCanTBeEmpty: '有効期限は空にできません',
  Cargo_Export: 'エクスポート',
  Cargo_ExportBaiwangInvoice: '百旺請求書エクスポート',
  Cargo_ExportClientSuccessfully: 'クライアントのエクスポートに成功しました',
  Cargo_ExportedSuccessfully: 'エクスポートは成功しました。',
  Cargo_ExportExcel: 'EXCLEエクスポート',
  Cargo_ExportExpenses: '費用エクスポート',
  Cargo_ExportFailed: 'エクスポートに失敗しました。',
  Cargo_ExportOrNot: 'エクスポートするかどうか',
  Cargo_ExportRecordsSuccessfully: 'レコードのエクスポートに成功しました',
  Cargo_ExportRequired: 'エクスポートが必要です',
  Cargo_ExportResult: 'エクスポート結菓',
  Cargo_ExportSuccessfully: 'エクスポート完了、成功',
  Cargo_ExportVatInvoice: 'VAT請求書エクスポート',
  Cargo_ExportVatInvoiceXLS: 'VAT請求書エクスポート.xls',
  Cargo_ExportVoucher: '証明書のエクスポート',
  Cargo_ExportWriteOffDetails: '売上明細のエクスポート',
  Cargo_ExpressAddress: '宅配便の住所',
  Cargo_ExpressInfo: 'エクスプレス情報',
  Cargo_Extend: '順延するかどうか',
  Cargo_ExtendPeriod: '期間の延長',
  Cargo_ExtensionAfterExpiration: '期限切れ後に順延',
  Cargo_ExtensionCycle: '順延サイクル',
  Cargo_External: '外部',
  Cargo_Fax: 'ファックス',
  Cargo_FCAEFAIIVWBIWBCCTV: '{0}個の領収書がすでに財務証明書を導出したことがあって、もし無効になったらシステムは赤い領収書を生成して、無効にすることを確認しますか？',
  Cargo_FCAOCAE: '元の通貨金額を計算する外貨計算があります',
  Cargo_FCASPSCT: '外貨計算が選択されています。計算する通貨を選択してください',
  Cargo_FCL: '箱全体',
  Cargo_SpecialSize: 'special size',
  Cargo_SpecialSizeTip: 'After checking, the packing information list can additionally display the "Size Specification (length * width * height unit M)" field.',
  Cargo_FclLclTypeSeaExport: '統合タイプ（海上輸出）',
  Cargo_FclLclTypeSeaImport: '統合タイプ（海上輸入）',
  Cargo_EstimatedArrivalTimeSeaExport: '出港予定時間（海上輸出）',
  Cargo_EstimatedArrivalTimeSeaImport: '到港予定時間（海上輸入）',
  Cargo_EstimatedArrivalTimeAirExport: '到着予定時間（航空輸出）',
  Cargo_FDMOPPE0: '毎月の指定日、または会計期間が0より大きい',
  Cargo_February: '2月',
  Cargo_FeederOrNot: 'バージするかどうか',
  Cargo_FIAICTR: '以下の請求書はすでに請求されているので、取り消すことはできません！',
  Cargo_FIDSEC: '異なる決済単位の費用を選択しました。連結を続行しますか？',
  Cargo_FileApplication: '申請します',
  Cargo_FileDocumentation: 'ファイル資料',
  Cargo_FileFormat: 'ファイル形式',
  Cargo_FileHistory: 'ファイル履歴',
  Cargo_FileLoadingFailed: 'ファイルのロードに失敗しました',
  Cargo_FileName: 'ファイル名',
  Cargo_FileNo: '文書番号',
  Cargo_FileNotFoundInCloud: 'クラウドストレージでこのファイルが見つかりません',
  Cargo_FileRetrievedSuccessfully: 'ファイルの取得に成功しました。',
  Cargo_FileSize: 'ファイルサイズ',
  Cargo_FileStatus: 'ファイルの状態',
  Cargo_FileType: 'ファイルタイプ',
  Cargo_FileTypeDescription: 'ファイルタイプ名',
  Cargo_Filter: 'フィルタ',
  Cargo_FilterP: 'フィルタ: ',
  Cargo_FinalDestination: '最終目的地',
  Cargo_FinancialApprovalDate: '財務承認日',
  Cargo_FinancialApproved: '財務承認済み',
  Cargo_FinancialAudit: '財務監査',
  Cargo_FinancialAuditDetail: '財務監査-詳細',
  Cargo_FinancialChangeReview: '財務変更レビュー',
  Cargo_FinancialCharges: 'ファイナンスチャージ',
  Cargo_FinancialCode: '財務コード',
  Cargo_FinancialDate: '会計処理日',
  Cargo_FinancialExpenseIs: 'ファイナンスチャージは: ',
  Cargo_FinancialPeriod: '会計期間',
  Cargo_FinancialReceived: '実収',
  Cargo_FinancialRemarks: '財務コメント',
  Cargo_FinancialSoftware: '財務ソフトウェア',
  Cargo_FinasialCheck: '財務承認',
  Cargo_FindExistingCurrencies: '既存の通貨が見つかりました',
  Cargo_FirstAccruedProfit: '最初の歩合給利益',
  Cargo_FirstAccruedTime: '最初の計上時間',
  Cargo_FirstContactDate: '最初の接触日',
  Cargo_FiscalPeriod: '会計期間',
  Cargo_Fit: '個人のお客様',
  Cargo_FixedAccountingCode: '固定会計コード',
  Cargo_FixedDateMonthly: '毎月指定日',
  Cargo_FJTLCTW: '次の作業指示はロックされているため、キャンセルできません: ',
  Cargo_FLCLType: '混載種別',
  Cargo_FlightVoyage: 'フライト回数',
  Cargo_FollowingBillsInTheTextNotFound: 'テキスト内の次の請求書は見つかりませんでした: ',
  Cargo_ForAirBusiness: '空輸使用',
  Cargo_ForAirExportBusiness: '空輸輸出使用',
  Cargo_ForAirImportBusiness: '空輸輸入使用',
  Cargo_ForRailwayBusiness: '鉄道事業利用',
  Cargo_ForIntegratedJob: '総合物流使用',
  Cargo_ForFbaSeaBusiness: 'FBA海運使用',
  Cargo_ForFbaAirBusiness: 'FBA空輸使用',
  Cargo_ForFbaRailwayBusiness: 'FBA鉄道使用',
  Cargo_ForceDelete: '強製削除',
  Cargo_ForeignCurrency: '外貨',
  Cargo_ForeignCurrencyAccounting: '外貨会計',
  Cargo_ForeignCurrencyAccountingExist: '外貨会計があります',
  Cargo_ForeignTrade: '対外貿易',
  Cargo_Format: 'フォーマット',
  Cargo_FormLayout: 'フォームレイアウト',
  Cargo_FormVerification: 'フォームの検証',
  Cargo_ForOceanBusiness: '海上輸送の使用',
  Cargo_ForOtherBusiness: 'その他の業務使用',
  Cargo_ForRailwayExportBusiness: '鉄道輸出用',
  Cargo_ForSeaExportBusiness: '海上輸出の使用',
  Cargo_ForSeaImportBusiness: '海運輸入使用',
  Cargo_FreeDetension: 'キャビネットレンタル期間なし',
  Cargo_FreightForwardingFee: '貨物輸送代理費',
  Cargo_FristApprovalDate: '申請日',
  Cargo_From: 'から',
  Cargo_Frozen: 'フリーズしました',
  Cargo_FrozenSuccessfully: 'フリーズしました。',
  Cargo_FullPayment: 'すべての支払い',
  Cargo_FullScreenDisplay: 'フルスクリーン表示するかどうか',
  Cargo_Fumigation: '燻蒸',
  Cargo_FunctionOfSuccessfulAcquisition: '成功した関数の取得',
  Cargo_FVOCPIOOPRECTBV: '現在の実収実付記録はすでに財務証憑を導出したので、無効にすることはできません',
  Cargo_FVOVNP: '証憑【{0}】以下の検証に失敗しました: ',
  Cargo_GeneralInvoice: '通常の請求書',
  Cargo_GeneralLedger: '総勘定元帳',
  Cargo_GeneralLedger2: 'GL2',
  Cargo_GeneralRate: '通常価格',
  Cargo_GeneratedAccountStatement: '取引明細書が生成されたかどうか',
  Cargo_GeneratedBillsOrNot: '請求書が生成されたかどうか',
  Cargo_GetBack: '取り込み',
  Cargo_GoldenTaxationExportPrint: 'ゴールデン税エクスポート印刷',
  Cargo_GoOn: '続行します',
  Cargo_ARAP_Locked: '選択した業務は売掛・買掛ともにロックされているため、費用を追加できません。',
  Cargo_AR_Locked: '選択した業務は売掛がロックされているため、売掛費用を追加できません。',
  Cargo_AP_Locked: '選択した業務は買掛がロックされているため、買掛費用を追加できません。',
  Cargo_Only_AR: '現在のユーザーは売掛費用のみ追加可能です。',
  Cargo_Only_AP: '現在のユーザーは買掛費用のみ追加可能です。',
  Cargo_Cannot_Add_Charge: '現在のユーザーは費用を追加できません。',
  Cargo_ChargeLockStatusChanged: '業務の売掛・買掛ロック状態が更新されました。再度検索してから費用追加を行ってください。',
  Cargo_GrandTotal: '合計',
  Cargo_GrandTotalP: '合計: ',
  Cargo_GreaterThan: 'より大きい',
  Cargo_GroupCompany: 'グループ会社',
  Cargo_GroupExchangeRate: 'グループ為替レート',
  Cargo_GroupingConditions: 'グループ化の条件',
  Cargo_GroupingConditions1: 'グループ化条件1',
  Cargo_GroupingConditions2: 'グループ化条件2',
  Cargo_GroupingConditions3: 'グループ化条件3',
  Cargo_GroupingConditions4: 'グループ化条件4',
  Cargo_GroupingConditions5: 'グループ化条件5',
  Cargo_GroupingConditions6: 'グループ化条件6',
  Cargo_GroupingMethod: 'グループ化方法',
  Cargo_GroupingRulesOfJournalEntries: '入力グループ化ルール',
  Cargo_GroupingType: 'グループ化タイプ',
  Cargo_GroupingTypesOfJournalEntries: '入力グループ化タイプ',
  Cargo_GroupingTypesOfJournalEntriesP: '入力グループ化タイプ: ',
  Cargo_HalfMonthly: '半月決算',
  Cargo_Harbour: '港',
  Cargo_HaulageCompany: '運送会社',
  Cargo_HaveHas: 'あります',
  Cargo_HaveOrNot: 'あるかどうか',
  Cargo_HazmatContained: '危険物が含まれていますか',
  Cargo_HBLFreightTerm: '個別運送条件',
  Cargo_HBLMode: 'HB/L請求モード',
  Cargo_MBLMode: 'MB/L請求モード',
  Cargo_HBLTransitTerm: '個別運送条件',
  Cargo_HedgingInvoice: 'ヘッジ請求',
  Cargo_HideQuantity: '数量を隠す',
  Cargo_HoldCargoOrNot: '商品を差し押さえるかどうか',
  Cargo_HoldDoc: '差し押さえ',
  Cargo_SpecialApprovalOrder: 'Special approval order',
  Cargo_HoldSubmission: 'しばらく提出しない',
  Cargo_HqSWriteOffPendingConfirmation: '本部の消込要確認',
  Cargo_HsCode: 'HS番号',
  Cargo_IADBD: '請求申請日業務日',
  Cargo_IARS: '請求取消は成功しました。',
  Cargo_IBOCR: '入金レコードの残高不足: ',
  Cargo_ICDOOAABBD: '海空輸送要約データをデフォルトで初期化します',
  Cargo_IDVOCVDCCIATTC: 'カスタマイズされた証憑インタフェースバージョンを表示するインタフェースは、構成に応じてカスタマイズされたインタフェースを表示します',
  Cargo_Ignore: '無視します',
  Cargo_IgnoreP: '無視するかどうか',
  Cargo_IICS: '請求書情報が成功しました。',
  Cargo_IINMCTBE: '請求書品目名登録/変更は空にできません。',
  Cargo_Import: 'インポート',
  Cargo_ImportBankSlip: '水リストを導入します',
  Cargo_ImportExcel: 'Excelインポート',
  Cargo_INABNCTBBE: '請求書番号または業務番号の両方を空にすることはできません',
  Cargo_INCBMDON: '請求書番号を直接変更できますか',
  Cargo_IncludedToBusinessNo: '事業番号に計上',
  Cargo_IncludedToBusinessNoP: '計上ビジネス番号: ',
  Cargo_InclusiveExpense: '料金が含まれています',
  Cargo_InclusiveExpenseP: '費用を含む: ',
  Cargo_InclusiveOfAR: '売掛金を含むかどうか',
  Cargo_Income: '受信',
  Cargo_IncorrectWriteOffRecord: '帳簿記録が正しくありません',
  Cargo_IncoTerm: '取引条件',
  Cargo_IncreaseAdjustment: '調整を追加します',
  Cargo_IncrementValueDuty: '付加価値税',
  Cargo_ProductNameEn: '製品名（英語）',
  Cargo_ContainerNumber: 'コンテナ番号',
  Cargo_TotalDataCount: '合計{0}件のデータ',
  Cargo_PalletDetails: 'パレット明細',
  Cargo_PalletDimensions: 'パレットサイズ',
  Cargo_ShippingCompanyWebsite: '海運会社ウェブサイト',
  Cargo_OverseasWarehouseAddress: '海外倉庫住所',
  Cargo_Index: 'インデックス',
  Cargo_IndexCanTBeEmpty: '要約は空にできません',
  Cargo_IndexName: '要約名',
  Cargo_IndustrialTradingCompany: '工業貿易一体化会社',
  Cargo_INEPREIN: '請求書番号はすでに存在します。請求書番号を再入力してください',
  Cargo_Infomation: '情報',
  Cargo_InformationSentDate: '送信されたデータの日付',
  Cargo_InformationSentTime: '送信されたデータの時間',
  Cargo_InitialBalance: '勘定初期残高',
  Cargo_InitialBalanceImport: '初期残高のインポート',
  Cargo_InitializePageSwitching: 'ページ切り替えの初期化',
  Cargo_InitializingPleaseWait: '初期化中です。しばらくお待ちください...',
  Cargo_InitialPeriod: '初期期間',
  Cargo_InitialPeriodCannotBeEmpty: '初期期間は空にできません。',
  Cargo_InitialPeriodCanTBeEmpty: '初期期間年は空にできません。',
  Cargo_InitialPeriodOrNot: '初期期間かどうか',
  Cargo_InitialPeriodP: '初期期間: ',
  Cargo_InitiateContainerPickupRequest: 'スーツケースサービス要求の開始',
  Cargo_INNECTCW: '請求書番号が入力されていません。ウィンドウを閉じますか？',
  Cargo_INNECTP: '請求書番号が入力されていません。印刷を続行しますか？',
  Cargo_INNECTS: '請求書番号が入力されていません。保存しますか？',
  Cargo_InputBusinessNumber: 'ビジネス番号を入力してください',
  Cargo_InputTime: '入力時間',
  Cargo_InsertJournalEntry: 'エントリの挿入',
  Cargo_InsidePacking: '小さなパッケージ',
  Cargo_InsideQuantity: '小件数',
  Cargo_InstantMessengerQqWechatEtc: 'インスタントメッセンジャー（QQウィーチャットなど）',
  Cargo_InsufficientRecordBalance: '記録残高不足: ',
  Cargo_IntentionStage: '意向段階',
  Cargo_InterfaceScheme: 'インタフェーススキーム',
  Cargo_Internal: '内部',
  Cargo_InternalCode: '内部コード',
  Cargo_InternalInvoice: '内部請求書',
  Cargo_International: '海外',
  Cargo_InternationalBill: '海外請求書',
  Cargo_IntLFreight: '国際代理運賃',
  Cargo_IntLFreightForwardingServiceFee: '国際貨物代サービス料',
  Cargo_IntLOceanFreight: '国際代理海運費',
  Cargo_InUseByBusinessCanTBeDeleted: 'ビジネスで使用されているため削除できません',
  Cargo_Invalid: '無効にする',
  Cargo_InvalidDate: '有効終了日',
  Cargo_InvalidNavigation: '無効なナビゲーション',
  Cargo_InvalidOrNot: '無効かどうか',
  Cargo_InvalidParameter: '無効なパラメータ',
  Cargo_InverseSelect: '選択解除',
  Cargo_Invoice: '請求書',
  Cargo_Invoiceable: '請求可能',
  Cargo_InvoiceAcquisition: '請求書受領',
  Cargo_InvoiceAfterARAPOffset: '売掛金の相殺請求書',
  Cargo_InvoiceAmount: '請求書金額',
  Cargo_InvoiceAmountP: '請求書金額: ',
  Cargo_InvoiceConfirmation: '請求が確定しました',
  Cargo_InvoiceContent: '請求書の内容',
  Cargo_InvoiceCurrency: '請求書通貨',
  Cargo_InvoiceCurrencyP: '請求書通貨: ',
  Cargo_Invoiced: '請求済み',
  Cargo_InvoiceDate: '請求日',
  Cargo_InvoiceDateP: '請求日: ',
  Cargo_InvoicedBy: '振出人',
  Cargo_InvoicedByP: '振出人: ',
  Cargo_InvoiceDeleted: '請求書が削除されました',
  Cargo_InvoicedOrNot: '請求書が発行されたかどうか',
  Cargo_InvoiceHasBeenWrittenOff: '請求書は消却されました',
  Cargo_InvoiceHeader: '請求書ヘッダー',
  Cargo_InvoiceInformation: '請求書情報',
  Cargo_InvoiceIssued: '請求済み',
  Cargo_InvoiceItemName: '請求書アイテム名',
  Cargo_InvoiceItemNameSetup: '請求書項目名の設定',
  Cargo_InvoiceNo: '請求書番号',
  Cargo_InvoiceNoCanTBeEmpty: '請求書番号は空にできません。',
  Cargo_InvoiceNoEntry: '請求書番号入力',
  Cargo_InvoiceNoExist: '請求書番号があります',
  Cargo_InvoiceNoExistedContinue: '請求書番号は既に存在します。続行しますか？',
  Cargo_InvoiceNoExistedContinueToSave: '請求書番号は既に存在します。保存しますか？',
  Cargo_InvoiceNoExistedRewrite: '請求書番号【{0}】はすでに存在します。請求書番号を再入力してください。',
  Cargo_InvoiceNoIsEmpty: '請求書番号が空です。',
  Cargo_InvoiceNoIsEmptyContinue: '請求書番号が空です。続行しますか？',
  Cargo_InvoiceNoMandatory: '請求書番号が必須かどうか',
  Cargo_InvoiceNoNotEntered: '請求書番号が入力されていません。',
  Cargo_InvoiceNoP: '請求書番号: ',
  Cargo_InvoiceNoSegment: '請求書番号セグメント',
  Cargo_InvoiceNoStatus: '請求書番号の処理状況',
  Cargo_InvoicePrintedCanTBeDeleted: '請求書は印刷されているので削除できません。',
  Cargo_InvoicePrinting: '請求書の印刷',
  Cargo_InvoiceRecord: '請求書レコード',
  Cargo_InvoiceReIssued: '請求書が再発行されました',
  Cargo_InvoiceRemark: '請求メモ',
  Cargo_InvoiceSavedSuccessfully: '請求書の保存に成功しました',
  Cargo_InvoiceSaveFailed: '請求書の保存に失敗しました',
  Cargo_InvoiceStatus: '請求書処理状況',
  Cargo_InvoiceTitle: '請求先名',
  Cargo_ChargeInvoiceTitle: '請求書の宛名',
  Cargo_InvoiceTitleInvoiceNo: '請求先請求書番号',
  Cargo_InvoiceTitleNotMatched: '請求書のヘッダーが一緻しません。',
  Cargo_InvoiceTitleP: '請求先: ',
  Cargo_InvoiceType: '請求書タイプ',
  Cargo_InvoiceTypeIncompatible: '請求書タイプが統一されていません。',
  Cargo_InvoiceTypeP: '請求書タイプ: ',
  Cargo_InvoiceTypeSelection: '請求書タイプの選択',
  Cargo_InvoiceUse: '請求書の使用',
  Cargo_InvoiceVoided: '請求書は無効になりました。',
  Cargo_InvoiceVoidedCanTBeDeleted: '請求書は無効化され、削除できません。',
  Cargo_InvoiceVoucherAfterARAPOffset: '売掛/未収金相殺請求書買掛伝票',
  Cargo_InvoiceWrittenOffCanTBeDeleted: '請求書は消込済で削除できません',
  Cargo_InvoiceWrittenOffCanTBeVoided: '請求書は消込済で無効にできません',
  Cargo_Invoicing: '請求します',
  Cargo_InvoicingAccordingToCurrency: '通貨別請求',
  Cargo_InvoicingAddress: '請求先アドレス',
  Cargo_InvoicingAmount: '請求金額',
  Cargo_InvoicingApplicationDate: '請求申請日',
  Cargo_InvoicingApplicationReview: '請求申請レビュー',
  Cargo_InvoicingCompleted: '請求が完了しました',
  Cargo_InvoicingCurrency: '請求通貨',
  Cargo_InvoicingDateBusinessDate: '請求日取引日',
  Cargo_InvoicingHeadCannotBeEmpty: '請求ヘッダーは空にできません。',
  Cargo_InvoicingInformation: '請求情報',
  Cargo_InvoicingListNo: '請求リスト番号',
  Cargo_InvoicingMachineNo: '請求マシン番号',
  Cargo_InvoicingMethod: '請求方法',
  Cargo_InvoicingMethodP: '請求方法: ',
  Cargo_InvoicingMode: '請求モード',
  Cargo_InvoicingPerBill: '個別に請求',
  Cargo_InvoicingPerMonth: '月締め請求',
  Cargo_InvoicingRequirements: '請求条件',
  Cargo_InvoicingSearch: '請求クエリ',
  Cargo_InvoicingStatus: '請求処理状況',
  Cargo_InvoicingType: '請求タイプ',
  Cargo_InvoicingVerification: '請求書の検証',
  Cargo_IOSPIM: '決済相手は情報を入力する必要があります',
  Cargo_IPCTFATROJE: '無効なパラメータで入力勘定ルールが見つかりません',
  Cargo_IsBroken: '区切り記号',
  Cargo_IsExtended: '期限切れ有無',
  Cargo_IsItAR: '売掛金かどうか',
  Cargo_IsItCollection: '入金かどうか',
  Cargo_IsItDefaultExpense: '費用をデフォルト設定するかどうか',
  Cargo_IsCharterFlightCosts: 'チャーター料金かどうか',
  Cargo_IsCharterVesselCosts: 'プレートチャージを含めるかどうか',
  Cargo_IsCharterFlight: 'チャーターするかどうか',
  Cargo_IsCharterVessel: '板を包むか否か',
  Cargo_Number_Of_Charter_Containers: 'チャーターコンテナ数',
  Cargo_Charter_weight_Restrictions: 'チャーター機の重量製限',
  Cargo_Charter_Volume_Restrictions: 'チャーター機の容量製限',
  Cargo_Description_of_the_package_Information: 'パッケージ情報の説明',
  Cargo_Pallets_can_be_loaded_in_Weight: 'パレットの積載可能重量',
  Cargo_Packing_Plates_Can_Be_Loaded_In_Volume: 'パッキングプレートの積載可能体積',
  Cargo_The_Total_Cost_Amount: 'コスト合計金額',
  Cargo_Unit_Load_Device: 'コンテナ',
  Cargo_MountingInformation: 'マウント情報',
  Cargo_Please_Load_The_Main_Ticket: 'メインチケットにプレートを装着してください',
  Cargo_Please_Empty_And_Load_The_Main_Ticket_For_The_Operation: 'メインチケットで空にしてください',
  Cargo_OtherBusinessUse: 'その他のビジネス使用',
  Cargo_DefaultArSettlementObject: 'デフォルト売掛金固定決済オブジェクト',
  Cargo_DefaultArSettlementObjectNull: 'デフォルト売掛/未収金オブジェクトが空かどうか',
  Cargo_DefaultApSettlementObject: 'デフォルトの固定決済対象',
  Cargo_DefaultApSettlementObjectNull: 'デフォルトの対応オブジェクトが空かどうか',
  Cargo_IsItWriteOff: 'ヘッジかどうか',
  Cargo_IsoCode: 'ISOコード',
  Cargo_IsShutOut: 'ログアウトするかどうか',
  Cargo_IssuanceReceiptOfInvoice: '請求書受領',
  Cargo_Issued: '公開されました',
  Cargo_IssueHbl: 'HBLにサインするかどうか',
  Cargo_IssueInvoiceDirectly: '直接請求書を生成する',
  Cargo_IssueInvoiceDirectlyOrNot: '直接請求するかどうか',
  Cargo_IssueOfTheYear: '{0}年の{1}期',
  Cargo_ISWBDC: 'この{0}データを削除してもよろしいですか？',
  Cargo_Item: 'アイテム',
  Cargo_Item1: '項目1',
  Cargo_Item2: '項目2',
  Cargo_ItemNo: '項目番号',
  Cargo_ItemNo2P: '項目番号2: ',
  Cargo_ItemNoP: 'プロジェクト番号: ',
  Cargo_ItemsAdded: '{0}個が追加されました',
  Cargo_ItemsNBR: '件数',
  Cargo_ReturnContainerAddress: 'コンテナ返却先住所',
  Cargo_LoadingAddress: '荷積み住所',
  Cargo_ITIOCBNMPCBITIITBCPOTS: '現在の支社請求端末IDはメンテナンスされていません。基本構成の百旺請求端末IDを設定してください',
  Cargo_ITPIEI: '請求書の種類紙請求書電子請求書',
  Cargo_IYDTRIAACWTACYIYWTKTAABFFIACNCTCIA: '請求申請者と確認し、請求申請を取り消す場合は【はい】をクリックします。請求申請を将来の請求の根拠として保持する場合は【はい】をクリックします。「いいえ」、請求をキャンセルしますか？',
  Cargo_January: '1月',
  Cargo_JEODTD: 'データ型（{0}）のエントリが削除されました！',
  Cargo_JEOOSC: '海外決済センター入力かどうか',
  Cargo_JFOCP: '受付字判別フィールド',
  Cargo_JobListSearched: '検索されたワークリスト',
  Cargo_JobNo: 'ジョブ番号',
  Cargo_JobNoP: 'ジョブ番号: ',
  Cargo_JobTypeImport: 'インポート',
  Cargo_JournalEntryCategory: '入力タイプ',
  Cargo_JournalEntryRule: '仕訳ルール',
  Cargo_July: '7月',
  Cargo_June: '6月',
  Cargo_KeyWord: 'デリケートな単語',
  Cargo_KeyWordCanTBeEmpty: 'デリケートな単語は空にできません',
  Cargo_KingdeeCloudApprove: '金蝶Cloudレビュー',
  Cargo_KingdeeCloudReview: '金蝶雲レビュー',
  Cargo_LastAccrualTime: '最新の取得時間',
  Cargo_LastDate: '前回の日付',
  Cargo_LastInvoiceNo: '最後の請求書番号',
  Cargo_LastModificationTime: '最終変更時間: ',
  Cargo_LastReceiveDate: '最終入金日',
  Cargo_LastReceivingDate: '最終入金日',
  Cargo_LastTimeBalance: '前回の残高',
  Cargo_LBNRYSTW: '関連業務はまだ審査されていません。キャンセルしますか？',
  Cargo_LegalUnit: '法定単位',
  Cargo_Lender: '借貸方',
  Cargo_LessThan: 'より小さい',
  Cargo_Letter: 'ワード',
  Cargo_Level: 'レベル',
  Cargo_Level1AccountTitle: '一級科目',
  Cargo_Level2AccountTitle: '二次科目',
  Cargo_Level3AccountTitle: '三級科目',
  Cargo_Level4AccountTitle: 'レベル4の科目',
  Cargo_Level5AccountTitle: 'レベル5の科目',
  Cargo_Level6AccountTitle: 'レベル6の科目',
  Cargo_Limit: '与信限度',
  Cargo_LinkBills: '請求書を関連付けるかどうか',
  Cargo_LinkOffsetExpenseDifferentials: '差異ヘッジ費用を関連付けるかどうか',
  Cargo_LinkPaymentRequests: '支払要求を関連付けますか',
  Cargo_LinkToInvoice: '請求書に関連付けられます',
  Cargo_Load: '読み込み',
  Cargo_LoadCache: 'キャッシュのロード',
  Cargo_Loaded: 'ロード完了',
  Cargo_LoadedAndSave: 'ロードが完了したら、保存をクリックします。',
  Cargo_LoadingAtDoor: 'ドアポイントの梱包',
  Cargo_LoadingAtFactory: '生産パッケージ',
  Cargo_LoadOrNot: 'ロードするかどうか',
  Cargo_Loan: 'ローン',
  Cargo_LoanSwap: '貸借交換',
  Cargo_LocalAgent: '現地代理',
  Cargo_LocalCharge: 'ローカルチャージ',
  Cargo_LocalChargeOrNot: 'ローカル料金かどうか',
  Cargo_LocalCurrency: '基本通貨',
  Cargo_LocalizedName: 'ローカライズされた名前',
  Cargo_Location: '場所',
  Cargo_LocationOfCurrentVoucher: '現在の買掛伝票の場所',
  Cargo_LockCancellationDate: '日付のロック解除',
  Cargo_LockTheBill: '編集ロック',
  Cargo_Log: 'ログ',
  Cargo_LogisticsCompany: '物流会社',
  Cargo_LogRecord: 'ログレコード',
  Cargo_LOTFINMBGT3D: '最初の請求書番号は3桁以上でなければなりません。',
  Cargo_LowerCase: '小文字',
  Cargo_MainLineTransport: '幹線輸送',
  Cargo_MaintenanceOfShippingTerms: '運送条件登録/変更',
  Cargo_ManagementOfWithdrawal: 'キャンセル管理',
  Cargo_ManageParameters: 'クエリパラメータの管理',
  Cargo_MANMWCSAISCTD: '宅配便の住所がシステムメンテナンスデータの顧客の住所と異なります。本当に送りますか？',
  Cargo_March: '3月',
  Cargo_Mark: 'マーキング',
  Cargo_MarkTime: 'マーク時間',
  Cargo_Marker: 'マークする人',
  Cargo_MarkStatus: 'マーク状態',
  Cargo_MarkCancelledSuccessfully: 'マーク解除に成功しました',
  Cargo_MarkDate: '日付のマーク',
  Cargo_Marked: 'マークが成功しました',
  Cargo_MarkedBy: 'マークする人',
  Cargo_MarkOfConfirmation: 'マークの確認',
  Cargo_Marks: 'マーキング',
  Cargo_MarkSymbols: 'タグID',
  Cargo_MasterBillNotSearched: 'マスタは検索されません',
  Cargo_May: '5月',
  Cargo_MBACM: '請求金額の計算方法の変更',
  Cargo_MBEIRPSUB: 'レコードにマークされた請求書があります。マークされていない請求書を選択してください。',
  Cargo_MBLAudit: 'MBLレビュー',
  Cargo_MBLCargoDetention: 'MBL控除',
  Cargo_MBLFreightTerm: 'マスタ運送料条件',
  Cargo_MblNo: 'マスタコード',
  Cargo_MBLPayable: 'MBL支払可能',
  Cargo_MBLPaymentTime: 'MBL支払時間',
  Cargo_MBLReviewTime: 'MBLレビュー時間',
  Cargo_MBLTimeOfCargoHolding: 'MBL荷下ろし時間',
  Cargo_MBLTransitTerm: 'マスタ運送条件',
  Cargo_MDEPSBP: '変更されたデータがあります。保存してから印刷してください。',
  Cargo_MDEPSBPIN: 'データが変更されました。保存してから印刷してください【請求書番号: {0}】',
  Cargo_Merge: 'マージ開始',
  Cargo_MergeOrNot: 'マージするかどうか',
  Cargo_MethodOfClaim: '承認モード',
  Cargo_MethodOfClaimP: '承認モード: ',
  Cargo_Metrics: 'メジャー',
  Cargo_MfnTaxRate: '最恵国税率',
  Cargo_Mode: 'モード',
  Cargo_ModelSpecification: '仕様モデル',
  Cargo_ModificationOfCollection: '受託修正',
  Cargo_ModificationTime: '変更時間',
  Cargo_ModifiedDataNotSavedCancel: '変更されたデータは保存されていません。キャンセルしますか？',
  Cargo_Modifier: '変更者',
  Cargo_Modify: '変更',
  Cargo_ModifyAccountTitle: '勘定の変更',
  Cargo_ModifyAccountTitleName: '勘定科目名の変更',
  Cargo_ModifyAdjustBill: '請求書-修正調整',
  Cargo_ModifyBillingInformation: '請求書情報の修正',
  Cargo_ModifyCollectionInformation: '回収情報の変更',
  Cargo_ModifyInvoice: '請求書の修正',
  Cargo_ModifyPort: 'ポートの変更',
  Cargo_ModifyRailwayStation: '鉄道駅の変更',
  Cargo_ModifyOverseaWarehouse: '海外倉庫の編集',
  Cargo_AddOverseaWarehouse: 'アマゾン倉庫を追加します',
  Cargo_NewOverseaWarehouse: '海外倉庫の追加',
  Cargo_CannotDeleteWarehouse: '{0}倉庫コードは使用されているため削除できません！',
  Cargo_ModifyRateWithTax: '税込価格の変更',
  Cargo_ModifySelectedInvoiceStatus: '選択した請求書処理状況を変更します',
  Cargo_ModifyWriteOffRecord: '消込レコードの変更',
  Cargo_MOMAOB: '顧客/仕入先補助期首残高メンテナンス',
  Cargo_MonetaryEquivalent: '換算された金額',
  Cargo_MonetaryEquivalentCNY: '換算CNY金額',
  Cargo_Month: '月',
  Cargo_FinanceMonthUnitTip: '暦月で計算：当月1日を基準にNか月前を境界日とし、境界日より前のデータのみロックします（境界日当日は含まない）。例：9月に2か月を設定した場合、7月1日より前（7月1日を含まない）が対象',
  Cargo_Monthly: '月締め',
  Cargo_MonthlyReconciliation: '月締め',
  Cargo_Months: '月',
  Cargo_MoreConditions: 'その他の条件',
  Cargo_MoreSearch: 'その他のクエリ',
  Cargo_Motorcade: 'チーム',
  Cargo_MscServiceCode: 'サービスコード',
  Cargo_MultipleChoiceBox: '【複数選択】',
  Cargo_MultipleCurrenciesExit: '複数の通貨が存在します。',
  Cargo_MultipleSettlingPartiesExist: '複数の決済対象が存在します。',
  Cargo_MUPIOOPFWO: '売掛/未収金勘定を使用する必要がありますか',
  Cargo_MustSelectTheSameClient: '同じ顧客を選択する必要があります。',
  Cargo_MVOACP: '前受付証憑を維持するかどうか',
  Cargo_MVOARAPOI: '売掛金/未収金ヘッジ請求書買掛伝票を維持するかどうか',
  Cargo_Name: '名前',
  Cargo_NameCanTBeEmpty: '名前は空にできません。',
  Cargo_ExistDoorSite: '同じドアポイント情報が既に存在します。',
  Cargo_PleaseSelectCommissioningUnit: 'パートナーの中から委託単位を選択してください。',
  Cargo_PleaseInputOneDoorInfoAtLeast: '少なくとも1つのドアポイント情報を入力してください。',
  Cargo_EnglishNameCheck: '英語名は空にできません。',
  Cargo_LandTransportationDetails: '陸運詳細の編集',
  Cargo_NameP: '名前: ',
  Cargo_NAMISANOSNBCWBRS2DPTED: '注: リマインダ方法は\'システムリマインダ\'で、システムは有効期限の2日前にビジネス構成の作成を禁止するように再度リマインダします',
  Cargo_NatureOfSales: '売上属性',
  Cargo_NBCTBGTC: '負の差額は-1セントより大きくできません。',
  Cargo_NECDFTIC: '請求通貨と異なる通貨は{0}個を超えてはいけません',
  Cargo_BillPaymentCurrencyBeyond: '支払い通貨とは異なる通貨は {0} 個を超えることはできません。',
  Cargo_PayByBillingRate: '請求書レートで支払う',
  Cargo_NeedAccountingPeriod: '申し訳ありませんが、現在使用している会計ソフトウェアのバージョン「WattFinanceSoftware」では、勘定を編集するために会計期間を設定する必要があります',
  Cargo_NeedAccrue: '計上するかどうか',
  Cargo_NeedCustomsDeclare: '通関するかどうか',
  Cargo_NeedHqToWriteOffOrNot: '本社からの消込が必要かどうか',
  Cargo_NeedInvoiceOrNot: '請求書発行要否',
  Cargo_NeedMandatoryAccrue: '強製的に計上するかどうか',
  Cargo_NeedToBillCNYToCNY: '{0}に{1}RMBを請求する必要があります',
  Cargo_NeedToConfiCNYankAccountOrNot: '銀行口座の確認が必要かどうか',
  Cargo_NeedToCreateBillOrNot: '請求書を作成しますか？',
  Cargo_NeedToExportOrNot: 'エクスポートする必要がありますか',
  Cargo_NeedToPayTo: '{0}に{1}RMBを支払う必要があります',
  Cargo_NEFEIDE: 'デフォルトエクスポート時に空でないフィルタがあります',
  Cargo_NegotiationStage: 'ビジネスステージ',
  Cargo_NEIAFPRPOCA: '申請書には料金がありません。ページを更新するか、システム管理者に連絡してください',
  Cargo_NEICTBD: '非電子請求書はダウンロードできません。',
  Cargo_NetWork: 'ネットワーク',
  Cargo_NetworkName: 'ネットワーク名',
  Cargo_NetworkNameCanTBeEmpty: 'ネットワーク名は空にできません',
  Cargo_New: '新規作成',
  Cargo_NewAccountStatement: '新規アカウント明細書',
  Cargo_NewAccountTitle: '新規アカウント',
  Cargo_NewFiscalPeriod: '新しい会計期間',
  Cargo_NewInvoiceNo: '新しい請求書番号',
  Cargo_NewInvoiceNoP: '新しい請求書番号: ',
  Cargo_NewPaymentRequest: '支払要求の作成',
  Cargo_NewValue: '新しい値',
  Cargo_Next: '次へ',
  Cargo_NextItem: '次へ',
  Cargo_NextStep: '次のタスク',
  Cargo_NextStepToSave: '次へ保存',
  Cargo_NFFICSPRE: 'クラウドストレージファイルが見つかりません。再エクスポートしてください',
  Cargo_NFMKWPEAW: '注: 複数のデリケートな単語は改行してください',
  Cargo_NFPAFTS: 'この帳簿には使用可能な会計期間がありません。',
  Cargo_NFPSCATWBSACYCTS: '会計期間が存在しないため、現在の会計年度は今年に設定され、確認は保存されます。',
  Cargo_NMT2MCTAIEAWO: 'チャージには、売上通貨と異なる2つ以上の通貨は使用できません。',
  Cargo_NNTCVFCOPL: '繰越損益伝票を生成する必要はありません',
  Cargo_NNTEIBOPLBFSOATBOTY: '年初に有効にした帳簿は、損益の初期残高を入力する必要はありませんよ。',
  Cargo_No: 'いいえ',
  Cargo_NOATGCAAIODMBETTGMO: '科目グループ条件は個数を順番に並べ、データは科目グループマイナス1に等しくなければなりません！',
  Cargo_NoBillToConfirm: '確認できる請求書がありません。',
  Cargo_NoBillToCreateSoa: '請求書がありません。',
  Cargo_NoBillToWriteOff: 'キャンセルが必要な請求書はありません。',
  Cargo_NoBusinessNeedFinancialReview: '財務レビューできるビジネスはありません。',
  Cargo_NoBusinessTypeSelected: '取引タイプ が選択されていません',
  Cargo_NoCitySelectedToEdit: '編集する都市が選択されていません',
  Cargo_NoConfirmedBillToCancel: 'キャンセル可能な請求書はありません。',
  Cargo_NoData: 'データがありません。',
  Cargo_NoDataModifiedNoNeedToSave: 'データは変更されていないので、保存する必要はありません。',
  Cargo_NoDataSelected: 'データが選択されていません。',
  Cargo_NoDataSelectedToDelete: '削除するデータが選択されていません',
  Cargo_NoDataToExport: 'エクスポートできるデータがありません。',
  Cargo_NoDataToModify: '変更可能なデータがありません',
  Cargo_NoDataToPreview: 'プレビューできるデータがありません。',
  Cargo_NoDataToTransfer: '送信できるデータがありません。',
  Cargo_NoDoNotLink: 'いいえ、関連付けはしません',
  Cargo_NOEGT1ICTSTNWBST1C: 'チャージの数は1より大きく、チャージの分割を続行すると数は1に設定されます。続行しますか？',
  Cargo_NoElectronicInvoiceNoToCreate: '電子請求書番号が生成されませんでした。',
  Cargo_NoEligibleExpenseToPrint: '印刷できる費用はありません。',
  Cargo_NoEligibleRecord: '該当するレコードがありません。',
  Cargo_NoEligibleRecordsFound: '条件を満たすレコードが見つかりません',
  Cargo_NoExpenseDifferentialsToProcess: '処理する差額はありません。',
  Cargo_NoExpenseToBill: '請求できる費用はありません。',
  Cargo_NoExpenseToInvoice: '請求可能な費用はありません。',
  Cargo_NoExpenseToReject: '却下できる費用はありません',
  Cargo_NoExpenseToReview: '監査可能な費用はありません',
  Cargo_NoExpenseToWriteOff: '償却可能な費用はありません。',
  Cargo_NoFileToRetrieve: '取得できるファイルがありません。',
  Cargo_NoFileToRevoke: '元に戻すファイルがありません',
  Cargo_NoForeignCurrencyAccounting: '外貨会計なし',
  Cargo_NoInvoiceNo: '請求書番号がありません',
  Cargo_NoInvoiceNoForInvoiceAmounted: '金額{0}の請求書には請求書番号がありません！',
  Cargo_NoInvoiceNoToCheck: 'チェックする請求書番号がありません',
  Cargo_NoMaintainedBankForClient: '顧客は銀行を維持していません',
  Cargo_NoMatchedRecordFound: '該当するレコードが見つかりませんでした',
  Cargo_NominatedAgent: '貨物代理指定',
  Cargo_NonAccrual: '非計上',
  Cargo_None: 'なし',
  Cargo_NoneAnyBillable: '請求可能な費用はありません。',
  Cargo_NoNeedToRepeatConfirmation: '確認されました。再度確認する必要はありません。',
  Cargo_NoNeedToSplitThisKeyWord: 'このデリケートな単語は分割する必要はありません',
  Cargo_NonElectronicInvoice: '非電子請求書',
  Cargo_NonSplitWriteOffExpense: '消込済の費用は分割できません。',
  Cargo_NoNumberBreak: '区切りなし',
  Cargo_NoOfPages: 'ページ数',
  Cargo_NoParentAccountTitles: '親勘定なし',
  Cargo_NoPortSelected: '港が選択されていません',
  Cargo_NoRecordChecked: 'レコードが選択されていません。',
  Cargo_NoRecordSelected: 'レコードが選択されていません。',
  Cargo_NoRecordToSave: '保存できるレコードがありません。',
  Cargo_NoRelease: 'ドロップ不可',
  Cargo_NoReviewedExpenseToCancel: 'レビューをキャンセルできる費用はありません',
  Cargo_NoServiceTicketToDelete: '削除できる料金確認書がありません。',
  Cargo_NoSiteSelected: 'サイトが選択されていません',
  Cargo_NoSobSetUpCurrently: '現在、帳簿が設定されていません。',
  Cargo_NotAcquired: '未受領',
  Cargo_NotAdjustedExpense: '非調整費用',
  Cargo_NotAFinalAccountTitle: '【{0}}】は最終勘定ではありません。',
  Cargo_NotCarriedOver: '繰越なし',
  Cargo_NotCollectAdvance: '立て替え払いではありません',
  Cargo_NotCollected: '未回収',
  Cargo_NotCollectedCNY: 'CNY未収',
  Cargo_NotCollectedEUR: 'EURは回収されていません',
  Cargo_NotCollectedGBP: 'GBPは回収されていません',
  Cargo_NotCollectedHKD: 'HKD未回収',
  Cargo_NotCollectedInFull: '不揃い',
  Cargo_NotCollectedJPY: 'JPYは受け取っていません',
  Cargo_NotCollectedNGN: 'NGNが受信されていません',
  Cargo_NotCollectedP: '未回収: ',
  Cargo_NotCollectedUSD: 'USDは回収されていません',
  Cargo_Collected: '受信済み',
  Cargo_NotContracted: '契約していません',
  Cargo_NotDisplayedIfMultipleItemsExist: '複数ある場合は表示しない',
  Cargo_NOTDIST: 'クエリタブに表示されるテンプレートの数',
  Cargo_NotificationOfPaymentFreeze: '支払凍結の通知',
  Cargo_NotificationOfUnfrozenPayment: '支払通知の解除',
  Cargo_NotifyHq: '本部への通知',
  Cargo_NotifyId: '通知先コード',
  Cargo_NotifyInfo: '通知先情報',
  Cargo_NotifyParty: '通知先',
  Cargo_NotifyPartySName: '通知先の名前',
  Cargo_NotifyUser: 'ユーザーに通知します',
  Cargo_NotifyMethod: '通知方法',
  Cargo_NotInvoicedMoney: '未請求金額',
  Cargo_NoTotal: '{0}枚目,合計{1}枚目',
  Cargo_NotReviewed: '未確認',
  Cargo_NotSent: '送信されていません',
  Cargo_NotSet: '未設定',
  Cargo_NotSubmittedCanTWithdraw: '未提出はキャンセルできません',
  Cargo_NotTaxFree: '非免税',
  Cargo_NotWrittenBack: '赤フラッシュなし',
  Cargo_NotWrittenOff: '未消込',
  Cargo_NotWrittenOff2: '未販売換算RMB',
  Cargo_NotWrittenOffCurrency: '未転記（{0}）',
  Cargo_NotWrittenOffHKD: '未販売（HKD）',
  Cargo_NotWrittenOffUSD: '売上なし（USD）',
  Cargo_NoUnInvoicedExpense: '未請求の費用はありません。',
  Cargo_November: '11月',
  Cargo_NPDOSB: '補助残高初期データがありません。',
  Cargo_NRFTAL: '自引自送',
  Cargo_NSEFPCA: '分割料金が見つかりません。管理者に連絡してください！',
  Cargo_NTWBWRLION: '赤字の請求書を作成しますか？',
  Cargo_Number: '番号',
  Cargo_NumberS: '番号',
  Cargo_NumberOfAttachedDocuments: '添付ドキュメントの数',
  Cargo_NumberOfCopies: '部数',
  Cargo_NumberOfCopiesCanTBe0: '部数は0にできません。',
  Cargo_NumberOfExpenseWriteOffs: '消込済費用数量',
  Cargo_NumberOfNominatedAgents: 'エージェント数の指定',
  Cargo_OBCILC: '期首残高（連結基本通貨）',
  Cargo_OBIMICMAWTCSCCPBR: '入金方法が小切手銀行振替本票代収代付水単の場合、こちらの銀行は必ず記入します',
  Cargo_OceanExport: '海上輸出',
  Cargo_OceanFreight: '海上輸送',
  Cargo_OceanImport: '海運輸入',
  Cargo_OceanImportExport: '海上の出入り',
  Cargo_OCLWSPCBS: '販売に関連する顧客のみを選択できます',
  Cargo_October: '10月',
  Cargo_Oddment: '端数処理勘定',
  Cargo_ODWSSCBP: '同じ処理状況のドキュメントのみ印刷できます。',
  Cargo_OEOSET: '資本または株主資本の合計',
  Cargo_OEVCBWB: 'エクスポートされた買掛伝票のみを赤で消し込みます。',
  Cargo_OFAOPOTFSIITPRPPDNOATRIC: '操作が失敗しました。すべてまたは一部の費用は支払承認プロセス中です。プロセスが完了してから操作してください。',
  Cargo_OFCIIFPRNRN: '請求された費用が含まれています。\\n支払請求番号を再選択してください: ',
  Cargo_OFCTCMT2: '操作が失敗しました。通貨は2つを超えてはいけません。',
  Cargo_OffsetDataSource: 'ヘッジデータソース',
  Cargo_OffsetEntity: 'ヘッジエンティティ',
  Cargo_OffsetOrNot: 'ヘッジするかどうか',
  Cargo_MustInvoiceNoAndTitle: '請求書番号と請求先名義を記入する必要があります',
  Cargo_OFGTECOBUFEIIC: '操作が失敗しました。ゴールデン税エクスポートは人民元の電子請求書にのみ適用されます。',
  Cargo_OFNBFSWWF: '請求できません。請求可能な費用はありません。',
  Cargo_OFTAPFSDNMTIR: '買掛金処理状況が請求条件を満たしていません',
  Cargo_OFTARFSDNMTIR: '売掛金処理状況が請求要件を満たしていません',
  Cargo_OFTCBDNMTTINSIIITIEI: '操作が失敗しました。現在の支社は納税者識別番号を維持していないため、電子請求書を発行できません。',
  Cargo_OFTFRCWNM: '操作が失敗しました。財務監査条件が満たされていません。',
  Cargo_OFTFRCWNMCSRT: '直接財務監査はできません。設定を変更してからやり直してください。',
  Cargo_OFTIISCBD: '請求書が作成されました。削除できません。',
  Cargo_OFTIRCBDTNIAF: '以下の請求書はすでに請求されているので、削除できません！',
  Cargo_OFTIRCBETNIAF: '以下の請求書はすでに請求されているので、編集できません！',
  Cargo_OFTRFOTARFCBIITB: '請求書内の費用には赤消し費用または赤消し費用が含まれています',
  Cargo_OFTUFSCBS: '操作が失敗しました。まだ保存されていない費用は分割できません。',
  Cargo_OFTWOANTBETTSOREGALFE: '操作が失敗しました。この消込金額は、入金金額+為替差損益+ファイナンスチャージ+端数処理勘定の合計と等しくする必要があります。',
  Cargo_OFWTIARTARMBGTTAP: '操作が失敗しました。収支タイプが売掛金の場合、売掛金の合計は買掛金の合計より大きくなければなりません。',
  Cargo_OIRWPSCBCAC: '請求保留中の請求書のみが請求書を生成できます！',
  Cargo_OIWWBCBP: '未処理の請求書のみを印刷できます。',
  Cargo_OnAccountHedge: '（掛け勘定ヘッジ）',
  Cargo_OneClickRenewal: 'ワンクリックで更新',
  Cargo_OnlyCheckedRecordsCanBeCancelled: 'チェックされたレコードのみをキャンセルできます。',
  Cargo_OnlyReviewedVouchersCanBeDeleted: '未監査の買掛伝票のみ削除できます。',
  Cargo_OnlyUnCheckedRecordsCanBeChecked: 'チェックされていないレコードのみをチェックできます。',
  Cargo_OOAPIICCTTTEPRCOEA: '受託は未払い費用のみで、これ以上費用を振り込むことはできません。別の受託または費用申請をしてください！',
  Cargo_OORCBSFASBI: '単一の請求に対して選択できるレコードは1つだけです。',
  Cargo_OpeningAmountOfTheYear: '年初数',
  Cargo_OpeningBalance: '期首残高',
  Cargo_OpeningBalanceCreditCNY: '期首残高貸方（人民元）',
  Cargo_OpeningBalanceCreditUSD: '期首残高貸方（米ドル）',
  Cargo_OpeningBalanceDebitCNY: '期首残高借方（人民元）',
  Cargo_OpeningBalanceDebitUSD: '期首残高借方（米ドル）',
  Cargo_OperateBy: 'オペレータ',
  Cargo_OperatedSuccessfullyRefreshPage: '操作によりページが再表示されました',
  Cargo_OperatingCompany: '営業単位',
  Cargo_Operation: 'オペレーション',
  Cargo_OperationCompany: 'オペレーション会社',
  Cargo_OperationComplete: '操作は成功しました',
  Cargo_OperationDate: '処理日',
  Cargo_OperationDepartment: '業務部門',
  Cargo_OperationOffice: '支社操作フラグ',
  Cargo_OperationFailed: '操作が失敗しました',
  Cargo_OperationHistory: '操作履歴',
  Cargo_OperationModeAir: 'オペレーションモード（空輸）',
  Cargo_OperationModeAirExport: 'オペレーションモード（空）',
  Cargo_OperationModeAirImport: '操作モード（航空輸入）',
  Cargo_OperationRequirementType: '操作要求タイプ',
  Cargo_OperationSuccessfully: '操作は成功しました。',
  Cargo_OperationSymbol: '演算記号',
  Cargo_OperationType: '操作タイプ',
  Cargo_OperationTypeCanTBeEmpty: '操作内容要求タイプは空にできません',
  Cargo_Operator: 'オペレータ',
  Cargo_OperatorOfWithdrawal: '返品担当者',
  Cargo_OppositeVoucherNo: '相手の買掛伝票番号',
  Cargo_OppositeVoucherNoP: '相手買掛伝票番号: ',
  Cargo_OPVWES: 'この操作内容は、処理状況が確認済みの買掛伝票に対してのみ実行できます。',
  Cargo_Order: 'レベル',
  Cargo_OrdinaryTaxRate: '普通税率',
  Cargo_ORDM: '操作内容要求記述情報登録/変更',
  Cargo_Original: 'オリジナル',
  Cargo_OriginalAmount: '元の金額',
  Cargo_OriginalAmountCNY: 'CNY元の金額',
  Cargo_OriginalAmountInBill: '請求元金額',
  Cargo_OriginalAmountUSD: 'USD元の金額',
  Cargo_OriginalContent: 'オリジナルコンテンツ',
  Cargo_OriginalCurrency: '元の通貨',
  Cargo_OriginalCurrencyInBill: '請求元通貨',
  Cargo_OriginalCurrencyNotWrittenOff: '元の通貨は相殺されません',
  Cargo_OriginalCurrencyP: '元の通貨: ',
  Cargo_OriginalExchangeRateInBill: '請求元為替レート',
  Cargo_OriginalExpense: '元の費用',
  Cargo_OriginalExpenseAmount: '元の費用金額',
  Cargo_OriginalExpenseP: '元の費用: ',
  Cargo_OriginalInvoiceNo: '元の請求書番号',
  Cargo_OriginalInvoiceNoP: '元の請求書番号: ',
  Cargo_OriginalInvoiceTitle: '元の請求書のタイトル',
  Cargo_OriginalInvoiceTitleP: '元の請求先: ',
  Cargo_OriginalValue: '元の値',
  Cargo_ChargeItemView: '有料アイテムの表示',
  Cargo_ORORDCBO: '回収または返却されたドキュメントのみを操作できます。',
  Cargo_ORVCBE: '監査証跡のみエクスポートできます。',
  Cargo_OSVBMP: 'メカニズム証明書のみ検索',
  Cargo_Other: 'その他',
  Cargo_OtherChargeItem: '航空運送状の雑費',
  Cargo_OtherContact: 'その他の契約',
  Cargo_OtherConversionAP: 'その他の換算買掛金',
  Cargo_OtherConversionAPCNY: 'その他換算CNY買掛金',
  Cargo_OtherConversionAPEUR: 'その他換算EURで支払う',
  Cargo_OtherConversionAPGBP: 'その他換算GBP買掛金',
  Cargo_OtherConversionAPHKD: 'その他換算HKD対応',
  Cargo_OtherConversionAPJPY: 'その他の換算JPYで対応',
  Cargo_OtherConversionAPNGN: 'その他換算NGN対応',
  Cargo_OtherConversionAR: 'その他の換算売掛金',
  Cargo_OtherConversionARCNY: 'その他換算CNY売掛金',
  Cargo_OtherConversionAREUR: 'その他の換算EUR売掛金',
  Cargo_OtherConversionARGBP: 'その他換算GBP売掛金',
  Cargo_OtherConversionARHKD: 'その他換算HKD売掛金',
  Cargo_OtherConversionARJPY: 'その他換算JPY売掛金',
  Cargo_OtherConversionARNGN: 'その他換算NGN売掛金',
  Cargo_OtherCurrencies: 'その他の通貨',
  Cargo_OtherCurrencyExchangeRates: '他の通貨レート',
  Cargo_OtherExchangeRates: 'その他の為替レート',
  Cargo_OtherOutstandingConversionAP: 'その他換算未払い',
  Cargo_OtherOutstandingConversionAPCNY: 'その他換算CNY未払い',
  Cargo_OtherOutstandingConversionAPEUR: 'その他換算EUR未払い',
  Cargo_OtherOutstandingConversionAPGBP: 'その他換算GBP未払い',
  Cargo_OtherOutstandingConversionAPHKD: 'その他換算HKD未払い',
  Cargo_OtherOutstandingConversionAPJPY: 'その他換算JPY未払い',
  Cargo_OtherOutstandingConversionAPNGN: 'その他換算NGN未払い',
  Cargo_OtherOutstandingConversionAR: 'その他換算未回収',
  Cargo_OtherOutstandingConversionARCNY: 'その他の換算CNYは受領していません',
  Cargo_OtherOutstandingConversionAREUR: 'その他の換算EURは受領されていません',
  Cargo_OtherOutstandingConversionARGBP: 'その他の換算GBPは受領されていません',
  Cargo_OtherOutstandingConversionARHKD: 'その他換算HKD未回収',
  Cargo_OtherOutstandingConversionARJPY: 'その他の換算JPYは受領されていません',
  Cargo_OtherOutstandingConversionARNGN: 'その他の換算NGNは未回収',
  Cargo_OTNSOSICBD: '削除できるのは、送信されていないものと送信されたものです。',
  Cargo_OTWOOCCI: '帳消しを取り消すことができるのは、帳消し人だけです。',
  Cargo_OTWOOCMI: '帳消し者本人だけが帳消しを修正できます。',
  Cargo_OurAccount: 'こちらのアカウント',
  Cargo_OurBank: '当方の銀行',
  Cargo_OurBankIsEmptySaveBankReceipt: 'こちらの銀行は空です。水票を保存しますか？',
  Cargo_Outcomes: '成菓',
  Cargo_OutstandingAP: '未払未売',
  Cargo_OutstandingAPP: '未払: ',
  Cargo_OutstandingConversionAPInCNY: 'CNY未払に換算',
  Cargo_OutstandingConversionAPInCurrency: '{0}未払に換算',
  Cargo_OutstandingConversionPaidInCurrency: '{0}換算済みです。',
  Cargo_OutstandingPaymentParties: '未決済決済単位',
  Cargo_OutstandingWrittenOffItemsExist: '未転記があります',
  Cargo_OVDCBUFPLAT: '損益勘定は、仮想部門のみを選択できます。',
  Cargo_Virtual: '仮想',
  Cargo_Over90DaysShpt: '90日以上（チケット）',
  Cargo_OverdueExpenses: 'オーバーチャージ',
  Cargo_Overseas: '海外',
  Cargo_OverseasAgencyContract: '海外代理契約',
  Cargo_OverseasAgent: '海外エージェント',
  Cargo_OverseasAgentOrNot: '海外エージェントかどうか',
  Cargo_OverseasCollection: '海外からの入金',
  Cargo_OverseasDirectClient: '海外直客',
  Cargo_OverseasDirectClientOrNot: '海外直客かどうか',
  Cargo_OverseasDomestic: '海外国内',
  Cargo_OverseasOrNot: '海外かどうか',
  Cargo_OverseasPayment: '海外支払',
  Cargo_OverseasWriteOff: '海外売上勘定',
  Cargo_OverseasWriteOffOrNot: '海外売上かどうか',
  Cargo_OverseasWriteOffSearch: '海外売上勘定照会',
  Cargo_OVICBETGTEI: 'VAT請求書のみがゴールデン税の電子請求書をエクスポートできます。',
  Cargo_OVWCSNCBE: '連続する買掛伝票番号の買掛伝票のみエクスポートできます。',
  Cargo_OVWUSCBE: '処理状況が未確認の買掛伝票のみを確認できます。',
  Cargo_OWCICGTSEEI: 'ゴールデン税の電子請求書をエクスポートするには、請求通貨は{0}です',
  Cargo_OwningDept: '所属部署',
  Cargo_Package: 'パッケージ',
  Cargo_PackageExistsOrSelectNull: 'パッケージが存在するか、レコードが選択されていません',
  Cargo_PackageMaintenance: 'パッケージのメンテナンス',
  Cargo_PackingInformationNotSelected: '梱包情報が選択されていません。',
  Cargo_PADS: '支払拒否申請が成功しました。',
  Cargo_Page: 'チャン',
  Cargo_Paid: '支払済み',
  Cargo_PaidInFull: '支払済み',
  Cargo_PaidInOutOfPocket: '実際の支払い',
  Cargo_ReceiptPaymentpVoucher: 'じゅりょう証明書',
  Cargo_PANMWEAPCAOCA: '料金請求書が料金金額と一緻しません。金額を確認するか、管理者に連絡してください！',
  Cargo_ParentAccountTitle: '親勘定',
  Cargo_PARGMSA: '支払申請書に社長の承認が必要かどうか',
  Cargo_Parter: '取引先',
  Cargo_CreditAccountingPeriod: '与信会計期間',
  Cargo_CreditLine: '与信限度額',
  Cargo_ExceededAmount: '超過,{0}元',
  Cargo_Exceeded: '超過しました',
  Cargo_PartialConfirmation: '部分確認',
  Cargo_PartialExpense: '一部の費用',
  Cargo_PartialPayment: '一部支払',
  Cargo_PartialReversalCompleted: '部分ロールバックが成功しました。',
  Cargo_PartialWriteOff: '部分的な適用',
  Cargo_Participant: '参加者',
  Cargo_PartnerCanTBeEmpty: 'パートナーは空にできません',
  Cargo_PartnerSCreditLimitExceeded: 'パートナー枠の会計期間が超過しました',
  Cargo_Password: 'パスワード',
  Cargo_PasswordField: 'パスワードフィールド',
  Cargo_PAWOCTBD: '支払要求は消込済で削除できません',
  Cargo_Pay: '払います',
  Cargo_Payable: '支払可能',
  Cargo_PayableNeedPay: '支払可能（支払）',
  Cargo_PayableOrNot: '支払可能かどうか',
  Cargo_PayablesWriteOfStatus: '未払消込処理状況',
  Cargo_Payee: '受取人',
  Cargo_PayeeP: '受取人: ',
  Cargo_Payment: '支払',
  Cargo_PaymentAccount: '支払アカウント',
  Cargo_PaymentAgainstMonthlySoa: '月締め/チケット締め',
  Cargo_PaymentAmount: '支払金額',
  Cargo_PaymentApplicationDirectlySent: '支払申請直通',
  Cargo_PaymentApplicationInformation: '支払申請情報',
  Cargo_PaymentApplicationNo: '支払申請番号',
  Cargo_PaymentAppliedSuccessfully: '支払い申請が成功しました。',
  Cargo_PaymentApprovalSlipDetails: '支払承認の詳細',
  Cargo_PaymentApprovalSlipNo: '支払承認番号',
  Cargo_PaymentCompany: '入金単位',
  Cargo_PaymentCompanyName: '入金会社名',
  Cargo_PaymentCycle: '会計期間サイクル',
  Cargo_PaymentDate: '支払日',
  Cargo_PaymentDateCanTBeEmpty: '支払日は空にできません。',
  Cargo_PaymentMethod: '支払方法',
  Cargo_PaymentNotApplied: '支払いが要求されていません',
  Cargo_PaymentNotificationNo: '支払通知番号',
  Cargo_PaymentPeriod: '支払期間',
  Cargo_PaymentPeriodExceeded: '会計期間の超過',
  Cargo_PaymentPeriodRange: '会計期間の範囲',
  Cargo_PaymentReceiveMethod: '受取方法',
  Cargo_PaymentReceiveMethodP: '受取方法: ',
  Cargo_PaymentReceiveType: '受取タイプ',
  Cargo_PaymentReceiveTypeP: '受取タイプ: ',
  Cargo_PaymentRequest: '支払要求',
  Cargo_PaymentRequestBusiness: '支払要求-ビジネス',
  Cargo_PaymentRequestDetail: '支払要求-詳細',
  Cargo_PaymentRequested: '支払が要求されました',
  Cargo_PaymentRequestedNotRequested: '支払申請済み/未申請',
  Cargo_PaymentRequestsCreatedOrNot: '支払要求書が発行されたかどうか',
  Cargo_PaymentTime: '支払時間',
  Cargo_PaymentToBeChecked: '保留中の金額',
  Cargo_CarryForwardList: '繰越リスト',
  Cargo_PaymentType: '支払タイプ',
  Cargo_PaymentVerification: '支払監査',
  Cargo_PayReceive: '支払区分',
  Cargo_PayReceiveDate: '入金日',
  Cargo_PayUnit: '支払単位',
  Cargo_PCAOCO: '確認してください。今回の{0}金額は: ',
  Cargo_PCHIUV: '審査待ちのお客様の公海',
  Cargo_PCITIHBI: '開票されたかどうかを確認してください。',
  Cargo_INVOICE_NO_FILE: 'この請求書の下に対応する電子請求書ファイルが見つかりません。',
  Cargo_Pcs: '個',
  Cargo_PCSALOA: '複数の申請書を選択してください。',
  Cargo_PCSALOI: '複数の請求書を選択してください。',
  Cargo_Pcst: 'バー',
  Cargo_PCTAOTCPI: '確認してください: \\n今回の実際の支払い金額は: ',
  Cargo_PCTOOPAIWOADSA: '確認してください: \\n今回の支払い金額: {0}、\\n売上金額: {1}、\\n差額: {2}端数処理！',
  Cargo_PDDPAF: '一部のデータしか表示されていません。検索条件のフィルタを追加してください。',
  Cargo_PeakSeason: 'ビジネスシーズン',
  Cargo_PEALTVJE: '有効なエントリを少なくとも2つ入力してください',
  Cargo_PEATGR: '勘定のグループ化ルールを入力してください。',
  Cargo_PECCI: '完全な宅配便情報を入力してください。',
  Cargo_PECINSWACONIO: '正しい請求書番号を入力してください。システムは自動的に他の番号を入力します！',
  Cargo_PEERAVC: '期末調整買掛伝票が生成されました: ',
  Cargo_PEFEA: '期末調整',
  Cargo_PEFEA2: '期末調整2',
  Cargo_PEFEAS: '期末為替調整が成功しました',
  Cargo_PendingBusinessApplication: '保留中のビジネス',
  Cargo_PendingPrice: 'レビュー待ち',
  Cargo_People: '人',
  Cargo_PerformLetterFiltering: '文字フィルタリングを行う',
  Cargo_PERFROIRF: 'コメントに再開理由を入力してください。',
  Cargo_Period: '期間',
  Cargo_PeriodEndAmount: '期末数',
  Cargo_PeriodEndBalance: '期末残高',
  Cargo_PeriodEndBalanceCreditCNY: '期末残高貸方（人民元）',
  Cargo_PeriodEndBalanceCreditUSD: '期末残高貸方（米ドル）',
  Cargo_PeriodEndBalanceDebitCNY: '期末残高借方（人民元）',
  Cargo_PeriodEndBalanceDebitUSD: '期末残高借方（米ドル）',
  Cargo_PeriodEndExchangeRateAdjustment: '期末調整かどうか',
  Cargo_PeriodRange: '期間の範囲',
  Cargo_Periods: '期間',
  Cargo_PermissionCheck: '権限チェック',
  Cargo_PermissionControl: 'アクセス製御',
  Cargo_PermissionToSubmitExpense: '経費を提出する権限',
  Cargo_PESAI: '【{0}】の補助会計{1}情報を入力してください。',
  Cargo_PESAIN: '【{0}】の補助勘定項目番号情報を入力してください',
  Cargo_PESCSBA: '売上ユニットの銀行口座番号を入力してください。',
  Cargo_PETSAINO: '【{0}】の補助勘定項目番号情報を入力してください。',
  Cargo_PETSFIIB: '分割した費用情報を下に入力してください',
  Cargo_PEWOIPETS: '売上勘定情報を入力してください。',
  Cargo_PFAEFTS: '上海空輸支払い',
  Cargo_PICNENCTSFS: '氏名、英語名、コード、略称あいまい検索を入力してください',
  Cargo_PlaceOfDelivery: '納品先',
  Cargo_PlaceOfMblPayment: 'マスタ支払サイト',
  Cargo_PlaceOfReceipt: '出荷先',
  Cargo_PlanDescription: 'シナリオの説明',
  Cargo_PlatformCode: 'プラットフォームコード',
  Cargo_PlatformCustomerService: 'プラットフォームカスタマーサービス',
  Cargo_CustomerServiceOverSea: '海外カスタマー',
  Cargo_PLCOS: '損益の繰越が成功しました',
  Cargo_PleaseAddAtLeastOneContactPerson: 'お客様の連絡先は少なくとも1つ記入してください',
  Cargo_PleaseAddContactPerson: '連絡先を入力してください',
  Cargo_PleaseAddExpense: '費用を追加してください。',
  Cargo_PleaseAddNominationCargoAgent: '指定貨物代理を記入してください',
  Cargo_PleaseAddNominationCargoAgentP: '指定貨物代理を記入してください: ',
  Cargo_PleaseAddTelNumbers: '電話番号を入力してください',
  Cargo_PleaseBatchSelectInvoiceNo: '{0}個の請求書番号を一括して選択してください',
  Cargo_PleaseCheckClient: 'お客様をチェックしてください',
  Cargo_PleaseCheckInvoice: '請求書をチェックしてください。',
  Cargo_PleaseChooseData: 'データを選択してください。',
  Cargo_PleaseChooseFeeName: '料金名を選択してください。',
  Cargo_PleaseChooseSettlementEntity: '決済単位を選択してください。',
  Cargo_PleaseClickSelectAnInvoice: '請求書をクリックしてください。',
  Cargo_PleaseClickSelectARecord: 'レコードをクリックしてください。',
  Cargo_PleaseConfirmPaymentMade: '{1}{2}が{0}に支払われたことを確認してください！',
  Cargo_PleaseConfirmReviewDate: 'レビュー日を確認してください: ',
  Cargo_PleaseConfirmFinancialDate: '財務日付をご確認ください:',
  Cargo_PleaseConfirmTheDueAmount: '確認してください: \\n今回は{0}金額: ',
  Cargo_PleaseConfirmThePaidInAmountIs: '確認してください。今回の実収金額は: ',
  Cargo_PleaseConfirmThisTime: '確認してください。今回の{0}金額は: ',
  Cargo_PleaseDeleteAfterVoid: '無効にしてから削除してください。',
  Cargo_PleaseEnterAccountTitle: '科目名を入力してください。',
  Cargo_PleaseEnterAmount: '金額を入力してください',
  Cargo_PleaseEnterClientName: '顧客名を入力してください。',
  Cargo_PleaseEnterCode: 'コードを入力してください。',
  Cargo_PleaseEnterCorrectAmount: '正しい金額を入力してください。',
  Cargo_PleaseEnterCorrectBillingParty: '正しい決済対象を入力してください。',
  Cargo_PleaseEnterCorrectExchangeRate: '正しい為替レートを入力してください。',
  Cargo_PleaseEnterCorrectNumber: '正しい数字を入力してください。',
  Cargo_PleaseEnterCurrencyExchangeRate: '通貨【{0}】の為替レートを入力してください。',
  Cargo_PleaseEnterDate: '日付を入力してください',
  Cargo_PleaseEnterDateOfReceipt: '入金日を入力してください。',
  Cargo_PleaseEnterDifferential: '差額を入力してください',
  Cargo_PleaseEnterExpenseDescription: '費用名を入力してください。',
  Cargo_PleaseEnterExpenseDetails: '費用の詳細を入力してください',
  Cargo_PleaseEnterFinancialCode: '財務コードを入力してください。',
  Cargo_ApAndArCodeIsEmpty: '現在、【未収符号化】／【未払符号化】はすべて空ですので、データを完全にしてから再試行してください。',
  Cargo_PleaseEnterFinancialDate: '会計処理日を入力してください',
  Cargo_PleaseEnterHsCode: 'HSCodeを入力してください',
  Cargo_PleaseEnterInformationOf: '【{0}】の補助会計{1}情報を入力してください。',
  Cargo_PleaseEnterInvoiceInformation: '請求書情報を入力してください',
  Cargo_PleaseEnterInvoiceNo: '請求書番号を入力してください。',
  Cargo_PleaseEnterInvoiceNoP: '請求書番号を入力してください: ',
  Cargo_PleaseEnterMailingAddress: '宅配便の住所を入力してください。',
  Cargo_PleaseEnterName: '名前を入力してください。',
  Cargo_PleaseEnterNewInvoiceNo: '新しい請求書番号を入力してください。',
  Cargo_PleaseEnterNewInvoiceTitle: '新しい請求書ヘッダーを入力してください。',
  Cargo_PleaseEnterOperationCode: 'オペレータを入力してください。',
  Cargo_PleaseEnterOurBankAccountNo: 'こちらの銀行口座番号を入力してください。',
  Cargo_PleaseEnterPaidInAmount: '実収金額を入力してください。',
  Cargo_PleaseEnterPaidInDate: '受取日を入力してください。',
  Cargo_PleaseEnterPaymentParty: '支払単位を入力してください',
  Cargo_PleaseEnterPaymentTerm: '支払条件を入力してください。',
  Cargo_PleaseEnterPlanName: 'シナリオ名を入力してください',
  Cargo_PleaseEnterGuarantrrName: '保証書名をお願いします。',
  Cargo_PleaseEnterRecipientSName: '受信者名を入力してください。',
  Cargo_PleaseEnterReturnedCourierNo: '返却宅配便番号を入力してください。',
  Cargo_PleaseEnterSalesCompanySBank: '売上単位の口座開設行を入力してください。',
  Cargo_PleaseEnterScarletLetterNumber: '赤い通知番号を入力してください',
  Cargo_PleaseEnterSearchInformation: 'クエリ情報を入力してください。',
  Cargo_PleaseEnterSettlingParty: '決済対象を入力してください',
  Cargo_PleaseEnterSobCode: '帳簿コードを入力してください。',
  Cargo_PleaseEnterSobName: '帳簿名を入力してください。',
  Cargo_PleaseEnterSplitAmount: '分割金額を入力してください。',
  Cargo_PleaseEnterTableName: 'テーブル名を入力してください',
  Cargo_PleaseEnterTelNo: '連絡先電話番号を入力してください。',
  Cargo_PleaseEnterUserName: 'ユーザーを入力してください',
  Cargo_PleaseEnterValueOfCondition: '条件値を入力してください。',
  Cargo_PleaseEnterVoucherLetter: '証憑の文字を入力してください。',
  Cargo_PleaseEnterVoucherNo: '買掛伝票番号を入力してください',
  Cargo_PleaseEnterVoucherType: '証明書のタイプを入力してください。',
  Cargo_PleaseInputJobNo: 'ジョブ番号を入力してください',
  Cargo_PleaseReselectTheVoucherToExport: 'エクスポートする資格情報を再度選択してください。',
  Cargo_PleaseSelect: '選択してください',
  Cargo_PleaseSelectP: '-選択してください-',
  Cargo_PleaseSelect2OrMoreApplications: '2つ以上の申請書を選択してください。',
  Cargo_PleaseSelectAccountTitle: '勘定を選択してください。',
  Cargo_PleaseSelectAnAdvanceReceipt: '前受/預り金を選択してください。',
  Cargo_PleaseSelectAnExpenseItem: '費用を選択してください。',
  Cargo_PleaseSelectAnInvoice: '請求書を選択してください。',
  Cargo_PleaseSelectAPAndARExpense: '買掛金と売掛金を選択してください。',
  Cargo_PleaseSelectApplication: '申請書を選択してください。',
  Cargo_PleaseSelectARecord: 'レコードを選択してください。',
  Cargo_PleaseSelectBill: '請求書を選択してください。',
  Cargo_PleaseSelectBillToMark: 'マークする請求書を選択してください。',
  Cargo_PleaseSelectBillToPrint: '印刷する請求書を選択してください。',
  Cargo_PleaseSelectBillToRemove: '削除する請求書を選択してください。',
  noRowsToShow: '検索結果なし',
  Cargo_HblTeleReleaseGuarantee: 'HBL電放印刷検査保証書です',
  Cargo_TeleReleaseBillType: '電放荷証券の種類です',
  Cargo_PleaseSelectBranch: '支社を選択してください。',
  Cargo_SelectBranch: '支社を選択します',
  Cargo_ApplicationBranch: 'アプリケーションオペレーションブランチ',
  Cargo_ApplicationDepartment: 'アプリケーションオペレーション部門',
  Cargo_MoreBusinessConditions: 'その他のビジネス条件',
  Cargo_MoreConditionsOptions: 'その他の条件オプション',
  Cargo_BusinessConditionsOptions: 'ビジネス条件オプション',
  Cargo_PleaseSelectBusiness: 'ビジネスを選択してください。',
  Cargo_PleaseSelectBusinessDate: '取引日を選択してください。',
  Cargo_PleaseSelectBusinessOrderRecord: 'ビジネスシートレコードを選択してください。',
  Cargo_PleaseSelectBusinessType: '取引タイプ を選択してください',
  Cargo_PleaseSelectGuaranteeType: '保証書の種類をお願いします。',
  Cargo_PleaseSelectClosureTime: '終了時間を選択してください。',
  Cargo_PleaseSelectContentToModify: '変更するものを選択してください。',
  Cargo_PleaseSelectCurrency: '通貨を選択してください。',
  Cargo_PleaseSelectData: 'データを選択してください。',
  Cargo_PleaseSelectContainerGroup: '追加操作を行うため、コンテナグループを1つ指定して選択してください。',
  Cargo_AutomaticReleaseTips: 'There is a bill of lading in the status of being available for release, and there is no need for special approval of the bill.',
  Cargo_PleaseSelectDataToDelete: '削除するデータを選択してください。',
  Cargo_PleaseSelectDataToRevoke: '無効にするデータを選択してください。',
  Cargo_SuredRevokeJob: '選択したビジネスを無効にしますか？',
  Cargo_PleaseSelectDataToExport: 'エクスポートするデータを選択してください。',
  Cargo_PleaseSelectDataType: 'データ型を選択してください。',
  Cargo_PleaseSelectDataTypeToCreate: '生成するデータ型を選択してください。',
  Cargo_PleaseSelectDate: '日付を選択してください',
  Cargo_PleaseSelectExpense: '費用を選択してください。',
  Cargo_PleaseSelectExpenseToConfirm: '確認する費用を選択してください。',
  Cargo_PleaseSelectExpenseToSplit: '分割する費用を選択してください。',
  Cargo_PleaseSelectExpenseToWriteOff: 'キャンセルする費用を選択してください。',
  Cargo_PleaseSelectFile: 'ファイルを選択してください',
  Cargo_OwnFileDelete: '権限不足: 他のユーザーがアップロードしたファイルを削除できません',
  Cargo_PleaseSelectFileType: 'ファイルタイプを選択してください',
  Cargo_PleaseSelectGroupingCondition: 'グループ化条件を選択してください',
  Cargo_PleaseSelectGroupingCondition2: 'グループ化条件1を選択してください。',
  Cargo_PleaseSelectIncludedBizNo: '計上ビジネス番号を選択してください',
  Cargo_PleaseSelectInvoice: '請求書を選択してください。',
  Cargo_PleaseSelectInvoiceNo: '請求書番号を選択してください。',
  Cargo_PleaseSelectOurBank: 'こちらの銀行を選択してください。',
  Cargo_PleaseSelectPaymentApplication: '支払要求を選択してください。',
  Cargo_PleaseSelectTheRecord: '変更するレコードを選択してください',
  Cargo_batchChangePaymentSuccess: '支払要求の一括変更に成功しました',
  Cargo_batchChangePaymentFailed: '支払要求の一括変更に失敗しました',
  Cargo_NotEmptyChangePaymentTime: '支払要求時間は空にできません',
  Cargo_ApprovedSuccess: '承認されました。',
  Cargo_ApprovedFaild: '承認に失敗しました。',
  Cargo_ReturnedSuccess: '返品に成功しました。',
  Cargo_ReturnedFaild: '返品に失敗しました。',
  Cargo_NoBusinessApproval: 'ビジネス承認が必要なデータはありません。',
  Cargo_NoDeptApproval: '部門承認が必要なデータはありません。',
  Cargo_NoFinanceApprovalData: '財務審査が必要なデータはありません',
  Cargo_NoSupervisorApprovalData: '主管審査が必要なデータはありません',
  Cargo_PleaseSelectPeriodRange: '期間範囲を選択してください',
  Cargo_PleaseSelectRecord: 'レコードを選択してください。',
  Cargo_PleaseSelectRecordToInvoice: '請求するレコードを選択してください。',
  Cargo_PleaseSelectRecordToReview: 'レビューするレコードを選択してください。',
  Cargo_PleaseSelectRecordToCancelReview: 'レビューをキャンセルするレコードを選択してください。',
  Cargo_PleaseSelectRecordToWriteOff: 'キャンセルするレコードを選択してください。',
  Cargo_PleaseSelectReviewDate: 'レビュー日を選択してください。',
  Cargo_PleaseSelectSameInvoiceType: '同じ請求書タイプを選択してください。',
  Cargo_PleaseSelectServiceTicket: '料金確認票を選択してください。',
  Cargo_PleaseSelectSettlingParty: '決算対象を選択してください。',
  Cargo_AddTag: 'マークを追加',
  Cargo_NotFoundNeedSaveCharges: 'リストには追加料金はありません。',
  Cargo_SureSaveBilling: '請求書を保存して生成してもよろしいですか？',
  Cargo_SureSaveChargeOnly: '費用のみを保存してもよろしいですか？',
  Cargo_SureCancelEdit: '編集をキャンセルしてもよろしいですか？',
  Cargo_JobBillingChargeNotEqual: '業務【｛0｝】の【｛1｝】【｛2｝】と請求書の不一致は、不一致費用を削除してから修正できます！。',
  Cargo_SaveGenerateBills: '請求書を保存して生成する',
  Cargo_GenerateExpensesOnly: '費用のみ生成',
  Cargo_PleaseSelectSoa: '請求書を選択してください。',
  Cargo_PleaseSelectSob: '帳簿を選択してください。',
  Cargo_PleaseSelectStartTime: '開始時間を選択してください。',
  Cargo_PleaseSelectThePurchaser: '購入者を選択してください。',
  Cargo_PleaseSelectTypeOfJournalEntries: '入力タイプを選択してください。',
  Cargo_PleaseSelectVatInvoice: 'VAT請求書を選択してください。',
  Cargo_PleaseSelectVatEiInvoice: 'VAT電子チケットを選択してください。',
  Cargo_PleaseSelectVoucher: '証明書を選択してください。',
  Cargo_PleaseSelectVoucherGroupingRule: '証憑のグループ化ルールを選択してください',
  Cargo_PleaseSelectVoucherToCancel: 'キャンセルする資格情報を選択してください。',
  Cargo_PleaseSelectVoucherToReview: '監査する資格情報を選択してください。',
  Cargo_PleaseSelectWriteOffDetails: '相殺明細を選択してください。',
  Cargo_PleaseSelectWriteOffRecord: '売上レコードを選択してください。',
  Cargo_PleaseSpecifyPaymentPeriodRange: '会計期間の範囲を指定してください',
  Cargo_PleaseUseComponent: 'コンポーネントを使用してください',
  Cargo_PlsInput: '入力してください',
  Cargo_PLVDCTBE: '損益伝票日付は空にできません',
  Cargo_PLVDNITP: '損益伝票日付が期間内ではありません',
  Cargo_PLVFCTBE: '損益伝票は空欄にできません',
  Cargo_PLVNAPATCTBE: '損益計算書の未分配利益勘定は空にできません',
  Cargo_PoaCustomsDeclaration: '通関の依頼',
  Cargo_PODcode: '港コード',
  Cargo_PodSea: '荷揚港（海港）',
  Cargo_Unloading: 'Unloading',
  Cargo_ArrivalNotice: 'Arrival Notice',
  Cargo_PickUp: 'Pick Up',
  Cargo_AircraftGISPositioning: 'aircraft GIS positioning',
  Cargo_FileFromQuotation: '見積管理からインポートされたファイルは削除できません',
  Cargo_FileFromInquiry: '見積依頼管理からインポートされたファイルは削除できません',
  Cargo_PointOfPermission: 'アクセスポイント',
  Cargo_PointsToNote: '特殊性の有無',
  Cargo_Pol: '船積み港',
  Cargo_PolAgent: '出発港エージェント',
  Cargo_POLCannotBeNull: '出発港は空にできません',
  Cargo_PolSea: '出港（海港）',
  Cargo_Port: '港',
  Cargo_PortCodeCanTBeEmpty: '港コードは空にできません',
  Cargo_PortGroup: '港群',
  Cargo_PortGroupCanTBeEmpty: 'ポートグループは空にできません',
  Cargo_PortOfDestinationCode: '宛先ポートコード',
  Cargo_PortOfDischarge: '揚げ港',
  Cargo_PortOfDischargeCannotBeNull: '荷揚げ港は空にできません',
  Cargo_PortOfLoading: '出発港',
  Cargo_PortOfLoadingSea: '積み出し港（海運）',
  Cargo_PortOfLoadingAir: '出発港（空輸）',
  Cargo_PortPrompt: '港を入力してください',
  Cargo_PortRequirement: '港の要求',
  Cargo_PositiveOperation: '正の操作',
  Cargo_Post: '部署',
  Cargo_PotentialStage: '潜在的なステージ',
  Cargo_PPNCASA: '端数処理として、前払金は生成されません。',
  Cargo_PRCTBCFWOE: '消込済費用/業務は支払要求を作成できません。',
  Cargo_PreCollection: '前受金',
  Cargo_PreferredAgentAtDestination: '優先目的地エージェント',
  Cargo_PreferredAirline: '優先航空会社',
  Cargo_PreferredAirport: '優先空港',
  Cargo_PreferredAirportAir: '港（空港）を好む',
  Cargo_PreferredCustomsBroker: '優先通関サービス',
  Cargo_PreferredOceanCarrier: '船会社を好む',
  Cargo_PreferredPort: '港を好みます',
  Cargo_PreferredPortSea: '好みの港（海港）',
  Cargo_PreferredShippingMethod: '優先出荷タイプ',
  Cargo_PreferredShippingRoute: '優先ルート',
  Cargo_PreferredShippingTerms: '優先運送条件',
  Cargo_PreferredTrucker: '優先トレイラ行',
  Cargo_PreferredTruckingService: '優先トレーラーサービス',
  Cargo_PrepaidOrNot: '前払いするかどうか',
  Cargo_PreparedBy: '作成者',
  Cargo_PreparedByP: '作成者: ',
  Cargo_PrepareServiceTicket: '料金確認票を作成します',
  Cargo_PrePayment: '前受金かどうか',
  Cargo_PrepaymentRecordedSuccessfully: '前払いの登録に成功しました。',
  Cargo_PreReviewStatus: 'レビュー前の状態',
  Cargo_PreReviewAllStatus: '予審処理状況（レビュー）',
  Cargo_PreSubmission: 'プレコミット',
  Cargo_PreviewEmailContent: 'メールの内容をプレビューします',
  Cargo_Previous: '前へ',
  Cargo_PrimeCost: 'コスト',
  Cargo_Print: '印刷',
  Cargo_PrintAll: 'すべて印刷',
  Cargo_PrintBill: '請求書の印刷',
  Cargo_PrintedSuccessfully: '印刷に成功しました。',
  Cargo_PrintInvoice: '請求書の印刷',
  Cargo_PrintList: 'リスト印刷',
  Cargo_PrintOrNot: '印刷するかどうか',
  Cargo_LACKINVOICE: '請求書不足かどうか',
  Cargo_Printout: '印刷結菓',
  Cargo_PrintPaymentList: '支払リストの印刷',
  Cargo_PrintSoa: '取引明細書の印刷',
  Cargo_PrintStatusSaved: '印刷状態の保存に成功しました。',
  Cargo_PrintTheProfit: '利益の印刷',
  Cargo_PrintVerification: '印刷の確認',
  Cargo_PrintWithdrawalList: '印刷（返品リスト）',
  Cargo_ProcessedAsShortAccount: '端数処理勘定として処理',
  Cargo_ProcessedBy: '処理者',
  Cargo_ProcessingChangeRemarks: '調整コメントの処理',
  Cargo_ProcessingPleaseWait: 'お待ちください。処理中です...',
  Cargo_ProcessingRemarks: 'コメントの処理',
  Cargo_ProcessingTime: '処理時間',
  Cargo_ProductName: 'プラン名',
  Cargo_Profit: '利益',
  Cargo_ProfitLossAccount: '損益勘定',
  Cargo_ProfitLoss: '損益計算書',
  Cargo_ProfitLoss2: '損益計算書2',
  Cargo_ProfitLossVoucherNoCanTBeEmpty: '損益伝票番号は空にできません',
  Cargo_ProfitLossVoucherNotInThePeriod: '損益伝票は期間内ではありません',
  Cargo_Prompt: '業務通知',
  Cargo_Proof: '買掛伝票',
  Cargo_ProofDate: '証憑日付',
  Cargo_ProofDateP: '証憑の日付: ',
  Cargo_ProofOrNot: '証憑を生成するかどうか',
  Cargo_Property: 'プロパティ',
  Cargo_Province: '省',
  Cargo_PRSCSCRICP: '船会社の回収記録、回収タブで取り消してください。',
  Cargo_PSALOAPAARE: '少なくとも1つの買掛金および売掛金を選択してください。',
  Cargo_PSALOER: '少なくとも1つの費用レコードを選択してください。',
  Cargo_PSALOGODC: '少なくとも1組の日付条件を選択してください。',
  Cargo_SelectLockOrderCondition: 'ロック条件を選択',
  Cargo_PSBOTSSP: '同じ決済単位の請求書を選択してください',
  Cargo_PSCI: '回収情報を選択してください',
  Cargo_PSDTOVG: '証憑のグループ化データ型を選択してください。',
  Cargo_PSEDTRWO: 'キャンセルする費用の詳細を選択してください。',
  Cargo_PSFDD: '通関申告書入力ページングクエリ',
  Cargo_PSFPOTSY: '会計期間は同じ年を選択してください。',
  Cargo_PleaseSelectVoucherRange: '買掛伝票の範囲を選択してください',
  Cargo_PSGROJE: '入力グループ化ルールを選択してください',
  Cargo_PSOR: '操作内容要件を選択してください',
  Cargo_PSPAF: '支払申請書を選択してください。',
  Cargo_PSPATD: '削除する支払要求を選択してください。',
  Cargo_PSPATW: '取り下げる支払要求を選択してください。',
  Cargo_PSPATR: '返品する支払要求を選択してください。',
  Cargo_PSPATS: '送信する支払要求を選択してください。',
  Cargo_PSROACP: '実際の入金レコードを選択してください。',
  Cargo_PSRTCPA: '支払要求を作成するレコードを選択してください。',
  Cargo_PSRTCV: '買掛伝票を生成するレコードを選択してください。',
  Cargo_PSSDOCD: '開始日または終了日を選択してください。',
  Cargo_PSUSPAF: '未提出の支払申請書を選択してください。',
  Cargo_PSSPAF: '承認されていない支払要求のみが取り下げられます',
  Cargo_PSVOFS: '財務ソフトウェアのバージョンを選択してください。',
  Cargo_CurrencyMismatch: '{0}の通貨が銀行口座番号と一緻しません。帳簿を修正してください',
  Cargo_PublicClientHub: '顧客公海',
  Cargo_Publish: 'パブリッシュ',
  Cargo_PublishStatus: '発行処理状況',
  Cargo_PurchasedBy: '購入者',
  Cargo_PurchaseRecord: '購入記録',
  Cargo_PurchaseRegisteredSuccessfully: '購入登録が成功しました。',
  Cargo_PurchaseRegistration: '購買登録',
  Cargo_PurchasingParty: '購入する側',
  Cargo_PurchasingUnit: '購入単位',
  Cargo_PUSBAANMRIDSS: '購入単位の口座開設行と口座番号は{0}の銀行口座ではありません。保存しますか？',
  Cargo_PutARItemsOnTop: '売掛金を上に',
  Cargo_PYPALAA: '前年度の損益調整勘定',
  Cargo_PYPALAAP: '前年度の損益調整勘定: ',
  Cargo_Query: 'データ検索',
  Cargo_QueryFailed: 'クエリが失敗しました。',
  Cargo_QueryInvoice: '請求書照会',
  Cargo_QuickSearch: '簡単なクエリ',
  Cargo_QuotaCurrency: 'クォータ通貨',
  Cargo_QuotaRange: '定額区間',
  Cargo_RAIAV: '絶対値をとった決済金額',
  Cargo_Railway: '鉄道',
  Cargo_RailwayExport: '鉄道の出口',
  Cargo_RailwayImport: '鉄道の輸入',
  Cargo_RailwayBusiness: '鉄道事業',
  Cargo_IntegratedJob: '総合物流',
  Cargo_FbaOrder: 'Fba Order',
  Cargo_FbaSea: 'FBA海運',
  Cargo_FbaAir: 'FBA空輸',
  Cargo_FbaRailway: 'FBA鉄道',
  Cargo_RailwayRoute: '鉄道路線',
  Cargo_RCAFTPOY: '逆決算{0}年第{1}期',
  Cargo_RCBDIDL: '現在のプルダウン支社データを更新します',
  Cargo_RealPaid: '実払い',
  Cargo_RealPaidP: '実払い: ',
  Cargo_ReasonNotEntered: '理由未記入',
  Cargo_ReasonOfCargoDetention: '控除の理由',
  Cargo_ReasonOfCargoDetentionP: '控除理由: ',
  Cargo_ReCalculateBillingAmount: '請求金額の再計算',
  Cargo_Receipt: '入金',
  Cargo_ReceiptAmount: '入金金額',
  Cargo_Receivable: '売掛金',
  Cargo_ReceivableToCNY: 'CNY未収金換算：',
  Cargo_ReceivableB: '（受取）',
  Cargo_ReceivedCNY: 'CNY受信しました',
  Cargo_PayPaidCNY: 'CNY払いました',
  Cargo_ReceivedUSD: 'USD受信しました',
  Cargo_ReceivedEUR: 'EUR受信しました',
  Cargo_ReceivedGBP: 'GBP受信しました',
  Cargo_ReceivedHKD: 'HKD受信しました',
  Cargo_ReceivedJPY: 'JPY受信しました',
  Cargo_ReceivedNGN: 'NGN受信しました',
  Cargo_PayPaidUSD: 'USD払いました',
  Cargo_PayPaidEUR: 'EUR払いました',
  Cargo_PayPaidGBP: 'GBP払いました',
  Cargo_PayPaidHKD: 'HKD払いました',
  Cargo_PayPaidJPY: 'JPY払いました',
  Cargo_PayPaidNGN: 'NGN払いました',
  Cargo_OtherConversionReceivedUSD: 'その他の換算USD受信済みです',
  Cargo_OtherConversionReceivedEUR: 'その他の換算EUR受信済みです',
  Cargo_OtherConversionReceivedGBP: 'その他の換算GBP受信済みです',
  Cargo_OtherConversionReceivedHKD: 'その他の換算HKD受信済みです',
  Cargo_OtherConversionReceivedJPY: 'その他の換算JPY受信済みです',
  Cargo_OtherConversionReceivedNGN: 'その他の換算NGN受信済みです',
  Cargo_OtherConversionPayPaidUSD: 'その他はUSD払いです',
  Cargo_OtherConversionPayPaidEUR: 'その他はEUR払いです',
  Cargo_OtherConversionPayPaidGBP: 'その他はGBP払いです',
  Cargo_OtherConversionPayPaidHKD: 'その他はHKD払いです',
  Cargo_OtherConversionPayPaidJPY: 'その他はJPY払いです',
  Cargo_OtherConversionPayPaidNGN: 'その他はNGN払いです',
  Cargo_OtherConversionReceivedCNY: 'その他の換算CNY受信済みです',
  Cargo_OtherConversionPayPaidCNY: 'その他はCNY払いです',
  Cargo_ReceivableCNY: 'CNY売掛金',
  Cargo_ReceivableEUR: 'EUR売掛金',
  Cargo_ReceivableGBP: 'GBP売掛金',
  Cargo_ReceivableHKD: 'HKD売掛金',
  Cargo_ReceivableJPY: 'JPY売掛金',
  Cargo_ReceivableNGN: 'NGN売掛金',
  Cargo_ReceivableP: '受取: ',
  Cargo_ReceivablesInvoicingDate: '入金請求日',
  Cargo_ReceivablesInvoicingStatus: '受取請求書処理状況',
  Cargo_ReceivablesWriteOfStatus: '売掛消込状況',
  Cargo_ReceivableUSD: 'USD売掛金',
  Cargo_Receive: '受信',
  Cargo_RevocationOfReceipt: '受信の取り消し',
  Cargo_Received: '受信しました',
  Cargo_ReceivedDate: '入金日',
  Cargo_ReceiveMethod: '入金方法',
  Cargo_Receiver: '受取人',
  Cargo_Receiver2: '受信者',
  Cargo_ReceiverCompanyName: '受信単位',
  Cargo_ReceivingBank: '受取銀行',
  Cargo_ReceivingBankAccount: '入金口座番号',
  Cargo_ReceivingDate: '取得日',
  Cargo_Recheck: 'レビュー',
  Cargo_RecheckDate: 'レビュー日',
  Cargo_ReCheckedSuccessfully: '確認に成功しました。',
  Cargo_CancelReCheckedSuccessfully: 'キャンセルに成功しました。',
  Cargo_RecheckOrNot: '再検討するかどうか',
  Cargo_RecheckP: 'チェック: ',
  Cargo_ReCheckPermission: 'レビュー権限',
  Cargo_RecipientOfWithdrawal: '返品先',
  Cargo_RecipientSCompanyOfWithdrawal: '返品先の単位',
  Cargo_ReconcileOrNot: '消込済ですか',
  Cargo_Reconciliation: '消込済',
  Cargo_ReconciliationAmount: '消込済金額',
  Cargo_ReconciliationConfirmation: '消込確認',
  Cargo_ReconciliationDate: '決済日',
  Cargo_ReconciliationOfAR: '売掛金の照合',
  Cargo_ReconciliationStatus: '決済処理状況',
  Cargo_ReconciliationStatusControl: '決済処理状況コントロール',
  Cargo_ReconciliationType: '決済タイプ',
  Cargo_SendEmailByReconciliationDiff: '保存時にメール通知料金を同期するか作成者の帳簿金額が一致しない',
  Cargo_ReconciliationDiffConfirm: '照合差異処理',
  Cargo_ReconciliationDiffReason: '差異の理由',
  Cargo_ReconciliationDiffConfirmTip: '保存時にメール通知を送信するかどうか帳簿金額が一致しない',
  Cargo_Record: 'レコードの登録',
  Cargo_RecordCount: 'レコード数',
  Cargo_Recorder: '記録者',
  Cargo_RecordLabel: 'レコードラベル',
  Cargo_RecordNoOfPaidIn: '実収登録番号',
  Cargo_RecordOrNot: '登録するかどうか',
  Cargo_RecordOutOfPocket: '実払い登録',
  Cargo_RecordPrepayment: '前払いの登録',
  Cargo_RecordsFound: '{0}レコードがクエリされました',
  Cargo_RecordsWithEmptyInvoiceTypeExist: '請求書タイプが空のレコードがあります',
  Cargo_RecordTime: '記録時間',
  Cargo_RedChargesOrNot: '海外費用に有効な請求書番号がないかどうか',
  Cargo_ReDeliveryOrNot: '再送しますか？',
  Cargo_ReferralFromExistingClient: '常連客の紹介',
  Cargo_Reflush: '更新',
  Cargo_RefNbr: '通関番号',
  Cargo_Refresh: 'リフレッシュ',
  Cargo_RefreshCompleteStatus: '更新が完了しました。',
  Cargo_RefreshSearch: 'クエリの更新',
  Cargo_RefundAdvanceReceipt: '前受/預り金の返却',
  Cargo_RefundOfLclBusiness: 'チャージバックは必要ですか？',
  Cargo_Refuse: '拒否します',
  Cargo_Region: 'エリア',
  Cargo_RegisteredCapital: '会社登録金',
  Cargo_RegisteredCapitalIn10Thousand: '会社登録金/万',
  Cargo_RegistrationNumber: '納税者識別番号',
  Cargo_RegistrationNumberP: '納税者識別番号: ',
  Cargo_ReIssuedInvoiceNo: '新規請求書番号の再発行',
  Cargo_ReIssuedInvoiceNoP: '新規請求書番号の再発行: ',
  Cargo_ReIssueInvoice: '請求書の再発行',
  Cargo_ReIssueVoidedInvoice: '無効化後に再請求',
  Cargo_RelatedBLNo: '関連船荷証券番号',
  Cargo_Release: 'リリース',
  Cargo_ReleaseHbl: '個別にリリースします',
  Cargo_Releasing: '注文を入れます',
  Cargo_ReleasingStatus: 'リリース処理状況',
  Cargo_RemainingAmount: '残りの金額',
  Cargo_RemainingPledgedAmount: '残りの請求金額',
  Cargo_Remarks: '備考',
  Cargo_SupervisorComments: '管理者コメントエリア',
  Cargo_RemarksCannotBeEmptyWhenWipeOut: '端数を無視する場合、コメントは空にできません。',
  Cargo_RemarksOnAROrAPItems: '支払勘定コメント',
  Cargo_RemarksOnPayment: '支払コメント',
  Cargo_RemarksP: 'コメント: ',
  Cargo_ArOriginalCurrency: '受取（元の通貨）',
  Cargo_ApOriginalCurrency: '買掛金（元の通貨）',
  Cargo_RemarkTheLengthCannotExceedP: 'コメントの長さは超えられません',
  Cargo_RemarkTheLengthCannotExceedP256: 'コメントの長さは256を超えてはいけません。',
  Cargo_RemittanceFee: '為替手数料',
  Cargo_Remove: '削除',
  Cargo_RemoveConfig: 'Remove Config',
  Cargo_AddConfig: 'Add Config',
  Cargo_RemoveBillCharge: '費用の削除',
  Cargo_RemoveDetails: '詳細の削除',
  Cargo_RemoveExpenseRemoveAll: '費用の削除/すべての削除',
  Cargo_RemoveParameterFunction: 'パラメータ除去機能',
  Cargo_RemovePartial: '部分を削除します',
  Cargo_OrderType: '注文タイプ',
  Cargo_TruckTrailer: '集峠トレーラー',
  Cargo_WholeVehicleAndLessThanCarload: '車全体/ゼロ荷',
  Cargo_RemovePermissionToSubmitExpense: '支出権限の削除',
  Cargo_RemoveSelectedData: '選択したデータを削除します',
  Cargo_RemoveSelectedExpense: '選択した費用を削除します',
  Cargo_RenderStyle: 'スタイルレンダリング',
  Cargo_Renew: '更新します',
  Cargo_RenewContract: '契約の更新',
  Cargo_ReOpen: '再開します',
  Cargo_ReOpenedSuccessfully: '再開に成功しました。',
  Cargo_RepeatedMaintenance: '繰り返しメンテナンス',
  Cargo_ReplaceBill: '請求書の交換',
  Cargo_ReportTo: 'レポートオブジェクト',
  Cargo_Reset: 'リセット',
  Cargo_ResetFilter: '条件リセット',
  Cargo_Restore: '復元',
  Cargo_RestoreSelectedClient: '選択したクライアントのリカバリを確認しますか',
  Cargo_RetreatASingle: '返品リスト',
  Cargo_RetrievalFailureReturnFunction: '取得失敗の戻り関数',
  Cargo_RetrievalFunction: '検索関数',
  Cargo_RetrievalType: '取得タイプ',
  Cargo_RetrievalTypeP: '取得タイプ: ',
  Cargo_Retrieved: '取り込み済み',
  Cargo_RetrievedButNotReturned: '回収済み（未返却）',
  Cargo_RetrieveMark: 'マーク取得',
  Cargo_Return: '返却',
  Cargo_ReturnDate: '返却日',
  Cargo_Returned: '返却済み',
  Cargo_ReturnedSuccessfully: '返却は成功しました。',
  Cargo_ReturnExpressNumber: '返却宅配便番号',
  Cargo_ReturnOrderExpressNumber: '返品エクスプレス番号',
  Cargo_ReturnQuery: 'クエリを返す',
  Cargo_ReturnToSearch: 'クエリを返すかどうか',
  Cargo_Revenue: '収益',
  Cargo_RevenueAndExpenditureType: '収支種別',
  Cargo_RevenueOrExpenditure: '収支',
  Cargo_Reverse: '赤沖の確認',
  Cargo_ReversedCloseAccountSuccessfully: '逆決算が成功しました',
  Cargo_CloseAccountSuccessfully: '決済が成功しました',
  Cargo_ReverseReview: 'レビューの取り消し',
  Cargo_ReverseReviewedSuccessfully: 'レビューは成功しました',
  Cargo_ReviewCancelledSuccessfully: 'レビューのキャンセルに成功しました。',
  Cargo_ReviewedOrNot: 'レビュー済みかどうか',
  Cargo_ReviewOverallSearch: '監査グローバルクエリ',
  Cargo_ReviewTime: 'レビュー時間',
  Cargo_ReviewVoucher: '監査証跡',
  Cargo_Revoke: '取り消し',
  Cargo_RevokeClaim: '受領取消',
  Cargo_RevokedSuccessfully: '取り消しに成功しました。',
  Cargo_RevokeInvoicingApplication: '請求取消申請',
  Cargo_RevokeOrNot: '取り消しますか',
  Cargo_PushFailByCBMS: 'プッシュに失敗しました。スタッフに連絡して調査してください',
  Cargo_PushSuccessByCBMS: 'プッシュビジネス成功',
  Cargo_RevokeReview: 'レビューの取り消し',
  Cargo_RevokeSelection: 'チェックを外す',
  Cargo_RevokeWithdrawal: 'キャンセルを取り消します',
  Cargo_RevokeWithdrawalList: 'キャンセルリスト',
  Cargo_RevokingRetrievalFailed: '取得の取り消しに失敗しました。',
  Cargo_RFPNMIS: '対応する会計期間が帳簿で維持されていません。',
  Cargo_RITSS: 'レコードがシステムに正常にインポートされました。',
  Cargo_RTGTEOMCACC: 'ゴールデン税エクスポートを繰り返すと追加料金が発生する可能性があります。再度ゴールデン税エクスポートを行いますか？',
  Cargo_RTIAFRODI: '【経費精算書も削除】を選択しない場合は、請求書を請求書要求レビューに戻します。選択しない場合は、請求書と経費精算書を削除します',
  Cargo_RTPIRS: '請求書審査中にリセットされました',
  Cargo_Rule: 'ルール',
  Cargo_SABID: '基本情報の記入を直接スキップするかどうか',
  Cargo_SADNSUICAT: '現在の勘定には補助勘定が設定されていません。',
  Cargo_SailingDate: '出航日',
  Cargo_SailingDay: '出航日',
  Cargo_ETD: 'ETD（出発予定日）',
  Cargo_ETA: 'ETA（到着予定日）',
  Cargo_ATD: '出港予定日（ATD）',
  Cargo_ATA: '到着予定日（ATA）',
  Cargo_LookDetail: '詳細を表示する',
  Cargo_Sales: '営業',
  Cargo_SalesP: '営業: ',
  Cargo_SalesBranchCompany: '営業部門名',
  Cargo_SalesCommission: '売上歩合',
  Cargo_SalesCompany: '販売会社',
  Cargo_SalesDepartment: '営業部門名',
  Cargo_SalesFreeHand: '売上自拓',
  Cargo_Salesman: '営業マン',
  Cargo_SalesmanP: '営業担当者: ',
  Cargo_SalesParty: '販売先',
  Cargo_SalesPerson: '営業担当者',
  Cargo_SALOGROEI: '少なくとも1つのグループ化条件を選択するか、要約名を入力する必要があります。',
  Cargo_SameYear: '同じ年',
  Cargo_SAPPMBI: '選択した受取/支払決済単位は同じでなければなりません。',
  Cargo_Save: '保存',
  Cargo_SaveAll: 'すべてを保存',
  Cargo_SaveAndAdd: '保存して追加します',
  Cargo_SaveAndCalculateTotalAmount: '合計金額を保存して計算します',
  Cargo_SaveBill: '請求書の保存',
  Cargo_SaveCurrentSelection: '現在の選択を保存します',
  Cargo_CurrentSelection: '現在の選択',
  Cargo_Saved: '保存が完了しました。',
  Cargo_SaveEditing: '編集を保存します',
  Cargo_SaveEntity: 'エンティティの保存',
  Cargo_SaveExchangeRateToCache: '為替レートをキャッシュに保存',
  Cargo_SaveFailed: '保存に失敗しました。',
  Cargo_SaveGroupInfo: 'グループ情報の保存',
  Cargo_SaveInvoice: '請求書の保存',
  Cargo_SaveInvoiceNo: '請求書番号の保存',
  Cargo_SaveOrNot: '正大保存かどうか',
  Cargo_SaveQueryP: 'クエリーパラメータを保存',
  Cargo_SaveReconciliation: '決済の保存',
  Cargo_SaveSucceed: '保存に成功しました。',
  Cargo_Saving: '保存中',
  Cargo_SBRASPATFRD: '支払申請は業務審査を必要とせず、直接財務審査に提出する',
  Cargo_SBSPISB: '同じ支社を決算対象別に集計',
  Cargo_ScaleOfCompany: '会社の規模',
  Cargo_ScaleOfCompanyEmployees: '会社規模/人',
  Cargo_SCNEIPMSL: 'パートナーモジュールに類似した名前の企業が存在しますが、関連付けが必要ですか',
  Cargo_SCOCCSC: '売上歩合操作歩合顧客サービス歩合',
  Cargo_SDNCCNTFL: '請求書データがロードされていません。次へをクリックしてロードしてください。',
  Cargo_SDNMBR: '請求書処理状況が請求要件を満たしていません',
  Cargo_SDNMWOR: '請求書の処理状況が消込要件を満たしていません',
  Cargo_SeaportOfDischarge: '荷揚港（海港）',
  Cargo_Search: '検索します',
  Cargo_SearchAlreadyExisted: 'クエリは既に存在します',
  Cargo_SearchAPWriteOffs: '買掛金照会',
  Cargo_SearchARWriteOff: '売掛金照会',
  Cargo_SearchCompleted: 'クエリが成功しました。',
  Cargo_SearchConditions: 'クエリー条件',
  Cargo_SearchCreated: 'クエリが生成されました',
  Cargo_SearchDisplayColumn: 'クエリー表示列',
  Cargo_SearchError: 'クエリエラー。',
  Cargo_SearchForBill: '請求書の検索',
  Cargo_SearchForBusinessDeptApproved: 'ビジネス承認と部門承認のクエリ',
  Cargo_SearchForBusinessOfSameGroup: '同じグループのビジネスを検索します',
  Cargo_SearchForData: 'クエリーデータ',
  Cargo_SearchForDataAsPerPermission: '権限に基づいてデータをクエリーするかどうか',
  Cargo_SearchForExpenses: '費用の照会',
  Cargo_SearchForMore: 'クエリを追加しますか',
  Cargo_SearchForOverseasExpense: '海外費用を照会しますか',
  Cargo_SearchForParameterTemplateList: 'クエリーパラメータテンプレートリスト',
  Cargo_SearchInformation: 'クエリ情報',
  Cargo_SearchMark: 'クエリタグ',
  Cargo_SearchOperation: 'クエリ操作',
  Cargo_SecondNotifyParty: '第2通知人',
  Cargo_SecondVoyage: '船次',
  Cargo_SecureBusiness: 'ビジネスをロックする',
  Cargo_SEFInput: '通関書類の入力',
  Cargo_Select: '選択します',
  Cargo_SelectAddPlatfoCNYLMethod: 'プラットフォーム請求方法選択追加',
  Cargo_SelectAddPlatformContainerType: 'プラットフォームコンテナタイプ選択追加',
  Cargo_SelectAddPlatformCurrency: 'プラットフォーム通貨選択追加',
  Cargo_ShippingAddress: '配送先住所',
  Cargo_AddModel: 'モデルメンテナンス',
  Cargo_maintenance: 'コンテナメンテナンス',
  cargo_container_type: 'コンテナタイプ',
  cargo_container_code: 'コンテナコード',
  cargo_container_number: 'コンテナ番号',
  cargo_pallet: 'パッケージボード',
  cargo_container_max_weight: 'コンテナに積載可能な貨物の重量',
  cargo_container_max_capacity: 'コンテナに積載可能な貨物容量',
  cargo_loading_rate: '搭載率',
  Cargo_Container_Type_Not_Configured: 'コンテナをメンテナンスしていません。【基礎データ-コンテナ】に行って対応するデータをメンテナンスできます',
  cargo_please_enter_the_container: 'コンテナを入力してください',
  cargo_please_enter_the_cost: '費用を入力してください',
  Cargo_please_enter_flight_costs: 'チャーター/チャーター便、フライトコストを入力してください。',
  Cargo_Please_enter_charter_details_or_flight_costs: 'チャーター便、チャーター情報またはフライトコストを入力してください。',
  cargo_please_enter_the_container_code: 'コンテナコードを入力してください',
  cargo_Please_select_a_container: 'コンテナを選択してください',
  cargo_Charter_package_board_statistics: 'パッケージボード統計',
  Cargo_not_allowed_reconfiguration: '操作状態以外の業務は再配置できません',
  Cargo_cross_flight_tips: 'クロスフライトは新しいコンテナを関連付け、元のビジネスに関連付けられたすべてのコンテナ情報を削除します。続行しますか？',
  Cargo_CheckUldWeightOrCubage: 'コンテナコード: {0}貨物{1}が積載可能貨物{2}を超えています。保存を確認してください。',
  Cargo_master_reconfiguration_tips: '変更後、マスターチケットの下のすべてのチケットがこのコンテナの下に関連付けられます。続行しますか？',
  cargo_can_only_be_dragged_under_a_container: 'コンテナの下までしかドラッグできません',
  cargo_requires_dragging_across_containers: 'コンテナ間のドラッグが必要です',
  cargo_no_flight_information: '現在の業務にはフライトがなく、目標位置にもフライト情報がないので、処理する必要はありません',
  cargo_unloaded_container_business: 'コンテナビジネスがロードされていません',
  Cargo_SelectAddPlatformPackages: 'プラットフォームパッケージ選択追加',
  Cargo_SelectAddPlatformShippingTerms: 'プラットフォーム運送条件選択追加',
  Cargo_SelectAddPlatformTradeMethod: 'プラットフォーム取引方法選択追加',
  Cargo_SelectAddPlatformTradeTerms: 'プラットフォーム取引条件選択追加',
  Cargo_SelectAll: 'すべて選択します',
  Cargo_SelectBusinessDateRange: '取引日範囲の選択',
  Cargo_SelectCopyContent: 'コピーするコンテンツを選択します',
  Cargo_SelectCurrency: '通貨の選択',
  Cargo_Selected: '選択されました',
  Cargo_SelectedByDefault: 'デフォルトで選択されます',
  Cargo_SelectedData: '選択されたデータ',
  Cargo_SelectedEntity: '選択されたエンティティ',
  Cargo_SelectedExpenseConfirmedExpense: '選択した費用確認済みの費用',
  Cargo_SelectedInvoice: '選択された請求書',
  Cargo_SelectedItems: '選択済み: {0}',
  Cargo_SelectedP: '選択済み: ',
  Cargo_SelectedVoucher: '選択された証明書',
  Cargo_SelectedVoucherCantOver100: '選択された買掛伝票は{0}個で、100個を超えてはいけません。',
  Cargo_SelectEventStatus: 'イベントの状態を選択してください',
  Cargo_SelectEventToApprove: '承認事項を選択してください',
  Cargo_SelectFilesToDownload: 'ダウンロードするファイルを選択してください',
  Cargo_SelectInvoiceNo: '請求書番号を選択します',
  Cargo_SelectNewInvoiceNo: '新しい請求書番号を選択します',
  Cargo_SelectOrAddInvoiceNo: '請求書番号の選択または入力',
  Cargo_SelectPaperInvoiceByDefault: 'デフォルトで紙の請求書が選択されます',
  CargoMsg_Information_Supplement: '情報の補足',
  Cargo_SelectRecordsToExport: 'エクスポートするレコードを選択してください',
  Cargo_SelectSalesPerson: '販売を選択してください',
  Cargo_SelectSalesPersonDep: '営業部門を選択してください',
  Cargo_SelectCsr: 'カスタマーサービスを選択してください',
  Cargo_SelectCsrDep: 'カスタマーサービス部門を選択してください',
  Cargo_SelectDoc: 'ドキュメントを選択してください',
  Cargo_SelectDocDep: 'ドキュメント部門を選択してください',
  Cargo_SoldSlots: '販売済みスロット',
  Cargo_RemainingSlots: '残りスロット',
  Cargo_SoldVolume: '販売済み体積',
  Cargo_RemainingVolume: '残り体積',
  Cargo_FlightDateError: 'フライト日が航路製品の有効期間外、またはフライト日と対応する便が航路製品で管理されていない便の場合、続行しますか？',
  Cargo_SelectOverseaOp: '海外カスタマーサービスを選択してください',
  Cargo_SelectOverseaOpDep: '海外カスタマーサービス部門を選択してください',
  Cargo_SelectCargoSales: '委託販売を選択してください',
  Cargo_SelectPlanner: '航路担当者を選択してください',
  Cargo_SelectPlannerDep: '航路責任者部門を選択してください',
  Cargo_invalidBatchModifyBusiness: 'オペレーションブランチと販売ブランチが同じビジネスが見つかりません。もう一度選択して試してください',
  Cargo_SelectSob: '会計帳簿の選択',
  Cargo_SelectSubject: 'テーマを選択してください',
  Cargo_SelectToCopyInFutureDoNotAsk: '後でこの選択に従ってコピーする必要はありません',
  Cargo_SelectVoucherDate: '証憑の日付を選択',
  Cargo_SelfDeclaration: '自己申告します',
  Cargo_SelfDeclareToCustoms: '自分で通関するかどうか',
  Cargo_SelfDelivery: '自分で送る',
  Cargo_SpecialApprovalIssuance: '特別承認の発行',
  Cargo_CurrentAvailableQuantity: '現在の利用可能数',
  Cargo_OccupiedBusinessNumber: '占有されているビジネス番号',
  Cargo_RemainingAvailableQuantity: '残りの利用可能数',
  Cargo_SpecialApprovalCreateBusiness: '決済対象が信用制限を超え、[保存不可]が設定されている場合、業務作成時に特別承認を利用して発行数量を特別に作成できます。',
  Cargo_CopyResult: '正常に{0}件をコピーしました、{1}件のコピーに失敗しました',
  Cargo_SellingPrice: '売値',
  Cargo_SellTitle: '販売単位',
  Cargo_Send2: '送り出す',
  Cargo_SendAll: 'すべて送信',
  Cargo_SendAllP: 'すべて送信しますか',
  Cargo_SendBack: '返却します',
  Cargo_SendConfirmationStatus: '送信確認処理状況',
  Cargo_SendFailed: '送信に失敗しました。',
  Cargo_SendingDate: '送信日',
  Cargo_SendMessage: 'メッセージを送信',
  Cargo_SendPartial: '部分送信',
  Cargo_SendToBranchCompany: '送信支社',
  Cargo_Sent: '送信済み',
  Cargo_SentDate: '送信日',
  Cargo_SeparateNumber: 'セクション番号',
  Cargo_September: '9月',
  Cargo_SequenceNumber: 'シーケンス番号',
  Cargo_UNNumber: '国連番号',
  Cargo_ChargeUnit: '課金単位/単位',
  Cargo_DangerousGoods: '危険物',
  Cargo_IndicatesRequired: '*記号は必須です',
  Cargo_NewTo: '新規追加',
  Cargo_EditTo: '編集',
  Cargo_AccountingPeriodRange: '会計期間の範囲を指定してください。',
  Cargo_SerialNoOfBankReceipt: '水単通し番号',
  Cargo_AutoUpdateNote: '備考を自動的に更新しますか？',
  Cargo_ConfirmBeforeEnable: 'オンにする前に技術チームに確認してください。安易にオンにしないでください。',
  Cargo_MultiHeaderBankMode: '複数のヘッダー銀行モード',
  Cargo_ServiceCodeCannotBeNull: 'サービスコードは空にできません',
  Cargo_ServiceItems: 'サービスアイテム',
  Cargo_ServiceName: 'サービス名',
  Cargo_AutoGenerateFeeName: '費用名称を自動生成',
  Cargo_AutoGenerateTaxRate: '費用税率を自動生成',
  Cargo_TaxNameRateConsistency: '税率/費用名称と税率は、両方入力するか、または両方未入力とする必要があります。',
  Cargo_AutoGenerateOrDefaultTaxExclusive: '費用税率の自動生成とデフォルト税率は、いずれか一方のみ有効にできます。',
  Cargo_ServiceNameCanTBeEmpty: 'サービス名は空にできません',
  Cargo_ServiceRequestAddressForEInvoice: '電子請求書サービス要求アドレス',
  Cargo_ServiceTicket: '料金確認票',
  Cargo_ServiceTicketState: 'チケット状態の確認',
  Cargo_ServiceTicketCreatedOrNot: '料金確認書が発行されたかどうか',
  Cargo_ServiceTicketIssued: '確認書が発行されました',
  Cargo_SetAging: 'エイジングの設定',
  Cargo_SetDefault: 'デフォルトを設定する',
  Cargo_SetDefaultItemDescription: 'デフォルトのプロジェクト名を設定します',
  Cargo_SetDefaultItemName: 'デフォルトのプロジェクト名',
  Cargo_SetFocusToFileNoTextTable: 'ファイル番号テキストボックスにフォーカスを設定します',
  Cargo_SetName: '設定名',
  Cargo_SetsOfBooks: '帳簿セット',
  Cargo_SetsOfBooksP: '帳簿: ',
  Cargo_SetText: 'テキストを設定',
  Cargo_SettleAccountsTo: '決算対象',
  Cargo_SettleByMonthly: '月締',
  Cargo_SettleByWeekly: '週単位で決算',
  Cargo_SettlementAgent: '支払代行者',
  Cargo_SettlementByBill: '都度',
  Cargo_SettlementCompany: '会計単位',
  Cargo_SettlementMethod: '支払方法（口座/手段）',
  Cargo_SettlementMethodP: '支払方法',
  Cargo_SettlementNotByBill: 'チケットなし',
  Cargo_SettlementNotice: '決済通知',
  Cargo_SettlementPartyDoesNotExist: '決済オブジェクトが存在しません。',
  Cargo_SettlementStatus: '決済処理状況',
  Cargo_SettlementType: '決済タイプ',
  Cargo_DoNotSpecify: '指定しない',
  Cargo_DomesticAndForeign: '国内/外',
  Cargo_CurrencyRequirements: '通貨要件',
  Cargo_NotSpecified: '指定されていません',
  Cargo_Appoint: '指定します',
  Cargo_PaymentInOriginalCurrency: '元の通貨での支払い',
  Cargo_SettlingAgentInconsistent: '決済エージェントが一緻しません。',
  Cargo_SettlingCompanyMustBeIdentical: '決済単位は同じでなければなりません。',
  Cargo_SettlingCompanySAbbreviation: '決済単位（略称）',
  Cargo_SettlingCompanySCode: '決済単位（コード）',
  Cargo_SettlingPartyCanTBeEmpty: '決済オブジェクトは空にできません。',
  Cargo_SettlingPartyIncompatible: '決済対象が統一されていません。',
  Cargo_SettlingPartyInconsistent: '決済対象が一緻しません。',
  Cargo_SettlingPartyOrSettlementAgentInconsistent: '決済対象または決済エージェントが一緻しません',
  Cargo_SettlingPartyIsMandatory: '決済対象は入力する必要があります。',
  Cargo_SettlingPartyMustBeConsistent: '決済対象は一緻している必要があります。',
  Cargo_ProjectNumberNotNull: 'プロジェクト番号は空にできません',
  Cargo_SettlingPartyOfPayables: '支払決済単位',
  Cargo_SetToCurrentSob: '現在の帳簿に設定',
  Cargo_SetUpDefaultsInBatch: '一括デフォルト設定',
  Cargo_SetUpServiceTypesInBatch: 'サービスタイプの一括設定',
  Cargo_SFEDOCSP: '現在の決済対象費用の明細を照会',
  Cargo_CollectFeeType: 'チャージタイプ',
  Cargo_Shipper: '荷送人',
  Cargo_ShipperId: '積荷コード',
  Cargo_ShipperInfo: '出荷元情報',
  Cargo_ShipperSName: '積荷名',
  Cargo_ShippingCompanyContractNo: '船会社契約番号',
  Cargo_ShippingCompanySAbbreviation: '船会社（略称）',
  Cargo_ShippingCompanySCode: '船会社（コード）',
  Cargo_ShippingInformation: '出荷情報',
  Cargo_ShippingRouteArea: '航路/エリア',
  Cargo_ShortAccountIs: '端数処理勘定は: ',
  Cargo_ShowDetailedTitles: '詳細な勘定を表示します',
  Cargo_ShowAdjustRateEntry: '期末調整入力を含む',
  Cargo_ShowDetails: '詳細を表示',
  Cargo_ShowedByVessel: '船名別に表示',
  Cargo_ShowFromTo2: 'へ',
  Cargo_ShowInvoiceDetails: '請求書の詳細を表示します',
  Cargo_ShowOpeningBalance: '期首残高を表示',
  Cargo_ShowRows: '表示本数',
  Cargo_ShowStatementInformation: '請求書情報を表示します',
  Cargo_ShutOut: 'ログアウトしました',
  Cargo_SIATEPIISOTT: 'テンプレートの最初のセグメントに1人あたり1つのスペースを割り当てます',
  Cargo_SignContract: '契約書に署名する',
  Cargo_SingleBillPrinting: '単票印刷',
  Cargo_SITCINCOSDHBFLBS: '合計: {0}取引明細書、現在: {1}番目（保存時に他の取引明細書データのロードが完了していることを確認）',
  Cargo_SiteVisit: '実地訪問',
  Cargo_Size: 'サイズ',
  Cargo_SkipPreviousStep: '前のステップを通るかどうか',
  Cargo_SLNECTS: '赤字通知番号が入力されていません。保存しますか？',
  Cargo_SoaConfirmed: '【{0}】請求書が確認されました。',
  Cargo_SoaCreated: '請求書が作成されました',
  Cargo_SoaCreatedM: '【{0}】請求書が作成されました',
  Cargo_SoaCreatedAlready: '請求書が作成されました。',
  Cargo_SoaNoAlreadyCreated: '取引明細書番号が作成されました。',
  Cargo_SobCode: '帳簿コード',
  Cargo_SobCodeAlreadyExists: '帳簿コードは既に存在します。',
  Cargo_SobDataLoadingFailed: '帳簿データのロードに失敗しました。',
  Cargo_SobList: 'カバーリスト',
  Cargo_SobName: '帳簿名',
  Cargo_SobNameP: '帳簿名: ',
  Cargo_SobSetup: '会計帳簿の設定',
  Cargo_Soc: '荷主箱',
  Cargo_IsSoc: 'Is it SOC',
  Cargo_SoftwareVersion: 'ソフトウェアのバージョン',
  Cargo_SolicitationType: '集荷種別',
  Cargo_SOSINTU: '選択した請求書番号の処理状況を更新します',
  Cargo_SOSINTUIU: '選択した請求書番号の処理状況を使用済みに更新します',
  Cargo_SourceOfClient: '顧客ソース',
  Cargo_SOWLC: 'コンテナ倉庫',
  Cargo_Sp1: '請求書連結',
  Cargo_Sp17: '詳細展開',
  Cargo_Sp18: '連結明細',
  Cargo_Sp24: '財務説明',
  Cargo_Sp27: '企業署名',
  Cargo_Sp31: '費用分割',
  Cargo_SPABNCTBBE: '決済対象と業務番号の両方を空にすることはできません。',
  Cargo_Space2: '請求書の日付',
  Cargo_SPBNMNAL1SCR: '決済対象、業務番号、マスタ番号、日付照会条件は必ず1つ記入してください。',
  Cargo_SpecialApproval: '特別承認',
  Cargo_SpecialApprovalValidUntil: 'Special approval valid until',
  Cargo_BusinessExpirationDate: '業務満了日',
  Cargo_SpecialApprovalTip: 'Note: When the validity period is empty, special approval is granted for long-term validity.',
  Cargo_SpecialGoods: '製品の特殊性の有無',
  Cargo_SpecialInvoice: '専用の請求書',
  Cargo_SpecialInvoiceGeneralInvoice: '専用請求書/通常請求書',
  Cargo_SpecialInvoiceInternalInvoice: '専用請求書/内部請求書',
  Cargo_SpecialPrice: '特別価格',
  Cargo_SpecialPriceInstructions: '特別価格の説明',
  Cargo_SpecifyCollectionPayment: '受取と支払の区別',
  Cargo_SPIANA: '決済対象が一緻せず、マージ関係がありません。',
  Cargo_SPIANA_DiffSettlementAgent: '決済対象が一緻せず、マージ関係もなく、決済エージェントも一緻しません。',
  Cargo_Split: '分割',
  Cargo_SplitBillingFees: '請求書の費用を分割する',
  Cargo_SplitBL: '分割します',
  Cargo_SplitExpense: '分割料金',
  Cargo_SplitExpenseP: '分割料金: ',
  Cargo_SplitHBL: 'HBL分割',
  Cargo_SplitMBL: 'MBL分割',
  Cargo_SplitOldDataToNew: '分割（古いデータを新しいデータに）',
  Cargo_SplitSuccessfully: '分割が成功しました',
  Cargo_SPNETRSC: '決済対象が存在しません。キャッシュをリセットしてみてください。',
  Cargo_SPWPWO: '売掛金決済対象',
  Cargo_SSNMIR: '請求書処理状況が請求要件を満たしていません',
  Cargo_SSNMWOR: '取引明細書の処理状況が消込済の要件を満たしていません',
  Cargo_SSSFPR: '保存に成功しましたか？プレビュー状態を送信しますか？',
  Cargo_STAEONRS: '運送条件が存在するか、レコードが選択されていません',
  Cargo_Staff: 'スタッフ',
  Cargo_StaffP: 'スタッフ: ',
  Cargo_StampOfSalesUnit: '売上単位: （章）',
  Cargo_StartDateOfContainerReturn: 'キャビネット返却開始日',
  Cargo_StartDateOfFinancialPeriod: '会計期間の開始日',
  Cargo_StartingAccountTitle: '開始勘定',
  Cargo_StartNo: '開始番号',
  Cargo_StartReconciliation: '手動決済',
  Cargo_StatementOfBalance: '取引残高テーブル',
  Cargo_StatementOfBalance2: '取引残高テーブル2',
  Cargo_Statistics: '統計照会',
  Cargo_StatisticsWithoutMblExpenses: 'マスタ料金を集計しない',
  Cargo_Status: '処理状況',
  Cargo_StatusChanged: '処理状況変更',
  Cargo_StatusOfAdvanceReceipt: '前受/預り金処理状況',
  Cargo_STCCOTB: 'この{0}請求書の確認をキャンセルしますか？',
  Cargo_STDTATM: 'この勘定マッピングを削除しますか？',
  Cargo_STDTATNRAD: 'この勘定を削除しますか？削除後は復元できません！',
  Cargo_STDTPA: 'これらの支払要求を削除しますか？',
  Cargo_STWTPA: 'これらの支払要求を取り下げますか？',
  Cargo_STDTSPT: 'このクエリパラメータテンプレートを削除しますか？',
  Cargo_STDTSRRAVWBDT: '帳簿を削除しますか？帳簿に関連付けられたルールと買掛伝票も削除されます。',
  Cargo_STDTSVRJEWBDT: '選択した資格情報を削除しますか？関連する買掛伝票エントリも削除されます。',
  Cargo_STDTSVRJEWBDTM: '選択したこの{0}の証明書を削除してもよろしいですか？関連する買掛伝票エントリも削除されます。',
  Cargo_STDTVGR: 'この資格証明のグループ化規則を削除しますか？',
  Cargo_STOAOWO: '売上金額の合計を表示',
  Cargo_Storage: '倉庫',
  Cargo_SendToEachRecipientSeparately: '各受信者に個別に送信',
  Cargo_SyncSendCCAddress: '同期送信ccアドレスです',
  Cargo_SearchForTheDataYouWantToInsert: '挿入するデータを検索します',
  Cargo_StorageRequired: '倉庫かどうか',
  Cargo_STRAEAAWORWBRC: '取り消しますか？すべての調整費用と償却記録がリセットされます。',
  Cargo_StreetAddress: '詳細ストリートアドレス',
  Cargo_StreetAddressCanTBeEmpty: '詳細なストリートアドレスは空にできません',
  Cargo_STRTWOREAIIWBR: 'このキャンセル操作を取り消しますか？対応する費用と請求書情報がリセットされます。',
  Cargo_Stuff: 'フィル',
  Cargo_STWBTSV: '選択した{0}の買掛伝票を赤で消しますか？',
  Cargo_SubCategoryOfAccountTitle: '勘定科目のサブクラス',
  Cargo_Submit: '送信',
  Cargo_SubmitExpenseForReviewDirectly: '監査費用を直接提出するかどうか',
  Cargo_SubmitPaymentNotice: '支払通知の送信',
  Cargo_SubmitStatusSelection: '送信処理状況の選択',
  Cargo_Submitted: '送信済み',
  Cargo_SubmittedForPreReviewStatus: 'レビュー前の状態を送信しますか',
  Cargo_SubmittedSuccessfully: '送信に成功しました。',
  Cargo_SpecialFeeLimitReleaseApply: '特別費用制限解除申請',
  Cargo_SpecialFeeLimitReleaseApplyContent: '{0}の特別費用制限解除を申請',
  Cargo_SpecialFeeLimitReleaseApplyContentPlain: '特別費用制限解除を申請',
  Cargo_ReleaseDocumentNumberApplication: '書類/番号発行申請',
  Cargo_ReleaseNumberDocument: '番号発行/書類発行',
  Cargo_IsPaymentReceived: '入金確認',
  Cargo_PaymentTime2: '入金時間',
  Cargo_ReleaseNumberQuantity: '発行番号数量',
  Cargo_RelatedAttachments: '関連添付ファイル',
  Cargo_ReleaseNumber: '番号発行',
  Cargo_ReleaseDocument: '書類発行',
  Cargo_RemainingTemporaryReleaseQuantity: '残りの一時発行数量',
  Cargo_TemporaryDocumentReleaseApplication: '一時書類発行申請',
  Cargo_TemporaryNumberReleaseApplication: '一時番号発行申請',
  Cargo_SubscribePOL: '出発地',
  Cargo_SubsidiaryAccounting: '補助会計',
  Cargo_SubsidiaryAccountingClient: '補助会計クライアント',
  Cargo_SubsidiaryAccountingCondition1: '補助会計条件1',
  Cargo_SubsidiaryAccountingCondition2: '補助会計条件2',
  Cargo_SubsidiaryAccountingCondition3: '補助会計条件3',
  Cargo_SubsidiaryAccountingCondition4: '補助会計条件4',
  Cargo_SubsidiaryAccountingCondition5: '補助会計条件5',
  Cargo_SubsidiaryAccountingCondition6: '補助会計条件6',
  Cargo_SubsidiaryAccountingItems: '補助勘定項目',
  Cargo_SubsidiaryAccountingStaff: '補助会計スタッフ',
  Cargo_SubsidiaryLedger: '補助元帳',
  Cargo_SubsidiaryLedger2: '補助元帳2',
  Cargo_SubtitlesOfAccount: '補助科目',
  Cargo_SubTotal: '小計',
  Cargo_SubTotalOfOpeningBalance: '期首残高小計',
  Cargo_Success: '成功',
  Cargo_SummarizeDistributionExpense: 'チャージバックを集計するかどうか',
  Cargo_SummarizeMblExpense: 'マスタ料金を集計するかどうか',
  Cargo_SupervisionMethod: '監視方法',
  Cargo_SupplierContract: '仕入先契約',
  Cargo_Surcharge: 'サーチャージ',
  Cargo_Controlled: '製御されたアイテム',
  Cargo_NeedInvoice: '請求が必要な項目',
  Cargo_SurchargeOrNot: '追加料金はかかりますか',
  Cargo_SureToAddToBlackList: '本当にブラックリストに追加しますか',
  Cargo_SureToBatchConfirmTheBill: 'この{0}の請求書を一括確認しますか？',
  Cargo_SureToBatchReviewTheExpense: 'この{0}の費用を一括レビューしますか？',
  Cargo_SureToCancel: 'キャンセルしますか？',
  Cargo_SureToCancelConfirmation: '本当に確認をキャンセルしますか？',
  Cargo_SureToCancelConfirmationYes: '確認をキャンセルしますか？確認',
  Cargo_SureToCancelReviewOfTheExpense: 'この{0}の費用の監査をキャンセルしますか？',
  Cargo_SureToCancelReviewOfTheVoucher: 'この{0}の証明書の監査をキャンセルしますか？',
  Cargo_SureToCancelReviewOfTheExpenseCheck: '選択された費用は{0}存在します <br/>',
  Cargo_Billinged: '請求書が生成されました',
  Cargo_WriteOffed: '消込済',
  Cargo_SureToCancelVerification: 'レビューをキャンセルしますか？',
  Cargo_SureToCarryOver: '繰り越しを確認しますか？',
  Cargo_SureToConfirmWriteOffRecord: '本当にレコードの消し込みを確認しますか？',
  Cargo_SureToCreateInvoice: '請求書を生成しますか？',
  Cargo_SureToCreateListOfCombinedBills: 'チケットリストを生成しますか？',
  Cargo_SureToDelete: '削除しますか？',
  Cargo_SureToDeleteWarehouse: '削除するとすべての倉庫情報がクリアされます。続行しますか？',
  Cargo_SureToDeleteInvoice: '請求書を削除しますか？',
  Cargo_SureToDeleteSelectedRecord: '選択したレコードを削除してもよろしいですか',
  Cargo_SureToDeleteTheAbstractRule: 'この要約規則を削除してもよろしいですか？',
  Cargo_SureToDeleteTheAdvanceReceipt: 'この前受/預り金を削除してよろしいですか？',
  Cargo_SureToDeleteTheBill: 'この{0}の請求書を削除してもよろしいですか？',
  Cargo_SureToDeleteTheExchangeRate: 'この為替レートを削除しますか？',
  Cargo_SureToDeleteTheInvoice: 'この{0}の請求書を削除してもよろしいですか',
  Cargo_SureToDeleteTheMapping: 'このマッピングを削除してもよろしいですか？',
  Cargo_SureToDeleteTheRecord: '本当にこのレコードを削除しますか？',
  Cargo_SureToDeleteTheRule: 'このルールを削除してもよろしいですか？',
  Cargo_SureToDeleteThisSoaItem: 'この{0}の取引明細書を削除してもよろしいですか？',
  Cargo_SureToDeliverToBranch: '支社を送信しますか？',
  Cargo_SureToDeny: '本当に拒否しますか？',
  Cargo_SureToFreezeApplication: '申請を凍結しますか？',
  Cargo_SureToHoldSubmission: '送信を保留してもよろしいですか',
  Cargo_SureToIssueCombinedInvoice: '統合請求を確定しますか？',
  Cargo_SureToModifyBillingDate: '請求日を変更しますか？',
  Cargo_SureToPrint: '本当に印刷しますか？',
  Cargo_SureToPrintDetailList: '明細書を印刷しますか？',
  Cargo_SureToReIssueInvoice: '本当に再請求しますか？',
  Cargo_SureToRejectIt: '拒否しますか？',
  Cargo_SureToRejectTheExpenseItem: 'この{0}の費用を却下しますか？',
  Cargo_SureToRemoveTheBill: 'この{0}請求書を削除しますか？',
  Cargo_SureToRemoveTheExpenseItem: 'この{0}の費用を削除しますか？',
  Cargo_SureToReturnApplication: '申請を返却しますか？',
  Cargo_SureToReviewTheBills: 'これらのシートを確認しますか？',
  Cargo_SureToReviewTheVoucher: 'この{0}の証明書を確認しますか？',
  Cargo_SureToRevokeContractWith: '****との****契約の取り消しを確認しますか',
  Cargo_SureToRevokeRetrieval: '回収を取り消しますか？',
  Cargo_SureToRevokeWithdrawal: 'キャンセルを確定しますか？',
  Cargo_SureToVoid: '無効にしますか？',
  Cargo_SureToVoidInvoice: '請求書を無効にしますか？',
  Cargo_SureToVoidTheInvoice: 'この請求書を無効にしますか？',
  Cargo_SureToVoidTheInvoiceM: 'この{0}枚の請求書を無効にしますか？',
  Cargo_SUSBODNMWBACTS: '売上単位の口座開設銀行と銀行口座番号が一緻しません。保存しますか？',
  Cargo_SUSBODNMWRISCTS: '売上ユニットの銀行口座番号がシステムで維持されているものと一緻しません。保存しますか？',
  Cargo_SUTCPALVIBC: '会計前に繰越損益の買掛伝票情報を設定します',
  Cargo_SVSFPHBC: '現在選択されている買掛伝票日付の会計期間はクローズされています。',
  Cargo_SVSMHBC: '現在選択されている買掛伝票の月が決済されました。',
  Cargo_SWDE: '費用は計上されません',
  Cargo_Switch: '切り替え',
  Cargo_SwitchBasisToAcquireDocument: '取得したドキュメントに基づいて切り替えます',
  Cargo_SwitchCurrency: '通貨の切り替え',
  Cargo_SwitchFile: 'ファイルの切り替え',
  Cargo_SwitchInvoice: '請求書の切り替え',
  Cargo_SwitchMethodOfClaim: '承認モードの切り替え',
  Cargo_SwitchSob: '帳簿の切り替え',
  Cargo_Symbol: 'シンボル',
  Cargo_SynchronousCodingPartners: '顧客/仕入先コードの同期',
  Cargo_SystemAlertForPayment: 'システム督促',
  Cargo_SystemBusy: 'システムがビジーです',
  Cargo_SystemBusyPRL: 'システムがビジーです。後で再試行してください。',
  Cargo_TableFilter: 'テーブルフィルタ',
  Cargo_TakeByCustomsBroker: '通関は自分で取ります',
  Cargo_TAOPLFESAMBETCWOA: '金額+要約損益+ファイナンスチャージ+端数処理勘定は、この消込金額と等しくなければなりません。',
  Cargo_TAOPLFESAMBETCWOANoFinance: '金額+要約損益+端数処理勘定は、この消込金額と等しくなければなりません。',
  Cargo_TAOPLFESAMBETCWOAPC: '金額+要約損益+ファイナンスチャージ+端数処理勘定は、この消込金額と等しくなければなりません。チェックしてください。',
  Cargo_TAPBACTBLTARAWIETIAP: '収支タイプが「買掛金」の場合、「買掛金」の合計金額は「売掛金」の合計金額より小さくすることはできません。',
  Cargo_Tax: '税金',
  Cargo_TaxAmount: '税額',
  Cargo_TaxAmountP: '税額: ',
  Cargo_TaxationNbr: '税登録番号',
  Cargo_TaxExcludedPrice: '税抜き価格',
  Cargo_TaxExcludedPriceP: '税抜き価格: ',
  Cargo_TaxFreeAmount: '税抜き金額',
  Cargo_TaxIncludedPrice: '税込み価格',
  Cargo_TaxIncludedPriceP: '税込み価格: ',
  Cargo_TaxpayerAuthorizationCode: '納税者承認コード',
  Cargo_TaxRate: '税率',
  Cargo_TaxRateP: '税率: ',
  Cargo_TaxRatePct: '税率（%）',
  Cargo_TBTRS: '振替決済が成功しました。',
  Cargo_TDCBODNBTTCBOTULBC: '操作しているデータの支社は、現在の支社または1つ上の支社に属していません。続行しますか？',
  Cargo_TeamLeader: 'チームリーダー',
  Cargo_TeamLeaderAssignment: 'チームリーダーの割り当て',
  Cargo_Tel: '電話',
  Cargo_TelexReleaseApplicant: '電放申請者',
  Cargo_TelexReleaseApplicationDate: '送電申請時間',
  Cargo_TelexReleaseFee: '電気料金',
  Cargo_TelexReleaseMaterial: '電放資料',
  Cargo_TelexReleaseNo: '電放号',
  Cargo_ExpenseBoxNo: '請求グループ番号',
  Cargo_TemplateDownload: 'テンプレートのダウンロード',
  Cargo_TemplateDownloadFailed: 'モジュールのロードに失敗しました。',
  Cargo_TenDigitCode: '10桁のコード',
  Cargo_TenThousandYuan: '万元',
  Cargo_TEYAPHBMBSEC: '操作した料金は他の人によって変更されました。続行しますか？',
  Cargo_TFCFDTECNIPSDOACS: '次の番号のお客様がパートナーに存在するため、署名に失敗しました。残りのお客様は署名に成功しました',
  Cargo_TFOTPCTBCWOP: '期間の時間範囲は他の期間の時間範囲と交差できません。',
  Cargo_TFSIIUDNA: '以下のサイトは業務で使用されているため削除できません',
  Cargo_The1StInvoiceNoCanTBeEmpty: '最初の請求書番号は空にできません。',
  Cargo_TheAmountOfWrittenOff: '売上金額',
  Cargo_TheExpenseNotBoundToInvoice: 'この費用は請求書にバインドされていません。',
  Cargo_TheLast: '最後の一枚',
  Cargo_TheLastPage: '前のページ',
  Cargo_TheNextPage: '次へ',
  Cargo_TheOppositeSideAccount: '相手のアカウント',
  Cargo_TheOppositeSideBank: '相手の銀行',
  Cargo_TheOppositeSideCompany: '相手先の単位',
  Cargo_TheOppositeSideInvoiceNo: '相手の請求書番号',
  Cargo_ThisFeeHasBeenInvoiced: 'この費用は請求済みで分割できません！',
  Cargo_ThisFeeHasBeenWrittenOff: 'この費用はすでに適用されており、分割できません！',
  Cargo_ThisTimeBalance: '今回の残高',
  Cargo_ThisTimeWriteOff: '今回の適用',
  Cargo_ThisTimeWriteOffEq: '今回の消込=入金金額+要約損益+ファイナンスチャージ+端数処理勘定',
  Cargo_ThisWriteOffNoIs: '今回の売上伝票番号: ',
  Cargo_TIBYEIB: '入力した初期残高バランス',
  Cargo_TIBYEIUPDCTBSAIS: '入力した初期残高はバランスが取れていません。「貸借対照表」と「利益表」をよくチェックしてください',
  Cargo_Time: '時間',
  Cargo_TimeFrame: '時間範囲',
  Cargo_TimeOfCargoHolding: '引落時刻',
  Cargo_TimeOfDocHolding: '引き落とし時間',
  Cargo_TimeOfPurchase: '購入時間',
  Cargo_TimeOfPurchaseCanTBeEmpty: '購入時間は空にできません',
  Cargo_TimeOfUse: '時間の使用',
  Cargo_TimeOfUseCanTBeEmpty: '使用時間は空にできません。',
  Cargo_Tips: 'ヒント',
  Cargo_PleaseSelectTheSailingScheduleBelow: 'Please select the sailing schedule below',
  Cargo_ChooseShippingSchedulesTips1: '1. Please select the corresponding sailing schedule. If you do not make a choice, you may not be able to obtain the planned berthing time, port opening and interception time, and actual berth time related to the sailing schedule',
  Cargo_ChooseShippingSchedulesTips2: '2. If you are still unable to confirm the sailing schedule, you can click the [Do not select] button, and then click the [Select Schedule] button to select the sailing schedule',
  Cargo_MoreShippingSchedulesTips: 'The port area returns the sailing schedule of multiple terminals, which will affect the display and push of sailing schedule information, please select the sailing schedule information you want',
  Cargo_ChooseShippingSchedules: 'Choose Shipping Schedules',
  Cargo_NoSelectYet: 'Don\'t select it yet',
  Cargo_ChangePayment: '支払要求の変更',
  Cargo_PaymentTimeLimit: '支払期限',
  Cargo_Title: 'タイトル',
  Cargo_TitleOfAccount: '勘定科目',
  Cargo_TLOOSE: '負債と資本または株主資本の合計',
  Cargo_TMAEONRS: '取引方法が存在するか、レコードが選択されていません',
  Cargo_To: 'から',
  Cargo_FROM: 'から',
  Cargo_ToDetermineIfEditableWhenViewing: '閲覧時に編集可能かどうかを判断するため',
  Cargo_TOEIAADFIA: '経費項目金額の合計が請求書金額と異なります。',
  Cargo_ChargeAmountCannotExceedInvoiceAmount: '経費項目金額は請求書金額を超えることはできません。',
  Cargo_ChargeAlreadyAssociatedInvoice: '{0}費用は既に請求書に関連付けられています。',
  Cargo_TORFRS: '{0}レコードがクエリされ、{1}レコードが選択されました',
  Cargo_Total0: '合計: {0}',
  Cargo_TotalAmount: '合計金額',
  Cargo_TotalAmountNotWrittenOff: '売上金額の合計',
  Cargo_TotalAmountOfCurrentPeriod: '当期合計',
  Cargo_TotalAmountPJ: '合計金額-',
  Cargo_TotalAmountP: '合計金額: ',
  Cargo_TotalAmountToWriteOff: '売上可能金額の合計',
  Cargo_TotalAPAmount: '買掛金合計',
  Cargo_TotalARAmount: '売掛金合計',
  Cargo_TotalBalance: '合計残高',
  Cargo_TotalCommissionAmount: '歩合給金額の合計',
  Cargo_TotalCommissionAmountP: '歩合給合計: ',
  Cargo_TotalCost: 'コスト合計',
  Cargo_TotalCurrency: '通貨別合計',
  Cargo_TotalCurrentLiabilities: '流動負債合計',
  Cargo_TotalIncome: '総売上／総収益',
  Cargo_TotalLiabilities: '負債合計',
  Cargo_TotalNonCurrentAssets: '非流動資産合計',
  Cargo_TotalNonCurrentLiabilities: '非流動負債合計',
  Cargo_TotalOfVouchersEntered: '証憑{0}枚を入力しました',
  Cargo_TotalOutstandingAmountByCurrency: '未償却分通貨合計',
  Cargo_TotalPriceWithTaxInWords: '価格税合計（大文字）',
  Cargo_TotalProfit: '利益の合計',
  Cargo_TotalRevenue: '収益合計',
  Cargo_TotalWriteOffAmount: '消込済合計金額',
  Cargo_Choose: '選択します',
  Cargo_TotalWriteOffs: '消込合計',
  Cargo_TotalWriteOffsP: '消込合計Credit: ',
  Cargo_TPOPNOINOE: '利益合計営業利益営業外収益営業外支出',
  Cargo_TPTODIDDYCTMAGV: '支払タイプまたは支払方法が異なります。買掛伝票をマージして生成しますか？',
  Cargo_TradeTerm: '取引方法',
  Cargo_TradeTerms: '成約条件',
  Cargo_TradeTermsMaintenance: '取引条件のメンテナンス',
  Cargo_TradeType: '取引タイプ',
  Cargo_TradingCompany: '貿易会社',
  Cargo_Transfer: '回る',
  Cargo_TransferAllToReconciliation: 'すべての振替を戻します',
  Cargo_TransferBackAmount: 'ロールバック金額',
  Cargo_TransferBackGrandTotal: 'ロールバック合計金額',
  Cargo_TransferBackToReconciliation: 'ロールバック決済',
  Cargo_TransferCash: '現金の振替',
  Cargo_TransferExpense: '移転費用',
  Cargo_TransferIntoCollection: '預入への転入',
  Cargo_TransferOutToCollection: '委託品の転送',
  Cargo_TransferPort: '中継港',
  Cargo_TransferToCNY: 'CNYに移動',
  Cargo_TransitPortSea: '中継港（海港）',
  Cargo_TransitTerm: '輸送条件',
  Cargo_Transportation: '輸送',
  Cargo_TRAYEINR: '入力した決済金額が不正です！',
  Cargo_TRFRBLFDAF: '電気料金のオフサイト料金変更料金',
  Cargo_TrialBalance: '試算バランス',
  Cargo_TrialBalanceCheck: '試算バランスチェック',
  Cargo_TRNAPUCWOFISI: 'すべてを取り消すことはできません。クエリインタフェースのキャンセル機能を使用してください。',
  Cargo_TruckCompany: 'トラック会社',
  Cargo_TSASOBMBTS: '請求書の決済エージェントは同じでなければなりません！',
  Cargo_TSBADNCTCC: '選択した銀行口座にはこの通貨が含まれていません。続行しますか？',
  Cargo_TTAEONRS: '取引条件が存在するか、レコードが選択されていません',
  Cargo_TTOAFNTCCPM: '勘定は計算のみ: {0}、現在の通貨: {1}、修正してください',
  Cargo_TUPAOTPALVCBE: '損益計算書の未分配利益勘定は空にできません',
  Cargo_TWORHBRCC: 'この帳簿レコードはすでに赤消しされているので、取り消すことはできません。',
  Cargo_Type: 'タイプ',
  Cargo_MaximumTakeOffWeight: '最大離陸重量',
  Cargo_Charter_Flights_Tips: 'チャーター/チャーターボードの場合\'チャーター/チャーターボードのフライトの場合、ここでフライトコストを維持することができます',
  Cargo_Charter_package_board: 'チャーター/パッケージボード',
  Cargo_Board_Tips: '包板業務は後続の収容率と利益分析に用いられる',
  Cargo_Flight_costs: 'フライトコスト',
  Cargo_NumberOfCartridges: 'コンテナ数',
  Cargo_Please_Select_The_Model_You_Want_To_Edit: '編集するモデルを選択してください',
  Cargo_Please_Select_The_Model_To_Be_Deleted: '削除するモデルを選択してください',
  Cargo_Please_Select_The_Uld_You_Want_To_Edit: '編集するコンテナを選択してください',
  Cargo_Please_Select_The_Uld_To_Be_Deleted: '削除するコンテナを選択してください',
  Cargo_WeightRestrictions: '重量製限',
  Cargo_VolumeLimit: 'ボリューム製限',
  Cargo_LoadableCapacity: '積載可能容量',
  Cargo_LoadableWeight: '積載可能重量',
  Cargo_DeadWeight: '自重',
  Cargo_LSize: 'サイズ（長さ）',
  Cargo_WSize: 'サイズ（幅）',
  Cargo_HSize: 'サイズ（高さ）',
  Cargo_ApplicableModels: '適用機種',
  Cargo_ApplicableContainerType: 'コンテナタイプ',
  Cargo_ApplicableContainerCode: 'コンテナコード',
  Cargo_ApplicableContainerNumber: 'コンテナ番号',
  Cargo_CharterPack: 'チャーター機/チャーターボード',
  Cargo_TypeOfBill: 'チケットタイプ',
  Cargo_TypeOfGoods: '貨物種別',
  Cargo_TypeOfPort: 'ポートタイプ',
  Cargo_UBEIRPSMB: 'レコードにマークされていない請求書があります。マークされた請求書を選択してください',
  Cargo_UCOVEIIDPCTD: '現在インポートされているデータは顧客または仕入先がシステムで維持されていません。ダウンロードをクリックしてください。',
  Cargo_Unbilled: '請求されていません',
  Cargo_Uncommitted: 'コミットされていません',
  Cargo_Unconfirmed: '未確認です',
  Cargo_UnderConfirmation: '確認中',
  Cargo_UnfrozenSuccessfully: '解凍に成功しました。',
  Cargo_UnInvoiced: '未請求書',
  Cargo_Unissued: '未公開',
  Cargo_UnissuedServiceTicket: '未発行確認票',
  Cargo_Unit: '単位',
  Cargo_UnitOfMeasurement: '測定単位',
  Cargo_UnitOfPaymentPeriod: '会計期間の単位',
  Cargo_UnitPrice: '単価',
  Cargo_UnitPriceP: '単価: ',
  Cargo_Unknown: '不明',
  Cargo_UnKnownStatus: '処理状況不明',
  Cargo_Unlimited: '無製限',
  Cargo_Unpaid: '未払い',
  Cargo_UnpaidClear: '未払い',
  Cargo_UnpaidCNY: 'CNY未払い',
  Cargo_UnpaidEUR: 'EUR未払い',
  Cargo_UnpaidGBP: 'GBP未払い',
  Cargo_UnpaidHKD: 'HKD未払い',
  Cargo_UnpaidJPY: 'JPY未払い',
  Cargo_UnpaidNGN: 'NGN未払い',
  Cargo_UnpaidP: '未払い: ',
  Cargo_SimpleUnpaidP: '未払い',
  Cargo_UnpaidUSD: 'USD未払い',
  Cargo_ReceivedP: '受け取りました',
  Cargo_PaidP: '支払済み',
  Cargo_EmptyValue: '空',
  Cargo_UnsavedNewExpenseCanTBeSplit: '新規未保存の費用は分割できません！',
  Cargo_UpdateBar: '更新バー',
  Cargo_UpdateBusinessDate: '取引日変更',
  Cargo_UpdatedSuccessfully: '更新が成功しました。',
  Cargo_UpdateFailed: '更新に失敗しました。',
  Cargo_UpdatePageDisplay: 'ページ表示の更新',
  Cargo_UpdatePrintButtonStatus: '印刷ボタンの状態を更新します',
  Cargo_Upload: 'アップロード',
  Cargo_UploadAttachment: '添付ファイルのアップロード',
  Cargo_DeleteAttachment: '添付ファイルを削除',
  Cargo_UploadContract: '契約のアップロード',
  Cargo_UploadContractAttachments: '契約添付のアップロード',
  Cargo_UploadData: 'データのアップロード',
  Cargo_URVUTSWBRIKC: 'この帳簿の下で未審査の証憑は金蝶Cloudで審査されます。本当に続けますか？',
  Cargo_USD: '米ドル',
  Cargo_USDAmount: 'ドル',
  Cargo_USDExchangeRate: '米ドルレート',
  Cargo_USDInvoiceNo: '米ドル請求書番号',
  Cargo_USDP: 'ドル: ',
  Cargo_Use: '使用する',
  Cargo_Used: '使用済み',
  Cargo_UseGroupExchangeRate: 'グループ為替レートを使用',
  Cargo_UseOriginalTemporarily: '一時用テキスト',
  Cargo_User: 'ユーザー',
  Cargo_UserCanTBeEmpty: '利用者は空にできません。',
  Cargo_UseShouldBeTemporarily: 'ここでは一時的に',
  Cargo_ValidityOfInvoice: '請求書が有効かどうか',
  Cargo_Value: '値',
  Cargo_VatGeneralInvoice: 'VAT一般請求書',
  Cargo_VatInvoice: 'VAT請求書',
  Cargo_VatInvoiceIssuingMachineNo: 'VAT請求書発行機番号',
  Cargo_VatSpecialInvoice: 'VAT専用請求書',
  Cargo_Vendor: 'ベンダー',
  Cargo_VendorCantBeEmpty: '仕入先は空にできません',
  Cargo_VendorClient: '仕入先顧客',
  Cargo_VendorModification: '仕入先の変更',
  Cargo_VendorP: 'ベンダー: ',
  Cargo_VendorSInvoiceNo: '仕入先請求書番号',
  Cargo_VerificationCancelled: '監査がキャンセルされました',
  Cargo_VerificationPassed: '審査に合格したかどうか',
  Cargo_VerificationRejected: 'レビュー拒否',
  Cargo_VerifiedSuccessfullyClickToSave: '検証に成功しました。保存をクリックしてください。',
  Cargo_VerifiedSuccessfullyClickToExport: '検証に成功したので、エクスポートをクリックします。',
  Cargo_Verify: '確認します',
  Cargo_VerifyARAPExpense: '売掛金と買掛金の検証',
  Cargo_VerifyInvoiceNo: '請求書番号を確認します',
  Cargo_VerifyJournalEntry: '入力の検証',
  Cargo_VesselAndVoyage: '船名/航次',
  Cargo_VesselVoyageFlight: '船名運航便',
  Cargo_VGIVSI: 'VAT一般請求書VAT専用請求書',
  Cargo_VHBCFSACCTBC: '補助会計【顧客】は買掛伝票を生成しました。キャンセルできません。',
  Cargo_VHBCFSADCTBC: '補助会計【部門】は買掛伝票を生成しました。キャンセルできません。',
  Cargo_VHBCFSAICTBC: '補助会計【プロジェクト】は買掛伝票を生成しました。キャンセルできません。',
  Cargo_VHBCFSASCTBC: '補助会計【従業員】は買掛伝票を生成しました。キャンセルできません。',
  Cargo_VHBCFSAVCTBC: '補助会計【仕入先】は買掛伝票を生成しました。キャンセルできません。',
  Cargo_ASCCCTBC: '会社確認が送信されました。キャンセルできません。',
  Cargo_VHBEFCWOWBRWBCITWORSTWB: 'この消込レコードはすでに財務証憑をエクスポートしています。消込を取り消すと、システムは赤消しレコードを生成します。赤消しを確認しますか？',
  Cargo_View: '表示更新',
  Cargo_ViewAllBusiness: 'すべてのビジネスを表示',
  Cargo_ViewAllExpenses: 'すべての費用を表示します',
  Cargo_ViewBill: '請求書の表示',
  Cargo_ViewBusinessOfSameGroup: '同じグループのビジネスを表示する',
  Cargo_ViewDetail: '詳細を表示する',
  Cargo_ViewDetails: '詳細を表示する',
  Cargo_ViewDetailsOfRemovals: '削除の詳細を表示します',
  Cargo_ViewedByFee: '料金別に表示',
  Cargo_ViewedByJob: '業務別に表示',
  Cargo_ViewExpensesOfSameGroup: '同じグループの費用を表示します',
  Cargo_ViewFile: 'ファイルの表示',
  Cargo_ViewInvoice: '請求書の表示',
  Cargo_ViewSelfBusiness: '自分のビジネスを表示する',
  Cargo_ViewSoa: '請求書の表示',
  Cargo_ViewUploadedDeclarationDocInfo: 'アップロードされた通関ファイルの情報を表示します',
  Cargo_ViewVoucher: '資格情報の表示',
  Cargo_ViolationOfUniquenessConstraint: '一意性製約違反',
  Cargo_VOCMEICSR: '現在選択されているレコードには、決算した月の買掛伝票が含まれています。',
  Cargo_VoidCompleted: '無効化が完了しました。',
  Cargo_Voided: '無効になりました',
  Cargo_VoidedBy: 'ダメ人間',
  Cargo_VoidedInvoice: '無効請求書',
  Cargo_VoidedInvoiceNo: '無効請求書番号',
  Cargo_VoidedInvoiceNoP: '無効請求書番号: ',
  Cargo_VoidedSuccessfully: '無効になりました。',
  Cargo_VoidStatus: '無効状態',
  Cargo_VoidTime: '無効時間',
  Cargo_AssociatedExpenseID: '関連費用ID（経理参照用）',
  Cargo_ChargeID: '費用コード（チャージID）',
  Cargo_VOPLCOCTBD: '繰越損益伝票は削除できません。',
  Cargo_StateDeleteError: '信用証明システムの導入に成功しましたので,削除不可',
  Cargo_VoucherAbstract: '証憑の要約',
  Cargo_VoucherCannotBeEmpty: '買掛伝票は空にできません！',
  Cargo_VoucherCreatedOrNot: '証明書が生成されたかどうか',
  Cargo_VoucherCreatedSuccessfully: '{0}個の証明書が正常に生成されました',
  Cargo_VoucherDateCanTBeEmpty: '証憑の日付は空にできません',
  Cargo_VoucherEntryCanTBeEmpty: '買掛伝票エントリは空にできません。',
  Cargo_VoucherGroupingRule: '証憑のグループ化ルール',
  Cargo_VoucherGroupingType: '証憑のグループ化タイプ',
  Cargo_VoucherGroupingTypeP: '証憑のグループ化タイプ: ',
  Cargo_VoucherLetter: '証憑番号',
  Cargo_VoucherLetterCanTBeEmpty: '証憑の文字は空にできません',
  Cargo_VoucherLetterNo: '証憑のサイズ',
  Cargo_VoucherLetterP: '証憑の文字: ',
  Cargo_VoucherList: '証憑の一覧',
  Cargo_VoucherMonth: '買掛伝票月',
  Cargo_VoucherNo: '買掛伝票番号',
  Cargo_VoucherNoCanTBeEmpty: '買掛伝票番号は空にできません',
  Cargo_VoucherNoP: '証憑番号: ',
  Cargo_VoucherNotCreatedCreateItNow: '証憑が生成されていません。証憑を生成しますか？',
  Cargo_VoucherOfAdvance: '前受付証憑',
  Cargo_VoucherPeriod: '買掛伝票の期間',
  Cargo_VoucherPeriodCanTBeEmpty: '買掛伝票期間は空にできません',
  Cargo_VoucherRule: '証憑のルール',
  Cargo_VoucherSearch: 'バウチャー検索',
  Cargo_VoucherStatus: '証憑の状態',
  Cargo_VoucherType: '買掛伝票タイプ',
  Cargo_VoyageFlight: 'フライト情報',
  Cargo_VoyageNo: '航次',
  Cargo_VRDBR: '消込済明細の表示',
  Cargo_VSRAOGTEPAEIADPERAPIT: 'ゴールデン税は紙の請求書、電子請求書の検証とサービス要求先が異なるので、請求書の種類によってそれぞれ導出してください。',
  Cargo_Warehouse: '倉庫',
  Cargo_WarehouseDoor: '倉庫/ドアポイント',
  Cargo_WarehouseLoading: '倉庫の内容',
  Cargo_WarehouseLoadingStorage: 'コンテナ/倉庫',
  Cargo_WarehouseNo: '入庫番号',
  Cargo_WBOWBVCTBD: 'レッドインパクト買掛伝票またはレッドインパクト買掛伝票は削除できません。',
  Cargo_WBOWBVCTBWB: '買掛伝票を赤で消し込むか、または赤で消し込まれた場合は赤で消し込むことができません。',
  Cargo_REVERSE: 'レッドインパクト買掛伝票が成功しました。',
  Cargo_WCDCOVCWBDBOSRCCWBIDDRWNOPC: 'チェックすると、今回のクエリは検索結菓に応じて異なる通貨の詳細列を表示し、カスタムの設定は無視されます。動的に表示された結菓は、元の構成を上書きしません。',
  Cargo_WDPCCS: 'データが間違っています。カスタマーサービスに連絡してください。',
  Cargo_Wechat: 'ウィーチャット',
  Cargo_Week: '週',
  Cargo_Weight: '重量',
  Cargo_WHCode: '進入番号',
  Cargo_WhetherOrNotBroken: '破損しているかどうか',
  Cargo_WipeOut: '端数は無視する',
  Cargo_WithdrawalAddress: '返品先アドレス',
  Cargo_WithdrawalListOfLinkedConsignors: '関連委託先返品リスト',
  Cargo_WithdrawExpense: '費用を抽出します',
  Cargo_WONCPPC: 'アカウントを削除して支払いを確認するプロセスが完了しました',
  Cargo_WORIPCPARO: '転記記録が正しくありません。ページを閉じて再度開いてください',
  Cargo_WorkSetAfterSearch: 'クエリ後のワークセット',
  Cargo_WriteBack: '赤沖',
  Cargo_WriteBackVoucher: '紅沖証憑',
  Cargo_WriteOff: '消込',
  Cargo_WriteOffAll: 'すべてを書き込み',
  Cargo_WriteOffAllP: 'すべてを消し込むかどうか',
  Cargo_WriteOffAmount: '売上金額',
  Cargo_WriteOffAmountCNY: 'CNY売上金額',
  Cargo_WriteOffAmountIs: '売上金額は: ',
  Cargo_WriteOffAmountUSD: 'USDの売上金額',
  Cargo_WriteOffAR: '売掛金勘定',
  Cargo_WriteOffBalance: '消込済残高',
  Cargo_WriteOffBalanceIs: '消込済残高: ',
  Cargo_WriteOffCurrency: '消込通貨',
  Cargo_WriteOffDate: '売上日',
  Cargo_WriteOffDetails: '消込明細',
  Cargo_WriteOffEntry: '仕訳入力',
  Cargo_WriteOffFailed: '転記に失敗しました',
  Cargo_WriteOffInputError: '選択された未消込費用には支払申請書の費用が含まれています。支払申請書の審査プロセスが完了した後に消込してください。',
  Cargo_WriteOffList: '売上明細',
  Cargo_WriteOffListPDF: '売上明細.pdf',
  Cargo_WriteOffListXLS: '売上明細.xls',
  Cargo_WriteOffNo: '帳消し番号',
  Cargo_WriteOffOfAdvance: '前受付消込済',
  Cargo_WriteOffOrNot: '帳消しにするかどうか',
  Cargo_WriteOffP: '帳消し-',
  Cargo_WriteOffPerson: '転記者',
  Cargo_WriteOffRate: '為替レートの適用',
  Cargo_WriteOffRecordsNotSelected: '売上レコードが選択されていません。',
  Cargo_WriteOffRemarks: '帳消しコメント',
  Cargo_WriteOffReverseWriteOff: '適用/非適用',
  Cargo_WriteOffRevokedSuccessfully: 'キャンセルに成功しました。',
  Cargo_WriteOffSerialNumber: '売上伝票番号',
  Cargo_WriteOffStartingPeriod: '消込期首',
  Cargo_WriteOffStartingPeriodP: '消込期首: ',
  Cargo_WriteOffStatus: '消込済処理状況',
  Cargo_WriteOffType: 'ピン',
  Cargo_WriteOffTypeP: '売上タイプ: ',
  Cargo_WrittenOff: '消込済',
  Cargo_WrittenOff2: '売上換算RMB',
  Cargo_WrittenOffItemsCanTBeModified: 'すでに適用されており、変更できません。',
  Cargo_WrittenOffItemsExist: '消込済勘定があります',
  Cargo_WrittenOffNotWrittenOff: '消込済、未消込済',
  Cargo_WrittenOffSuccessfully: '帳消しに成功しました',
  Cargo_WrongInvoicingMachineNoEntered: '開票機番号の入力が間違っています。',
  Cargo_WroteOff: '適用するかどうか',
  Cargo_WroteOffOrNot: '適用済みかどうか',
  Cargo_X10: '10',
  Cargo_X100: '百',
  Cargo_X1000: '千',
  Cargo_X10000: '万',
  Cargo_YadongKingdee: '亜東金蝶',
  Cargo_YesControlled: '管理対象（または：制御中）',
  Cargo_NotControlled: '製御されません',
  Cargo_Year: '年',
  Cargo_Years: '年',
  Cargo_Yes: 'はい',
  Cargo_YesLink: 'はい、関連付けます',
  Cargo_YesNo: 'いいえ',
  Cargo_Yuan: '元',
  Cargo_ContentIsEmpty: '内容が空です。',
  Cargo_PleaseSelectExpenseToProcess: '処理する費用を選択してください。',
  Cargo_EditSoa: '取引明細書の編集',
  Cargo_InvalidParameterCFR: '無効なパラメータです。入力勘定規則が見つかりません。',
  Cargo_SuccessItemsFailedItems: '{0}件が成功し、{1}件が失敗しました。',
  Cargo_BADNMOPRTB: '請求書{0}の決済エージェントが取引明細書の決済対象と一緻しません。この請求書を削除して保存してください。',
  Cargo_IVCNBVPDTORTI: '{0}個の請求書が生成されました。買掛伝票は無効にできません。買掛伝票を削除するか、赤消ししてください。',
  Cargo_Temp: '-空-',
  Cargo_OperationCommission: 'オペレーション・リベート',
  Cargo_CSCommission: 'カスタマーサービスのリベート',
  Cargo_ViewPaymentRequest: '支払申請書の表示',
  Cargo_WantToAddThemToTheBill: '選択した費用には消込済の費用が含まれています。請求書に追加しますか？',
  Cargo_AddAllToTheBill: 'すべて請求書に追加',
  Cargo_OnlyTheUnwrittenOffExpenses: '未消込費用のみを加算します',
  Cargo_ImportAndQueryOfBillNumber: '請求書番号インポートクエリ',
  Cargo_DebitAmountCN: '借方金額',
  Cargo_CreditAmountCN: '貸方金額',
  Cargo_PushMiddleTable: '中間表をプッシュします',
  Cargo_IfError: '間違いですか',
  Cargo_ErrorInfo: 'エラー情報です。',
  Cargo_AIOCER: '為替レート原貨金額',
  Cargo_BalanceInRmb: '残高人民元',
  Cargo_BalanceInUsd: '残高ドル',
  Cargo_CanTDeleteInvoicedItems: '請求済みで削除できません',
  Cargo_CanTDeleteIssuedInvoice: '請求書は削除できません！',
  Cargo_CardAccessControl: 'カード権限製御',
  Cargo_CCTBEVCTBE: '顧客は空にできません。仕入先は空にできません',
  Cargo_ConfirmAPP: '支払を確認しますか',
  Cargo_ConfirmBill: '請求書の確認',
  Cargo_CreditSideRmb: '貸方（人民元）',
  Cargo_CreditSideUsd: '貸方（米ドル）',
  Cargo_CurrencyIncompatible: '通貨が一緻しません',
  Cargo_CustomizedField: 'カスタムフィールド',
  Cargo_IssuedUnissued: '公開済み未公開',
  Cargo_NoExpensesToBeInvoiced: '請求できません。請求可能な費用はありません',
  Cargo_OVICBETGTEI_2: 'VAT請求書のみがゴールデン税無効化電子請求書',
  Cargo_OWCICGTSEEI_2: '請求通貨がRMBの場合のみ、ゴールデン税の電子請求書を無効にできます',
  Cargo_PleaseSelectAnBillPayment: '支払要求を選択してください',
  Cargo_PleaseSelectPurchaser: '購入者を選択してください。',
  Cargo_SelectAddPlatformBLMethod: 'プラットフォーム請求方法選択追加',
  Cargo_SettlingPartyMustBeIdentical: '決済対象は同じでなければなりません',
  Cargo_Space5: '半月決算',
  Cargo_TARBACTBLTAPAWIETIAR: '収支タイプが売掛金の場合、売掛金の合計金額は買掛金の合計金額より小さくすることはできません',
  Cargo_CanNotRemovedAllCharge: 'すべてのチャージを削除できません！',
  Cargo_BillNotAllowEditEtowerOne: 'EtowerOneからの請求書には操作が許可されていません！',
  Cargo_NoSubmit_SR: '送信されていません',
  Cargo_AwaitApproval_SR: '承認中',
  Cargo_Approved_SR: '承認完了',
  Cargo_ModifyFilter: '条件追加／削除',
  Cargo_SaveChanges: '保存',
  Cargo_SaveAsScheme: '新規保存',
  Cargo_QueryScheme: 'クエリスキーム',
  Cargo_QuerySchemeManagement: 'クエリスキーム管理',
  Cargo_SchemeName: 'スキーム名',
  Cargo_SelectQueryCriteria: 'クエリ条件の選択',
  Cargo_ApplicationForm: '申請書',
  Cargo_ApprovalHistory: '承認履歴',
  Cargo_AllQueryCriteria: 'すべてのクエリ条件',
  Cargo_MyQueryCriteria: '私のクエリ条件',
  Cargo_DisplayName: '表示名',
  Cargo_ConditionalExpression: '条件式',
  Cargo_ProcessingDifference: '差額を処理します',
  Cargo_NotFoundTemplate: '対応する印刷テンプレートが見つかりません！',
  Cargo_NoPaymentMethodPermissionOfReconciliation: '権限が不足しています。管理者に連絡して、決済タブの受取方法の権限を設定してください！',
  Cargo_NoFeeTypePermissionOfReconciliation: '権限が不足しています。管理者に連絡して、決済タブの費用タイプ権限を設定してください！',
  Cargo_SearchDataForReconciliation: 'データを調べてから、決済を開始してください！',
  Cargo_ChargeUpdateFailed: '{0}個のチャージが他の人によって変更されました。更新は成功しませんでした！',
  Cargo_SaveReconciliationSuccess: '決済の保存に成功しました！',
  Cargo_RemoveAll: 'すべて削除',
  Cargo_ViewDeleteChargeDetail: '詳細の表示/削除',
  Cargo_DeleteAdjustment: '調整の削除',
  Cargo_PleaseSelectedCancelConfirmCharge: 'キャンセル確認が必要な料金を選択してください',
  Cargo_PleaseSelectedConfirmCharge: '確認する費用を選択してください',
  Cargo_PleaseSelectedBillingDate: '請求日を選択してください！',
  PleaseSelectSplitCharge: '分割する費用を選択してください！',
  OnlySelectOneChargeToSplit: '分割する費用は1つしか選択できません！',
  ChargeHasInvoicedOrWriteOff: 'この費用は請求済みまたはキャンセル済みです。もう一度選択してください！',
  NoChargeForSplit: '実際に分割できる費用はありません。再選択してください！',
  Cargo_exportExcelAll: 'データ一括出力',
  Cargo_PleaseInputKeyWordsForQuery: 'キーワードクエリを入力してください',
  Cargo_AccountNumber: 'アカウント',
  Cargo_OwnerBankOfDeposit: '我が銀行',
  Cargo_JoinBill: '請求書を追加します',
  Cargo_SelectedUnConfirmedCharge: 'キャンセルするチャージを選択してください！',
  Cargo_NoChargeForSplit: '実際に分割できる費用はありません。もう一度選択してください！',
  Cargo_InputTaxAmount: '税込み価格を入力してください！',
  Cargo_ReconciliationTypeP: '決済タイプ: ',
  Cargo_ByFee: '料金別',
  Cargo_SelectBill: '請求書を選択',
  Cargo_BillOfType: '請求書タイプ: ',
  Cargo_BillDateP: '請求日: ',
  Cargo_StatementDateP: '請求書日付: ',
  Cargo_RegistrationAddress: '納税者の住所',
  Cargo_OriginalCurrency2: '元の通貨',
  Cargo_ExchangeRate2: 'レート',
  Cargo_BillRateEmpty: '請求書の元の通貨レートは空にできません！',
  Cargo_BillCurrencyMore: '請求書のチャージ通貨は3つ以上にできません！',
  Cargo_BillCurrencyEmpty: '請求通貨は空にできません！',
  Cargo_SettlementAgentEmpty: '決済エージェントは空にできません！',
  Cargo_IncludingTaxAmountZero: '税込価格はゼロにできません！',
  RequiredAccrueDate: '計上日を入力してください',
  RequiredCancelDate: 'キャンセル日を入力してください',
  Cargo_NoChargeForBillPayment: '支払要求を作成する費用がありません！',
  Cargo_CancelSpecialApproval: '特別承認の取り消し',
  Cargo_LockTheBillTime: 'シートのロック時間',
  Cargo_CreditControlObject: 'コントロールオブジェクト',
  Cargo_SpecialApprovalTime: '特別承認時間',
  Cargo_SpecialApprovalUser: '承認者',
  Cargo_AmountExceeded: '超過しました',
  Cargo_DateExceeded: '期限切れ',
  Cargo_CreditControlInfo: '信管状況',
  Cargo_OperateTime: '操作時間',
  Cargo_DownloadLog: 'ダウンロードログ',
  Cargo_Times: '次',
  Cargo_LockTheBillDate: 'ロックシートの日付',
  Cargo_SpecialApprovalDate: '承認日',
  Cargo_OperateDate: '処理日',
  Cargo_LockTheBillUser: 'ロックシングル',
  Cargo_sono: 'S/O番号（出荷指図番号）',
  Cargo_pono: 'PO.No.',
  Cargo_PolAir: '出発港（空港）',
  Cargo_keyWordsTip: 'キーワードを入力してください',
  Cargo_sopDoubleClickTip: 'テキストボックスをダブルクリックしてノード状態クエリを選択します。',
  Cargo_NewQueryScheme: '新しいクエリスキーム',
  Cargo_TheQueryItemSelected: 'このクエリアイテム【{0}】はすでに選択されています',
  Cargo_SchemeSaveSuccess: 'スキームが保存されました',
  Cargo_BillLogManagement: '船荷証券ログ管理',
  Cargo_ModifyContent: '変更内容',
  Cargo_CheckPermission: 'ビジネスを表示する権限がありません！',
  Cargo_CheckBusinessType: '同じ取引タイプ を選択してください！',
  Cargo_MasterChargeWhetherShareOrNot: 'マスタ手数料配賦フラグ',
  Cargo_DepartmentPrefixNotSelected: '決算部門が選択されていません。',
  Cargo_SalesIsEmpty: '現在の顧客販売は空で、サインできません！',
  Cargo_Distribution: '配布',
  Cargo_SalesNotSelected: '売上が選択されていません！',
  Cargo_ReviewedByLeader: '割り当て済み、この顧客は元のリーダーによるレビュー待ち: ',
  Cargo_AllocationSucceeded: '割り当てが成功しました！',
  Cargo_FormerGroupLeader: '元グループリーダー',
  Cargo_ChineseNameIsEmpty: 'お客様の氏名が空です！',
  Cargo_OriginalTeamLeaderIsEmpty: '元チームリーダー名が空です！',
  Cargo_DoNotOperate: '現在の顧客に対する操作は禁止されています。営業マネージャに連絡して解決してください！',
  Cargo_RestoreCurrentCustomer: '現在の顧客を復元しますか？',
  Cargo_CustomerInformationIsEmpty: '顧客情報が空です！',
  Cargo_CannotBeDeleted: 'この顧客はビジネスで使用されているため、削除できません！',
  Cargo_DeleteSuccessfully: '削除に成功しました。この顧客は顧客のごみ箱に移動されました！',
  Cargo_AreYouSureDelete: '本当に削除しますか？',
  Cargo_PleaseSelectForDelete: '削除する顧客を選択してください！',
  Cargo_ChineseNameAlreadyExists: '氏名は既に存在します',
  Cargo_EnglishNameAlreadyExists: '英語名は既に存在します',
  Cargo_ChineseOrEnglishAlreadyExists: '中国語または英語の名前が既に存在します',
  Cargo_ContactPersonToFillInA: 'お客様の連絡先は少なくとも1つ記入してください！',
  Cargo_PleaseInvoicingRequirementsTab: '請求要件タブの通貨要件を入力してください！',
  Cargo_SignOrNot: 'サインするかどうか',
  Cargo_DangerousChemicals: '危険物かどうか',
  Cargo_DaysNotFollowedUp: 'フォローしていない日数',
  Cargo_CustomerNotSelected: 'お客様が選択されていません！',
  Cargo_AssignedClientsSuccessfully2: '{0}個の顧客が割り当てられました',
  Cargo_examine: '個の取引先は元の組長の審査を待っています',
  Cargo_CreateSource: 'ソース',
  Cargo_Tenant: 'テナント',
  Cargo_Platform: 'プラットフォーム',
  Cargo_DistributionSales: '個の顧客が販売の割り当てに成功しました',
  Cargo_MoreThan1Year: '1年以上',
  Cargo_list: 'リスト',
  Cargo_MyClients: '私の顧客',
  Cargo_CustomersInThisGroup: 'このグループの顧客',
  Cargo_CustomerRecycleBin: '顧客のごみ箱',
  Cargo_PleaseSelectTheCustomerToExport: 'エクスポートする顧客を選択してください！',
  Cargo_city: '市',
  Cargo_email: 'メールボックス',
  Cargo_add: '追加',
  Cargo_Append: '追加',
  Cargo_PSCF: '先に連絡先を選択してください！',
  Cargo_NCS: '連絡先が選択されていません！',
  Cargo_CNATCBE: '連絡先名と電話番号は空にできません！',
  Cargo_ERF: 'ファイルの削除エラー！',
  Cargo_FDS: 'ファイルの削除に成功しました！',
  Cargo_AYSDF: '本当にファイルを削除しますか？',
  Cargo_PSAEF: 'まずイベントを選択してください',
  Cargo_theme: 'テーマ',
  Cargo_FTMFT: 'ファイルタイプの変更に失敗しました',
  Cargo_EventStatus: 'イベントの状態',
  Cargo_TaskTime: 'タスク時間',
  Cargo_CustomerChineseName: '顧客の氏名',
  Cargo_CustomerEnglishName: '顧客の英語名',
  Cargo_NextTask: '次のタスク',
  Cargo_RWSR: '{0}レコードが拒否されました',
  Cargo_isActive: '有効状態',
  Cargo_OverdueLimit: '超過限度額',
  Cargo_OverdueDays: '期限切れ日数',
  Cargo_Enable: '有効にする',
  Cargo_Disable: '無効にする',
  Cargo_EnableStatus: '有効状態',
  Cargo_Enabled: '有効になっています',
  Cargo_Disabled: '無効になっています',
  Cargo_amount: '本数',
  Cargo_HasChosen: '選択されました',
  Cargo_RemoveToBlackList: 'ブラックリストから削除',
  Cargo_SureToRemoveToBlackList: 'ブラックリストから削除してよろしいですか？',
  Cargo_Flight: 'フライト',
  Cargo_OutstandingAmount: '未償却額（費用）',
  Cargo_WriteOffAmountCharge: '充当金額（チャージ）',
  Cargo_ReceivableExcludingTax: '税抜き売掛金（請求書）',
  Cargo_TaxIncludedReceivable: '税込受取（請求書）',
  Cargo_PayableExcludingTax: '税抜き支払（請求書）',
  Cargo_TaxPayable: '税込み（請求書）を支払う',
  Cargo_TotalExcludingTax: '税抜き合計（請求書）',
  Cargo_TotalTaxIncluded: '税込合計（請求書）',
  Cargo_PleaseEnterBoxTypeOrBoxType: '箱型または箱種を入力してください！',
  Cargo_EffectiveDateMustBeLessThanTheExpirationDate: '有効日は失効日より小さくなければなりません',
  Cargo_MaintenanceOfExpenseDetails: '費用明細のメンテナンス',
  Cargo_CustomerQuickSearch: 'クイック検索: 顧客名/英語名',
  Cargo_WechatAccount: 'WeChatアカウント',
  Cargo_Download: 'ダウンロード',
  Cargo_ChineseNamed: '中国語名',
  Cargo_EnglishNamed: '英語名',
  Cargo_SignContractTip: '類似した名前の企業がパートナーモジュールにすでに存在します。関連付けが必要ですか？',
  Cargo_SignContractTipYes: 'はい、関連付けます',
  Cargo_SignContractTipNo: 'いいえ、関連付けはしません',
  Cargo_CooperationStage: 'コラボレーションステージ',
  Cargo_Financial_Year: '会計年度',
  Cargo_ConfirmCloseWindow: 'ウィンドウを閉じますか？',
  Cargo_NoteUpdatedSuccessfully: 'コメントの更新に成功しました',
  Cargo_PleaseSelectAPieceOfData: 'データを選択してください。',
  Cargo_SelectDataIsNotAuditState: '事前承認処理状況がレビュー対象のビジネスのみをサポートしています。再チェックしてください.',
  Cargo_SelectDataIsNotSubmittedTemporarilyOrRejectState: '事前承認処理状況の提出が保留中または却下されたビジネスのみをサポートする場合は、再度チェックしてください。',
  Cargo_SelectAtLeastOneRecord: '少なくとも1つのレコードを選択してください',
  Cargo_FieldDisplay: 'フィールド表示',
  Cargo_ControlSelection: 'コントロール選択',
  Cargo_EnumValue: '列挙値',
  Cargo_StatusIsNotPending: '処理状況は保留中ではありません。',
  Cargo_NotSubmittedAndRejectedStatusTips: '保留中と拒否済みの状態しか選択できません。',
  Cargo_subimitPreStatusTips: 'レビュー前の状態を送信しますか？',
  Cargo_TransitCannotBeNull: '中継港は空にできません',
  Cargo_TheClientDoesNotBelongToYourCustomerTips: 'この委託先はお客様のものではありません。新しいものを選択してください',
  Cargo_ThereAreBargesTips: 'バージがあります。バージの締め切り日を入力してください',
  Cargo_ClosingDateCannotBeGreaterThanTheSailingDate: '締切日は出航日より大きくできません',
  Cargo_ClosingDateOfBargeTips: 'バージの締切日は締切日より大きくできません',
  Cargo_CurrentAccount: '当座勘定',
  Cargo_BusinessNoAndChargeName: '業務番号/料金名',
  Cargo_BusinessNum: 'ビジネス数',
  Cargo_UploadTime: 'アップロード時間',
  Cargo_Finished: '完了したかどうか',
  Cargo_OperationRequirement: '操作内容要件',
  Cargo_measurements: 'サイズCM（長さ*幅*高さ*件数）',
  Cargo_VoucherLineNumberSetting: '証憑の行数設定',
  Cargo_VoucherLine: '証憑の行数',
  Cargo_UseRmbEntrytypeByInvoice: '請求書証憑入力が[原通貨金額]から直接[機能通貨金額]を取るかどうか、為替レート1',
  Cargo_UseRmbEntrytypeByInvoiceTip: '（「,」で区切る：1＝売掛金3＝買掛金5＝営業収益7＝営業原価）',
  Cargo_UseRmbEntrytypeByFact: '受取証憑入力が[原通貨金額]から直接[機能通貨金額]を取るかどうか、為替レート1',
  Cargo_UseRmbEntrytypeByFactTip: '（「,」で区切る：1＝売掛金3＝買掛金73＝買掛金（個人）40＝売掛金（連結）41＝買掛金（連結）42＝営業収益（連結）43＝営業原価（連結））',
  Cargo_UseRmbEntrytypeByPre: '前払買掛伝票入力が[原通貨金額]から直接[機能通貨金額]を引き出すかどうか、為替レート1',
  Cargo_UseRmbEntrytypeByPreTip: '（「,」で区切る：1＝売掛金3＝買掛金26＝前払金44＝前払金）',
  Cargo_Note: '説明',
  Cargo_ChooseEdiTemplate: 'EDIテンプレートの選択',
  Cargo_OperatedFailed: '操作が失敗しました',
  Cargo_SelectPurchaseRecord: '購入レコードを選択してください。',
  Cargo_SelectAcquiredRecord: '受領記録を選択してください。',
  Cargo_CheckInvoiceInvalidState: '現在の選択には、無効または使用された請求書番号が含まれています。',
  Cargo_CheckInvoiceUsedState: '請求書が選択されていないか、受領状態が選択されていません。',
  Cargo_InvoiceRestoreSuccessfully: '請求書が正常に復元されました。',
  Cargo_CheckInvoiceRestoreState: '現在の選択には無効化されていない請求書番号が含まれています。',
  Cargo_ConfirmRestoreInvoice: '無効になった請求書を復元しますか？',
  Cargo_InvoiceInvalidSuccessfully: '請求書は無効になりました。',
  Cargo_CheckInvoiceType: '請求書タイプが一緻しません。',
  Cargo_CheckInvoiceRecipientState: '現在の選択には受領済みレコードが含まれています。',
  Cargo_LocalAmount: '基本通貨',
  Cargo_SourceAmount: '原貨',
  Cargo_DebitAmountOccurredLocal: '発生額（基本通貨）の借方記帳',
  Cargo_DebitAmountOccurredSource: '借方発生額（原貨）',
  Cargo_CreditAmountOccurredLocal: '貸方発生額（基本通貨）',
  Cargo_CreditAmountOccurredSource: '貸方発生額（元の通貨）',
  Cargo_hidePop: 'クリックして統計を取ります',
  Cargo_dispPop: 'クリックすると統計が展開されます',
  Cargo_SchemeUserTips: '注: ユーザーの料金プランが維持され、以下のリスト内のユーザーにのみ適用されます',
  Cargo_NoDataCanBeModified: '変更可能なデータはありません。',
  Cargo_BalanceLocal: '残高（基本通貨）',
  Cargo_BalanceSource: '残高（元の通貨）',
  Cargo_DebitAmountLocal: '借方金額（基本通貨）',
  Cargo_DebitAmountSource: '借方金額（原貨）',
  Cargo_DebitSideLocal: '借方（基本通貨）',
  Cargo_DebitSideSource: '借方（原貨）',
  Cargo_CreditAmountLocal: '貸方（基本通貨）',
  Cargo_CreditAmountSource: '貸方（元の通貨）',
  Cargo_BatchUpload: '一括アップロード',
  Cargo_PleaseSelectBusinessData: 'ファイル名を一緻させるビジネスデータを選択してください',
  Cargo_DocumentsBack: 'ドキュメントの回収',
  Cargo_CanNotWriteOffForDifferentExpenseTypes: '国内と海外の費用は同時に適用できません！',
  Cargo_VehicleRequestForm: '車両申請書',
  Cargo_VehicleOrder: '車両注文書',
  Cargo_BatchGenerateVehicleOrder: '車両注文書を一括生成',
  Cargo_VehicleRequestFormNo: '車両申請書番号',
  Cargo_PickUpDelivery: '引取/配送',
  Cargo_EstimatedPickUpDate: '予想引取日',
  Cargo_Port2: '港',
  Cargo_VehicleOrderNo: '車両注文書番号',
  Cargo_VehicleTime: '車両出発時間',
  Cargo_CancelVehicleOrder: '車両注文書のキャンセル',
  Cargo_VehicleDispatched: '車両出発済み',
  Cargo_CancelVehicleStatus: '車両状態のキャンセル',
  Cargo_CancelCompletedStatus: '完了状態のキャンセル',
  Cargo_StatusUpdateRecord: '状態更新記録',
  Cargo_UpdateVehicleOrderStatus: '車両注文書状態更新',
  Cargo_CancelCondition: '車両注文書の状態が「未出発」の場合のみキャンセル可能',
  Cargo_ConfirmCancelVehicleOrder: '車両注文書をキャンセルしてもよろしいですか？',
  Cargo_SelectNotDispatched: '「未出発」状態の車両注文書を選択して操作してください。',
  Cargo_SelectDispatched: '「出発済み」状態の車両注文書を選択して操作してください。',
  Cargo_SelectStatusConsistent: '選択した車両注文書の状態は一致する必要があります。',
  Cargo_VehicleOrderCompleted: '車両注文書の状態は完了しています。',
  Cargo_SelectCompleted: '「完了」状態の車両注文書を選択して操作してください。',
  Cargo_CompletionTimeNotEarlierThanDispatchTime: '「完了時間」は「出発時間」より早く設定できません',
  Cargo_ActualPickupDate: '実際の荷物引き取り日',
  Cargo_DispatchTaskLinkedToVehicle: '配送タスクは車両注文に関連付けられており、削除できません。最初に解除してから変更してください。',
  Cargo_DispatchTaskLinkedToVehicle_ArrivalMethod: '配送タスクは車両注文に関連付けられており、「到着方法」を変更できません。最初に解除してから変更してください。',
  Cargo_DispatchTaskLinkedToVehicle_DestinationPort: '配送タスクは車両注文に関連付けられており、「目的港配送」をキャンセルできません。最初に解除してから変更してください。',
  Cargo_Port_Airport: '港（空港）',
  Cargo_VehicleRequestDifferentPorts: '車両申請書は異なる港に属しています。統合して生成しますか？',
  Cargo_VehicleOrderGeneratedSuccess: '車両注文の生成に成功しました',
  Cargo_VehicleOrderSerialNumber: '車両注文のシリアル番号は',
  Cargo_BusinessCreationTime: '業務作成時間',

  Cargo_CurrencyMustBeTheSame: '通貨は同じでなければなりません！',
  Cargo_AccountContacts: '決算単位の連絡先',
  Cargo_AccountAddr: '決算単位の所在地',
  Cargo_AccountContactsTel: '連絡先の電話番号',
  Cargo_CustomsDeclarationInformationOujian: '通関情報（現在、特別規製区域の通関モードはサポートされていません）',
  Cargo_ChargeSubmit: 'チャージを送信するかどうか',
  Cargo_ContractRatePropertySE: '契約価格区分（海上輸出）',
  Cargo_ContractRatePropertySI: '契約価格区分（海上輸入）',
  Cargo_TaxRevenueShortName: 'エンコード',
  Cargo_TaxRevenueName: '税コード名',
  Cargo_TaxRevenueToolTip: '注: コードは国家税統一コード、例: 30408020102000000000；税コード名は税分類コードの略称、例: 仲介代理サービス',
  Cargo_CargoSourceTip: '集荷種別【{0}】を切り替えますか？',
  Cargo_AccountingMonthMaintain: '会計月のメンテナンス',
  Cargo_FclApproximatePrice: '箱単位の価格',
  Cargo_LclApproximatePrice: '箱詰め契約価格',
  Cargo_AddContractNo: '契約番号を追加します',
  Cargo_Income20: '20\'調整',
  Cargo_Income40: '40\'調整',
  Cargo_Income40HC: '40HC\'調整',
  Cargo_Income45: '45\'調整',
  Cargo_WeightPriceAdjust: '重量価格調整',
  Cargo_CubagePriceAdjust: 'ボリューム価格調整',
  Cargo_MinimumPriceAdjust: '最低価格調整',
  Cargo_GrossMargin: '粗利率',
  Cargo_IncorrectExpenseStatus: 'チャージ処理状況が正しくありません！',
  Cargo_ExpenseStatusModifiedSuccessfully: '費用処理状況の変更に成功しました！',
  Cargo_DestinationSelection: '目的地の選択',
  Cargo_AciPortCode: 'aciポートコード',
  Cargo_InlandLocation: '内陸の場所',
  Cargo_SubLocationCode: 'サブロケーションコード',
  Cargo_DeleteBillTips: '請求書番号が生成されず、請求書処理状況が未確認の請求書のみ削除できます！',
  Cargo_ForceDeleteBillTips: '請求書処理状況が未確認、確認済、印刷済、無効の請求書のみ削除できます！',
  Cargo_ConfirmDeleteCategoryAndType: '選択したカテゴリとタイプを削除しますか？',
  Cargo_RangeAndGE: '下限値（含む）',
  Cargo_RangeAndLT: '上限値（除く）',
  Cargo_FinancialDateCheckNull: '会計処理日は空にできません！',
  Cargo_CurrencyCheckNull: 'Currency cannot be blank !',
  Cargo_FinancialDateCheckBefore: '選択日は現在の日付より後にすることはできません',
  Cargo_OperatingCompanyCannotBeEmpty: 'オペレーション会社は空にできません',
  Cargo_DeliveryCannotBeNull: '配送先は空にできません',
  Cargo_DesignatedCannotBeNull: '指定された貨物エージェントは空にできません！',
  Cargo_SalesCannotBeEmpty: '売上は空にできません',
  Cargo_ItemNumberCannotBeEmpty: 'プロジェクト番号は空にできません！',
  Cargo_PleaseSelectLoadingPort: 'ロードポートを選択してください！',
  Cargo_PleaseChooseTheDestinationPort: '宛先ポートを選択してください！',
  Cargo_UserManagement: 'ユーザー管理',
  Cargo_Search2: 'データ検索',
  Cargo_RecordAmount: 'レコード数',
  Cargo_RoleUserSettings: 'ロールユーザー設定',
  Cargo_SystemAdministrator: 'システム管理者',
  Cargo_UserCode: 'ユーザーコード',
  Cargo_UserDepartment: 'ユーザーの所属部署',
  Cargo_UserCompany: 'ユーザーの所属会社',
  Cargo_IncludingElectricitySupplierAccount: 'Eコマースアカウントを含む',
  Cargo_ValidOrNot: '有効かどうか',
  Cargo_Valid: '有効',
  Cargo_Invalid2: '無効',
  Cargo_LoginName: 'ログイン名',
  Cargo_MobilePhoneNo: '携帯電話',
  Cargo_PasswordExpirationDate: 'パスワードの有効期限',
  Cargo_NetworkManagementCode: 'ネットワーク管理コード',
  Cargo_Superior: '上司',
  Cargo_OfficeAndDep: '所属支店/部局',
  Cargo_ConfirmBatchModifyUser: '[{0}]に該当するチェック済みデータを一括置換',
  Cargo_BatchModifyUserSucceed: '{0} 転送データ [{1}] を [{2}] に正常に変更しました',
  Cargo_ExternalAssociationCode: '外部関連コード',
  Cargo_ExternalAssociationCodeValidMessage: '外部関連コードは文字または数字のみです',
  Cargo_Activation: 'アクティブ化',
  Cargo_ElectricitySupplierAccountOrNot: 'Eコマースアカウントかどうか',
  Cargo_SystemAdministratorOrNot: 'システム管理者です',
  Cargo_BatchModify: '一括編集',
  Cargo_TheCompanyToWhichTheAccountBelongs: 'アカウントの所属会社',
  Cargo_EditPermission: '権限の編集',
  Cargo_AddUser: 'ユーザーの追加',
  Cargo_DeleteUser: 'ユーザーの削除',
  Cargo_RemoveUser: 'ユーザーを削除',
  Cargo_Filter2: 'フィルタ条件',
  Cargo_Import2: '一括インポート',
  GOODS_INFO_IMPORT: '貨物情報のインポート',
  Cargo_ContinueToCreate: 'このパートナーは{0}の下で維持されています。作成を続けますか？',
  Cargo_AssignRolesToUsers: 'ロールを割り当てるユーザー',
  Cargo_SelectARangeOfUsers: 'ユーザーの範囲を選択します',
  Cargo_NotSubmittedOrRejectedTips: '保留中または拒否されたビジネスのみ削除できます。再選択してください',
  Cargo_SelectedMoreThenNPieces: '選択したデータは製限数{0}を超えています。再選択してください',
  Cargo_SmallTicketCannotBeRemoved: '請求書には手数料が含まれており、削除できません。',
  Cargo_invoiceNotInconsistent: '請求書タイプ、請求書の種類が一緻しません。続行しますか？',
  Cargo_OnlyBillsWithBillingNumbersCanBeSubmitted: '請求書番号のある請求書のみを提出できます',
  Cargo_SureDoThis: '本当に実行しますか？',
  Cargo_BillHasBeenSubmitted: '請求書【{0}】は提出されました',
  Cargo_BillWasNotSubmitted: '請求書【{0}】は提出済みではありません',
  Cargo_OnlyBillsWithBillingNumbersCanBeWriteOff: '請求書番号のある請求書のみを消し込むことができます',
  Cargo_BillsHasBeenPaidInFull: '請求書{0}はすべて支払われたため、再請求はできません。',
  Cargo_NotAllowWriteOffFee: '消込保留中の費用のうち、支払要求が行われていないか、支払要求プロセスが完了していないため、消込不可です。',
  Cargo_BillsAlreadyWriteOffFee: '請求書{0}はすでに転記されており、返却できません',
  Cargo_RevokeAll: 'すべて取り消し',
  Cargo_ConfirmAndNotityHQ: '本社に通知しますか？',
  Cargo_AllBillingHasBeenSentToBranches: '現在選択されている決済対象はすべて会社に送信されました',
  Cargo_Sender: '送信者',
  Cargo_SendDate: 'EDI date',
  Cargo_VersionNo: 'バージョン番号',
  Cargo_BookingLog: '予約ログ',
  Cargo_BookingSubscribe: '購読',
  Cargo_BookingSubscribeSync: 'データ同期',
  Cargo_BookingSubscriptionStatus: '購読詳細',
  Cargo_SubscribeDataType: 'データ種別',
  Cargo_SubscribeStatus: '購読状態',
  Cargo_BatchUpdateExchangeRate: '為替レート一括更新',
  Cargo_UpdateExchangeRate: '為替レートの更新',
  Cargo_SelectAccountAndCurrency: '決済対象と通貨を選択してレートを変更してください: ',
  Cargo_InputRate: '入力レート: ',
  Cargo_ConfirmUpdateExchangeRate: '為替レートの更新を確認しますか？',
  Cargo_PleaseInputRate: '変更する為替レートを入力してください！',
  Cargo_PleaseSelectAccountAndCurrency: '為替レートを変更する決済対象/通貨を選択してください！',
  Cargo_ValidateUpdateRateTips: '操作が失敗しました。今回の更新レートの決済単位/通貨は今回のチェック業務に含まれていません！',
  Cargo_UpdateRateConfirmTipsHead: '一括更新レートには生成が含まれます',
  Cargo_UpdateRateConfirmTipsTail: 'の費用、今回は元の費用為替レートのみを更新します。修正後のデータは回復できません。続行しますか？',
  Cargo_BillVoidTipForState: '請求書は「未確認」状態でのみ無効にできます！',
  Cargo_BillVoidTipForReview: '請求書は「未検討」状態でのみ無効にできます！',
  Cargo_DuplicatedCode: 'このコードは重複しています。再入力してください。',
  Cargo_billPaymentNo: '支払申請書番号',
  Cargo_RangeSmaller: '小範囲を推奨します',
  Carge_ConfirmDate: '確認時間',
  Carge_ConfirmUser: '確認者',
  Carge_BillingConfirmDate: '請求書確認日',
  Carge_BillingConfirmUser: '請求書確認者',
  Carge_BillingGroupConfirmDate: '請求書確認日',
  Carge_BillingGroupConfirmUser: '請求書確認者',
  Carge_ChinessNameExist: '中国語の名前はすでに存在します。修正してください',
  Carge_EnglishNameExist: '英語名は既に存在します。変更してください',
  Cargo_Dep: '入力部門',
  Cargo_SyncFinanceCode: 'パートナーコードを顧客/仕入先コードに書き込みます。続行しますか？',
  Cargo_SyncFinanceCodeSuccess: '顧客/仕入先コードの同期が成功しました',
  Cargo_contactInformationCopy: '連絡先情報-単号抄録',
  Cargo_contactInformationCode: '連絡先情報-コード検索',
  Cargo_auditResult: '監査結菓',
  Cargo_number: '番号',
  Cargo_PlatformCode2: 'プラットフォームコード',
  Cargo_InterchaneeCode: '交換コード',
  Cargo_abbreviation: '略称',
  Cargo_TemplateDescribe: 'テンプレートの説明',
  Cargo_Describe: '説明',
  Cargo_BillingHeaderName: '請求ヘッダー名',
  Cargo_EnglishNameOfBank: '銀行の英語名',
  Cargo_ContactName: '連絡先名',
  Cargo_TenantID: 'テナントID',
  Cargo_AppendQuery: 'クエリ追加',
  Cargo_CollapseList: 'リストを閉じる',
  Cargo_SetAsDefault: 'デフォルトにする',
  Cargo_MultipleWorkNoEnter: '複数の作業番号の入力にはキャリッジリターンを使用してください',
  Cargo_DeleteConfirm: '削除するとデータは復元できなくなります。続行しますか？',
  Cargo_EachPage: 'ページごと',
  Cargo_DataBar: 'バーデータ',
  Cargo_ClientNumberMaintenance: '税コントロール番号のメンテナンス',
  Cargo_BillingPointCode: '開票ポイントコード',
  Cargo_UseDepartment: '部門の使用',
  Cargo_CanNotEmpty: '空にできません！',
  Cargo_CanNotRepeat: '繰り返すことはできません！',
  Cargo_BeforeCurrentDisplay: '現在の表示前',
  Cargo_ReceivableChargeInput: '売掛入力有無',
  Cargo_CostChargeInput: '買掛入力有無',
  Cargo_ConvertToCnyAr: '売掛金: 換算RMB',
  Cargo_ConvertToCnyAp: '対応: 換算RMB',
  Cargo_FeeModifier: '費用変更者',
  Cargo_FeeModifyDate: '料金変更日',
  Cargo_SoNoChangeTips: '通関番号の数が変更されました。元の通関番号単位の費用を更新しますか？',
  Cargo_EditSaleInfo: '販売情報調整',
  Cargo_PleaseSelectChargeApplyData: '費用監査データを選択してください。',
  Cargo_PleaseSelectExportChargeDetailData: '申請記録をチェックしてから試してください',
  Cargo_BeyondMaxExportChargeDetailData: 'エクスポート申請レコードは5000件を超えてはいけません。再選択してください',
  Cargo_ExportChargeDetailDataSucceed: '詳細のエクスポートに成功しました',
  Cargo_NotSameEtd: 'チェックイン業務の出航日月が一緻しません！',
  Cargo_BatchModifyJobNoMore: '1回の一括変更では、業務番号は100件を超えてはいけません。',
  Cargo_BatchModifyJobNoSuccess: '一括変更成功: {0}',
  Cargo_VolumeIsChanged: '実際の体積が変更されました。元の体積価格単位の費用を更新しますか？',
  Cargo_DealingsCustomer: '取引残高が取引番号に基づいているかどうか',
  Cargo_AllowsExceptionProofExport: '例外証明のスキップを可能にします',
  Cargo_ChargeChanger: '単価変更者',
  Cargo_ChargeCreadBy: 'チャージ作成者',
  Cargo_DeleteData: 'データが削除されました。管理者に連絡してください',
  Cargo_MasterTicketShareCharge: 'マスタチケットの料金はすでに割り勘されています。新しいチケットを追加するには、料金を再割り勘してください。',
  Cargo_CreateBillNo: '請求書番号を生成するかどうか',
  Cargo_CalcShareAmount: '配賦金額の計算',
  Cargo_CalcShareAmountTip: '配賦金額の計算ボタンをクリックして再計算して確認してください。',
  Cargo_CancelOrder: '{0}件の注文がキャンセルされました。{1}件の注文をキャンセルできませんでした。操作中の注文のキャンセルのみがサポートされています。',
  Cargo_CancelOrderTip1: '次の注文はキャンセルできません。続行しますか？',
  Cargo_CancelOrderTip2: 'この注文はすでに出港し、幹線業務番号があり、キャンセルできません',
  Cargo_CancelOrderTip3: 'この注文は出港しました。キャンセルできません',
  Cargo_CancelOrderTip4: 'この注文にはすでに幹線業務番号があり、キャンセルできません',
  Cargo_CancelOrderTip5: 'この{0}件の注文を一括キャンセルしますか？',
  Cargo_CancelOrderTip6: '注文をキャンセルします',
  Cargo_CancelOrderTip7: '今回は{0}件の注文を提出することができます。次の注文はキャンセルできません。続行しますか？',
  Cargo_CancelOrderTip8: '注文の状態は{0}で、キャンセルできません',
  Cargo_Reason: '理由',
  Cargo_PushResultLog: 'データプッシュ結菓レコード',
  Cargo_SendContent: '送信コンテンツ',
  Cargo_ResultSuccess: '送信状態',
  Cargo_ResultMessage: '失敗の理由',
  Cargo_DesignatedCargoWarehouseNo: 'When designating cargo, the warehouse entry number is equal to the business reference number.',
  Cargo_SelfCargoWarehouseNo: 'When self-handling cargo, the warehouse entry number is equal to the business reference number.',
  Cargo_BusinessMark: 'ビジネスマーク',
  Cargo_ModifyBusiness: '修正し再度生成する業務',
  Cargo_SelectJobNo: '業務番号を選んでください',
  Cargo_ClosingRecord: '決算記録',
  Cargo_ClosingAudit: '会計監査のクローズ',
  Cargo_AccountKeeper: '会計担当者',
  Cargo_ClosingMonth: '決算月',
  Cargo_ClosingBranch: '決算支社',
  Cargo_AccountClosingType: '会計タイプ',
  Cargo_ClosingDate: '決算日',
  Cargo_FinancialClosing: '会計締め',
  Cargo_BusinessClosing: '取引のクローズ',
  Cargo_SelectClosingDate: '決算日を選択',
  Cargo_SelectDeleteTip: 'Please select the template information you want to delete.',
  Cargo_SelectDeleteTip2: '{0} is in use and cannot be deleted.',
  Cargo_SelectDeleteTip3: '選択した設定を削除してもよろしいですか？削除後、インターフェースを呼び出すとデータが返されなくなります。',
  Cargo_SameCurrencyForMultipleRecord: '同じ通貨の実際の入金記録をチェックして、帳消しにしてください！',
  Cargo_SamePayReceiveDateForMultipleRecord: '消込日が同じ実績レコードを選択してください！',
  Cargo_DefaultTaxRete: 'デフォルトの税率',
  Cargo_TaxRateRange: '税率範囲',
  Cargo_TaxRateRangeLimit: '{0}、現在の税率は使用できません。必要に応じて、責任者に連絡して費用の【使用可能な税率】を維持してください。',
  Cargo_BargeETD: 'バージETD',
  Cargo_DataModifyDate: 'データ変更時刻',
  Cargo_sendOcOrder: '注文情報の再送',
  Cargo_sendOcTracking: '軌跡情報の再送',
  Cargo_sendOcFile: 'ファイル情報の再送',
  Cargo_sendOcBilling: '請求書情報の再送信',
  Cargo_chargeUpdater: '料金更新者',
  Cargo_WriteOffForMultipleRemainTipAr: '今回の選択では実収金額が不足しているので、今回の売上金額を修正することをお勧めします！',
  Cargo_SharedChargeRecord: '費用配賦レコード',
  Cargo_ExcludingTaxAmount: '税抜き金額',
  Cargo_IncludedTaxAmount: '税込み金額',
  Cargo_ShareScheme: '配賦方法',
  Cargo_ChargeSyncStatus: 'チャージ同期処理状況',
  Cargo_ChargeSyncConfirmStatus: '同期確認処理状況',
  Cargo_WriteOffForMultipleRemainTipAp: '今回選択した支払金額が不足しています。今回の売上金額を修正することをお勧めします！',
  Cargo_GroupScene: 'グループシーン',
  Cargo_GroupName: 'グループ名',
  Cargo_GroupType: 'グループタイプ',
  Cargo_CcPerson: 'CC',
  Cargo_UpdatePerson: '更新者',
  Cargo_Common: 'パブリック',
  Cargo_Personal: 'プライベート',
  Cargo_ReleasePerson: '人を置く',
  Cargo_MailGroupType: '少なくとも1つのタイプを選択してください。',
  Cargo_MailGroupName: 'グループ名を入力してください。',
  Cargo_MailGroupEmail: '少なくとも1つのメールアドレスを入力してください。',
  Cargo_MailGroupCheckEmail: '入力されたメール形式を確認してください。',
  Cargo_MailGroupDelete: '削除操作は回復できません。データを削除してもよろしいですか？',
  Cargo_ChargeRate: 'チャージレート',
  Cargo_BillingRate: '請求レート',
  Cargo_GroupChargeRate: 'グループ費用為替レート',
  Cargo_BranchRate: '支社為替レート',
  Cargo_EnabledChildOffice: '現在の為替レートは下位子会社に対して有効です',
  Cargo_ShowParentRateOffice: '適用：{0}為替レート',
  Cargo_SetEnabledChild: '子会社の有効化の設定',
  Cargo_SetEnabledChildDialog: '下位子会社に対する有効化の設定',
  Cargo_SetEnabledChildCheckbox: '下位子会社への発効',
  Cargo_CopyOfficeRate: '子会社為替レートのコピー',
  Cargo_CopyHqRate: 'グループ為替レートのコピー',
  Cargo_ConfirmCopyBillingRateTip: '既存のデータを上書きしますか？',
  Cargo_Cover: '上書き',
  Cargo_NotCover: '上書きしない',
  Cargo_PleaseSelectExportData: 'エクスポートするデータを選択してください！',
  Cargo_UploadRateTip: 'アップロードするファイルはxls、xlsx形式のみ！',
  Cargo_UploadDataSizeMore: 'ファイルサイズは2MB以下！',
  Cargo_UploadDataFailed: 'インポートに失敗しました。管理者に連絡してください！',
  Cargo_UploadFailedCheckExcel: 'インポートに失敗しました。テンプレートの内容を確認してください！',
  Cargo_ValidateUploadRateTip1: '元の通貨値は{0}で、基準通貨値は{1}でExcelの他のデータと重複！',
  Cargo_ValidateUploadRateTip2: '元の通貨値は{0}で、基準通貨値は{1}で、テーブルにデータが重複しています！',
  Cargo_ValidateUploadRateTip3: 'データがテーブル内の既存のデータと重複しています！',
  Cargo_DefaultReceivableMode: 'デフォルトの受取モード',
  Cargo_DefaultReceivableRate: '売掛金のデフォルトレート',
  Cargo_SecondReceivableRate: '売掛金第2レート',
  Cargo_ChargeableAmountInterval: '課金すべき金額区間',
  Cargo_ReceivableIntervalType: '受取区間タイプ',
  Cargo_DefaultUnitPrice: 'デフォルト単価',
  Cargo_DefaultRate: 'デフォルトレート',
  Cargo_Suit: '適用されます',
  Cargo_DefaultPayableMode: 'デフォルトの支払モード',
  Cargo_DefaultPayableRate: '支払デフォルトレート',
  Cargo_SecondRatePayable: '2番目に支払うレート',
  Cargo_PayableAmountInterval: '支払金額の範囲',
  Cargo_PayableIntervalType: '支払区間タイプ',
  Cargo_EDIFileType: '送信時のEDIファイルタイプ(UploadFileSuffix)',
  Cargo_MarkOrCargoEnglishNameChangeTip: '基本タブ{0}が変更されました。船荷証券タブのデータを更新しますか？',
  Cargo_ShareChargeCheckCurrency: '手数料配賦の通貨と支払方向は一緻する必要があります。',
  Cargo_ShareChargeCheck: '請求書の配賦費用の合計が元の費用と等しくありません！',
  Cargo_PleaseSelectedSalesForCustomer: '顧客対応販売を維持してください！',
  Cargo_PleaseSelectServicePersonnel: '対応サービス担当者を維持してください！',
  Cargo_PleaseSelectedLevelForCustomer: '顧客対応 顧客ランクを維持してください！',
  AutomaticReconciliation: '自動決済',
  AutomaticReconciliationHistory: '自動決済履歴',
  CheckHistory: '消込履歴',
  ReconciliationResult: '決済結菓',
  ImportReconciliationExcel: '消込済Excelシートのインポート',
  Cargo_BatchUpdateChargeConfirmSerialNumber: 'バッチ変更バッチ',
  Cargo_BatchUpdateChargeConfirmSerialNumberTip: '選択された費用は次のロット番号に変更されます',
  Cargo_InputChargeConfirmSerialNumber: 'ロット番号を入力してください',
  Cargo_ChargeConfirmSerialNumber: '費用確認ロット番号',
  Cargo_ChargeConfirmSerialNumberLengthMore: 'ロット番号は20桁を超えてはいけません！',
  Cargo_PleaseSelectSolicitationType: '受注タイプを選択してください！',
  Cargo_WriteoffSeqNo: '売上バッチ番号',
  Cargo_CustomerContactChannel: '顧客接点ルート',
  Cargo_AgentBilling: '代理請求書の分割',
  Cargo_AgentBillingCanNotEdit: '代理請求書は編集できません！',
  Cargo_RecheckBillingCanNotEdit: '検討された請求書は編集できません！',
  Cargo_ContainsAgentBilling: '代理請求書が含まれています。別の請求書を選択して操作してください！',
  Cargo_HasAgentBilling: '代理請求書が含まれています。別の請求書を選択して操作してください！',
  Cargo_ForeignBillStatusError: '国外請求書の状態が印刷要件を満たしていません。',
  Cargo_ExportBillVoucherStatus: '帳票憑証ステータスのエクスポート',
  Cargo_BillGeneratedNoCancel: '請求書番号が発行済みのため、レビュー取消不可',
  Cargo_OverseasBillReverseRule1: '海外請求書は取消には請求書番号が必要です',
  Cargo_WriteOffStatusReverseRule: '消込済みステータスは取消不可',
  Cargo_VoidStatusReverseRule: '無効化された請求書は取消不可',
  Cargo_AlreadyReversedRule: '取消済みの請求書は再取消不可',
  Cargo_NoBillToReverse: '取消可能な請求書がありません',
  Cargo_ConfirmReverseBills: 'これらの{0}件の請求書を取消しますか？',
  Cargo_ReversedBillNoInvoice: '取消済み請求書は再請求不可',
  Cargo_BillInvoicedNoReverse: '請求書はインボイス済みのため取消不可',
  Cargo_BillPaymentAppliedNoReverse: '請求書は支払申請済みのため取消不可',
  Cargo_BillStatementMadeNoReverse: '請求書は対帳票作成済みのため取消不可',
  Cargo_BillWrittenOffNoReverse: '請求書は消込済みのため取消不可',
  Cargo_Config: '設定',
  Cargo_OrderTemplateName: 'インポート注文テンプレート名',
  Cargo_TemplateTips: 'ヒント: ',
  Cargo_Blue: '青',
  Cargo_MusetSelectd: '必須、削除できません。テンプレートのヘッダー名を設定する必要があります。テンプレートに値がない場合は、オーダデフォルトを設定してください',
  Cargo_StartLine: 'インポート開始行（タイトル付き）',
  Cargo_TemplateDefault: 'テンプレートに必須フィールドがない場合は、ここでインポート生成オーダのデフォルト値を維持できます',
  Cargo_TemplateDefaultValue: 'テンプレート値',
  CargoFieldDescription: 'フィールドの説明',
  Cargo_FieldDropdownValue: 'フィールドのドロップダウン値',
  Cargo_ActualFieldName: '実際のビジネスフィールド名',
  Cargo_TemplateHeaderName: 'テンプレートヘッダ名',
  Cargo_TemplateImportValue: 'テンプレートインポート値',
  Cargo_OrderDefaultValue: '注文のデフォルト値',
  Cargo_OrderOperation: 'オペレーション',
  Cargo_OrderDelete: '削除',
  Cargo_CloseAccountTips: 'The current adjustment date has been closed for accounting, please choose again.',
  Cargo_CloseAccountTips2: 'The current financial date has been closed for accounting, please select again.',
  Cargo_PayableOrderCreationDate: 'Payable order creation date',
  Cargo_InvoiceHistoryEmail: 'Invoice history email',
  Cargo_SendCc: 'Send carbon copies to the synchronized address',
  Cargo_DoInvoiceTip: 'Only {0} permission, cannot operate ticket collection',
  Cargo_DoInvoiceTip2: 'Only {0} permission, cannot operate receivable and payable mixed invoicing',
  Cargo_CallBackTip: 'The insurance record marked as \'Submitted and Policy Issued\' cannot go back to the previous step.',
  Cargo_CabinSpaceSerialNo: 'Cabin Space Serial Number',
  Cargo_CabinSpaceStatus: 'Cabin Space Status',
  Cargo_CabinSpaceNote: 'Cabin Space Note',
  Cargo_AllocationStatus: 'Allocation Status',
  Cargo_QuantityInconsistency: 'S/O or MBL quantity is inconsistent with the cabin space quantity.',
  Cargo_VesselCallSign: 'Vessel Call Sign',
  Cargo_SORecognitionNewAdd: 'SO Recognition New Addition',
  Cargo_ShutOut2: 'Shut Out',
  Cargo_CabinSpaceBackFill: 'Cabin Space Backfill',
  Cargo_RevokeAllocation: 'Revoke Allocation',
  Cargo_CancelCabinReservation: 'Cancel Cabin Reservation',
  Cargo_AllocateCabinSpace: 'Allocate Cabin Space',
  Cargo_Allocate1: 'Allocate - Associate with Business',
  Cargo_Allocate2: 'Allocate - Create Business',
  Cargo_SelectBusinessTip: 'Please select a business to modify and replicate',
  Cargo_GuidedSellingPrice: 'Guided Selling Price',
  Cargo_CabinCancellationNote: 'Cabin Cancellation Note',
  Cargo_CutOffDate: 'Cut-off Date',
  Cargo_DeclarationCutOffDate: 'Declaration Cut-off Date',
  Cargo_CutOffDate2: 'Customer Cut-off Date for Customs',
  Cargo_ReturnDateForCustoms: 'Customer Return Date for Customs',
  Cargo_CutOffTime: 'Cut-off Time',
  Cargo_FreeStorageDays: 'Free Storage Days',
  Cargo_TotalPiecesMismatchContinue: '総件数が一致しません。続行しますか？',
  Cargo_BasicData: '基本データ',
  Cargo_CustomerVendorRating: '顧客・仕入先評価',
  Cargo_DeliveryOperator: '納品作業者',
  Cargo_DeliveryOperationTime: '納品作業時刻',
  Cargo_DeliveryOperationMethod: '納品作業方法',
  Cargo_PartnerApprovalRequired: '選択したパートナーは承認フローを開始する必要があり、承認完了後にのみ有効となります。承認中は利用できません。今すぐ承認を開始しますか？',
  Cargo_ContractApprovalRequired: 'この契約は承認フローを開始する必要があり、承認後にのみ有効となります。承認中は編集・更新・書類管理ができません。今すぐ承認を開始しますか？',
  Cargo_ViewPartnerDetails: 'パートナー詳細を見る',
  Cargo_PartnerApplicationForm: 'パートナー申請書',
  Cargo_ContractApplicationForm: '契約申請書',
  Cargo_PartnerApplicationApprovalProcess: 'パートナー申請・承認フロー',
  Cargo_ContractApplicationApprovalProcess: '契約申請・承認フロー',
  Cargo_UnderReview: '審査中',
  Cargo_CanSubmitOnlyUnreviewedPartner: '未審査ステータスのパートナーのみ提出可能です。再選択して再試行してください。',
  Cargo_DataUnderReviewCheckRetry: '審査中のデータがあります。確認して再試行してください',
  Cargo_ViewContractDetails: '契約詳細を見る',
  Cargo_WeightOutOperator: '出重作業者',
  Cargo_WeightOutOperationTime: '出重作業時刻',
  Cargo_WeightOutOperationMethod: '出重作業方法',
  Cargo_ConfirmBatchOperation: '一括操作を確認しますか？',
  Cargo_AutomationConfig: '自動化設定',
  Cargo_TaskScenario: 'タスクシナリオ',
  Cargo_TimingMethod: 'タイミング方式',
  Cargo_LastExecutionTime: '最終実行時刻',
  Cargo_ExecutionFrequency: '実行頻度',
  Cargo_PerHour: '毎時間',
  Cargo_Daily: '毎日',
  Cargo_Weekly: '毎週',
  Cargo_Monthly2: '毎月',
  Cargo_VesselEnglishName: '船舶英名',
  Cargo_ActualSailingTime: '実際出航時刻',
  Cargo_EstimatedSailingTime: '予定出航時刻',
  Cargo_ShippingCompanyName2: '船会社名',
  Cargo_ActualAmount: '実際金額（費用の最終金額）',
  Cargo_FeeCreationTime: '費用作成時刻',
  Cargo_StartExecutionTime: '実行開始時刻',
  Cargo_Every: 'ごと',
  Cargo_Hour: '時間',
  Cargo_EffectiveTime: '有効時刻',
  Cargo_TaskResult: 'タスク結果',
  Cargo_TaskResultReminder: 'タスク結果通知（メール・Excel添付）',
  Cargo_ScenarioName: 'シナリオ名',
  Cargo_AutomationTask: '自動化タスク',
  Cargo_SpecifiedWeekday: '指定曜日',
  Cargo_SpecifiedDay: '指定日',
  Cargo_LastDayOfMonth: '今月末日',
  Cargo_Day29to31Fallback: '29、30、31日を選択した月に該当日が存在しない場合、月末日に自動的に実行されます。',
  Cargo_ExecuteCommand: 'コマンド実行',
  Cargo_AutoInvoicing: '自動請求書発行',
  Cargo_TaskName: 'タスク名',
  Cargo_MultiLegVoyageManagement: 'マルチレッグ航海管理',
  Cargo_ScheduleSelection: '船期選択',
  Cargo_Leg1: '第1レッグ',
  Cargo_Leg2: '第2レッグ',
  Cargo_Leg3: '第3レッグ',
  Cargo_Leg4: '第4レッグ',
  Cargo_Leg5: '第5レッグ',
  Cargo_OnlyOneVoucherForCopy: '証憑は1件のみ選択してコピーできます！',
  Cargo_VoyageInfoCannotBeEmpty: '航程情報の{0}は空にできません',
  Cargo_AutoExecute: '自動実行',
  Cargo_TaskNameCannotBeEmpty: 'タスク名を入力してください！',
  Cargo_TaskNameAlreadyExists: 'タスク名「{0}」は既に存在するため、重複できません！',
  Cargo_TaskScenarioAutoExecuteCannotDelete: 'このタスクシナリオは自動実行に設定されているため削除できません！',
  Cargo_EnabledStatusCannotDelete: '{0}有効状態です。削除する前に無効にしてください。',
  Cargo_ConfirmDeleteTaskScenario: 'このタスクシナリオを削除してもよろしいですか？',
  Cargo_ScenarioSettings: 'シナリオ設定',
  Cargo_TransmissionRule: 'Transmission Rule',
  Cargo_Script: 'Script',
  Cargo_AccountPassword: 'Account & Password',
  Cargo_GetTokenUrl: 'Token Acquisition URL',
  Cargo_InterfaceUrl: 'Interface URL',
  Cargo_TransmissionSample: 'Transmission Format Sample',
  Cargo_RuleSettings: 'ルール設定',
  Cargo_CommandSettings: 'コマンド設定',
  Cargo_DataScript: 'データスクリプト',
  Cargo_DataDisplay: 'データ表示',
  Cargo_DeleteFromLastLeg: '最後のレッグから削除してください',
  Cargo_PreviewData: 'データプレビュー',
  Cargo_NotificationPersonnel: '通知対象者',
  Cargo_DebugExecute: 'デバッグ実行',
  Cargo_ConditionName: '条件名',
  Cargo_SendToExchangeTime: '航交所送付時刻',
  Cargo_EnterYourRequirement: 'ご要件を入力してください',
  Cargo_ConfigExecuteCommands: '実行コマンドの設定（番号順に実行）',
  Cargo_CommandName: 'コマンド名',
  Cargo_SelectCommand: 'コマンド選択',
  Cargo_ConfirmRuleSettings: 'ルール設定を確認してください',
  Cargo_ScenarioDescription: 'シナリオ説明',
  Cargo_Command: 'コマンド',
  Cargo_ExecutionTime: '実行時間',
  Cargo_HistoryDetails: '履歴詳細',
  Cargo_ExecutionScenario: '実行シナリオ',
  Cargo_DataID: 'データID',
  Cargo_ExecuteCommandName: '実行コマンド名',
  Cargo_ManualRun: '手動実行',
  Cargo_AsyncExecutingCheckLogLater: '非同期実行中です。しばらくしてから実行ログをご確認ください',
  Cargo_ExecutionLog: '実行ログ',
  Cargo_Execute: '実行',
  Cargo_NoOutboundCommandConfirmPickList: '{0},出庫指示が出ていません。ピッキングリストを作成してもよろしいですか？',
  Cargo_CabinSpaceAllocationDate: 'Cabin Space Allocation Date',
  Cargo_AssociatedBusinessNo: 'Associated Business Number',
  Cargo_AssociatedBusinessStatus: 'Associated Business Status',
  Cargo_FirstTimeSalesAllocation: 'First-Time Sales Allocation',
  Cargo_FirstTimeAllocationEntrustingUnit: 'First-Time Allocation to Entrusting Unit',
  Cargo_CabinCancellationExplanation: 'Cabin Cancellation Explanation',
  Cargo_CabinSpaceRecord: 'Cabin Space Record',
  Cargo_VoyageInformation: 'Voyage Information',
  Cargo_AssociatedBusinessStatus2: 'Associated business status',
  Cargo_UploadFileOver50: 'Due to the large amount of data, the upload speed may be slow, please check later.',
  Cargo_UserSecurityPolicy: 'ユーザーセキュリティポリシー',
  Cargo_RoleGroupManagement: 'ロールグループ管理',
  Cargo_RoleGroupName: 'ロールグループ名',
  Cargo_UnmaintainedRoleGroupPermissions: '対応するロールグループ権限が未維持',
  Cargo_RoleGroup: 'ロールグループ',
  Cargo_RoleGroupCountLessThanTwo: 'ロールグループ数 < 2',
  Cargo_PolicySettings: 'ポリシー設定：',
  Cargo_EnableUserSecurityPolicy: 'ユーザーセキュリティポリシーを有効にする',
  Cargo_PasswordLengthRange: 'パスワード長範囲：',
  Cargo_MaxLengthRange8to20: '最大長8-20文字で設定可能',
  Cargo_CompositionRule: '構成ルール：',
  Cargo_RequireNumUpperLower: '数字、大文字、小文字を含む必要あり',
  Cargo_MustIncludeSpecialChars: '必須特殊文字：!、$、%、&、_、|、-、@、#、*、=',
  Cargo_PasswordHistoryCheck: 'パスワード履歴チェック：',
  Cargo_HistoryLength0to10: '0-10で設定、0で履歴チェックなし、3で直近3回と重複不可',
  Cargo_PasswordErrorLock: 'パスワード誤りロック：',
  Cargo_LockLength0to10: '0-10で設定、0でロックなし、設定回数でアカウント無効化',
  Cargo_AdminApplication: '管理者適用：',
  Cargo_AdminPwdFollowPolicy: '管理者パスワードも同ポリシーを適用',
  Cargo_NoRepeatLastNPasswords: '直近 {0} 回のパスワードと一致しないこと',
  Cargo_PasswordRulePrompt: 'パスワードルール：長さ {0}-{1}、数字・大文字・小文字を含む',
  Cargo_DimensionsExceedRouteProductLimits: '寸法が航路製品-航海の制限を超えています。続けますか？',
  Cargo_FlightReassignment: '便の再割り当て',
  Cargo_InformationMaintenance: '情報の維持',
  Cargo_VehicleInformation: '車両情報',
  Cargo_CountyDistrict: '県/区',
  Cargo_TownStreet: '町/街道',
  Cargo_VillageCommunity: '村/コミュニティ',
  Cargo_FleetPhoneNumber: 'フリート電話番号',
  Cargo_DoorPointName: 'ドアポイント名',
  Cargo_DeliveryArea: '配達区域',
  Cargo_EstimatedLoadingTime: '予定積載時間',
  Cargo_ActualLoadingTime1: '実際の積載時間',
  Cargo_DeliverySequenceNumber: '配達順番',
  Cargo_DispatchVehicleNoteFields: '車両派遣操作中に以下のフィールドを完全にしてください:',
  Cargo_TTDEG: '運送会社、トレーラー料金、ドアポイント名、予定積載時間、毛重量',
  Cargo_RouteMarking: '航路のマーク',
  Cargo_SecondaryConfirmation: '二次確認',
  Cargo_BookingCompleted: '予約がすでに完了しています。確認してください:',
  Cargo_DataNotPendingConfirmation: '非確認待ちデータが存在します。確認してください:',
  Cargo_PortMismatch: '出発港と到着港が完全に一致していません。続けますか？',
  Cargo_DataNotConfirmed: '非確認済みデータが存在します。確認してください:',
  Cargo_RouteNotConfirmedOrDoubleConfirmed: '航路確認されていないデータまたは二重確認されたデータが存在します。確認してください:',
  Cargo_SelectOneMasterBill: '最大で1つのマスタービルをチェックしてください',
  Cargo_DataNotRouteDoubleConfirmed: '航路二重確認されていないデータが存在します。確認してください:',
  Cargo_GrossProfitAmount: '粗利額',
  Cargo_SpecialExpenseIndicator: '特別費用の識別',
  Cargo_IsNoInvoiceExpense: '請求書なし費用か',
  Cargo_SpecialExpensePayableTotal: '特別費用の支払合計',
  Cargo_SpecialExpensePayableCurrency: '特別費用の支払通貨',
  Cargo_SpecialExpenseReceivableTotal: '特別費用の受取合計',
  Cargo_SpecialExpenseReceivableCurrency: '特別費用の受取通貨',
  Cargo_BookingCompletion: '予約完了',
  Cargo_RouteConfirmation: '航路確認',
  Cargo_RouteConfirmationStatus: '航路確認処理状況',
  Cargo_FlightDateRange: '便の日付範囲',
  Cargo_RouteConfirmationPerson: '航路確認者',
  Cargo_RouteConfirmationTimeRange: '航路確認時間範囲',
  Cargo_IsBookingCompleted: '予約が完了しましたか',
  Cargo_OrderNumber: '注文番号',
  Cargo_FlightNumber: '便名',
  Cargo_SecondLegFlight: '二程便',
  Cargo_SecondLegAirline: '二程航空会社',
  Cargo_SecondLegDocumentNumber: '二程伝票番号',
  Cargo_SecondLegETD: '二程ETD',
  Cargo_SecondLegETA: '二程ETA',
  Cargo_ThirdLegFlight: '三程便',
  Cargo_ThirdLegAirline: '三程航空会社',
  Cargo_ThirdLegDocumentNumber: '三程伝票番号',
  Cargo_ThirdLegETD: '三程ETD',
  Cargo_ThirdLegETA: '三程ETA',
  Cargo_FreightUnitPrice: '運賃単価',
  Cargo_SignatureWeight: 'サイン重量',
  Cargo_SignatureDimensions: 'サイン寸法',
  Cargo_SignatureRemarks: 'サイン備考',
  Cargo_FoldedWeightRemarks: '折り込み重量備考',
  Cargo_TotalPrice: '総価格',
  Cargo_TransshipmentFee: '転送料金',
  Cargo_HumanResourcePerformance: '人事パフォーマンス',
  Cargo_AIEngine: 'AIエンジン',
  Cargo_ProvisionReport: '予定報告',
  Cargo_ScriptName: 'スクリプト名',
  Cargo_ScriptDescription: 'スクリプトの説明',
  Cargo_GenerateScript: 'スクリプトを生成する',
  Cargo_RuleDescription: 'ルールの説明',
  Cargo_ScriptPreview: 'スクリプトのプレビュー',
  Cargo_CommissionRole: 'コミッションロール',
  Cargo_CommissionPersonnel: 'コミッション担当者',
  Cargo_ApplicableScript: '適用スクリプト',
  Cargo_RuleApplication: 'ルールの適用',
  Cargo_ApplicablePersonnel: '適用担当者',
  Cargo_BusinessVolume: 'ビジネスボリューム',
  Cargo_ApplicableRule: '適用ルール',
  Cargo_CustomsProvision: '通関予定',
  Cargo_OperationProvision: '操作予定',
  Cargo_CustomerServiceProvision: 'カスタマーサービス予定',
  Cargo_BusinessProvision: 'ビジネス予定',
  Cargo_SalesProvision: '営業予定',
  Cargo_OperationTicketProvision: '操作チケットの予定',
  Cargo_SalesSupervisorProvision: '営業主管予定',
  Cargo_OperationSupervisorProvision: '操作主管予定',
  Cargo_ConfirmCancelProvision: '予定をキャンセルしますか',
  Cargo_LockLimit: 'ロック制限',
  Cargo_ReceivableFullWriteOffTime: '全額受取の消去時間',
  Cargo_LockAccountsReceivableAndPayableEntry: '受取手形と支払手形の入力をロックする',
  Cargo_ViewDetailedBusiness: '詳細ビジネスを表示する',
  Cargo_TestRun: 'テスト実行',
  Cargo_ProvisionLimit: '予定の制限',
  Cargo_ViewProvisionDetails: '予定の詳細を表示する',
  Cargo_ProvisionBatchNumber: '予定のバッチ番号',
  Cargo_ProvisionPerson: '予定の担当者',
  Cargo_ProvisionTime: '予定の時間',
  Cargo_ProvisionRole: '予定のロール',
  Cargo_PendingProvision: '保留予定',
  Cargo_ProvisionHistory: '予定の履歴',
  Cargo_ResponsibleCustomerService: '責任カスタマーサービス',
  Cargo_ResponsibleOperator: '責任オペレーター',
  Cargo_ConfirmAndBookingCompleted: '確認かつ予約完了',
  Cargo_OrderQuantity: '注文数量',
  Cargo_FinancialStatus: '財務状態',
  Cargo_FinancialColorTip: 'テーブルの色制御設定範囲：\n航空予約 - 一覧\n航空操作 - 一覧\n総合物流 - 一覧\n鉄道操作 - 一覧\nリモート予約 - 一覧\n販売照会 - 一覧\n海上輸出 - 一覧\n海上操作 - 一覧\n海上輸入 - 予報 - 一覧\n販売照会 - 海外部門 - 一覧\n販売照会 - 販売部門 - 一覧\n海上輸出 - 荷物受取証 - 一覧\n海上輸出 - EDI - 一覧\n財務監査 - 一覧\n財務監査 - 締め - 一覧\n航空輸出 - 通関申告 - 一覧\n航空輸出 - 前置倉 - 一覧\n航空輸出 - 倉庫 - 一覧\n海上輸入 - 倉庫操作 - 一覧',
  Cargo_CurrentInvoiceDifferentRates: '現在の請求書には異なる税率の費用が含まれています。税率ごとに請求書を分割し、発行します。デフォルトの税コードを使用して維持します。この操作を続けますか？',
  Cargo_CurrentSelectionContains9TaxPointsAndOthers: '現在の選択項目には、9つの税点とその他の税点が含まれています。貨物運送の請求書は特別なため、別途申請してください。一緒に請求書を提出することはできません。',
  Cargo_Allocated: 'Allocated',
  Cargo_NotAllocated: 'Not Allocated',
  Cargo_PriceAuditEventFclTitle: 'Freight rate audit update reminder',
  Cargo_FillSO: 'Fill S/O',
  Cargo_FillMBL: 'Fill MBL',
  Cargo_FillALL: 'Fill Both MBL and S/O',
  Cargo_CustomsReturnAndRecovery: 'Customs Return and Recovery',
  Cargo_CheckDTip: 'MBL NO. or SO NO. already exists, confirm to continue creation?',
  Cargo_BatchUpdateTitle1: 'Batch Update - Cabin Space Backfill',
  Cargo_WindowTip1: '*Bulk update of bill of lading information.',
  Cargo_WindowTip2: '**If there are differences in box type and quantity in the batch selected orders, please fill in the cabin space backfill individually.',
  Cargo_CheckDTip2: 'Cannot perform operations in the "Canceled" or "Allocated" state',
  Cargo_CheckDTip3: 'Please select cabin space with consistent box type and quantity for operation.',
  Cargo_NoItems_NoAudit: '{0}はありません、監査は不要',
  Cargo_Audited_NoNeedAudit: '監査済み、再監査は不要',
  Cargo_AvailableCabinSpace: 'Available Cabin Space',
  Cargo_QueryTip: 'Quick search: Cabin space serial number',
  Cargo_PriceUpdateUser: 'Freight rate modifier',
  Cargo_BookingPreAudit: 'Booking Pre-Audit',
  Cargo_UniversalIntelligentRecognition: '汎用インテリジェント認識',
  Cargo_PromptWords: 'プロンプト',
  Cargo_PleaseUploadFile: 'ファイルをアップロードしてください',
  Cargo_BatchImportAr1: '入金消込一括登録',
  Cargo_BatchImportAp1: 'Batch Import of Payment Write-off',
  Cargo_BatchImportAr2: 'Download receipt import template',
  Cargo_BatchImportAp2: 'Download payment import template',
  Cargo_ImportingDataSuccess1: 'This operation is asynchronous, you can check the results in',
  Cargo_ImportingDataSuccess2: 'File Storage -> Upload Logs',
  Cargo_ImportingDataSuccess3: 'View import results',
  Cargo_RecordsWrittenOff: '{0}件のレコードを消込済みです。',
  Cargo_lockLabel1: 'Lock purchase price',
  Cargo_lockLabel2: 'Lock selling price',
  Cargo_lockLabel3: 'Unlock purchase price',
  Cargo_lockLabel4: 'Unlock selling price',
  Cargo_UnLockLabel: 'Unlock',
  Cargo_LockLabel: 'Lock',
  Cargo_LockSuccess: '{0}{1} successful',
  Cargo_DisplayByBillOfLading: 'Display by Bill of Lading',
  Cargo_DisplayByDateAndVoyageNo: 'Display by Date and Voyage Number',
  Cargo_ShowSeaExportJob: 'Merge and view outbound booking data',
  Cargo_OperatingSpaceOnly: 'Operating space only',
  Cargo_IsCabinSpace: 'Is Cabin Space Available',
  Cargo_CheckBoxTip: 'The box type and quantity do not match the cabin space, please verify.',
  Cargo_CheckBoxTip2: 'The vessel name, voyage number, shipping company, and ETD (Estimated Time of Departure) of the order are inconsistent with the cabin space, please confirm whether to continue.',
  Cargo_CheckBoxTip3: 'The pending associated business already has an MBL NO. or SO NO., and cannot be associated.',
  Cargo_AllocationSuccess: 'Allocation successful!',
  Cargo_AllocationCancel: 'Confirm to revoke allocation?',
  Cargo_CabinReturn: 'Return cabins simultaneously.',
  Cargo_CabinReturnTip: 'Please provide a reason for the cabin return.',
  Cargo_CancelCabinTip1: 'Revocation completed.',
  Cargo_CancelCabinTip2: 'Cabin return completed.',
  Cargo_CancelCabinTip3: 'There are associated businesses with the cabin space, please cancel the association first.',
  Cargo_CancelCabinTip4: 'The associated business with the cabin space is still in the booking pre-audit phase, if you want to revoke the allocation, please reject it in the booking pre-audit.',
  Cargo_CancelCabinTip5: 'The associated business with the cabin space has not yet been returned to customs, please return to customs first.',
  Cargo_CancelCabinTip6: 'There are unallocated cabin spaces, please check.',
  Cargo_BusinessProcessStage: 'Business Process Stage',
  Cargo_PleaseSelectDataAndUpload: 'Please select data and upload files in batches.',
  Cargo_PleaseSelectDataAndUpload2: 'Please select the same business type and upload files in batches.',
  Cargo_BatchUploadFile: '一括ファイルアップロード',
  Cargo_BatchUploadFile2: 'Upload failed, unsupported format',
  Cargo_Allocate3: 'Allocate - Create Business',
  Cargo_CabinCreate1: 'Create to Booking Pre-Audit',
  Cargo_CabinCreate2: 'Create to Sea Freight Booking',
  Cargo_CabinCreate3: 'Business order number generated:',
  Cargo_CloseAndCopyNumber: 'Close and Copy Order Number',
  Cargo_AllocateCheck1: 'There is allocated data, please check',
  Cargo_AllocateCheck2: 'There is data that is not released for cabin space, please check',
  Cargo_OnlyReturnTheCabin: 'Only delete return the cabin',
  Cargo_CabinManagement: 'cabin management',
  Cargo_TheRedFontFieldWillOverwriteTheSeaExportWithTheValueOfTheSpaceManagement: 'The red font field will overwrite the sea export with the value of the space management',
  Cargo_OriginalValueOfTheSeaExportAndWillNotBeOverwritten: 'The blue font field will retain the original value of the sea export and will not be overwritten',
  Cargo_ImportedMultipleBusiness: 'Imported and matched multiple business tickets',
  Cargo_UploadedRepeatedly: 'Uploaded repeatedly',
  Cargo_BoxType2: 'Corresponding box type and category',
  Cargo_BoxTypeAndCategory: 'Box type and category',
  Cargo_CheckBoxSize: 'Please specify the box type',
  Cargo_UsedQuota: 'Used quota',
  Cargo_PleaseSelectTheConsignee: 'Please select the consignee',
  Cargo_ViewingMessage: 'Viewing the original message',
  Cargo_ChangeSettlement: '精算先変更',
  Cargo_CanNotEditTips: 'Contains non-editable expenses, please check!',
  Cargo_PleaseSelectExpenseToModify: '変更する費用を選択してください。',
  Cargo_ArChargeSettlementCannotModify: '売掛費用の精算先は変更できません。',
  Cargo_ChargeSettledCannotModify: '費用は請求書/請求/支払/消込済みのため変更できません。',
  Cargo_ArChargeSettlementCannotModifyDetail: '費用{0}は売掛費用のため、精算先を変更できません。',
  Cargo_ChargeSettledCannotModifyDetail: '費用{0}は請求書/請求/支払/消込済みのため変更できません。',
  Cargo_CanNotEditChargeDetail: '費用{0}に編集権限がないため変更できません。',
  Cargo_CheckChargeDetailBranchDetail: '費用{0}の所属支店は操作できません。',
  Cargo_BeforeAdjustment: '調整前',
  Cargo_AfterAdjustment: '調整後',
  Cargo_SetAMarginAlert2: 'リマインダーを設定',
  Cargo_SetAMarginAlert: '余剰量アラートを設定',
  Cargo_ApplicableBranch: '適用する支店',
  Cargo_AdditionalRemark: '追加説明',
  Cargo_FixedLastNumber: '最後の番号を固定00',
  Cargo_GenerativeRule: '生成規則',
  Cargo_StartNumber: '開始番号',
  Cargo_EndNumber: '終了番号',
  Cargo_MarginTip1: '会社の番号余剰不足アラート',
  Cargo_MarginTip2: '使用者の余剰量不足アラート',
  Cargo_MarginTip3: 'アラートが必要な場合は、対応する欄に番号の余剰量不足数を入力してください。',
  Cargo_useTip: '番号はまだ使用されていない必要があります',
  Cargo_useTip2: 'An invalid order number cannot be assigned',
  Cargo_DeleteTip: '取り消しされた番号のみを削除できます',
  Cargo_PrefixTip: '主な番号の接頭辞が正しくありません',
  Cargo_StarTip: '開始番号、終了番号が規則に適合していません',
  Cargo_StarNoTip: '開始番号が異常です',
  Cargo_MarginTip4: 'Please fill in the person in charge.',
  Cargo_NumberErrTip: '*番号の数字の桁数が不足しています',
  Cargo_NumberErrTip2: '番号が生成規則に適合していません',
  Cargo_AlreadyExistTip: 'インポートに失敗しました、インポートされた番号はすでに存在しています。<br/>{0}',
  Cargo_ImportStarTip: 'インポートに失敗しました。インポートされた注文番号のプレフィックスが正しくありません。<br/>{0}',
  Cargo_ImportNoTip: 'インポートに失敗しました。インポートされた注文番号に異常があります。<br/>{0}',
  Cargo_EmptyNoTip: 'インポートされたExcelファイルにMBL番号が含まれていません',
  Cargo_CarrierCheck: 'まず船会社を登録してください',
  Cargo_NumberMarginUse: '現在のユーザーの注文番号の余剰が{0}未満です',
  Cargo_NumberMarginCompany: '現在の会社の注文番号の余剰が{0}未満です',
  Cargo_receiveTip: '入力された注文番号は既に使用されています。続けますか確認してください？',
  Cargo_receiveTip2: 'The main order number does not match the data maintained in \'Main Order Number Management\'. Are you sure you want to continue using this order number?',
  Cargo_ImperialUnits: '英制単位',
  Cargo_Imperial: '英制',
  Cargo_Metric: '公制',
  Cargo_AirExportEnableImperialUnits: '空輸輸出で英制単位の入力を有効にする',
  Cargo_Inch: 'インチ',
  Cargo_Pound: 'ポンド',
  Cargo_CubicFoot: '立方フィート',
  Cargo_Centimeter: 'センチメートル',
  Cargo_Kilogram: 'キログラム',
  Cargo_CubicMeter: '立方メートル',
  Cargo_measurements2: 'サイズin（長さ*幅*高さ*件数）',
  Cargo_GrossProfit: '粗利',
  Cargo_MustEnterComplete: '完全に入力する必要があります',
  Cargo_CostVirtualImplementationToConsolidationPlan: '費用の仮想的な実装を組み立て計画に適用する',
  Cargo_EstimatedDeliveryDate: '予定納品日',
  Cargo_CheckWarehouseInConfig: '倉庫を選択してください',
  Cargo_SelectScales: '地衡を選んでください',
  Cargo_ReceivablesWriteoffDate: '受取手形消込日',
  Cargo_PayablesWriteoffDate: '支払手形消込日',
  Cargo_PleaseEnterPieceCount: '個数を入力してください',
  Cargo_PleaseConfirm: '入庫流水番号/送庫伝票番号を確認してください',
  Cargo_WarehouseInState: '業務入庫処理状況',
  Cargo_LocationConfigurationError: 'パレットが重複しているか、すでに使用されています。確認してください',
  Cargo_KeyNull: 'appKeyが設定されていません',
  Cargo_TokenNull: 'tokenの取得が空です',
  Cargo_CameraNull: 'カメラ設定に誤りがあります',
  Cargo_Reading: '読み取り',
  Cargo_FeeInvoiceTitle: '費用請求書の宛名',
  Cargo_PaymentApplicationTitle: '支払い申請の宛名',
  Cargo_ReadingTip: '複数の寸法はコンマ\',\'またはセミコロン\';\'で区切る\nフォーマット：長さ幅高さ/個数;長さ×幅×高さ/個数\n例：354030/3;35×40×30/3;',
  Cargo_ReadingTip2: '倉庫で地衡器の設定を指定してください',
  Cargo_CargoTerminalGrossWeight: '貨物ターミナルの総重量 (KG)',
  Cargo_FileUpload: '添付ファイルのアップロード',
  Cargo_inputMblTip: 'マスターエアウェイビル番号をスキャン/入力してください',
  Cargo_OutboundWeight2: '出庫重量操作',
  Cargo_FileInfo: '添付ファイル情報',
  Cargo_DeliveryOperation: '納品操作',
  Cargo_MasterAirwayBill: 'マスターエアウェイビル番号',
  Cargo_DeliveryCargoStation: '納品貨物ターミナル',
  Cargo_SplitOrderNumber: '分割注文数',
  Cargo_TotalPieces: '総個数',
  Cargo_TotalGrossWeight: '総重量',
  Cargo_TotalChargeableWeight: '総課税重量',
  Cargo_TotalVolume: '総体積',
  Cargo_PrintCheck1: '印刷範囲または部数が正しくありません。確認してください',
  Cargo_PrintRange: '印刷範囲',
  Cargo_PrintNumber: '印刷部数',
  Cargo_GrossWeight3: '配重重量',
  Cargo_DimensionsEntry: '寸法入力',
  Cargo_WarehouseTip3: '出庫指示のキャンセルが完了しました',
  Cargo_WarehouseTip2: '出庫指示が完了しました',
  Cargo_WarehouseTip1: '配荷が完了していません。確認してください',
  Cargo_CancelOutboundOrder: '出庫指示をキャンセルする',
  Cargo_OutboundOrder: '出庫指示',
  Cargo_GoodsArrived: '荷物が到着しました',
  Cargo_Pallet3: 'パレット',
  Cargo_WeightedInfo: '既に計量された情報',
  Cargo_ScaleReading: '地衡器の読み取り',
  Cargo_ScalePhoto: '地衡器の写真撮影',
  Cargo_Tip: 'ヒント：入庫流水番号/送庫伝票番号をサポートしています',
  Cargo_ReadScale: '計量する',
  Cargo_TakePhoto: '写真を撮る',
  Cargo_Weighing: '計量',
  Cargo_WeightRecord: '計量記録',
  Cargo_WeightHandling: '計量処理',
  Cargo_SaveDone: '保存して入庫を完了する',
  Cargo_DeliverySecurityCheck: '納品',
  Cargo_OutboundWeight: '出庫重量',
  Cargo_NetGrossWeight: '純重量と総重量',
  Cargo_VolumeWeight: '体積重量',
  Cargo_BatchEnterDimensions: '寸法の一括入力',
  Cargo_CoveringSizeAndQuantity: '注：既存のサイズと数量情報を完全に上書きします',
  Cargo_Recognition: '認識',
  Cargo_EstimatedDeliveryDateError: '認識エラー',
  Cargo_ScaleWeight: '地衡器重量',
  Cargo_OurPallet: '弊社パレット',
  Cargo_TareWeight: '皮重',
  Cargo_GrossWeight2: '総重量',
  Cargo_Location2: '保管場所',
  Cargo_FrontEndWarehouseOperation: '前置倉庫操作',
  Cargo_CargoTerminalOperation: '貨物ターミナル操作',
  Cargo_FileSizeCannotExceed20m2: 'ファイルのサイズは20Mを超えることはできません。.xls および .xlsx フォーマットをサポートします',
  Cargo_StateUpdate: '処理状況更新',
  Cargo_NotData: 'データが見つかりません',
  Cargo_LclHasMaster: '小切手はすでに主切手に関連付けられています',
  Cargo_ParamError: 'パラメーターにエラーがあります。確認してください',
  Cargo_CheckInventory: '在庫を確認する',
  Cargo_ReleaseLocation: '庫位を解放する',
  Cargo_LocationCode: '庫位コード',
  Cargo_Warehouse2: '所属倉庫',
  Cargo_LocationType: '庫位タイプ',
  Cargo_LocationStatus: '庫位処理状況',
  Cargo_LocationDeleteTip: '庫位はすでに使用されています。削除できません',
  Cargo_ReadFailure: '読み取り失敗',
  Cargo_PalletDeleteTip: '現在のパレットはすでに使用されています。削除できません',
  Cargo_NoLocationSelected: '場所が選択されていません',
  Cargo_PackingCondition: '包装状況',
  Cargo_SpecialHandling: '特別処理',
  Cargo_PalletNumber: 'パレット番号',
  Cargo_InventoryCheck: '在庫確認',
  Cargo_ApplyRuleToAllScenarios: 'ルール設定を全シナリオに適用',
  Cargo_DocumentsWithCargo: '同送書類',
  Cargo_CurrentBusinessAlreadyWeighedOut: '現在の業務は既に出重されています。重複操作は禁止です。',
  Cargo_CurrentBusinessAlreadyDelivered: '現在の業務は既に納品されています。重複操作は禁止です。',
  Cargo_PalletConfiguration: 'パレット管理',
  Cargo_Pallet2: 'パレット',
  Cargo_PalletID: 'パレットID',
  Cargo_PalletStatus: 'パレット処理状況',
  Cargo_PalletMaterial: 'パレット素材',
  Cargo_RecyclingType: 'リサイクルタイプ',
  Cargo_PalletTareWeight: 'パレットの皮重',
  Cargo_AirCargoTerminal: '空港貨物ターミナル',
  Cargo_WarehouseType: '倉庫タイプ',
  Cargo_WarehouseCode2: '倉庫コード',
  Cargo_WarehouseName: '倉庫名称',
  Cargo_WarehouseAddress: '倉庫住所',
  Cargo_Terminal: '貨物ターミナル',
  Cargo_TerminalCode: '貨物ターミナルコード',
  Cargo_TerminalName: '貨物ターミナル名称',
  Cargo_AirportCode: '空港コード',
  Cargo_TerminalAddress: '貨物ターミナル住所',
  Cargo_DeliveryMap: '配達マップ',
  Cargo_RecipientContact: '受取人',
  Cargo_RecipientContactPhone: '受取人連絡電話',
  Cargo_SecurityCheckMachineWidthLimit: 'セキュリティチェック機の幅制限',
  Cargo_SecurityCheckMachineHeightLimit: 'セキュリティチェック機の高さ制限',
  Cargo_CustomsCode: '税関コード',
  Cargo_WeighbridgeNumber: '地衡器番号',
  Cargo_WeighbridgeBaudRate: '地衡器のボーレート',
  Cargo_Checksum: 'チェックサム',
  Cargo_AutoFinanceAuditLockOrder: '自動財務監査で注文をロックする',
  Cargo_UnSubmittedBusinessLockOrder: '未提出のビジネスは、自動的に注文ロック操作が実行されます（ビジネス処理状況：進行中 -> 監査済み）',
  Cargo_PollingFrequency: 'ポーリング周波数',
  Cargo_SpecificDateMonthly: '毎月指定の日付',
  Cargo_DailyOnce: '毎日一度',
  Cargo_PhotoTaken: '写真撮影',
  Cargo_CameraConfiguration: 'カメラ設定',
  Cargo_WeighbridgeTest: '地衡器テスト',
  Cargo_Test: 'テスト',
  Cargo_MonitoringInterface: '監視インターフェース',
  Cargo_DeviceNumber: 'デバイス番号',
  Cargo_MonitoringChannel: '監視チャンネル',
  Cargo_MonitoringInterface1: 'Ezviz Cloud',
  Cargo_DeleteTip1: '【{0}】個の貨物ターミナル情報を削除します。慎重に操作してください',
  Cargo_GeneralCargoWarehouse: '一般貨物倉庫',
  Cargo_WoodenPackagingType: 'Wooden packaging type',
  Cargo_ClearSave: 'Clear and save',
  Cargo_OrderModificationTimes: 'Order modification times',
  Cargo_ServiceStatisticalArea: 'Service Statistical Area',
  Cargo_DangerousGoodPackage: 'Dangerous Goods Packaging',
  Cargo_DangerousGoodPackageCode: 'Dangerous Goods Packaging code',
  Cargo_OOGTEU: 'OOG TEU Volume',
  Cargo_SeaRailTransport: 'Sea-Rail Transport',
  Cargo_BoxOneWay: 'Container Usage (One-Way/Circulation)',
  Cargo_OOGTEUTip: 'Please enter the OOG TEU Volume',
  Cargo_OneWay: 'One-Way',
  Cargo_Circulation: 'Circulation',
  Cargo_Grade: '副次通関業務区分',
  Cargo_Grade2: 'Parent Custom Business Type',
  Cargo_LotteryDraw: 'Ticket Draw',
  Cargo_SchoolMonth: 'Monthly School',
  Cargo_WithdrawTheEntrustment: 'Withdraw the entrustment',
  Cargo_checkData1: 'No entrusted data found or it has already been reviewed.',
  Cargo_ContractTip: 'If you need to adjust the contract agreement, you must first revoke the contract.',
  Cargo_DetailMakeInvoice: 'Detailed Invoice Issuance',
  Cargo_SplitMakeInvoice: 'Split Currency Invoice Issuance',
  Cargo_RemarkAddContent: 'Add Content to Invoice Remarks',
  Cargo_RemarkAddContent3: '発票の備考欄に為替レートの内容を記入する',
  Cargo_BillResults: '船荷証券の認識フィールド',
  Cargo_BillResults2: 'システム船荷証券データ',
  Cargo_NotUpdate: '変更不可',
  Cargo_UpdateCheck1: 'コンテナの種類と数量が選択した積載情報と一致しないことに注意してください',
  Cargo_CustomerAssociatedFactory: '顧客関連工場',
  Cargo_FactoryName: '工場名',
  Cargo_AddAssociatedFactory: '関連工場を追加',
  Cargo_BatchOperationSameEntrustedUnit: 'この一括操作は、同一の委託単位の業務でのみ使用可能です。再度選択してください。',
  Cargo_ImportFailMessage: 'インポート失敗：今回のバッチインポート費用は、決済対象＝委託単位または関連工場の制限を満たしていません。調整後、再度お試しください',
  Cargo_SaveAndConfirm: 'Save and Confirm',
  Cargo_ExportUndoHistory: 'Export undo history',
  Cargo_RevocationBy: 'revocation',
  Cargo_RevocationByDate: 'Revocation time',
  Cargo_billingTip: 'Invoice according to billing requirements',
  Cargo_remarkAddContent2: 'Add Additional Remarks',
  Cargo_detailMakeInvoice2: 'Detailed Invoice Issuance',
  Cargo_splitMakeInvoice2: 'Split Currency Invoice Issuance',
  Cargo_rmbGoodsName: 'RMB Invoice Item',
  Cargo_usdGoodsName: 'USD Invoice Item',
  Cargo_CarrierCode: 'ship edi code',
  Cargo_OrderTemplateSaveSuccess: '注文テンプレートの構成が保存されました',
  Cargo_ContinueSave: 'テンプレートヘッダ名が実際のビジネスフィールド名を使用するように設定されていません。続行しますか？',
  Cargo_OrderTemplateSaveFail: '注文テンプレート構成の保存に失敗しました',
  Cargo_DownImportTemplate: 'インポートテンプレートのダウンロード',
  Cargo_DownImportTemplate_Simple: '個々のテンプレートのダウンロードインポート',
  Cargo_DownImport_Simport: '単一インポート',
  Cargo_ImportingData: 'データをインポート...',
  Cargo_ImportingDataSuccess: 'この操作は非同期操作で、ファイルストレージ->アップロードログでインポート結菓を確認できます',
  Cargo_WriteOffHeader: '売上げ抬頭',
  Cargo_PackageNo: 'パッケージ番号: ',
  Cargo_DeletePackage: 'パッケージの削除',
  Cargo_WareHoused: 'これらのパッケージは倉庫に入っています',
  Cargo_NotWareHoused: 'これらのパッケージは倉庫に入っていません',
  Cargo_CheckPackage: '対応するパッケージを削除してもよろしいですか？確定すると実際の入庫データも削除されます。',
  Cargo_SureDeletePackageIn: 'これらのパッケージはすでに倉庫に入っています。対応するパッケージを削除してもよろしいですか？確定すると実際の入庫データも削除されます。',
  Cargo_SelectPackage: '削除するパッケージデータを選択してください',
  Cargo_SureDeleteAbovePackage: 'これらのパッケージの削除を確認しますか？',
  Cargo_BalanceSheetQuarter: '貸借対照表四半期報告書',
  Cargo_ProfitLossQuarter: '損益計算書四半期報告書',
  Cargo_BalanceSheetYear: '貸借対照表の年次報告書',
  Cargo_ProfitLossYear: '損益計算書の年次報告書',
  Cargo_ReasonForJudgment: '判断理由',
  Cargo_CheckSavePoInfoItem: 'この商品はパッケージに関連付けられています。まず関連付けを解除してください！',
  Cargo_HasBillingGroup: 'この請求書はすでに生成されているので、編集できません！',
  Cargo_HasInvoice: 'この注文は請求済みで、編集できません！',
  Cargo_HasWriteOff: 'この注文はすでに適用されているので、編集できません！',
  Cargo_HasConfirm: 'このフォームは確認済みで、編集できません！',
  ContinueOperation: '操作を続行します',
  CancelOperation: '操作をキャンセルします',
  Cargo_BackTopPreviousVersion: '古いバージョンを返す',
  Cargo_Combine: 'マージ',
  Cargo_DataEnableSuccess: 'データの有効化に成功しました！',
  Cargo_DataDisEnableSuccess: 'データの無効化に成功しました！',
  Cargo_CombineChargeItem: 'チャージアイテムを結合します',
  Cargo_ConsolidatedChargeItem: '統合されたチャージアイテム: ',
  Cargo_ChargeItemHasUsedForCombine: '{0}は無効になっています。他のチャージ項目を選択してマージしてください！',
  Cargo_CombineChargeItemTips: '統合後、すべての{1}関連費用が{0}に更新され、無効に設定されます。続行しますか？',
  Cargo_CombineChargeItemTipsOne: '統合中です。しばらくお待ちください。',
  Cargo_CombineChargeItemTipsTwo: 'このインタフェースを終了できます。マージは10分以内に完了する予定です。後で確認してください。',
  Cargo_CombineChargeItemTipsThree: '統合する別のチャージ項目を選択してください！',
  Cargo_PayService: '課金アイテム: ',
  InvoiceTitleCannotBeBlank: '請求書ヘッダーは空にできません',
  InvoiceTitleCannotBeDuplicate: '請求書ヘッダーは重複できません',
  TaxControlPanelCannotBeDuplicate: '1つの税コントロール【{0}】は複数の請求先に関連付けることができません',
  CheckTaxControlPanelNo: '【{0}】は複数の税コントロール番号を維持しています。続行しますか？',
  TaxControlPanelNoHasInvoiceTitle: '税コントロール情報は請求先に関連付けられており、削除できません。まず関連付けを解除してください！',
  ChinaAdditionalTaxRateIsEmpty: '【中国付加税率】フィールドが空です。保存を続行しますか？',
  SpecialCharactersExcept: '英字、数字、句読点以外の特殊文字が存在する',
  Cargo_ThePreAllocatedManifestHasBeenSentForThisTicketBusiness: 'このチケットビジネスはすでにプロビジョニングハッチを送信しています。インポートに失敗しました。',
  EstimatedDeliveryDate: '配送予定日',
  ActualDeliveryDate: '実際の配送日',
  LatestDeliveryDate: '最終配送日',
  DischargingWay: '荷揚げ方法',
  Cargo_DownloadSource: '資料のダウンロード',
  Cargo_canOnlyBeUppercaseCharactersAndNumbers: '大文字と数字のみ',
  Cargo_numbersNotLetters: '数字、文字を含むことはできません',
  Cargo_pleaseSelectShippingTerms: '運送料条件を選択してください',
  Cargo_pleaseSelectTheTypeOfGoods: '商品タイプを選択してください',
  Cargo_pleaseSelectTheBillOfLadingMethod: '請求方法を選択してください',
  Cargo_pleaseEnterTheFullEnglishNameOfThePortInCapitalLetters: '港の大文字英字フルネームを入力してください',
  Cargo_PortOfDischargeTipText: '中継港を経由して、目的港に直行する',
  Cargo_pleaseEnterTheNameOfTheShipOnlyUppercaseCharactersAndNumbers: '文字、数字、「.」、「-」、「スペース」のみ',
  Cargo_PortPreRateCode: '港前運賃番号',
  Cargo_SideLineType: 'サイドラインタイプ',
  Cargo_EndRouteRateCode: '尾程運賃番号',
  Cargo_DeliveryAddressType: '配送先タイプ',
  Cargo_DirectHaul: '直行輸送',
  Cargo_SideLine: 'サイドライン',
  Cargo_HuzhouSeaRail: '湖州海鉄',
  Cargo_HaiNingBranch: '海寧支線',
  Cargo_ZhapuSideLine: '乍浦サイドライン',
  Cargo_OriginPortInfo: '出発港情報',
  Cargo_ChargeByContainerType: 'コンテナタイプ別料金項目',
  Cargo_ChargeNotByContainerType: 'コンテナタイプ別料金項目ではない',
  Cargo_SpecialRemark: '特別備考',
  Cargo_AddEntry: '項目追加',
  Cargo_FreeUseContainer: '無料使用コンテナ',
  Cargo_FreeStorage: '無料保管',
  Cargo_ThirdPartyAddress: '第三者住所',
  Cargo_AmazonWarehouse: 'アマゾン倉庫',
  Cargo_WalmartWarehouse: 'ウォルマート倉庫',
  Cargo_YiCang: 'イーカン倉庫',
  Cargo_DestinationPortInfo: '目的港情報',
  Cargo_Shelving: '棚に陳列',
  Cargo_PleaseSelectNonNormalRateForShelving: '「正常」状態でない運賃を選んで上架してください。',
  Cargo_PleaseSelectValidRateForShelving: '有効期限内の運賃を選んで上架してください。',
  Cargo_PleaseSelectNormalRateForUnShelving: '「正常」状態の運賃を選んで下架してください。',
  Cargo_SeaFreightFullContainer: '海上輸送フルコンテナ',
  Cargo_SeaFreightLessThanContainer: '海上輸送部分コンテナ',
  Cargo_EnquiryNumber: '見積番号',
  Cargo_EnquirySource: '見積元',
  Cargo_Enquirer: '見積依頼者',
  Cargo_EnquiryStatus: '見積状態',
  Cargo_FirstLegQuoteStatus: '港前見積もりステータス',
  Cargo_MainlineQuoteStatus: '幹線区間の見積状態',
  Cargo_LastLegQuoteStatus: '最終区間の見積状態',
  Cargo_PalletType: 'パレットの種類',
  Cargo_DirectOrTransshipment: '直行/中継',
  Cargo_Range: '区間',
  Cargo_Dimensions: '長さ、幅、高さ',
  Cargo_Terms: 'サービス規約',
  Cargo_DeliveryAddress: '配送先住所',
  Cargo_NameHSCode: '品名（HSコード）',
  Cargo_MainlineRate: '幹線運賃',
  Cargo_PrePortRate: '港前運賃',
  Cargo_EndRouteRate: '終点運賃',
  Cargo_RateCode: '運賃コード',
  Cargo_MatchQuote: '見積もりの一致',
  Cargo_Select_Inquiry_Responsible: '見積もり担当者を選択してください',
  Cargo_Multiple_Route_Leaders: '複数の航路担当者情報が一致しました。見積もりを開始する担当者を選択してください:',
  Cargo_Pre_Port_Rate_Leader: '港前運賃担当者',
  Cargo_Mainline_Rate_Leader: '幹線運賃担当者',
  Cargo_End_Route_Rate_Leader: '終点運賃担当者',
  Cargo_NoMatchFound: '一致するものが見つかりませんでした [{0}]',
  Cargo_CombinationPlanQuery: '組み合わせプランの検索',
  Cargo_FillQueryConditions: '検索条件を入力',
  Cargo_SelectMatchingRate: '一致する運賃を選択',
  Cargo_GenerateCombinationPlan: '組み合わせプランを生成',
  Cargo_ReturnToPreviousStep: '前のステップに戻る',
  Cargo_PrePortPrice: '港前価格',
  Cargo_MainlinePrice: '幹線価格',
  Cargo_LastMilePrice: 'ラストマイル価格',
  Cargo_AssociatedPrePortQuoteNumber: '関連港前見積番号',
  Cargo_AssociatedLastMileQuoteNumber: '関連ラストマイル見積番号',
  Cargo_20GPQuantity: '20GP数量',
  Cargo_40GPQuantity: '40GP数量',
  Cargo_40HCQuantity: '40HC数量',
  Cargo_45HCQuantity: '45HC数量',
  Cargo_20NORQuantity: '20NOR数量',
  Cargo_40NORQuantity: '40NOR数量',
  Cargo_20FootNORQuantity: '20\'NOR数量',
  Cargo_40FootNORQuantity: '40\'NOR数量',
  Cargo_SubmitQuotation: '見積もりを提出',
  Cargo_WithdrawQuotation: '見積もりを撤回',
  Cargo_RejectQuotation: '見積もりを拒否',
  Cargo_InquiryManagement: '貨物見積もり管理',
  Cargo_PrePort: '港前',
  Cargo_FinalMile: 'ラストマイル',
  Cargo_OriginAreaSelection: '出発地エリア選択',
  Cargo_ShippingAddressSelection: '配送先住所の選択',
  Cargo_AddArea: '+エリアの追加',
  Cargo_AddAddress: '+住所を追加',
  Cargo_AddressDisabledTip: '複数のエリアを追加できます。2つ以上の通り/町を選択すると、詳細住所は無効になります。',
  Cargo_PleaseMaintainAtLeastOne: '少なくとも1つは維持してください。',
  Cargo_CannotMatchPleaseFill: '{0}は一致しません。[{1}]を入力してください。',
  Cargo_Match: '一致',
  Cargo_QuoteStatusNotAllowedSave: '見積もり状態では保存できません',
  Cargo_SaveDraft: 'ドラフトを保存',
  Cargo_PublishDirectly: '直接公開',
  Cargo_SelectPendingQuoteSubmittedCancel: '見積もり待ちかつ提出済みの問い合わせ注文を選択してキャンセルしてください',
  Cargo_LastMileDeliveryAddress: 'ラストマイル配送先住所',
  Cargo_PackingDoorPoint: '梱包ドアポイント',
  Cargo_BoxTypeNotAllowedDuplicate: '箱の種類は重複してはいけません',
  Cargo_PrePortBusinessLeader: '港前ビジネスリーダー',
  Cargo_MainlineBusinessLeader: 'メインラインビジネスリーダー',
  Cargo_LastMileBusinessLeader: 'ラストマイルビジネスリーダー',
  Cargo_OverseaTracker: '海外跟単担当者',
  Cargo_EndCommerceSynced: '同期済み',
  Cargo_EndCommerceAudited: '承認済み',
  Cargo_EndCommerceNotSynced: '未同期',
  Cargo_EndCommercePleaseSelectAtLeastOne: '少なくとも1件のデータを選択してください',
  Cargo_EndCommerceOnlySelectOne: 'この操作では1件のデータのみ選択できます',
  Cargo_EndCommerceRecordNotAllowEdit: '現在のレコードは編集できません',
  CargoMsg_CurrentIdentityNotice: '現在の身分はその後の権限に関連付けられます。他の役割で見積もりを提出したい場合は、まずインターフェース右上で支社と部署を切り替えてください。',
  Cargo_enterTheVoyageThereCanBeNoV: '航路を力を入れて、V.があってはいけません。',
  Cargo_ResubscribeBookingReceipt: '再購読予約確認書',
  Cargo_BookingReceiptSubscriptionFailed: '予約確認書の購読に失敗しました',
  Cargo_inputVoyage: '航路番号を入力してください',
  Cargo_pleaseSelectAShippingGeneration: '船代を選択してください',
  Cargo_pleaseSelectAShippingCompany: '船会社を選んでください',
  Cargo_pleaseEnterAnAddressWithin140Characters: '住所を140文字以内で入力してください',
  Cargo_pleaseEnterTheEnterpriseCode: '企業コードを入力してください。「+」を含み、+記号の前後にスペースを含めることはできません',
  Cargo_pleaseEnterAPhoneNumber: '電話番号を入力してください',
  Cargo_pleaseEnterANameWithin140Characters: '名前を140文字以内で入力してください',
  Cargo_pleaseEnterANameWithin140Characters2: '名前を70文字以内で入力してください',
  Cargo_pleaseSelectACountryCode: '国コードを選択してください',
  Cargo_pleaseEnterTheActualContactName: '実際の連絡先名を入力してください',
  Cargo_ViewShipGenerations: '船代を表示',
  Cargo_ReferenceShipGenerations: '参考船代',
  Cargo_CopyShipInformation: '船情報をコピーします',
  Cargo_PleaseInquireWithTheBookingHatchOrCustomerService: '予約ハッチまたはカスタマーサービスにお問い合わせください',
  UnverifiedAmountForCharge: '売上金（チャージ）',
  VerifiedAmountForCharge: '売上金額（チャージ）',
  ReceivableForCharge: '受取（費用）',
  PayableForCharge: '買掛金（チャージ）',
  Cargo_PrePlanBookingCheckSoNo: '送信/訂正されたプロビジョニング・マニフェストに、このチケット・ビジネス内でメンテナンスされていない関連番号が存在します。続行しますか？',
  Cargo_SwitchToTheOldVersion: '古いバージョンに切り替え',
  Cargo_MaintainChargeItem: '費用項目を先に維持してください！',
  Cargo_UsePeriodRate: '明細為替レートを使用するかどうか',
  Cargo_initRatePeriod: '取得時レート有効日の初期化',
  Cargo_MonthRate: '月レート',
  Cargo_PartialImport: '部分的にインポート',
  Cargo_CopyCustomerShippingInformation: '送受信をコピーします',
  Cargo_NoPermissionForModule: 'モジュールを開く権限がありません！',
  Cargo_OcPayment: 'オフライン入金情報の照会',
  Cargo_BatchProcess: 'バッチ処理',
  Cargo_BatchCancelProcess: '一括キャンセル処理',
  Cargo_OcPaymentTime: '支払日',
  Cargo_ErialNumber: '三者支払通し番号',
  Cargo_OcErialNumber: 'OC支払通し番号',
  Cargo_BillingAccountId: '請求先顧客名',
  Cargo_BillingSettlementAgentId: '請求書代理決済名',
  Cargo_Processed: '処理するかどうか',
  Cargo_Project: 'プロジェクト名',
  Cargo_PaymentStatus: '支払処理状況',
  Cargo_UnlockPaymentTimeQuery: '選択した支払日の範囲が2年を超えると、データのロード速度に影響します。2年以外のデータをクエリしますか？',
  Cargo_OnlyUnProcessedRecordsCanBeProcessed: '処理されていない【オフライン振替】レコードのみ処理できます。',
  Cargo_ConfirmAndProcessSelectedRecord: '選択した【オフライン振替】レコードの処理を確認しますか？',
  Cargo_OnlyProcessedRecordsCanBeCancelled: '処理された【オフライン振替】レコードのみキャンセルできます。',
  Cargo_CancelProcessOfSelectedRecord: '選択した【オフライン振替】レコードの処理をキャンセルすることを確認しますか？',
  Cargo_ProcessedSuccessfully: '処理済みとしてマーク',
  Cargo_CancelProcessSuccessfully: '未処理としてマーク',
  Cargo_LockedOrNot: 'ロックするかどうか',
  Cargo_DeleteOCBillTips: 'ロックされていない請求書のみ削除できます！',
  Cargo_DeleteRecheckedBillTips: '未検討の請求書のみ削除できます！',
  Cargo_OCCanWriteOff: 'ロックされた【オフライン振替】請求書のみが適用されます！',
  Cargo_Adjustment: '調整します',
  Cargo_InChangeExpenseReview: '変更費用レビュー中',
  Cargo_Verification: '消込済',
  Cargo_BeWriteBack: 'レッドフラッシュされました',
  Cargo_InquiryAndQuotation: '見積依頼・見積',
  Cargo_AlertTodoCategoryList: 'アラート・ToDoカテゴリー一覧',
  Cargo_ItemDescription: '事項説明',
  Cargo_Alert: 'アラート',
  Cargo_Todo: 'ToDo',
  Cargo_TodoAlert: 'ToDo/アラート',
  Cargo_ChangeFeeApplicationProgress: '費用請求の進捗状況の変更',
  Cargo_userDefinedRole1: 'カスタム部署1',
  Cargo_userDefinedRole2: 'カスタム部署2',
  Cargo_userDefinedRole3: 'カスタム部署3',
  Cargo_userDefinedRole4: 'カスタム部署4',
  Cargo_userDefinedRole5: 'カスタム部署5',
  Cargo_userDefinedRole6: 'カスタム部署6',
  Cargo_userDefinedRole7: 'カスタム部署7',
  Cargo_userDefinedRole8: 'カスタム部署8',
  Cargo_DisplaysTheRequestChangeFee: '要求変更料金を表示します',
  Cargo_UpdateVesselVoyageMsg: '船名を変更しました。{0}には値があります。空にする必要がありますか？',
  Cargo_CheckUnitRate: '単価0の費用があります。保存を続けると単価0の費用が自動的にクリアされます。保存を続けますか？',
  Cargo_ZeroUnitPrice: '単価が0の費用がありますが、このまま保存しますか、それとも単価が0の費用を削除しますか？',
  Cargo_ClearZeroFee: '値が0の費用を削除',
  Cargo_NoFeesCanBeAdded: '追加する費用はありません',
  Cargo_ZeroUnitPriceEntry: '単価が0で入力されました。保存を続けるか確認してください',
  Cargo_ZeroAmountWarning: '費用単価または金額が0として入力されています。保存を続けるか確認してください。',
  Cargo_Readjust: '再調整',
  Cargo_Validate_Insure: '本社では保険機能を使用できません。支社に切り替えてください。',
  Cargo_ReceivingOperator: '受信オペレータ',
  Cargo_ReceivingOperationTime: '受信操作時間',
  Cargo_ClaimOperator: '受領オペレータ',
  Cargo_ClaimOperationTime: '受領操作時間',
  Cargo_OrderChangeOperator: '変更オペレータ',
  Cargo_ChangeOrderOperationTime: '注文変更操作時間',
  Cargo_ContinueToReleaseDocuments: '注文を続行しますか？',
  Cargo_ExpectedReturnDate: '返却予定日',
  Cargo_OcPrePayment: '前受フラグ',
  Cargo_OcCancelPrePayment: '前受/預りフラグの解除',
  Cargo_GetKingdeId: 'キンチョウIDの取得',
  Cargo_RefreshData: '操作が失敗しました。更新してからやり直してください！',
  Cargo_ContinueExportTip: '選択したレコードがエクスポートされました。再度エクスポートしますか？',
  Cargo_WarnRuleConfiguration: 'アラート・ルール構成リスト',
  Cargo_BPMApprovalProcess: 'BPM承認プロセス',
  Cargo_DataServiceReminder: 'データサービスアラート',
  Cargo_ValueAddedServiceReminder: '付加価値サービスリマインダー',
  Cargo_DataServiceItems: 'データサービス項目',
  Cargo_SopTemplate: 'SOPテンプレート',
  Cargo_SopNode: 'SOPノード',
  Cargo_TriggerTypeSelection: 'トリガタイプの選択',
  Cargo_TriggerType: 'トリガタイプ',
  Cargo_WarningConditions: 'アラート条件',
  Cargo_NodeUpdate: 'Node Update',
  Cargo_EarlyWarning: 'アラートタイプ',
  Cargo_WarningContent: 'アラートの内容',
  Cargo_DataServiceConfig: 'データサービス設定名',
  Cargo_ConfigureNameNotEmpty: '設定名は空にできません',
  Cargo_ConfigureNameRepeat: '{0} は既に存在します。設定名は一意である必要があります',
  Cargo_NotifierRoleRepeat: 'ポジション {0} は既に設定 {1} に存在します。重複して設定しないでください',
  Cargo_NotifierIdRepeat: 'ユーザー {0} は既に設定 {1} に存在します。重複して設定しないでください',
  Cargo_RemarksInfo: 'コメント情報',
  Cargo_DesignatedPost: '部署の指定(各チケット事業で設定された運営、販売、接客などの職位に応じて通知が送られます)',
  Cargo_SendSettings: 'Send Settings',
  Cargo_SetTheNotificationRecipients: 'Set The Notification Recipients',
  Cargo_ReminderMethod: 'Reminder Method',
  Cargo_DesignatedPersonnel: '指定者',
  Cargo_AutoIgnoreMode: '自動無視モード',
  Cargo_WarningLevel: '警告レベル',
  Cargo_ShipPlanReminderMethod: '船舶計画リマインダー方式',
  Cargo_ShipNameAndVoyage: '船名・航海番号によるリマインダー',
  Cargo_Job: '業務によるリマインダー',
  Cargo_AlertOnStatus: 'アラートオン状態',
  Cargo_EarlyWarningMode: '警告モード',
  Cargo_WarningSwitch: '警告スイッチ',
  Cargo_StartAlert: 'アラートをオンにする',
  Cargo_CloseAlert: 'アラートをオフにします',
  Cargo_EnablePersonalSettings: '個人設定を有効にする',
  Cargo_ClosePersonalSettings: '個人設定を無効にする',
  Cargo_DataServiceReminderWarning1: '1.【「基本設定」に従ったプッシュ】は、【基本設定】で統一されたプッシュノードで配信されます',
  Cargo_DataServiceReminderWarning2: '2.【アラートを有効】→【保存】後、受信ノードは個人設定を優先します',
  Cargo_ConfigurationAlert: '「基本設定」に従ったプッシュ',
  Cargo_PushNodeSettings: '個人プッシュノード設定',
  Cargo_NodPushSettings: 'ノードプッシュ設定',
  Cargo_VesselReminderMethodDifferent: '元の有効な【船舶スケジュールリマインダー方式】が{船名・航海回号別}の場合、最新の{業務別}に一括置換されます',
  Cargo_VesselReminderMethodDifferent2: '元の有効な【船舶スケジュールリマインダー方式】が{業務別}の場合、最新の{船名・航海回号別}に一括置換されます',
  Cargo_UserConfigOpenDifferent: '元の有効な【ノードプッシュ設定】が{個人設定無効}の場合、最新の{個人設定有効}に一括置換されます',
  Cargo_UserConfigOpenDifferent2: '元の有効な【ノードプッシュ設定】が{個人設定有効}の場合、最新の{個人設定無効}に一括置換されます',
  Cargo_BringForward: '前倒し',
  Cargo_Postpone: '後回し',
  Cargo_EarlyWarningReminder: '分钟、警告アラート',
  Cargo_EarlyTimedIgnore: 'タイミング無視',
  Cargo_TurnOffAutoIgnore: '自動無視をオフにする',
  Cargo_SetSOPNodeOfAlert: 'アラートのSOPノード',
  Cargo_SOPNodeOfAlert: 'SOPノードアラート',
  Cargo_ApplicationScope: '適用範囲',
  Cargo_DocumentNotification: 'ドキュメント通知',
  Cargo_ApplyToAllTemplates: '同じ取引タイプ のテンプレートに適用します',
  Cargo_UseOnlyTheCurrentTemplate: '現在のテンプレートのみ使用',
  Cargo_SetAlertNotificationObject: 'アラート通知オブジェクトの設定',
  Cargo_ReminderModes: 'Reminder Mode',
  Cargo_IgnoreTime: '時間を無視する',
  Cargo_AutomaticallyIgnoreAfterHours: '時間後に自動的に無視されます',
  Cargo_EditNodeAlertRules: 'ノード警告ルールの編集',
  Cargo_CloudPlatformFeeStatus: 'クラウドプラットフォームの費用処理状況',
  Cargo_CloudPlatformDocumentNumber: 'クラウドプラットフォームドキュメント番号',
  Cargo_SynchronousCloudPlatform: '同期クラウドプラットフォーム',
  Cargo_SendThirdParty: '第三者に送信',
  Cargo_SupplementaryInformation: '補足情報',
  Cargo_InvoiceTypeOfTheOppositePlatform: '相手先プラットフォーム請求書の種類',
  Cargo_PaymentBranch: '支払支店',
  Cargo_SyncInvoiceAttachment: '請求書添付ファイルを同期するか',
  Cargo_AddEmail: 'Add Email',
  Cargo_Send: '送信',
  Cargo_SendSuccess: '送信に成功しました',
  Cargo_SendFail: '送信に失敗しました',
  Cargo_Remarks2: 'コメントの内容',
  Cargo_PaymentInstructions: '支払い説明',
  Cargo_PaymentReason: '支払い理由',
  Cargo_OurHeader: '私たちのヘッダー',
  Cargo_DeleteBookingNote: 'Are you sure you want to delete these {0} booking notes?',
  Cargo_ApplicationDetails: '申請の詳細',
  Cargo_SubscribeToDataAlerts: 'データアラートの購読',
  Cargo_EnableDataServiceReminder: 'データサービス通知を有効にする',
  Cargo_ClickToLearnMore: 'クリックして詳細を見る',
  Cargo_DataServiceReminderWarning: '毎日受け取った箱物の注意が多すぎる場合は、この注意をオフにすることができます。以上の注意項目は付加価値サービスモジュールをオンにする必要があります。',
  Cargo_AskDataServiceReminder: 'データサービスを開始した後、効率的で正確な自動プッシュ通知を社内スタッフに通知します。詳細はこちら: ',
  Cargo_AskSopDataService: 'データサービスを開通した後、効率的で正確な自動プッシュ通知を社内の従業員と顧客に送ることができます（人工的な転送をサポートしない）。そして、警報ルールの配置にデータ警報サービスを設置することができ、すぐにあなたの会社の管理者に連絡することができます。詳細は以下の通りです: ',
  Cargo_ContactDataServiceReminder: ',またはWallTechオンラインカスタマーサービスまたはオペレーション021-65143931',
  Cargo_DataServiceRemind: 'データ警報サービス',
  Cargo_WhetherToTurnOffAlerts: 'アラートをオフにするかどうか',
  Cargo_DayWarning: 'Day Warning',
  Cargo_OnlyDataNodesAreDisplayed: 'To-Doノードのみを表示',
  Cargo_ViewProcessedAlerts: '処理されたアラートの表示',
  Cargo_ViewIgnoredAlerts: '無視されたアラートの表示',
  Cargo_SelectTheSopTemplateToApplyToTheBusiness: 'このビジネスに適用するSOPテンプレートを選択します',
  Cargo_MakeSureToApplyTheSopTemplate: 'SOPテンプレート【{0}】の適用を確認してください',
  Cargo_PleaseSelectAnSOPTemplate: 'SOPテンプレートを選択してください',
  Cargo_PleaseSelectSOPTemplateForChange: 'Please Select SOP Template For Change',
  Cargo_PleaseSelectOtherSOPTemplate: 'Please select other SOP template',
  Cargo_ReplaceTheSOPTemplate: 'SOPテンプレートを交換します',
  Cargo_Apply: '適用',
  Cargo_MoreFilters: 'その他のフィルタ',
  Cargo_Handled: '処理済み',
  Cargo_ProcessSelectedData: '選択されたすべてのアラート情報は処理済としてマークされます。この操作内容はアラート・メッセージの処理状況のみを更新しますか？',
  Cargo_IgnoreSelectedData: '選択されたすべてのアラート情報は無視されますか？',
  Cargo_Personnel: 'ユーザ',
  Cargo_NewSopTemplate: '新規SOPテンプレート',
  Cargo_EditSopTemplate: 'SOPテンプレートの編集',
  Cargo_CopySopTemplate: '現在のSOPテンプレートをコピーします',
  Cargo_SopTemplateName: 'SOPテンプレート名',
  Cargo_LookNode: 'ノードの表示',
  Cargo_NewNode: '新規ノード',
  Cargo_EditNode: 'ノードの編集',
  Cargo_NewNodeStatus: '新規ノードの状態',
  Cargo_NodeSettings: 'ノード設定',
  Cargo_NodeStatusSettings: 'ノード状態の設定',
  Cargo_NoticeOfEachBill: 'チケットごとの通知（チケットを含む）',
  Cargo_NoNoticeOfTickets: 'レシートドキュメントは通知されません',
  Cargo_AlertSettings: 'アラート設定',
  Cargo_ConfigureSopMessagePush: 'SOPメッセージのプッシュを設定します',
  Cargo_NodeType: 'ノードタイプ',
  Cargo_WhetherToDisclose: '公開するかどうか',
  Cargo_EditTheAlertConfiguration: 'アラート構成の編集',
  Cargo_AddedAlertConfiguration: '新しいアラート構成',
  Cargo_EditTheStatusDetails: '処理状況詳細の編集',
  Cargo_NewStatusDetails: '新規処理状況詳細',
  Cargo_StatusDetails: '処理状況の詳細',
  Cargo_SetUpSopTemplateApplicationBusinessScenarios: 'SOPテンプレートを設定してビジネスシナリオを適用します',
  Cargo_QuicklySelectBusinessNodes: 'ビジネスノードのクイック選択',
  Cargo_QuicklyConfigureDataServices: 'クイック構成データサービス',
  Cargo_QuicklyConfigureStatusNotifications: 'クイック構成処理状況通知（内部）',
  Cargo_ShipPlanningAtThePortOfDeparture: '出港船舶計画',
  Cargo_ContainerTracking: 'コンテナ追跡',
  Cargo_ShipDynamicsAtThePortOfDestination: '目的港の船舶動態',
  Cargo_CarryEmpty: '空を持ち上げる',
  Cargo_TheActualDischarging: '実際に船を降ろす',
  Cargo_ReturnBox: 'まだ空です',
  Cargo_TheHomePageIsDisplayed: 'トップページ表示',
  Cargo_QuicklyConfigureSettings: 'クイック構成設定',
  Cargo_QuickConfigurationIsCheckedByDefault: 'クイック設定のデフォルトチェック',
  Cargo_PleaseEnterAThemeTemplate: 'テーマテンプレートを入力してください',
  Cargo_PleaseEnterTheBodyTemplateContent: '本文テンプレートの内容を入力してください',
  Cargo_PleaseEnterTheTemplateContent: 'テンプレートの内容を入力してください',
  Cargo_PleaseEnterAnExampleTemplate: 'テンプレートのサンプルを入力してください',
  Cargo_SOPPushObjectChannelRepeats: 'SOPプッシュ対象チャネルが重複しています',
  Cargo_DataService: 'データサービス',
  Cargo_WarningRuleTips: 'SOPノードの状態が更新されると、対応するアラート情報が処理済みとしてマークされます',
  Cargo_SopTemplateChangeTips: '新しいSOPテンプレート【{0}】に一緻しました。元のSOPテンプレートを保持しますか？',
  Cargo_ApplyTheSopTemplateAs: '適用するSOPテンプレートは',
  Cargo_TheNodeIsShutDown: 'ノードがシャットダウンしました',
  Cargo_CanNotUploadFileOfNewContract: '新規未保存の契約番号はファイルをアップロードできません！',
  Cargo_OrderReceiving: '受注',
  Cargo_PrintTemplate: '印刷テンプレート',
  Cargo_ControlObject: 'コントロールオブジェクト',
  Cargo_ControlMode: 'コントロールモード',
  SetDefaultType: 'デフォルトのタイプを設定します',
  DefaultFileType: 'デフォルトのファイルタイプ',
  DefaultType: 'デフォルトのタイプ',
  Cargo_ActualPaymentAmount: '支払金額',
  Cargo_ReceivedAmount: '入金額',
  Cargo_OcServiceCharge: 'OC手数料',
  Cargo_ChannelServiceCharge: 'チャネル手数料の支払い',
  Cargo_Abnormal: '異常かどうか',
  Cargo_AbnormalState: '例外の説明',
  Cargo_AbnormalRemark: 'コメント',
  Cargo_ProcessedDate: '処理時間',
  Cargo_UpdateReceivedAmount: '転記済金額の編集',
  Cargo_AbnormalComment: '例外コメント',
  Cargo_MarkAbnormal: 'マーキング異常',
  Cargo_ValueAddedServices: '付加価値サービス',
  Cargo_CustomsMode: '通関方式',
  Cargo_POD: '到着港',
  Cargo_POL: '出発港',
  Cargo_ServiceType: 'サービスタイプ',
  Cargo_PODServices: '宛先ポートサービス',
  Cargo_InitData: '初期化データ',
  Cargo_NotInitData: 'すでにデータがあり、初期化できません',
  Cargo_GeneratedVoucherInvoice: '生成された買掛伝票を含む請求書番号: ',
  Cargo_DownLoad_Summary: '集計テンプレートのダウンロード',
  Cargo_DownLoad_Detail: '詳細テンプレートのダウンロード',
  Cargo_Import_OnOrder: '注文のインポート',
  Cargo_Not_Submit: '送信を保留しますか？',
  Cargo_Not_Approved: '【承認保留中】の注文のみバッチで送信できます！',
  Cargo_Not_Submit_Please: '【送信を保留する】のチェックボックスをオンにしてください！',
  Cargo_Not_Submit_Batch_Success: '保留中の送信処理状況の更新は成功しました',
  Cargo_Submit_Batch: '【送信】するビジネスを選択してください',
  Cargo_Submit_Pre_Qualification: 'レビュー前状態の送信を確認しますか？',
  Cargo_Submit_Job: '一括送信【保留中】のジョブのみ',
  Cargo_Submit_Success: '注文は送信されました',
  Cargo_ThirdTableCheck: '第三者の中間表がプッシュされており、操作できません。',
  Cargo_OnlySelectedOneVoucher: 'エクスポートするデータは1つだけ選択できます。',
  Cargo_BatchSetCategory: '一括設定カテゴリ',
  Cargo_ExportExcelTemplate: 'Excelテンプレートをエクスポート？',
  Cargo_Run: '実行します',
  Cargo_ExcelTemplateExport: 'Excelレポートのエクスポート',
  CARGO_OFFICE_EMAIL_ISEMPTY: '現在支社のメールボックスはメンテナンスされていません。チェックしてください。',
  Cargo_ChangeChargeChanged: '{0}の元の費用に修正があります（請求書/請求書/支払申請/消込等）。確認してください！',
  Cargo_SecondPolCode: '二程出発港（コード）',
  Cargo_SecondPodCode: '二次目的港（コード）',
  Cargo_SecondPol: 'Two way port of departure',
  Cargo_SecondPod: 'Second destination port',
  Cargo_WaybillDestination: '運送状の宛先',
  Cargo_PolCountry: '出荷国/地域',
  Cargo_IC: '国際カ航',
  Cargo_IC_Master: '国際カード航空主券',
  Cargo_IC_Basic: '国際カード航票',
  Cargo_Settlement: '決済',
  Cargo_ReconciliationTab: '照会タブ',
  Cargo_BillTab: ' 請求書タブ ',
  Cargo_CancelApprovalCheck: ' 選択したデータには既に BO を送信した業務が含まれているため、審査のキャンセルは許可されません。確認してください！',
  Cargo_BusinessPushStatus: ' 業務プッシュステータス ',
  Cargo_CostPushStatus: ' 費用プッシュステータス ',
  Cargo_AutoGenerateEnabled: '自動生成しますか？',
  Cargo_BusinessQuotationAmount: 'ビジネス見積金額',
  Cargo_BusinessQuotationConfirmed: 'ビジネス見積確認済み',
  Cargo_BusinessQuotationConfirmedCancel: '見積もり確認取消',
  Cargo_OperationAllowedOnlyForUnconfirmedQuotation: '見積が「いいえ」と確認された費用のみがこの操作を実行できます！',
  Cargo_OperationAllowedOnlyForConfirmedNonZeroQuotation: 'ビジネス見積が0ではなく、かつ見積が「はい」と確認された費用のみがこの操作を実行できます！',
  Cargo_VehicleModel: '車種',
  Cargo_TypeKh: 'カーゴホン',
  Cargo_waybillInvoice: '運送状請求書情報',
  Cargo_customsMethodPol: '通関方法',
  Cargo_transferAgent: '中継先エージェント',
  Cargo_destinationAgent: '宛先エージェント',
  Cargo_dispatchingPlace: '出荷先',
  Cargo_dispatchingPlace2: ' 入出庫先',
  Cargo_dischargingPortCode: '荷降地（POD）',
  Cargo_transferPortCode: '中継先',
  Cargo_loadingPortCode: '出荷先（POL）',
  Cargo_actAta: '実際の到着日（ATA）',
  Cargo_estEta: '到着予定日（ETA）',
  Cargo_actAtd: '実際の出荷日（ATD）',
  Cargo_estEtd: '予定出荷日（ETD）',
  Cargo_OrderCar: '予約クラス',
  Cargo_DestinationDelivery: '目的地配送',
  Cargo_trailerNumber: 'トレーラーナンバー',
  Cargo_polInfo: '出発港情報',
  Cargo_estLandingTime: 'カーゴ航空の到着予定時刻',
  Cargo_actLandingTime: '実際の到着時間',
  Cargo_estEntryTime: 'カーゴ航空の入国予定時刻',
  Cargo_actEntryTime: 'カーゴの実際の入国時間',
  Cargo_estExitTime: 'キャセイパシフィック航空の予定出国時間',
  Cargo_actExitTime: 'カーゴの実際の出国時間',
  Cargo_estReplacementTime: 'キャセイパシフィック航空の予想交換時間',
  Cargo_actReplacementTime: 'キャセイパシフィック航空の実際の交換時間',
  Cargo_declareTime: '航空会社の通関時間',
  Cargo_transferInfo: '中継先のトランジット情報',
  Cargo_declareCompletedTime: '中継先申告完了時間',
  Cargo_estShippingTime: '中継地の予定出荷時間',
  Cargo_actShippingTime: '中継地の実際の出荷時間',
  Cargo_estArrivePodTime: '目的地の国境到着予定時刻',
  Cargo_actArrivePodTime: '実際に目的地の国境に到着する時間',
  Cargo_estEnterPodTime: '到着予定時刻',
  Cargo_actEnterPodTime: '実際の到着時刻',
  Cargo_estArriveClearTime: '通関地への到着予定時刻',
  Cargo_actArriveClearTime: '実際にクリアした時間',
  Cargo_estDischargeTime: 'エアカーゴの予定荷揚げ時間',
  Cargo_actDischargeTime: 'エアカーゴの実際の荷揚げ時間',
  Cargo_estArriveTime: 'トレーラーの到着予定時刻',
  Cargo_actArriveTime: 'トレーラーの実際の到着時間',
  Cargo_estTakeTime: 'トレーラーの予定集荷時間',
  Cargo_actTakeTime: '実集荷時間（トレーラー）',
  Cargo_estUnloadTime: 'トレーラーの予定荷揚げ時間',
  Cargo_actUnloadTime: 'トレーラーの実際の荷揚げ時間',
  Cargo_podInfo: '目的港発送情報',
  Cargo_estWarehouseDeliveryTime: '倉庫への納品予定時刻',
  Cargo_actWarehouseDeliveryTime: '実際の倉庫への納品時間',
  Cargo_estGoodsDeliveryTime: '配送予定時刻',
  Cargo_actGoodsDeliveryTime: '実際の配送時間',
  Cargo_estReturnTime: '予定返却時間',
  Cargo_actReturnTime: '実際にはまだ空き時間',
  Cargo_polPortInfo: '出発地港情報',
  Cargo_khLandingTime: '航空便が到着しました',
  Cargo_khEntryTime: 'カーゴ入国',
  Cargo_khExitTime: 'カード航空出国',
  Cargo_khReplacementTime: 'カーポートの交換',
  Cargo_khDeclare: 'カード航空通関',
  Cargo_transferShipping: '中継地出荷',
  Cargo_transferTransitInfo: '中継先のトランジット情報',
  Cargo_transferDeclareCompleted: '中継先の申告が完了しました',
  Cargo_arriveDestinationBorder: '目的地の国境に到達します',
  Cargo_podClearInfo: '目的地のクリアランス情報',
  Cargo_arrivePod: '目的地に到着しました',
  Cargo_arriveClear: 'クリア地点に到達しました',
  Cargo_khUnloading: '航空貨物を降ろす',
  Cargo_polExchangeInfo: '出発地の荷揚げ情報',
  Cargo_trailerLoad: 'トレイラピック',
  Cargo_trailerArrive: 'トレーラー到着',
  Cargo_trailerUnload: 'トレーラーの荷下ろし',
  Cargo_podDeliveryInfo: '目的地配送情報',
  Cargo_warehouseDelivery: '倉庫渡し',
  Cargo_goodsDelivery: '配送する',
  Cargo_podReturn: 'まだ空です',
  Cargo_estTime: '予想時刻',
  Cargo_actTime: '実際の時間',
  Cargo_secondPlateNumber: '二程ナンバープレート',
  Cargo_secondTrailerNumber: '二程トレーラーナンバー',
  Cargo_secondVehicleType: 'セカンドカータイプ',
  Cargo_secondEtd: '出荷日',
  Cargo_secondPol: '出発地',
  Cargo_secondPod: '目的地',
  Cargo_secondLoadingTime: 'ロード時間',
  Cargo_secondShippingTime: '出発時刻',
  Cargo_secondArriveTime: '到着時刻',
  Cargo_secondDischargeTime: '荷揚げ時間',
  Cargo_secondTransportType: '輸送方法',
  Cargo_bargeInfo: 'バージ情報',
  Cargo_bargeEtd: 'バージ出荷日',
  Cargo_bargeAtd: 'バージ到着日',
  Cargo_bargePlateNumber: 'バージナンバー',
  Cargo_bargeTrailerNumber: 'バージトレーラーナンバー',
  Cargo_bargePol: 'バージ出発地（POL）',
  Cargo_bargePod: 'バージ目的地（POD）',
  Cargo_ActualEntryTime: 'Actual Entry Time',
  Cargo_ActualLoadingTime: 'Actual Loading Time',
  Cargo_EstimatedDepartureTime: 'Estimated Departure Time',
  Cargo_ActualDepartureTime: 'Actual Departure Time',
  Cargo_EstimatedArrivalTime: 'Estimated Arrival Time',
  Cargo_ActualArrivalTime: 'Actual Arrival Time',
  Cargo_ActualBillingTime: 'Actual Billing Time',
  Cargo_ActualUnloadingTime: 'Actual Unloading Time',
  Cargo_ActualArrivalNotificationTime: 'Actual Arrival Notification Time',
  Cargo_ActualPickupTime: 'Actual Pickup Time',
  Cargo_EstimatedTransitArrivalTime: 'Estimated Transit Arrival Time',
  Cargo_TransitArrivalTime: 'Transit Arrival Time',
  Cargo_EstimatedTransitDepartureTime: 'Estimated Transit Departure Time',
  Cargo_TransitDepartureTime: 'Transit Departure Time',
  Cargo_bargeLine: '公道航路コード',
  Cargo_bargeCarrierId: 'バージ運送会社',
  Cargo_khPlateNumber: '貨物番号',
  Cargo_khPlateNum: 'Card Air License Plate No',
  Cargo_PlateNums: 'Domestic License Plate number',
  Cargo_khTrailerNumber: 'トレーラー番号',
  Cargo_TypeTc: 'トレーラー',
  Cargo_SyncTargetDocumentNo: '相手の証明書番号を同期します',
  Cargo_PleaseChooseTargetDocumentNo: '相手の証憑番号があるレコードを選択してください',
  Cargo_WriteOffInputFail: '未消込費用のうち、支払要求をしていないか、または支払要求プロセスが完了していないため、消込不可！',
  Cargo_WriteOffInputFail2: 'In the expenses to be written off, there are expenses that the payment application process has not been completed, so write off is not allowed!',
  Cargo_OFAOPOTFSIITPRPPDNOATRIC_Payment: '操作が失敗しました。支払要求は支払承認プロセス中です。プロセスが完了してから操作してください。',
  Cargo_estimation: '仮評価するかどうか',
  Cargo_estimationAmount: '仮評価額',
  Cargo_CooperateBranchId: '協業支店',
  Cargo_EntrustBranchId: 'Entrusted branch',
  Cargo_CooperateBusinessType: 'コラボレーション取引タイプ ',
  Cargo_BillingWeightActual: '実費重量（チャージ）',
  Cargo_BillingWeightContract: '課金重量（委）',
  Cargo_NumberOfItemsActual: '件数（実績）',
  Cargo_NumberOfItemsContract: '件数（予定）',
  Cargo_VolumeActual: '実容積（m³）',
  Cargo_VolumeContract: '予定容積（m³）',
  Cargo_GrossWeightContract: '毛重量（予定）',
  Cargo_GrossWeightActual: '毛重量（実績）',
  Cargo_CooperateStatus: 'コラボレーション処理状況',
  Cargo_BusinessStatusRemark: 'ビジネス状態コメント',
  Cargo_ChargeStatusRemark: 'チャージ処理状況コメント',
  Cargo_CooperateStatusLog: 'コラボレーション状態の変更ログ',
  Cargo_BusinessStatusLog: 'ビジネス状態の変更ログ',
  Cargo_ChargeStatusLog: 'チャージ処理状況変更ログ',
  Cargo_AssociatedWithMasterTicket: 'マスタチケットを関連付けるかどうか',
  Cargo_SelectCooperateBranch: 'コラボレーションブランチの選択',
  Cargo_CooperateBranchCannotBeEmpty: 'コラボレーションブランチは空にできません。',
  Cargo_CooperateBusinessTypeCannotBeEmpty: 'コラボレーション取引タイプ は空にできません。',
  Cargo_Cooperation: 'コラボレーション',
  Cargo_CooperationReturn: '返却',
  Cargo_CooperateStatusApprovedCanTBeDeleted: 'コラボレーションタスクの処理状況は監査済みで削除できません。',
  Cargo_CooperateSucceed: 'コラボレーションが成功しました',
  Cargo_CooperateLogOperation: '操作内容',
  Cargo_CooperateLogState: '操作後の状態',
  Cargo_CooperateLogContent: '詳細',
  Cargo_AreYouSureReturn: '本当に返品しますか？',
  Cargo_CooperateCreatedDate: 'コラボレーションタスクの作成日',
  Cargo_CooperateReviewSeparately: '選択したレコードにコラボレーションがあるので、個別に確認してください',
  Cargo_CooperateNoPretrialReview: 'コラボレーションビジネスにはレビュー操作内容がありません',
  Cargo_ShowCooperateAll: 'その他のコラボレーション情報',
  Cargo_SettleBranchId: '決済会社',
  Cargo_ShowInternalCharges: '内結を表示します',
  Cargo_InternalCharges: '内結び',
  Cargo_IsCooperate: '連携業務であり、受注支社のみが操作できます',
  Cargo_BranchCooperate: '当社が業務に協力する',
  Cargo_DownLoad_Template: 'テンプレートのダウンロード',
  Cargo_EstimatedWarehousingTime: '入庫予定時刻',
  Cargo_ActualWarehousingTime: '実際の入庫時間',
  Cargo_EstimatedDeliveryTime: '出庫予定時刻',
  Cargo_ActualDeliveryTime: '実際の出庫時間',
  Cargo_SyncWarehouseData: '倉庫データの同期取得',
  Cargo_PleaseEnterActualWarehousingTime: '実際の入庫時間を入力してください',
  Cargo_LockOrderTip: '該当するすべてのビジネスが【監査済み】に更新されます。続行しますか？',
  Cargo_RefreshTcloudToken: 'openTokenの更新',
  Cargo_SeaBooking: '海上予約クラス',
  Cargo_RailwayOperate: '鉄道オペレーション',
  Cargo_IntegratedOperate: '総合物流オペレーション',
  Cargo_Timezone: 'タイムゾーン',
  Cargo_HiddenPlatform: 'プラットフォームの事前作成テンプレートを隠す',
  Cargo_TemplateName: 'テンプレートシナリオ名',
  Cargo_PleaseEnterPlanRemark: 'シナリオの説明を入力してください',
  Cargo_StartLine2: '先頭行（見出しあり）',
  Cargo_PleaseEnterStartLine: '開始行を入力してください',
  Cargo_ImportTableSet: 'テーブル設定のインポート',
  Cargo_PleaseQuery: '検索してください',
  Cargo_EnableFilterRowRule: 'フィルタ行ルールを有効にする',
  Cargo_ImportColumnsFilterOut: '表をインポートすると、表の有効な列のうち、ここで設定した条件を満たすすべての行がフィルタされます。',
  Cargo_SpaceGreaterThan: 'スペースの割合がより大きい',
  Cargo_PleaseEnterHeaderName: 'Excelセル名: インポートするExcel表のヘッダー名を入力してください。',
  Cargo_PleaseEnterHeaderGridNum: 'Excelセル列番号: A、B、AAなど、Excel表にインポートする列番号を入力してください。',
  Cargo_AddNewTemplate: '新規インポートテンプレートシナリオ',
  Cargo_SerialNo: 'No.',
  Cargo_InternalTableName: '内部テーブル名',
  Cargo_ExcelCellName: 'Excelセル名',
  Cargo_DocumentEntry: '通関書類の入力',
  Cargo_QueryTags: 'クエリタグ',
  Cargo_ChargebackManage: 'キャンセル管理',
  Cargo_ReconciliationRule: '決済ルール',
  Cargo_ReconciliationRuleName: '決済ルール名',
  Cargo_MatchFieldSettings: '一緻フィールドの設定',
  Cargo_PleaseSelectField: '比較するときに一緻するフィールドを選択してください',
  Cargo_Relationship: '関係',
  Cargo_And: 'と',
  Cargo_Or: 'または',
  Cargo_MatchingOrder: '照合順序',
  Cargo_MatchFieldName: '一緻するフィールド名',
  Cargo_CompareFieldOperations: '比較フィールドの設定',
  Cargo_SelectFieldToCompare: '比較するフィールド名を選択',
  Cargo_CompareOrder: '比較順序',
  Cargo_CompareField: '比較フィールド',
  Cargo_ComparisonOperation: '比較操作',
  Cargo_MultiRowSumMethod: '複数行の集計方法',
  Cargo_ComparisonSingleLine: '単一行の詳細比較',
  Cargo_AttachFilePlaneOrNot: 'ランダムファイルを添付するかどうか',
  Cargo_FlightDate: 'フライト日',
  Cargo_OtherWarehousingInstructions: 'その他の倉庫の説明',
  Cargo_PhotoShootingAwait: '倉庫に入って撮影するリスト',
  Cargo_PhotoShootingAwaitPallets: 'パネルの写真リスト',
  Cargo_DeleteSelected: '選択を削除します',
  Cargo_StartUploading: 'アップロード開始',
  Cargo_Register: '登録します',
  Cargo_Void: '無効にする',
  Cargo_Unbind: 'バインド解除します',
  Cargo_OrderPassingAgent: '注文代行',
  Cargo_BusinessBookiingAgent: 'ビジネス予約エージェント',
  Cargo_RegisteredDate: '受領日',
  Cargo_EstimatedBackDate: '戻り予定日',
  Cargo_ActualBackDate: '実際の戻り日',
  Cargo_FreightRateM: '運賃M',
  Cargo_FreightRateN: '運賃N',
  Cargo_FreightRate45: '運賃45',
  Cargo_FreightRate100: '運賃100',
  Cargo_FreightRate300: '運賃300',
  Cargo_FreightRate500: '運賃500',
  Cargo_FreightRate1000: '運賃1000',
  Cargo_NewIATAFreightRate: '新規IATA運賃',
  Cargo_EditIATAFreightRate: 'IATA運賃の編集',
  Cargo_DeliveryStation: '納品ステーション',
  Cargo_FlightSchedule: 'フライトスケジュール',
  Cargo_Schedule: 'スケジュール',
  Cargo_ArrivaledTime: '到着時刻',
  Cargo_Voyage: '航期',
  Cargo_MustBEntered: '必須入力',
  Cargo_NewFlight: '新規フライト',
  Cargo_EditFlight: 'フライトの編集',
  Cargo_OneWayPort: 'ワンウェイポート',
  Cargo_SecondPort: '二程港',
  Cargo_ThirdPort: '三程港',
  Cargo_TransshipmentPort: '輸送港',
  Cargo_NewLine: '新規ライン',
  Cargo_EditLine: '線路の編集',
  Cargo_NewAirTransportationArea: '新しい航空輸送エリア',
  Cargo_EditAirTransportationArea: '航空輸送エリアの編集',
  Cargo_RegionalPorts: '地域の港',
  Cargo_OriginRegionCode: '出発地域コード',
  Cargo_TargetRegionCode: 'ターゲットリージョンコード',
  Cargo_NewRoute: '新規ルート',
  Cargo_ResponsibilityList: '責任リスト',
  Cargo_ResponsibilityInformation: '役割情報',
  Cargo_ResponsibilityStep1: '手順1: 役割基本情報の入力',
  Cargo_ResponsibilityStep2: '手順2: 航路の選択',
  Cargo_ResponsibilityStep3: '手順3: 航空会社の選択',
  Cargo_ResponsibilityStep4: '手順4: 予約クラスの性質を選択する',
  Cargo_ResponsibilityStep5: '手順5: 空港の選択',
  Cargo_ResponsibilityStep6: '手順6: 販売の選択',
  Cargo_ResponsibilityStep7: '手順7: 役割情報の決定',
  Cargo_ResponsibilityNew: '新規操作内容ロール',
  Cargo_ResponsibilityEdit: '操作内容ロールの編集',
  Cargo_QueryType: 'クエリタイプ',
  Cargo_NotClearedToday: '前日の未申告オフ',
  Cargo_ToBeClearedToday: '当日通関当日便',
  Cargo_DeclarationTheSameDay: '当日の通関',
  Cargo_InculdeHistoricalData: '履歴データを含む',
  Cargo_DeclarationTracking: '通関追跡',
  Cargo_FlightTracking: 'フライト追跡',
  Cargo_ModifyDeclarationBatches: '通関状態の一括変更',
  Cargo_PrintedTag: 'タグ付けされています',
  Cargo_PrintTag: 'ラベルの印刷',
  Cargo_CheckData: 'チェックデータ',
  Cargo_AWBQuantity: '作成件数',
  Cargo_AWBWeight: '単位あたりの重量',
  Cargo_AWBVolume: 'シングルボリュームを作成する',
  Cargo_GoodsSize: '貨物のサイズ',
  Cargo_ActualFlight: '実際のフライト',
  Cargo_OnwardInformation: '継続情報',
  Cargo_AttachmentDescription: '添付ファイルの説明',
  Cargo_CustomsDeclarationStatus: '通関処理状況',
  Cargo_NumberDeclaration: '通関件数',
  Cargo_DeclarationGrossWeight: '通関時の総重量',
  Cargo_CustomsDeclarationRemarks: '通関コメント',
  Cargo_DeleteAccountingEntry: 'エントリの削除',
  Cargo_Assets: '資産',
  Cargo_LineNo: '行次',
  Cargo_LiabilitiesOwner: '負債と所有者（または株主）資本',
  Cargo_LineNo2: '行次',
  Cargo_OpeningAmountOfTheYear2: '年初数',
  Cargo_PeriodEndAmount2: '期末数',
  Cargo_AmountOfMonth: '今月の発生金額',
  Cargo_AmountOfYear: 'この年の累計金額',
  Cargo_TrackingTipOne: 'このアイコンはB2Bシステムで使用されます！',
  Cargo_TrackingTipTwo: '注: 白いpng形式で、サイズが500KB以下のアイコンをアップロードすることをお勧めします。',
  Cargo_WarehouseMapTip: '注: 倉庫マップの画像形式はPNG/JPGをアップロードすることをお勧めします。',
  Cargo_UploadDataSizeMore500KB: 'ファイルサイズは500KBより大きくできません！',
  Cargo_RuleNotesTip: 'コメントを入力すると、ユーザーは使用中に関連するコメントのヒントを確認できます。',
  Cargo_MainOrderRegistr: 'マスタ登録',
  Cargo_MainOrderStart: 'メインシートの開始番号',
  Cargo_TotalCopies: '合計コピー数',
  Cargo_LastUpdateTime: '最終更新時刻',
  Cargo_AddBranch: '支社を追加します',
  Cargo_CopyBranch: '支社をコピーします',
  Cargo_EORIDetail: 'EORI 詳細です',
  Cargo_DeleteEORITip: 'EORI削除後復旧できません。削除確認?',
  Cargo_EORINotNull: 'EORI空にはできません',
  Cargo_EORINotDuplicate: 'EORI繰り返してはいけません',
  Cargo_AddDept: '部署を追加します',
  Cargo_BranchCnName: '支社の氏名',
  Cargo_ChineseAddress: '中国語アドレス',
  Cargo_BranchEnName: '支社の英語名',
  Cargo_BranchCode: '支社の番号',
  Cargo_PostalCode: '郵便番号',
  Cargo_Email: 'メールアドレス',
  Cargo_LocalCurrency2: '現地通貨',
  Cargo_DefaultAirport: 'デフォルト空港',
  Cargo_DefaultHarbor: 'デフォルトの港',
  Cargo_DefaultTimeZone: 'デフォルトタイムゾーン',
  Cargo_RMBAccount: '支払人民元口座',
  Cargo_USDAccount: '支払米ドル口座',
  Cargo_ReceiveRMBAccount: '受取人民元口座',
  Cargo_ReceiveUSDAccount: '受取米ドル口座',
  Cargo_DefaultPaymentAccount: '支払デフォルト',
  Cargo_DefaultReceiveAccount: '受取デフォルト',
  Cargo_OverseasBillingAddress: '海外請求先アドレス',
  Cargo_DomesticBillingAddress: '国内請求先アドレス',
  Cargo_OverseasEDICode: '海外EDIコード',
  Cargo_ValueAddedTaxRate: '割増税率',
  Cargo_InvoicingTaxRate: '請求税率',
  Cargo_SettleEmail: '決算メール',
  Cargo_TaxationSystemAPIAddress: '税システムインタフェースアドレス',
  Cargo_TaxControlMachineNo: '税コントロール番号',
  Cargo_ElectronicInvoicePlatformCode: '電子チケットプラットフォームコード',
  Cargo_ElectronicInvoice: 'Eチケットのパスワード',
  Cargo_ElectronicInvoiceTaxpayer: '電子チケット納税者識別番号',
  Cargo_ElectronicInvoiceAuthCode: '電子チケット納税者承認コード',
  Cargo_ElectronicInvoiceRequestAddress: 'チケットサービス要求アドレス',
  Cargo_InvoiceCancellationRequestAddress: '請求書無効請求先アドレス',
  Cargo_EFreighAMSAccount: 'E-Freigh（AMSアカウント）',
  Cargo_EFreighACIAccount: 'E-Freigh（ACIアカウント）',
  Cargo_Preview: 'プレビュー',
  Cargo_NewBranchInformation: '新しい支社情報',
  Cargo_AssociatePartners: '関連パートナー',
  Cargo_AddRole: 'ロールの追加',
  Cargo_DepartmentCode: '部門コード',
  Cargo_JobNumberCodeField: 'ジョブ番号エンコーディングフィールド',
  Cargo_SettlementCompanyIsOrNot: '決済会社かどうか',
  Cargo_Introduction: 'はじめに',
  Cargo_EnableOpen: 'オープン',
  Cargo_DisableOpen: '閉じる',
  Cargo_GeneralSettings: '本社設定を適用する',
  Cargo_ControlMode2: '製御モード: ',
  Cargo_ReminderMode: 'リマインダーモード',
  Cargo_LockMode: 'ロックシングルモード',
  Cargo_Notification: '通知アラート: ',
  Cargo_LockingControl: 'ロックコントロール: ',
  Cargo_Event: 'イベント',
  Cargo_NotificationMethod: '通知方法',
  Cargo_NotificationObject: '通知オブジェクト',
  Cargo_BLRelease: '船荷証券のリリース',
  Cargo_NoLock: 'ボタンを押さない',
  Cargo_NewOrCopyJob: '新規/コピー正式業務',
  Cargo_LockAfterSaving: '保存後にロック',
  Cargo_CannotBeSaved: '保存できません',
  Cargo_JobSheetIsLocked: 'ビジネスがロックされています',
  Cargo_JobSheetIsUnlocked: 'ビジネスがロック解除されました',
  Cargo_CreditLimitExceeded2: '信控超過',
  Cargo_CreditLimitChanged: '信管変更',
  Cargo_CreditControlManager: '信控主管',
  Cargo_CreditForewarning: '情報統制警報です',
  Cargo_PaymentPeriodForewarning: '早期警報です',
  Cargo_TemplateManagement: 'テンプレート管理',
  Cargo_TemplateTypeManagement: 'テンプレートタイプ管理',
  Cargo_ConfigurationManagement: '構成管理',
  Cargo_MappingManagement: 'マッピング管理',
  Cargo_InitializeTemplateManagement: 'テンプレート管理の初期化',
  Cargo_BusinessStatusManagement: 'ビジネス状態管理',
  Cargo_TriggerTypeManagement: 'トリガタイプ管理',
  Cargo_FileTypeManagement: 'ファイルタイプ管理',
  Cargo_DefaultValueManagement: 'デフォルト値の管理',
  Cargo_ValidationRuleConfiguration: '検証ルールの構成',
  Cargo_EDITemplateSettings: 'EDI設定',
  Cargo_OnlineShippingOrderSettings: '海上輸送のオンライン注文設定',
  Cargo_RouteAndWarehouseConfiguration: '航路/港のプリセット構成',
  Cargo_PushServiceConfiguration: 'プッシュサービスの設定',
  Cargo_CustomInvoiceRemarks: '請求書カスタムコメント',
  Cargo_EmailTemplateManagement: 'メールボックステンプレート管理',
  Cargo_BillOfLadingConfiguration: 'ドロップ構成',
  Cargo_BranchBankAccount: '支店銀行口座番号',
  Cargo_SetRMBAccount: 'デフォルトのRMBアカウントにする',
  Cargo_SetUSDAccount: 'デフォルトのUSDアカウントに設定',
  Cargo_SetReceiveRMBAccount: '受取人民元口座に設定',
  Cargo_SetReceiveUSDAccount: '受取米ドル口座に設定',
  Cargo_SetDefaultPaymentAccount: 'デフォルト支払口座を設定',
  Cargo_SetDefaultReceiveAccount: 'デフォルト受取口座を設定',
  Cargo_ShortName: '短縮名',
  Cargo_Instructions: '説明',
  Cargo_BankChineseAddress: '銀行の中国語アドレス',
  Cargo_BankEnglishAddress: '銀行の英語アドレス',
  Cargo_BankCode: '銀行口座番号',
  Cargo_HeaderTitle: '所属ヘッダータイトル',
  Cargo_ClosingAccountRecord: '会計レコードを閉じる',
  Cargo_ClosingAccountReview: '会計監査のクローズ',
  Cargo_SelectClosingAccountDate: '会計処理日の選択',
  Cargo_EditConfigurationItem: '設定項目の編集',
  Cargo_EditConfigurationDefinition: '構成定義の編集: ',
  Cargo_CreditLimitExceededApproval: '与信管理が超過した後、自動的にロック解除または手動で承認されるまで作業指示をロックします',
  Cargo_CreditOnlyReminder: '与信管理が超過した場合、通知のみが送信され、作業指示はロックされません',
  Cargo_OperationExecutive: 'オペレーションエグゼクティブ',
  Cargo_SalesExecutive: '営業責任者',
  Cargo_CreditControlSupervisor: '信控主管',
  Cargo_BusinessCustomerService: 'ビジネス顧客サービス',
  Cargo_EmailsAndReminders: 'メールとリマインダー',
  Cargo_Bell2: '構内ベル',
  Cargo_Email2: 'メール',
  Cargo_BatchAddRolePermissions: 'ロール権限の一括追加',
  Cargo_RoleName: 'ロール名',
  Cargo_PermissionName: '権限名',
  Cargo_PermissionCategory: '権限クラス',
  Cargo_PermissionType: '権限タイプ',
  Cargo_PermissionPoint: 'アクセスポイント',
  Cargo_UpdatePermissionGroups: '権限グループの更新',
  Cargo_Personal2: '個人',
  Cargo_DepartmentGroups: '部門グループ',
  Cargo_GreaterRemove: '削除>>',
  Cargo_LessAdd: '<',
  Cargo_PleaseEnterNameEtc: '氏名、英語名、メールアドレスなどのあいまいなクエリを入力してください...',
  QuickSearchUser: 'クイック検索: ログイン名、中国語名、英語名、メールアドレス',
  Cargo_Expired: '期限切れになりました',
  Cargo_NearExpiration: '臨期',
  Cargo_NotVetDueEytended: '期限切れ/延期なし',
  Cargo_History: '歴史',
  Cargo_QuickSearchContractNumber: 'クイック検索: 契約番号',
  Cargo_Reminder30Day: '提示: 30日以内にシステムが臨期に設定されます',
  Cargo_PleaseSelectContractRecord: '契約レコードを選択してください。',
  Cargo_ContractAgreement: '契約書',
  Cargo_WhetherBookingConfirmation: '予約済みの章をアップロードしましたか',
  Cargo_IsContractAgreementUploaded: '契約書がアップロードされたかどうか',
  Cargo_ContractProhibitedOperated: '契約は更新されました。操作は禁止されています',
  Cargo_NeedToUpdateOrNot: '更新が必要かどうか',
  Cargo_ContractCreator: '契約作成者',
  Cargo_ContractCreationTime: '契約作成時間',
  Cargo_PartnerCreation: 'パートナー作成者',
  Cargo_ContractAuditor: '契約監査人',
  Cargo_ContractAuditTime: '契約監査時間',
  Cargo_TimeLeftUntilExpiry: '期日までの残り',
  Cargo_DayRemind: '日のリマインダ',
  Cargo_NoteReminderMethod: '注: リマインダ方法は「システムリマインダ」で、有効期限の2日前にリマインダされます',
  Cargo_ProhibitBusinessConfiguration: 'ビジネス構成の作成を禁止: ',
  Cargo_SettlementMethodGreaterThan0: '決算方法: 毎月の指定日、または会計期間が0より大きい',
  Cargo_ViewContract: '契約の表示',
  Cargo_PaymentTermPeriod: '会計期間',
  Cargo_WeekSettlement: 'Weekly Payment',
  Cargo_EveryMonth: 'Every month',
  Cargo_Day: 'day',
  Cargo_CAN_NOT_APPROVED: '選択されたデータには{0}状態のビジネスが含まれています。監査は許可されていません。チェックしてください！',
  Cargo_CAN_NOT_CANCEL_APPROVED: '選択されたデータには{0}状態の業務が含まれています。状態の業務は、審査を取り消すことができません。チェックしてください！',
  Cargo_HasOneOnly: 'レコードを1つだけ選択してください！',
  Cargo_CloseAndCopySerialNumber: '通し番号を閉じてコピーします',
  Cargo_QuickSearchBillPayment: 'クイック検索: 支払請求番号',
  Cargo_AmsNoTooltip: 'EDIメッセージを送信する場合、AMSNO文字数は12桁を超えないようにしてください。',
  Cargo_AmsNoEFreightTooltip: 'EDIメッセージを送信する場合、AMSNO文字数は12桁を超えないようにしてください、送信時にNvocc Scacに等しい接頭辞が除去されます。',
  Cargo_AmsNoLengthTooltip: 'AMSNO文字数は12桁を超えています。送信を続行しますか？',
  Cargo_VoyageFlightLengthTooltip: 'The Voyage cannot exceed 5 characters',
  Cargo_AmsUnitTypeTip: 'Can maintain the "Counter terrorism packaging code" mapping code in the mapping configuration',
  Cargo_VoyageFlightSpecialCharactersTooltip: 'Voyageフィールドに特殊文字があります。送信を続行しますか？変更してから送信することをお勧めします！',
  Cargo_BargeRemarks: '支線バージの注釈',
  Cargo_CalcRuleNotes: '計算ルールのコメント',
  Cargo_Pending: '保留中',
  Cargo_Processing: '処理中',
  Cargo_Completed1: '完了しました',
  Cargo_Revoked: '取り消されました',
  Cargo_StartTime: '開始時間',
  Cargo_StartDate: '開始日',
  Cargo_ProcessName: 'プロセス名',
  Cargo_ApprovalSerialNumber: '承認通し番号',
  Cargo_ApprovalDate: '承認日',
  Cargo_Approver: '承認者',
  Cargo_ApprovalTemplate: '承認テンプレート',
  Cargo_ProcessingStatus: '処理状態',
  Cargo_PleaseFill: '記入してください',
  Cargo_PleaseMaintain: 'メンテナンスしてください',
  Cargo_MessageNotificationMethod: 'メッセージの通知方法',
  Cargo_AreYouSureAboutTheModificationProcess: 'プロセスを変更しますか？',
  Cargo_AreYouSureAboutTheModificationProcessTips: '修正が確認されると、処理中のプロセスは開始時のプロセスに従って続行されます。その後に開始されるプロセスは、変更されたプロセスに従って実行されます。',
  Cargo_SetUpTheProcessTriggerCondition: 'プロセスのトリガ条件を設定してください。',
  Cargo_CurrentApprover: '現在の承認者',
  Cargo_Initiator: 'イニシエータ',
  Cargo_ApprovalRecord: '承認レコード',
  Cargo_SelectTheApprover: '承認者の選択',
  Cargo_RoleSelection: 'ロール選択',
  Cargo_ReviewTheProcessRecord: 'プロセスレコードの表示',
  Cargo_BatchApproval: '一括承認',
  Cargo_BatchReject: '一括拒否',
  Cargo_TerminateTheProcess: 'プロセスの終了',
  Cargo_ApprovalComments: '承認コメント',
  Cargo_ApprovalTime: '承認時間',
  Cargo_ApprovalCommentsRecord: '承認コメントレコード',
  Cargo_IInitiated: '私が開始しました',
  Cargo_IDealWithIt: '私が処理した',
  Cargo_SubmitAPaymentRequestForApproval: '支払要求承認の発行',
  Cargo_ReviewTheApprovalProcess: '承認プロセスの表示',
  Cargo_Committed: 'コミットされました',
  Cargo_Agreed: '合意済み',
  Cargo_Opinion: '意見',
  Cargo_ReviewWithdrawal: 'レビューの取り消し',
  Cargo_ProcessRevocation: 'プロセスの取り消し',
  Cargo_AlreadyWithdraw: '取り下げました',
  Cargo_NoHandlingRequired: '処理不要',
  Cargo_MyApprovals: '私の承認事項',
  Cargo_ApprovalsThatIInitiated: '私が開始した承認',
  Cargo_ApprovalsThatIHandle: '私が処理した承認',
  Cargo_CreateProcess: 'プロセスの作成',
  Cargo_EditProcess: 'プロセスの編集',
  Cargo_CopyProcess: 'プロセスのコピー',
  Cargo_DeleteProcess: 'プロセスの削除',
  Cargo_ProcessComment: 'プロセスコメント',
  Cargo_RevertProcessStatus: 'プロセスの状態を取り消します',
  Cargo_RevertProcess: 'プロセスを取り消します',
  Cargo_RejectProcess: 'プロセスを拒否します',
  Cargo_NotificationEmailCC: 'メッセージ通知メールのCC',
  Cargo_Irrevocable: '取り消し不可',
  Cargo_EstimateListQuery: '予測一覧の照会',
  Cargo_MappingConfiguration: 'マッピング設定',
  Cargo_CreateEstimate: '予測を作成',
  Cargo_SendSharingCenter: '共有センターに送信',
  Cargo_GenerateExpenseAmount: 'Generate Expense Amount',
  Cargo_GenerateExpenseMode: 'Generate Expense Mode',
  Cargo_GenerateInReceivables: 'Generate in Receivables',
  Cargo_GenerateInPay: 'Generate in Payables',
  Cargo_GenerateAll: 'Generate in Both Receivables and Payables',
  Cargo_ChargeAmount: 'Please enter the generated expense amount',
  Cargo_PushDate: 'プッシュ日',
  Cargo_GetSendResult: '送信結果を取得',
  Cargo_ALittleSend: '零の額の顧客にプッシュ',
  Cargo_MappingEditor: 'マッピングを編集',
  Cargo_NewMapping: '新しいマッピング',
  Cargo_Recipient: 'Recipient',
  Cargo_DataRepetition: '重複するデータがあります',
  Cargo_checkTip2: '{0} or {1}.',
  Cargo_ErrorExcel: 'テンプレートエラー',
  Cargo_ImportException: 'インポート例外',
  Cargo_SelectiveFinanceMonth: 'ファイナンシャル月を選択してください',
  Cargo_FinancialMonth: 'ファイナンシャル月',
  Cargo_PushLog: 'プッシュログ',
  Cargo_ConfirmImport: 'インポートしますか',
  Cargo_NumberOfOriginalCopies: '正本份数',
  Cargo_DisplayDllInformation: 'すべての情報を表示する',
  Cargo_DisplayDifferenceInformation: '差異情報を表示する',
  Cargo_OverrideSystemBillOfLading: 'システム船荷証券を上書きする',
  Cargo_ContainerIdTip: 'コンテナ情報（チェックすると、船荷証券に追加するか、船荷証券のデータを上書きします）',
  Cargo_ContainerInfo2: 'コンテナ情報（チェックして業務に追加、編集可能）',
  Cargo_ContainerTypeQuantityMismatch: 'コンテナタイプ／数量が選択したコンテナ情報と一致しません。確認してください。',
  Cargo_SystemData: 'システムデータ',
  Cargo_RecognitionData: '認識データ',
  Cargo_SETitle: 'Scheduled Departure Time/Estimated Time of Arrival (ETA)',
  Cargo_CurentSETitle: '現在の計画離泊時間（Current ETD）/現在の計画着港時間（Current ETA）',
  Cargo_OriginalSETitle: '当初計画離泊時間（Original ETD）/当初計画着港時間（Original ETA）',
  Cargo_AETitle: 'Estimated Departure Time/Estimated Arrival Time',
  Cargo_SEAtdAtaTitle: '実離泊時間（ATD）/実着港時間（ATA）',
  Cargo_AEAtdAtaTitle: '実際の離陸時間（ATD）/実際の到着時間（ATA）',
  Cargo_UpdateAtdAtaDateTip: '修正が必要な実際の離泊時間、実際の到着時間を入力してください',
  Cargo_UpdateAtdAtaDateTip2: '修正が必要な実際の離陸時間、実際の到着時間を入力してください',
  Cargo_UpdateDateTip: 'Please enter the planned departure time and the estimated time of arrival that need to be modified',
  Cargo_UpdateDateTip2: 'Please enter the estimated departure time and the estimated arrival time that need to be modified',
  Cargo_BusinessNotPositiveOperation: '{0} is not in a positive operational status, time modification is not possible',
  Cargo_SuccessTip: 'Successfully processed {0} items, with 0 failures',
  Cargo_SuccessTip1: 'Successfully processed {0} items, with {1} failures,<br/>Failure explanation: <br/> {2} is not in a positive operational status, time modification is not possible',
  Cargo_SuccessTip2: '成功{0}件、失敗{1}件。<br/>失敗理由: <br/> {2} は操作可能な状態ではないため、修正できません <br/> {3} はハウスビルのみ選択されマスタービル情報が選択されていないため、修正できません',
  Cargo_ErrorCause: 'エラーの原因',
  Cargo_PushMessage: 'プッシュメッセージ',
  Cargo_PushMessageRsp: '受信電文',
  Cargo_ViewMessage: 'メッセージを表示',
  Cargo_Message: 'メッセージ',
  Cargo_BusinessApplicationContext: 'Business Application Context',
  Cargo_ConfigureEmailTemplate: 'Configure Email Template',
  Cargo_SendingPosition: 'Sending Position',
  Cargo_DeleteEmailTip: 'Are you sure you want to delete the selected email templates？',
  Cargo_UpdateEmailTip: 'The email template name cannot be empty!',
  Cargo_UpdateEmailTip3: 'テンプレート名[{0}]は既に存在し、メールテンプレート名は重複できません！',
  Cargo_UpdateEmailTip2: 'Push segment: {0}, recipient: {1}, there is already a related setting, please do not repeat!',
  Cargo_EmailTemplate: 'Email Template',
  Cargo_OrganizeClearing: '決算組織',
  Cargo_DocumentCode: 'ドキュメント番号',
  Cargo_BillDate2: '請求日',
  Cargo_EndDate2: '期限日',
  Cargo_doTip: 'The backend is processing, please refresh the page later to check',
  Cargo_TypeOfExchange: '往来種類',
  Cargo_CurrentAccountCode: '往来口座コード',
  Cargo_PE: '予測/予想',
  Cargo_ENo: '予想番号',
  Cargo_OrderChannel: 'Applicable order channels',
  Cargo_MonthlyFinancial: 'ファイナンシャル月',
  Cargo_DocumentId: 'ビジネスシステムのドキュメントID',
  Cargo_NotInWarehouse: '荷物が倉庫に入庫していません。出庫指示を事前に発行しますか？指示を発行するには「確認」をクリックしてください。',
  Cargo_NotInWarehouse2: '荷物が倉庫に入庫していません。事前に発行された出庫指示を取り消しますか？取り消すには「確認」をクリックしてください。',
  Cargo_OutboundInstructionIssued: '出庫指示が発行されました',
  Cargo_AlreadyOutbound: '荷物はすでに倉庫から出庫され、出庫指示をキャンセルすることはできません。',
  Cargo_SourceSystemCoding: '来源システムのコーディング',
  Cargo_businessShipAgency: 'ビジネス種類(船代)',
  Cargo_CoinsReceivable: '受取金種別',
  Cargo_ArApAmount: '受取/支払金額',
  Cargo_CostItem: 'コストアイテム.コード',
  Cargo_TaxNumber: '税番号',
  Cargo_IsDefaultTitle: 'デフォルトの宛名かどうか',
  Cargo_SingleTitleMode: '単一宛名モード',
  Cargo_MultipleTitleMode: '複数宛名モード',
  Cargo_UnitPrice2: '含税単価',
  Cargo_TaxRateCode: '税率.コード',
  Cargo_Discount: '割引方法',
  Cargo_CanNotChargeTips: 'There are existing non-editable expenses, please handle them in a timely manner!',
  Cargo_RefreshChargeTips: 'There are existing expenses, would you like to refresh the expenses?',
  Cargo_ArAmount: '受取金額',
  Cargo_MonthCode: '月コード',
  Cargo_beforeChange1: 'Estimated profit for the entire ticket before change',
  Cargo_beforeChange2: 'Estimated profit for the entire ticket after change',
  Cargo_TaxPolicyCoding: '税務政策のコーディング',
  Cargo_SendingSharingCenter: '共有センターに送信',
  Cargo_SendingResult: 'プッシュ成功:{0}行,失敗:{1}行',
  Cargo_System2: 'システム',
  Cargo_FileDelete: 'File deletion: Delete',
  Cargo_BillsPayable: '支払請求書',
  Cargo_PaymentSlipDataNo: '支払明細書のドキュメント番号',
  Cargo_Payer: '支払先',
  Cargo_Prepaid: '予約済み',
  Cargo_TypeOfInvoice: '請求書の種類',
  Cargo_UploadInvoiceCloudStatus: '請求書のクラウド処理状況をアップロード',
  Cargo_AccountToBeCredited: '受取元の口座',
  Cargo_BankConnectionNo: '銀行の連絡先/SWIFTコード',
  Cargo_BankConnectionNo2: '連絡先/SWIFT',
  Cargo_OriginalPaymentSlipNo: '元の支払明細書番号',
  Cargo_ProcessNumber: 'プロセス番号',
  Cargo_FinancialPayStatus: 'ファイナンシャル支払請求書の処理状況',
  Cargo_PaymentRequisitionStatus: '支払請求書の処理状況',
  Cargo_DefaultDetailItems: 'Default detail entries',
  Cargo_GeneratePay: '支払請求書を作成',
  Cargo_MergeGeneratePay: 'マージして支払請求書を作成',
  Cargo_PrintChannel: 'Print Channel',
  Cargo_BookingConfirmed: 'Booking confirmed',
  Cargo_OrderRecorded: 'Order recorded',
  Cargo_CreateBillsPayable: '支払請求書を作成',
  Cargo_FinancialPayAreSent: 'ファイナンシャル支払請求書が送信されました',
  Cargo_PaymentRequestSent: '支払請求書が送信されました',
  Cargo_DetailEntryID: '明細分類ID',
  Cargo_PayableSingleAttribute: '支払請求書の属性',
  Cargo_SelectAp2: '支払請求書の請求書抬頭が一致するものを選択してください',
  Cargo_SelectAp: '支払請求書を選択してください',
  Cargo_LookAp: '支払請求書を確認してください',
  Cargo_IdentifyTheCustomsTips: 'There are files that are being parsed or have already been parsed.',
  Cargo_IdentifyTheCustomsDeclaration: 'Identify the customs declaration',
  Cargo_RefreshCustomsDeclaration: 'Refresh the customs declaration',
  Cargo_CustomsActivatedTip: 'The customs declaration recognition service function is not activated.',
  Cargo_CustomsActivatedTip2: 'Insufficient balance, please contact customer service to recharge.',
  Cargo_CustomsDeclarationNo: 'customs declaration number',
  Cargo_AnalysisStatus: 'Analysis Status',
  Cargo_SystemFee: 'system fee',
  Cargo_InsurancePremium: 'insurance premium',
  Cargo_ProcessingFee: 'processing fee',
  Cargo_FOBValue: 'FOB value',
  Cargo_ExportCustomsDeclaration: 'export customs declaration',
  Cargo_Nonstop: 'only consider nonstop flights',
  Cargo_InternationalRoute: 'only consider international routes',
  Cargo_SelectNoDeleteAp: '【支払請求書】がプッシュ済みで、削除できません',
  Cargo_SelectInvoiceAR: '請求書を選択してください',
  Cargo_SelectInvoiceAR2: 'プッシュ済みのデータを選択し、処理状況を取得してください',
  Cargo_SelectNoPushData: 'プッシュされていないデータを選択してください',
  Cargo_SelectNoDelete: '【予測】がプッシュ済みで、削除できません',
  Cargo_SendSharedCenter: '共有センターの処理状況',
  Cargo_SelectInvoiceType: '請求書の種類を選択してください',
  Cargo_EditAp: '支払請求書を編集',
  Cargo_NotPushAP: '受取状況、プッシュする必要がない【ファイナンシャル支払請求書】',
  Cargo_NotPushAP2: '連絡先/SWIFTが空でない場合、送信できません',
  Cargo_AttachmentName: '添付ファイル名',
  Cargo_AccessoriesAddress: '添付ファイルのアドレス',
  Cargo_canNotEdit: '既にプッシュ済みで、編集できません',
  Cargo_GetTheWriteOffResult: 'チェック結果の取得',
  Cargo_RemarkTip1: 'Invoice remarks total more than 230 characters',
  Cargo_RemarkTip2: '非明細開票の場合、発票の宛名と発票の項目名を記入する必要があります',
  Cargo_PortOfTransferCheck: '中転港を選択してください',
  Cargo_BatchServiceLocking: 'Batch service locking',
  Cargo_UnlockServicesInBatches: 'Unlock services in batches',
  Cargo_BindApprovalTemplate: '承認テンプレートのバインド',
  Cargo_ProcessTriggerCondition: 'プロセストリガ条件',
  Cargo_TriggerConditionConfiguration: 'トリガ条件の設定',
  Cargo_ApplicationBusinessDivision: 'アプリケーション事業部門',
  Cargo_ApproverSource: '承認者ソース',
  Cargo_ApproverExecutionMode: '承認者の実行モード',
  Cargo_FirstNodeSupervisorNextNodePreviousApproverSupervisor: '最初のノードはスポンサーのスーパーバイザーで、後続のノードは前のノードの承認者のスーパーバイザーです',
  Cargo_AnyApproverCanHandle: '承認者のどちらかが処理すればよい',
  Cargo_AllApproversAtCurrentNodeRequired: '現在のノードのすべての承認者による処理が必要です',
  Cargo_TheNumberOfApprovalsInProgress: '進行中の承認数',
  Cargo_NotNamed: '名前なし',
  Cargo_AdministratorSettings: '管理者設定',
  Cargo_FormName: 'フォーム名',
  Cargo_NumberOfConfigurableBranches: '設定可能な分岐数',
  Cargo_ExistDocumentPlatformConfig: 'この支社はすでに存在します。このフォームは有効な状態です。確認してから操作してください',
  EnableOrNot: 'Enable or not',
  Cargo_InitiateApproval: '承認の開始',
  Cargo_InitiateBranchCompany: '支社を開始します',
  Cargo_ApplicationBranch1: '適用支社',
  Cargo_InitiateApprovalSuccessfully: '承認が開始されました。',
  Cargo_AreYouSureToInitiateTheApproval: '承認の開始を確認しますか？',
  Cargo_AreYouSureToDo: '{0}を確認しますか？',
  Cargo_InitiateDepartment: '開始部門',
  Cargo_WhetherItIsEnabled: '有効にするかどうか',
  Cargo_Deactivate: '非アクティブ化',
  Cargo_PleaseSelectTenantId: 'プラットフォームIDを選択してください',
  Cargo_PleaseSelectOfficeIds: 'アプリケーションブランチを選択してください',
  Cargo_PleaseSelectDocumentConfigId: 'フォーム名を選択してください',
  Cargo_PleaseSelectBranchCount: '設定可能な分岐数を選択してください',
  Cargo_PleaseSelectUserIds: '管理者設定を選択してください',
  Cargo_DocumentPlatformConfigNote: '注: 管理者は、フォームに関連するすべての承認フローを表示できます。',
  Cargo_AddBranchProcess: '+分岐プロセスの追加',
  Cargo_Priority: '優先度',
  Cargo_TriggerConditions: 'トリガ条件',
  Cargo_PleaseSelectDocumentConfigId2: 'バインドフォームを選択してください',
  Cargo_AddBranchProcessCheck: '現在のフォームの分岐数が上限に達しました。',
  Cargo_BindForm: 'バインドフォーム',
  Cargo_UnknownProcessProcessing: '不明なプロセス処理',
  Cargo_AutoWriteOffAfterApproval: '承認後自動消去するかどうか',
  Cargo_Bell: 'ベル',
  Cargo_NotifierSource: 'CCソース',
  Cargo_PreconditionsForApproval: '事前承認条件です',
  Cargo_RuleConditions: 'ルール条件',
  Cargo_ConditionalItem: '条件アイテム',
  Cargo_ConditionalRule: '条件ルール',
  Cargo_ConditionalValue: '条件の値',
  Cargo_RejectMethod: '拒否方法',
  Cargo_AllowDirectReturnToInitiator: 'イニシエータへの直接返品を許可します',
  Cargo_ReturnToTheInitiatingNode: '開始ノードを返す',
  Cargo_Returned2: '返品されました',
  Cargo_RefuseAndReturnNode: '注: 拒否=前のノードへの返却、返却=元のノードへの返却。',
  Cargo_RefuseTitle: '前のノードに戻る',
  Cargo_ReturnTitle: '元のノードを返す',
  Cargo_BillPaymentUpdateFail: '支払要求の更新に失敗しました。',
  Cargo_OneClickCopy: 'ワンクリックコピー',
  Cargo_OneClickCopyNote: '注: 後で一括照会するために、「ワンクリックコピー」ボタンをクリックしてすべての承認番号をコピーすることができます。',
  Cargo_OneClickCopyNoteBillPaymentApply: '注: 後で一括照会するために、【ワンクリックコピー】ボタンをクリックしてすべての申請番号をコピーできます。',
  Cargo_SubmitException: 'コミット例外',
  Cargo_ApprovalException: '承認例外',
  Cargo_PriceType: '港前価格/幹線価格/最終区間価格を選択してください。少なくとも1つの見積もりタイプを選択してください',
  Cargo_AccountPeriodRemainingDays: '会計期間の残り日数',
  Cargo_WorkflowsBranchCountNotNull: 'ワークフローの分岐数は空にできません',
  Cargo_WorkflowsPlatformConfigRepeat: 'この支社はすでに存在します。このフォームは有効な状態です。確認してから操作してください',
  Cargo_PleaseSelectUser: 'このプロセスの管理者を選択してください',
  Cargo_Initiate: '開始します',
  Cargo_InitiateForm: '開始フォーム',
  Cargo_ApprovalMatters: '承認事項',
  Cargo_SelectApprovalWithSameTemplate: '同じ承認テンプレートの承認事項を選択してください',
  Cargo_SOPPanelNodeNotDisplayed: 'SOPパネルはこのノードを表示しません',
  Cargo_SOPPanelNoDataHide: 'SOPパネルはデータがない場合、自動的に非表示にします',
  Cargo_TaxInputConfig: '仕入税設定',
  Cargo_ReceiptInvoiceTitle: '請求書のタイトル',
  Cargo_ReceiptInvoiceChannel: '請求書のチャンネル',
  Cargo_InvoiceAssociation: '請求書関連',
  Cargo_BoundInvoiceOrNot: '請求書にバインド',
  Cargo_ManualUpdate: '手動更新',
  Cargo_GetInvoice: '請求書を取得する',
  Cargo_InvoiceTime: '請求書発行時間',
  Cargo_SellerName: '売り手名',
  Cargo_SellerTaxNumber: '売り手の税番号',
  Cargo_BuyerName: '買い手名',
  Cargo_BuyerTaxNumber: '買い手の税番号',
  Cargo_InvoicePool: '請求書プール',
  Cargo_InvoicePoolReceiving: 'インボイスプール受票',
  Cargo_WriteOffBank: '売上入金先銀行',
  Cargo_DepartureStation: '始発駅',
  Cargo_DestinationStation: '宛先ステーション',
  Cargo_TransitStation: '経由駅',
  Cargo_TransferStation: '中継局',
  Cargo_SOURCE_CURRENCY_NOT_NULL: '元の通貨は空にできません！',
  Cargo_SOURCE_AMOUNT_NOT_NULL: '元の通貨金額は空にできません！',
  Cargo_imWarning: '現在のjobには、沃行通のチャットグループを開くのに十分な役割がありません。',
  Cargo_ReceiptPaymentOffset: '前払勘定の戻し処理',
  Cargo_InvoicePayableOffset: '運転コストの戻し処理',
  Cargo_CheckFreightTermOne: '"{0}"運送条件の場合、{1}と{2}は空にできません',
  Cargo_CheckFreightTermTwo: '"{0}"運送条件の場合、{1}は空にできません',
  CargoMsg_QQ: 'LINE',
  CargoMsg_CorporateName: 'Corporate name',
  Cargo_EnableSopTemplate: 'Enable Current Sop Template',
  Cargo_UnableSopTemplate: 'Unable Current Sop Template',
  Cargo_EnableSopTemplateConfirm: 'Are you sure to enable the current SOP template？',
  Cargo_UnableSopTemplateConfirm: 'Are you sure to disable the current SOP template? After disabling, the business cannot apply this template. But it will not affect businesses that have already used this template.',
  Cargo_Disabled2: 'Disabled',
  Cargo_Got_It: 'Got it',
  Cargo_RepeatGoldenTaxExport: 'Do not repeat the Golden Tax export.',
  Cargo_CheckMergeExport: '買掛伝票と前払戻し買掛伝票をマージしてエクスポートし、レコードに他の買掛伝票タイプを選択できません。',
  Cargo_DeleteUnApprovedBillTips: '未承認の請求書のみ削除できます！',
  Cargo_EditUnApprovedBillTips: '承認されていない請求書のみ編集できます！',
  Cargo_DeleteUnApprovedInvoiceTips: '未承認請求書のみ削除できます！',
  Cargo_InvalidUnApprovedInvoiceTips: '未承認の請求書のみ無効にできます！',
  Cargo_InvoiceID: '請求書ID',
  Cargo_PleaseSelectNeedInvalidBillPaymentTip: '無効にする必要がある支払申請を選択してください。',
  Cargo_Deleted: '削除されました',
  Cargo_Canceled: 'キャンセル済み',
  Cargo_UpdateCustomerInfo: 'Update customer information',
  Cargo_SyncCustomerData: '顧客データの同期',
  Cargo_Synchronizing: 'Synchronizing, please check later',
  Cargo_Prediction: '予報',
  Cargo_PlaceOfDeliveryRegion: 'Place Of Delivery Region',
  Cargo_IsTransfer: 'Transfer or not',
  Cargo_TotalAmountTax: 'Total tax amount (invoice)',
  Cargo_CustomerNotOwnL: 'The customer subsidiary is inconsistent with the current company',
  Cargo_SimilarPartners: 'に似たようななまえ名前の【{0}】など{1}しゃ社がそんざい存在します。',
  Cargo_GoBackSuccess: 'フェッチ成功！',
  Cargo_SendBackSuccess: '払い戻しに成功しました',
  Cargo_AddSignature: '署名済み',
  Cargo_Appoint2: '委任',
  Cargo_Appointer: '委任者',
  Cargo_ApproverRepeat: '承認者は重複を許可しません',
  Cargo_ApproverAndAppointerRepeat: 'ユーザーは承認者と委任者の両方を持つことはできません',
  Cargo_CancelAddSignature: '自分に「サインオフ」をしてはいけません',
  Cargo_CancelAddSignatureNotSupport: 'ユーザーは「承認済」または「委任済」であり、「署名解除」はサポートされていません',
  Cargo_RuleError: 'フォーム・タイプの変更、プロセス・ルールの構成エラー',
  Cargo_SelectCcTo: 'CC送信者の選択',
  Cargo_SelectSigner: '署名者の選択',
  Cargo_SelectTransferor: '変更者の選択',
  Cargo_TransferSignature: '回転済サイン',
  Cargo_Appointed: '委任済み',
  Cargo_CancelSignature: '署名解除',
  Cargo_OnlySupportedFCL: 'ボックスビジネスのみを一時的にサポート',
  Cargo_CannotExceedThree: 'システム内の異なる箱型は3つを超えており、今回は関連データを送信することができません。速やかにカスタマーサービスに連絡してください。',
  Cargo_AddSignatureSelf: '自分に「おみくじを付ける」ことはできません',
  Cargo_TransferSignatureSelf: '自分を「のりかえ人」として選ぶことは許されない',
  Cargo_AddSignatureCurrentNode: '現在のノードの人に対する「サインオン」は許可されていません',
  Cargo_ApproverNotEmpty: '承認者は空にできません',
  Cargo_AppointerNotEmpty: '委任者を空にすることはできません',
  Cargo_NewWarehouseFee: 'アクティブな操作のみが倉庫手数料を追加できます。',
  Cargo_DefaultCurrencyConversion: 'Default Currency Conversion',
  Cargo_ChargeGroupCheck: 'Charge group[{0}], duplicate selection is not supported. Please readjust and save.',
  Cargo_RelatedChargeItems: 'Related Charge Items',
  Cargo_IncludeSoc: '荷主箱を含むか',
  Cargo_SubsidiaryLedgerDay: 'Subsidiary Ledger Daily Report',
  AccountingDate: 'Accounting date',
  PleaseSelectAccountDate: 'Please select accounting date.',
  CurrentDayAmountTo: 'Total(CurrentDay)',
  TotalReportingCurrencyOfThisDay: 'Total reporting currency of this day',
  Cargo_LastOverseasPort: 'When the unloading port is a US port, it can be directly equivalent to the loading port.\n' +
      'When the unloading port is not a US port, the previous non US port before the US should be filled in here.',
  Cargo_FirstPortOfCall: 'When the unloading port is a US port, it can be directly equivalent to the unloading port.\n' +
      'When the unloading port is not a US port, the first US port passing through the US should be filled in here.',
  Cargo_PoNoExistTips: 'The project number is duplicate. Are you sure to save it?',
  Cargo_Assignment: '分配する',
  Cargo_SetMarginReminder: '余裕アラームの設定',
  Cargo_NumberOfCompanyReminders: '企業からの注意喚起の数',
  Cargo_CompanyTrackingNumLower: '現在の会社番号のマージンが未満【{0}】',
  Cargo_BatchAdd: '大量追加です',
  Cargo_DownloadTemplate: 'テンプレートをダウンロードします',
  Cargo_AssignCompany: '配給会社です',
  Cargo_MawbSource: '主単源です',
  CARGO_CAN_NOT_ASSIGNMENT: '新規処理状況のメインオーダー割り当てのみサポートされます',
  CARGO_Confirm_Assignment: '「割り当てを確認します」',
  CARGO_Confirm_Assignment_Success: '割り当て成功',
  CARGO_Confirm_Assignment_Error: '割り当て失敗',
  CARGO_Only_Invalidated: '無効または非無効なメイン伝票のみサポートされます',
  CARGO_Only_Unbind: 'バインディングされたマスタリストの',
  CARGO_Not_Met_New_Conditions: '以下のマスターシートは新規条件を満たしていません',
  Cargo_Assign_People: 'Assign people',
  AERequiredChecksum: 'One of the main single start number and batch addition must be filled in',
  Cargo_DeleteCharge: '料金を選択しないと、チェックされているすべてのビジネス料金がデフォルトで削除されます',
  Cargo_BusinessOperationUpdateDynamics: 'ビジネスオペレーションの更新の動的',
  Cargo_UpdateDetails: '詳細の更新',
  Cargo_UpdateContent: 'コンテンツの更新',
  Cargo_ChangeLogRecord: '変更ログ',
  Cargo_BusinessNoChangeLogRecord: 'ビジネス番号の変更ログ',
  Cargo_ResultsDisplayedInRed: 'クエリ結果が赤で表示されます',
  Cargo_ChangeLocation: '位置変更',
  Cargo_TimeQuery: '時間クエリー',
  Cargo_BusinessNotExist: 'ビジネスは存在しません！',
  Cargo_UserNoRole: 'このユーザーはロールに関連付けられていません。保存を確認しますか？',
  Cargo_ResultsDisplayedInYellow: 'クエリ結果は黄色で表示されます',
  Cargo_CreateBillYesOrNo: '請求書を生成するかどうか',
  CurrencyReceivable: '{0} receivable',
  CurrencyPayable: '{0} payable',
  CurrencyNotReceived: '{0} not received',
  CurrencyUnpaid: '{0} unpaid',
  CurrencyReceived: '{0} received',
  CurrencyPaid: '{0} paid',
  Cargo_CheckShippingCompanyCargoTracking: 'You have activated the shipping company\'s cargo tracking service. Please select the shipping company and save it to ensure that the field information is successfully obtained.',
  Cargo_PodPortInfoPrompt: 'If you open the shipping company\'s cargo tracking service, Basic tab - Shipping company is a required field, please Properly selecting a shipping company and saving business, ensuring Successfully obtained field information.',
  Cargo_StatementReviewStatus: '請求書のチェック状態です',
  Cargo_StatementReviewer: '請求書の照合人です',
  Cargo_StatementReviewTime: '請求書の見直し時間です',
  Cargo_Port_Departure_Sea: '出港港(海運)です',
  Cargo_Port_Destination_Sea: '仕向港(船便)です',
  Cargo_Port_Departure_Air: '出発港(航空便です)',
  Cargo_Port_Destination_Air: '目的港(航空便です)',
  Cargo_Port_Departure_Rail: '出発港(鉄道)です',
  Cargo_Port_Destination_Rail: '目的港(鉄道)です',
  Cargo_Lob_NEQ_Port: '業務のタイプと港のタイプが一致しません。選択した港を空にします。',
  Cargo_DuplicateLaneCodePleaseTryItAgain: '航空便が重複していますので、再度入力してください。',
  Need: 'Need',
  NoNeed: 'No need',
  Responsible: '責任がある',
  No_Responsibility: '責任がない',
  Cargo_VAT_FEI: 'Electronic invoice (VAT special invoice)',
  Cargo_NORMAL_FEI: 'Electronic invoice (ordinary invoice)',
  Cargo_ViewMoreLogs: '詳細なログの表示',
  Cargo_ThreeDaysLogs: '直近3日間の動作動態',
  Cargo_CarryForward: '繰り越し',
  Cargo_ReconciliationNewVersion: '照合新版',
  Cargo_ApiCallBack: 'apiコールバック',
  Cargo_BWJS: '百旺金穂雲',
  Cargo_TaxEasy: '容津',
  Cargo_YGSH: 'たいようそくこう',
  Cargo_BaiHui: '柏輝金壬',
  Cargo_OverseasSettlementCenter: '海外決済センター',
  Cargo_Receivable2: 'Receivable:',
  Cargo_Payable2: 'Payable:',
  Cargo_NuoNuo: 'NuoNuo',
  Cargo_AISINO_EI: 'AISINO_EI',
  Pigeonhole: 'データアーカイブ',
  Unarchive: 'アーカイブ解除',
  Confirm_Archiving_Business: '選択したビジネスのアーカイブを確認します',
  Confirm_Unarchiving_Business: '選択した業務のアーカイブ解除を確認します',
  Is_Pigeonhole: 'アーカイブ有無',
  Financial_Review_Status: '財務鑑査処理状況',
  Other_Reminders: 'その他の注意',
  Can_Be_Archived: 'アーカイブ可能かどうか',
  Not_Accrued: '未計上',
  Receivables_Not_Fully_Written_Off: '未消込売掛金',
  Payable_Not_Fully_Written_Off: '未消込すべてに対応',
  Financial_Archiving_Settings: '財務アーカイブの設定',
  Financial_Filing_Preconditions: '財務アーカイブの前提条件',
  Financial_Filing_Effective_Effect: '財務アーカイブの効果',
  WHETHER_FINANCIAL_AUDIT: '財務審査かどうか:',
  WHETHER_ACCRUED: '計上済みかどうか:',
  CARGO_RECOGNITION_SETTING: 'OCR recognition Settings',
  AE_IDENTIFY_VENDORS: 'Add/edit identify vendors',
  TENANT_BUSINESS_NAME: 'Tenant business name',
  OFFSHORE_CONSIGNMENT_IDENTIFICATION_SUPPLIER: 'Offshore consignment identification supplier',
  OCEAN_BILL_OF_LADING_IDENTIFICATION_SUPPLIER: 'Ocean Bill of Lading identification supplier',
  DTip: 'Are you sure you want to delete the Settings for this tenant? After removal, the platform Settings are used to identify suppliers',
  FormEditTip: 'Please check the tenant identification Settings that you want to edit',
  FormDeleteTip: 'Select the tenant identification Settings to be deleted',
  OCRRecognition: 'OCR recognition',
  FINANCIAL_RECEIVABLES_VERIFICATION: '売掛/未収金をすべて消し込むかどうか:',
  FINANCIAL_DUE_VERIFICATION: 'すべての消込に対応するかどうか:',
  FINANCIAL_CHARGE: '進行中の費用の追加/変更/削除はありますか:',
  CANCEL_FINANCIAL_AUDIT: '財務審査を取り消す:',
  MODIFY_CHARGE: '料金の改定:',
  MODIFY_JOB: '財務情報を修正する:',
  MODIFY_RATE: '為替レートを修正する:',
  MODIFY_FINANCE_JOB_DATE: '会計処理日/業務日を変更する:',
  GENERATE_RED_INVOICE: 'レッド・パンチ伝票の生成:',
  RECEIVABLE_GENERATES_INVOICE: '売掛/未収金生成可能請求書:',
  COPE_GENERATES_INVOICE: '成可能な請求書への対応:',
  CANCEL_RECEIVABLE_VERIFICATION: '売掛金の消込を取り消す:',
  COPE_RECEIVABLE_VERIFICATION: '未消込の取消:',
  MODIFY_ACCRUAL: '繰り延べを修正する:',
  NON_FILEABLE_BUSINESS: 'アーカイブ不可能な業務がある',
  NOT_FULLY_COMPLETED: '業務が完全に完了していません。注意を確認してください',
  BUSINESS_CAN_ARCHIVED: 'ビジネスアーカイブ可能',
  ARCHIVE_DATE: 'アーカイブ日',
  NOT_OPERATIONAL: '操作できません。理由:業務はアーカイブされています。',
  CHANGE_CHARGE_IN_PROGRESS: '進行中の「変更費用の審査」は先に完了してください',
  ONLY_NOT_ARCHIVED_TRANSACTIONS: 'アーカイブされていない業務を選別して選択してください',
  ONLY_ARCHIVED_TRANSACTIONS: 'アーカイブされた業務をフィルタして選択してください',
  Cargo_Confirm_Delete: '選択したデータを削除しますか？',
  Cargo_From_Import: 'インレット同期',
  Cargo_From_Export: 'でぐちどうき',
  Cargo_Preplan: 'preplan',
  Cargo_SeaManagerSendPreplan: 'Sea manager (sending pre configuration)',
  Cargo_SeaManagerUpdatePreplan: 'Sea manager (modified pre configuration)',
  Cargo_SeaManagerDeletePreplan: 'Sea manager (delete pre configuration)',
  Cargo_SeaManagerSendingVGM: 'Sea manager (sending VGM)',
  Cargo_WseSendMPreplanQd: 'CW (Qingdao Port Master sends manifest)',
  Cargo_WseSendPreplanQd: 'CW (Qingdao Port sends manifest separately)',
  Cargo_WseSendUpdatePreplanQd: 'CW (Qingdao Port changes manifest)',
  Cargo_WseDeletePreplanQd: 'CW (Qingdao Port deletes manifest)',
  Cargo_WseSendPreplanSh: 'CW (manifest sent to Shanghai Port)',
  Cargo_WseSendUpdatePreplanSh: 'CW (Shanghai Port changes manifest)',
  Cargo_WseDeletePreplanSh: 'CW (Shanghai Port deletes manifest)',
  Cargo_WseSendingVGM: 'Sending VGM',
  Cargo_Ams: 'AMS送信',
  Cargo_Aci: 'ACI送信',
  Cargo_Afr: 'AFR送信',
  Cargo_EMainfest: 'eMainfest送信',
  Cargo_Ens: 'ENS送信',
  Cargo_Send_error: '送信例外',
  Approval_Approved_Time: '承認通過時間',
  CheckingExportToImport: 'この業務は輸入に輸出することはできません。チェックして再試行してください。',
  OnlySupportOneCustomsInfo: 'When opening the xinHaoQi interface, only one customs declaration detail is supported',
  CustomsDeclareTime: 'Required customs declaration date',
  SendContainer: 'Push the LCL list to the customs broker',
  IsTheLCLListSent: 'Is the LCL list sent',
  LCLList: 'LCL List',
  iEPort: 'iEPort',
  OceanBillOfLadingNumber: 'Ocean Bill Of Lading Number',
  NoticeBgh: 'Waiting For Notification Of Customs Declaration',
  SelfDeclaration: 'Self Declaration',
  NotSentCustomsFile: 'Have not sent any customs declaration documents. (If other offline channels have already sent it, this reminder can be ignored)',
  FilledMustFill: 'When Fill sends customs declaration information, the [{0}] field must be filled in',
  NoContainerInfo: 'There is no packing information below the box',
  InformationComparison: 'Information Comparison',
  Diff: 'Difference',
  PostLCLTask: 'Post LCL Task',
  ForceDeleteCustomsTips: 'The customs declaration information has been pushed to the xinHaoQi. Are you sure you want to forcibly delete it?',
  AddCustomerFileFirst: 'Please add customs declaration information first',
  Local: 'Local',
  CustomsDocumentPreparation: 'Document preparation',
  PleaseCreateSplitBillFirst: 'Please Create Split Bill First',
  Cargo_DisplaySell: 'Display the seller\'s bank account number',
  Cargo_DisplayBuyer: 'Display the buyer\'s bank account number',
  VGMWeighingAddressCannotBeEmpty: 'VGMロードアドレスは空にできません',
  ExitCustoms: 'Exit Customs',
  ItIsRecommendedToFillInWhenTheExitPortIsShanghai: '(PS: It Is Recommended To Fill In When The Exit Port Is Shanghai)',
  PleaseFillInTheIEPort: 'Please FillIn The IEPort',
  CustomsUnFrozen: 'Customs UnFrozen',
  UnFrozen: 'UnFrozen',
  LCLTaskSent: 'LCL Task Sent',
  LCLTaskNotSent: 'LCL Task Not Sent',
  Unfreeze: 'UnFreeze',
  NotUnfreeze: 'Not UnFreeze',
  CustomerFileHasBeenSent: 'Customer File Has BeenSent',
  NotSendingCustomerFile: 'Not Sending Customer File',
  XhqCustomerState: 'Xhq Customer State',
  unfrozenOffline: 'unfrozen Offline',
  NotifyCustomsUnfreeze: 'Notify customs clearance to unfreeze',
  CargoOwnerSOC: 'Cargo Owner SOC',
  ForwarderSOC: 'Forwarder SOC',
  SOCType: 'SOC Type',
  InvoiceConfig: 'Invoice configuration',
  FEI_NuoNuo: 'Nuonuo\'s full electronic invoice: Nuonuo',
  FEI_Bwjsy: 'Baiwang Jinsui Cloud: BWJSY',
  FEI_Kpzddm: 'Invoice terminal code (kpzddm)',
  FEI_Yhdm: 'User code (yhdm)',
  FEI_NotUse: 'not enabled',
  InvoicerConfig: 'Invoicer configuration',
  InvoiceChannel: 'Invoice Channel',
  Invoicer: 'Invoicer',
  ExtensionNumber: 'Extension number',
  OnlyInvoicer: 'Only corresponding to the invoicer for invoicing',
  AllInvoicer: 'Shared by all users',
  Cargo_ReceiveAmount: 'Accounts receivable amount',
  Cargo_BatchDeleteChargeTips: '費用が選択されていません。選択されたすべての業務費用がデフォルトで削除されます。続行しますか？',
  Cargo_Template_Push: 'テンプレートプッシュ',
  Empty: '（空）',
  Cargo_CanNotSplitMasterJob: 'The consolidation type does not equal to self consolidation or Buyer Console, cannot be split!',
  CustomsBrokerNotEntered: 'Customs broker not entered',
  OpenXhqChat: 'Open xinHaoQi chat',
  OpenXhqChatTips: 'The business has not sent customs declaration information, please send customs declaration information first',
  Cargo_UploadTemplateDataSample: 'テンプレートデータサンプルのアップロード',
  Cargo_SureDeleteTheFile: 'ファイルを削除しますか？',
  Cargo_DownloadContent: 'コンテンツのダウンロード',
  Cargo_ImportOrderTemplateFile: '：受注テンプレートファイルのインポート',
  Cargo_ImportOrderTemplateDataSampleFile: '：受注テンプレートデータサンプルファイルのインポート',
  Cargo_Sample: 'サンプル',
  Cargo_Sample_Tip: '*HQがデータサンプルファイルをアップロードした場合、他の支社がアップロードしていない場合、他の支社はHQのデータサンプルファイルをデフォルトで使用する',
  RespMsg: 'Response Message',
  Cargo_BillPaymentRemarkTip: '* コメントが空の場合、元のデータコメントの内容は上書きされません。',
  Cargo_WarehouseCode: '受入番号コード',
  Cargo_WarehouseCodeLengthLimit: 'エンクロージャ番号生成構成に使用されます。コード文字は最長10ビットです。',
  Cargo_ValueSetting: '値を取る設定',
  Cargo_SettingValuePriority: '値取り優先度の設定',
  Cargo_PleaseToPartnerWarehouseCode: 'パートナー受入番号コードを参照',
  Cargo_LineSeaAir: '航路（海運/空輸）',
  Cargo_LineRailWay: '航路（鉄道）',
  Cargo_BatchDeleteCharge: '一括削除費用',
  Cargo_SetDeleteCondition: '削除条件の設定',
  Cargo_ToBeDeletedCharge: '削除する費用データ',
  Cargo_ToBeDeletedChargeSelected: '費用データの削除が選択されました: ',
  Cargo_MatchCharge: '費用の照合',
  Cargo_SureDelete: 'OK：選択したものを削除します{0}バーのデータ項目ですか。',
  Cargo_ShowChargeDeleteResult: '費用削除結果の表示',
  Cargo_DeletedTips: '削除されました{0}バーデータ',
  Cargo_NotSelectDeletedTips: '費用削除結果の表示',
  Cargo_PleaseMatchDataFirstTips: 'まずデータを照合した後、一括処理が必要なデータを確認してください。',
  Cargo_NotSelectDeleteConditionTips: '料金削除条件が選択されていません！',
  Cargo_BatchEditCharge: '一括編集費用',
  Cargo_SetEditCondition: '調整条件の設定',
  Cargo_ToBeEditCharge: '調整待ち費用データ',
  Cargo_ToBeEditChargeSelected: '調整費用データが選択されました: ',
  Cargo_SureEdit: '調整が選択されていることを確認{0}バーのデータ項目ですか？',
  Cargo_ShowChargeEditResult: '費用更新結果の表示',
  Cargo_EditTips: '更新済み{0}バーデータ',
  Cargo_NotSelectEditTips: '調整が必要な費用データが選択されていません！',
  Cargo_NotSelectEditConditionTips: '料金調整条件が選択されていません！',
  Cargo_EditAmountNoZero: '調整単価は0にできません！',
  Cargo_EditUnitRate: '単価の調整',
  Cargo_EditSettleAccountsTo: '決済対象の調整',
  Cargo_HandleResult: '処理結果',
  Cargo_LoadMore: 'ローリングロードの詳細',
  Cargo_NoMoreData: 'データはありません',
  Cargo_ChargeHasDiffAmount: 'The cost has been processed as a difference and cannot be modified!',
  Cargo_ChargeHasConfirm: 'The cost has been confirmed and cannot be modified!',
  Cargo_ChargeHasVerified: 'The expense has been written off and cannot be modified!',
  Cargo_ChargeHasCommit: 'The fee has been submitted and cannot be modified!',
  Cargo_ChargeHasCreateBillPayment: 'The fee has been created and payment request cannot be modified!',
  Cargo_ChargeHasCreateInvoice: 'The cost has been invoiced and cannot be modified!',
  Cargo_JobStateNotAllowModified: 'ビジネスがコミットされている/レビュー済みで変更は許可されていません！',
  Cargo_InvoiceChargeItemSetup: 'ChargeItem Setup(Vietnam)',
  Cargo_InvoiceChargeUnitSetup: 'ChargeUnit Setup(Vietnam)',
  Cargo_ChargeItemId: 'ChargeItem(Cargoware)',
  Cargo_ChargeItemName: 'ChargeItem Name(Vietnam)',
  Cargo_ChargeUnitCode: 'ChargeUnit(Cargoware)',
  Cargo_ChargeUnitName: 'ChargeUnit Name(Vietnam)',
  Cargo_InvoicingByTaxRate: 'Invoicing By TaxRate',
  Cargo_SureToVoidTheInvoiceVietnam: 'According to Vietnam\'s tax control policy. Please confirm that the customer has been contacted to ensure that the invoice has not been taxed yet. If already bonded, please do not invalidate the invoice. <br/><br/>Are you sure you want to void this invoice?',
  Cargo_RandomPassword: 'Random passwords',
  ChargeSchemeCopy: 'Charge Scheme Copy',
  CompanyCopy: 'Company Copy',
  SourceCompany: 'Source Company',
  QueryChargeScheme: 'Query Charge Scheme',
  CopyChargeScheme: 'Copy Charge Scheme',
  QueryCompany: 'Query Company',
  CopyCompany: 'Copy Company',
  FuzzyQueryOfIdOrName: 'Fuzzy query of ID or name',
  CopyToCompany: 'Copy To Company',
  CopySuccessCount: 'Copy Success {0} Count',
  PleaseSelectTargetTenant: 'Please Select Target Tenant',
  Cargo_TemplateNodeWorkTaskSetting: 'テンプレートのノード作業タスク設定',
  Cargo_WorkTaskEnable: 'オープンノードの作業タスク設定',
  Cargo_SetNodeResponsible: 'このノードの責任を設定する',
  Cargo_DesignatedPosition: '指定部署（部署設置ノードの作業責任により、単一選択のみ）',
  Cargo_SetPreNode: '前置ノードの設定（ノード開始に必要な前置ノード状態）',
  Cargo_SetPreNodeTips: 'ノードのプリアンブルを設定する（最大5つのプリアンブル、との関係）',
  Cargo_HandlingPriorityMarkers: '優先タグの操作',
  Cargo_HandlingPriorityMarkersTips: '処理優先度の設定（最大3つ、設定しない場合はデフォルトで低優先度）',
  Cargo_HandlingPriorityMarkersHigh: '処理優先度を次のように設定します：高い',
  Cargo_HandlingPriorityMarkersMedium: '処理優先度を次のように設定します：中い',
  Cargo_HandlingPriorityMarkersLow: '処理優先度を次のように設定します：低い',
  Cargo_SOPWorkTaskBoard: 'SOP作業進捗ボード',
  Cargo_High: '高: ',
  Cargo_Medium: '中: ',
  Cargo_Low: '低: ',
  Cargo_SopBusinessFlowDashboard: 'SOP業務フローボード',
  Cargo_WarnTodoList: 'アラート事項',
  Cargo_BpmTodoList: '承認事項一覧',
  Cargo_BusinessTime: 'ビジネス時間',
  Cargo_HandleLevel: '処理レベル',
  Cargo_PreNode: 'フロントノード',
  Cargo_PriorityHigh: '高い優先度',
  Cargo_PriorityMedium: '中優先度',
  Cargo_PriorityLow: '低優先度',
  Cargo_SetDefaultDisplayItem: 'デフォルト表示に設定',
  Cargo_PreNodeRepeat: 'プリノード構成の繰り返し',
  Cargo_PriorityRepeat: '優先設定では、【条件項目＋トリガ方式＋日付】を繰り返すことはできません',
  Cargo_TrackingIconTip: 'このアイコンは、B 2 BシステムおよびSOP作業タスクのカンバンとして使用されます！',
  Cargo_LoadData: '更新',
  Cargo_TemplateNodeMergeShow: 'テンプレートノードのマージ表示',
  Cargo_PortPlaceOfDeparture: '出荷港/出荷地',
  Cargo_PortPlaceOfDischarge: '陸揚げ港/陸揚げ地',
  Cargo_MsgClassifyManager: 'メッセージ分類管理です',
  Cargo_BellMsg: 'ベルニュースです',
  QuickSearchMsgClassify: '名称を入力してぼかし検索をお願いします',
  Cargo_GroupingDimensionForRate: '「グループ化条件」は「税率」と同じで、「値」は「数値」として入力する必要があります。',
  Cargo_CheckAccountSetBranchId: '現在のアカウントセットが属する支店が現在の支店または親支店に属していない場合、運用を継続する必要がありますか?',
  Cargo_BillPayment: '支払請求書',
  Cargo_MakeInvoice: 'インボイス請求書',
  Cargo_JobCharge: '事業費請求書',
  Cargo_MblTip: '6～30文字の大文字と数字を入力してください',
  Cargo_VesselTip: '文字、数字、「.」、「-」、「スペース」を入力してください',
  Cargo_VesselTip2: '中国語と全角文字は入力できません',
  Cargo_VoyageTip: 'V.航空便を持たないように入力してください',
  Cargo_ShippingCompanyTip: '船司を選んでください',
  Cargo_CarrierAgentTip: '船代を選択してください',
  Cargo_SailingDateTip: '出航日を入力してください',
  Cargo_PortOfLoadingHgjTip: '海管家は上海港発送のみをサポート',
  Cargo_PortOfLoadingWsTip: '出発港を選んで、上海、青島を支持してください',
  Cargo_PortOfLoadingTip: '港の大文字英字フルネームを選んでください',
  Cargo_PortOfDischargeTip: '陸揚げ港を選択してください',
  Cargo_PortOfDestinationTip: '目的港を選択してください',
  Cargo_PortOfDestinationTip2: '港の大文字英字フルネームを選んでください',
  Cargo_BlNumberTip: '船荷証券の方法を選択してください',
  Cargo_DispatchingPlaceCodeTip: 'もし南京が商品を受け取って上海を経由すれば、出荷地は南京に記入する',
  Cargo_DispatchingPlaceCodeTip2: '出荷先を選択してください',
  Cargo_ShipperEnterpriseNameTip: '140以内の文字を入力してください',
  Cargo_ShipperEnterpriseNameTip2: '70以内の文字を入力してください',
  Cargo_ShipperContactsTip: '20文字以内の電話番号を入力してください',
  Cargo_CopyNotifier: '通知者のコピー',
  Cargo_CopyRecipient: '受取人のコピー',
  Cargo_InputIMO: 'IMO番号を入力してください',
  Cargo_InputBLFreightTermTootip: '運送条件を選択してください',
  Cargo_PureNumbers: '純数値を入力してください',
  Cargo_DefaultShanghai: 'デフォルトSHANGHAI｜CNSHA、変更不可',
  Cargo_IMO: 'IMO番号',
  Cargo_DangerousGoodsCheck: '{0}と記入しましたが、貨物種別は「一般貨物」を選択しているので、確認して再送してください',
  ChinaPostProductConfiguration: 'China Post Product Configuration',
  AllowSaleProduct: 'Allow Sale Product',
  NewChargeGroup: 'New Charge Group',
  ChargeMapping: 'Charge Mapping',
  ChargeMappingFuzzySearch: 'Please enter the transmission charge code or name for ambiguous query',
  RailwayUse: 'Railway use',
  FullOrInside: 'Full Or Inside',
  TransmitChargeName: 'Transmit Charge Group',
  TransmitChargeCode: 'Transmit Charge Group Code',
  MaintainerRemarks: 'Maintainer Remarks',
  AllowSaleProductNotNull: 'Allow Sale Product not selected',
  TransmitChargeNameNotNull: 'Transmit Charge Group not selected',
  FullOrInsideNotNull: 'Full Or Inside not selected',
  Cargo_TaxRateNotNull: 'Please fill in the tax rate',
  PushOrNot: 'Push or not',
  Cargo_BusinessLeaderCompanyPrePort: '港前ビジネスリーダー会社',
  Cargo_BusinessLeaderDeptPrePort: '港前ビジネスリーダー部門',
  Cargo_BusinessLeaderCompanyEndPort: '後方ビジネスリーダー会社',
  Cargo_BusinessLeaderDeptEndPort: '後方ビジネスリーダー部門',
  Cargo_CurrentNode: 'Current Node',
  Cargo_WorkNode: 'Work Node',
  Cargo_EditStateTip: 'Are you sure to modify the node status of {0} selected data items?',
  Cargo_BpmSubmitDuplicated: 'the current document already has an approval form. please do not resubmit',
  Cargo_TempCreditApply: '仮の信用制御申請書',
  Cargo_PartnerName: 'パートナー名',
  Cargo_ContractAmount: '契約額',
  Cargo_ContractAccountingPeriod: '契約期間',
  VerificationSheetRequired: 'Verification sheet required',
  Cargo_TransportSource: '運行リソース',
  Cargo_CustomerExpandMode: 'タクト方式',
  Cargo_SubmitTempCreditTip: '暫定情報管理の維持暫定情報管理承認プロセスを開始するには、今から承認を開始しますか？',
  Cargo_CustomFields: 'Custom Fields',
  Cargo_CustomerCode: 'Voucher system customer/supplier code',
  Cargo_NoHasFinanceCode: 'The corresponding invoice header does not have a corresponding "voucher system customer/supplier code" for UFIDA.',
  Cargo_MultiCurrency: 'The selected invoice has multiple currencies.',
  Cargo_YongYouDeleteTip: 'The current invoice has been pushed to UFIDA. To proceed, please go to the voucher system and delete the corresponding record. Are you sure you want to proceed?',
  Cargo_SyncVerifyDoc: 'Synchronize verification of documents',
  Cargo_HasSync: 'The selected data has been synchronized',
  Cargo_OverseaActualAmount: 'Foreign account cancellation data cannot be synchronized with UFIDA.',
  Cargo_MultiInvoiceTitle: 'There is a write off statement that contains multiple invoicing headers. Unable to push to UFIDA, please adjust the data.',
  Cargo_InvoiceTitleMustBeIdentical: 'The invoice header must be the same.',
  Cargo_ChargeChangeApply: '費用変更請求書',
  Cargo_CollectInvoiceApply: '受取申請書です',
  Cargo_HideUnmodifiedFees: '変更されていない費用を隠す',
  Cargo_ChargeChangeTip: '注：現在の変更内容は承認を待っており、今回の変更が終了した後に再度費用調整を行うことができる。',
  Cargo_UniqueIdentification: '一意のID',
  Cargo_CostNumber: '費用番号',
  Cargo_OriginalCostUniqueIdentifier: '原費用一意ID',
  Cargo_OriginalExpenseNumber: '原費用番号',
  Cargo_ChargeChange: '費用変更',
  Cargo_ApprovalProcessForChargeChange: '費用変更申請承認プロセス',
  Cargo_ChargeChangeTip2: 'すみません、今すぐ発起費変更承認を確認しますか？',
  Cargo_ChargeChangeTip3: '注意：今回の承認が終了するまで料金を変更することはできません。',
  Cargo_ViewChangeData: '変更データの表示',
  Cargo_GrossProfitMarginBeforeChange: '変更前粗利益率',
  Cargo_GrossProfitMarginAfterChange: '変更後粗利益率',
  CustomFieldDisplayConfiguration: 'フィールド表示のカスタマイズ',
  Field: 'フィールド',
  ChineseDisplayName: '中国語表示名',
  EnglishDisplayName: '英語表示名',
  FieldNotEmpty: 'フィールドを空にすることはできません',
  ChineseDisplayNameNotEmpty: '中国語表示名が入力されていません',
  EnglishDisplayNameNotEmpty: '英語表示名が記入されていません',
  Cargo_ContractRule: '契約ルール',
  Cargo_ApplicationConditions: '条件の適用',
  Cargo_ConditionValue: '条件値',
  Cargo_ContractWarning: '契約アラート',
  Cargo_ApplicationRules: '規則の適用',
  Cargo_ContractRuleChangeTip: '当現在のルールは一部の契約に適用されています。このルールを適用した契約を新しいルールに変更してから操作してください。',
  Cargo_DailySettlement: '日次決済',
  Cargo_ContractNumber2: '契約番号 ',
  CheckArApDisparity: 'Exist validation for Billing.Please operate AR and AP Bill separately.',
  VASChannelSetting: 'Value added service channel configuration',
  ManifestChannel: 'Pre shipping bill supplier',
  VGMChannel: 'VGM send supplier',
  VASChannelFormEditTip: 'Please check the tenant sending channel settings that need to be edited',
  VASChannelFormDeleteTip: 'Please check the tenant sending channel settings that need to be deleted',
  VASChannelSelectOneTip: 'Select at least one supplier for sending pre allocated manifest/VGM sending supplier',
  VASChannelDeleteTip: 'Are you sure you want to delete the settings for this tenant',
  VASChannelDTip: 'Delete sending channel settings',
  Cargo_PushAddCustomer: 'Push new customers',
  Cargo_ChooseArea: 'Please select region',
  Cargo_AllocationSuccessful: 'Allocation successful',
  Cargo_CreatedSuccessful: 'Created Successfully',
  Cargo_DuplicateCustomerName: 'Duplicate customer name',
  Cargo_ExistFinanceCode: 'Customer code already exists, no need to push it',
  Cargo_EntrustedReceiveInfo: '委任受入情報',
  Cargo_ContainerLoadTypeRailWay: 'Container Load Type(RailWay)',
  ExclusionOffice: 'Exclusion Office Setting',
  Cargo_MultiOrderTip: '複数のデータがある場合は受注を一括生成',
  Cargo_IdentifyTemplateName: 'テンプレート名の識別',
  Cargo_IdentifyTemplateName2: 'テンプレート名の識別：',
  Cargo_TemplateId: 'テンプレートID',
  Cargo_CodeProcessing: 'コード処理',
  Cargo_TestFile: 'テストファイル',
  Cargo_TemplateIdAutomaticallyGenerated: 'テンプレートID（自動生成）：',
  Cargo_TemplateStatus: 'テンプレートの状態:',
  Cargo_DocumentTypeDescription: 'ファイルタイプの説明',
  Cargo_DocumentTypeDescription2: 'ファイルタイプの説明：',
  Cargo_ReadField: '読み取りフィールド',
  Cargo_FieldName: 'フィールド名',
  Cargo_FieldRuleDescription: 'フィールド規則の説明',
  Cargo_PreviewPromptWords: 'プレビュープロンプト語',
  Cargo_Invalid3: '無効です',
  Cargo_Sequence: 'シーケンス',
  Cargo_FieldAdd: 'フィールドの新規作成',
  Cargo_FieldEdit: 'フィールドの編集',
  Cargo_FieldView: 'フィールドを確認する',
  Cargo_PlatformEnterpriseName: 'プラットフォーム企業名',
  Cargo_AccessKey: 'Access Key',
  Cargo_SecretKey: 'Secret Key',
  Cargo_CallBackUrl: 'コールバックアドレス',
  Cargo_PlatformEnterpriseInterfaceConfiguration: 'プラットフォームエンタープライズインタフェース構成',
  Cargo_OcrTemplateConfig: 'OCRテンプレート設定',
  Cargo_OcrCode: '埋め込みコード処理（埋め込みコード二次処理最終リターン結果をAPI出力値として）',
  Cargo_originalValue: '元の値',
  Cargo_DebuggingResults: 'デバッグ結果',
  Cargo_UsageStatistics: '統計の使用方法',
  Cargo_NumberOfSuccessfulCalls: '呼び出し成功回数',
  Cargo_UsingFlowingWater: '流水の使用',
  Cargo_CallTemplateId: '呼び出しテンプレートID',
  Cargo_CallResult: '呼び出し結果',
  Cargo_Template: 'テンプレート',
  Cargo_QueryFlowingWater: '流水の表示',
  Cargo_TemplateId2: 'テンプレートID：',
  Cargo_FileName2: 'ファイル名：',
  Cargo_IdentifyReturnResult: 'リターン結果の識別：',
  Cargo_CustomsChannel: '通関申告書識別仕入先',
  Cargo_IdentifyTheSupplier: '供給業者を識別する',
  Cargo_PleaseSet: '設定してください',
  Cargo_OnlyOneSupplier: '1つのタイプには1つの供給業者しか設定できません',
  Cargo_IdentificationCannotBePerformedTip: '識別タイプが設定されていないため、識別できません。必要がある場合は、カスタマーサービスに連絡してください。',
  Cargo_TemplateSettings: 'テンプレート設定',
  Cargo_IdentificationTip1: '識別タイプに対応する供給業者を設定してください',
  Cargo_PleaseSelectSpecificFields: 'このフィールドを削除するにはOK',
  Cargo_ConfirmToDeleteThisField: '本当にこのフィールドを削除しますか？削除するとインタフェースはこのフィールド情報を返さなくなります',
  Cargo_ValidThisRecognitionTemplate: 'この識別テンプレートを有効に復元しますか？',
  Cargo_InValidThisRecognitionTemplate: '本当にこの構成を無効にしますか？失効後にインタフェースを呼び出すと、データは返されなくなります',
  Cargo_ValidThisRecognitionEnterprise: 'エンタープライズを有効にリストアしますか？',
  Cargo_InValidThisRecognitionEnterprise: 'この企業を無効にしますか？無効になるとインタフェースを呼び出すことができません',
  Cargo_DateErrorTip: '有効期限は有効期限より大きくなければなりません',
  Cargo_ModifyCodeHandle: 'コード処理の変更',
  Cargo_ModifyPromptWords: 'プロンプト語の変更',
  Cargo_CannotEnable: '不有効期間内でないと【有効化】をクリックできません',
  Cargo_InputTokenCount: '大モデル識別input_token数',
  Cargo_OutputTokenCount: '大模型识别output_token数量',
  Cargo_PlsGenerate: '生成してください',
  Cargo_TemplateUsed: 'このテンプレートはお客様に使用されており、編集できません。バインド解除後に編集またはテンプレートをコピーして編集することができます',
  Cargo_SelectOneData: 'コピーするデータを1つだけチェックできます！',
  Cargo_OutputRequirements: '出力要件：',
  Cargo_AnalyticMethod: '解析モード：',
  Cargo_BLNoStatistics: 'BL番号統計',
  Cargo_RemainingQuantity: '残数',
  Cargo_RegistrationDate: '登録日',
  AnalyzeChannelSettings: '解析チャネル設定',
  EmailParsingSettings: 'メール解析設定',
  EmailPasswordAuthorizationCode: 'メールパスワード/認証コード',
  SenderServer: '送信サーバー',
  Port: 'ポート',
  AddOrEditEmail: 'メールの追加/編集',
  EmailPurpose: 'メールの用途',
  EnterCorrectEmail: '有効なメールアドレスを入力してください',
  SelectDeleteEmail: '削除するメールを選択してください',
  DeleteEmailConfirm: '選択したメールを削除してもよろしいですか？削除後、そのメールは解析のために読み取られなくなります。',
  ImportMblNo: 'マスター番号のインポート',
  ApplicableDepartment: '適用部署',
  Cargo_QuoteMethod_ExistingRate: '"既存運賃"の見積もりは撤回できません',
  Cargo_QuoteMethod: '見積もり方法',
  Cargo_ExistingRate: '既存運賃',
  Cargo_CommercialQuote: '商業見積もり',
  Cargo_PrePortQuoteMethod: '港前見積もり方法',
  Cargo_MainlineQuoteMethod: '干線見積もり方法',
  Cargo_EndlineQuoteMethod: '最終区間見積もり方法',
  PleaseSelectApplicableBranch: '適用支社を選択してください',
  Cargo_CheckSetting: '校验设置',
  Cargo_BookNoteFieldName: 'ブックフィールド名',
  Cargo_IfRequired: '必要かどうか',
  Cargo_Channel: 'ルート本',
  Cargo_IfSame: 'コントラストの不一致',
  Cargo_DefaultValue2: 'NULLデフォルト',
  Cargo_BookFieldNameRepeat: 'ブックフィールド名の重複',
  Cargo_BookNoteFieldAndSort: 'ブックの表示フィールドと順序',
  Cargo_IfAutoBooking: '自動的に船室を予約するかどうか',
  Cargo_BookRecognitionResults: 'ステープル識別結果',
  Cargo_ConfirmedBusinessData: '請求情報',
  Cargo_OtherData: 'その他のデータ',
  Cargo_BranchOffice: '支社（BranchOffice）',
  Cargo_ShippingCompany: '運航会社（Shipping company）',
  Cargo_IfAutomaticBooking: '自動購読の場合（IfAutomaticBooking）',
  Cargo_Book: 'に手紙を書く',
  Cargo_GoodNameContainSensitiveWord: '品名には敏感語<span style="color: red">{0}</span>が含まれていますが、予約を続けますか。',
  Cargo_OnlyGenerateJob: 'ビジネスのみ生成',
  Cargo_PleaseReceiveCallback: '領収書を受け取ることに注意してください',
  Cargo_JobProcess: 'ビジネスの進行状況',
  Cargo_IdentificationMethod: 'しきべつモード',
  Cargo_NoNeedSupplementaryInformationBookNote: '補足情報が必要な依頼書はありません',
  Cargo_SupplementaryInformationTip: '【アップロード進捗】が【解析完了】で、【識別ルート】が【CW-マルチモーダル識別】で、【識別タイプ】が【海外委託書】の記録を選択してください',
  CannotBeLongerThan35: '行ごとに35文字以内で区切られた行の置換',
  Cargo_OcrSetTip: 'あなたはまだ何の情報も設定していません。以下のフィールドと検証設定はすべてシステムのデフォルトで、プラットフォームのデフォルト設定を示しています<br/><br/>優先度の設定：適用本社をチェックすると、優先度適用本社＞テナント設定＞プラットフォーム設定',
  Cargo_AutomaticAllocation: '費用の自動配賦',
  Cargo_ChargeAutomaticAllocationConfig: '費用自動配賦構成',
  Cargo_EditAutomaticAllocationConfig: 'マスターチケット費用自動配賦構成の編集',
  Cargo_AddAutomaticAllocationConfig: '新規マスターチケット費用自動配賦構成',
  Cargo_MatchingCriteriaSelection: '一致条件の選択',
  Cargo_AutomaticAllocationRuleConfig: '自動配賦ルール構成',
  Cargo_AllocationNature: '割り当て性質',
  Cargo_HblSingleAllocation: 'HBL一括配賦',
  Cargo_OnlyAllocatedToHblSingle: '並単のみに配賦',
  Cargo_MasterBill: 'マスター・オーダー',
  Cargo_AddEditReceivablePayableFees: '受取および支払費用の追加/編集',
  Cargo_AddEditReceivableFees: '受取費用の追加/編集',
  Cargo_AddEditPayableFees: '支払費用の追加/編集',
  Cargo_AddEditReceivableSpecialFees: '受取特別費用の追加/編集',
  Cargo_AddEditPayableSpecialFees: '支払特別費用の追加/編集',
  Cargo_DeleteReceivablePayableFees: '受取および支払費用の削除',
  Cargo_DeleteReceivableFees: '受取費用の削除',
  Cargo_DeletePayableFees: '支払費用の削除',
  Cargo_ImportReceivablePayableFees: '受取および支払費用のインポート',
  Cargo_ImportReceivableFees: '受取費用のインポート',
  Cargo_ImportPayableFees: '支払費用のインポート',
  Cargo_BusinessTypeError: '選択した伝票業務タイプが一致しないため、変更できません！',
  Cargo_ReceivableSpecialFee: '受取特別料金',
  Cargo_PayableSpecialFee: '支払特別料金',
  Cargo_ReceivablePayableSpecialFee: '受取支払特別料金',
  Cargo_PleaseSetChargeNameAndAllocationType: '費用名と配賦タイプを設定してください',
  Cargo_PleaseSetChargeName: '料金名を設定してください',
  Cargo_PleaseSetAllocationType: '配賦タイプを設定してください',
  Cargo_HasDuplicateConfigItem: '重複構成データがあります！',
  Cargo_ConfirmDeleteTheConfigItem: '構成アイテムを削除しますか？',
  Cargo_ConfirmSaveModifiedInfo: '変更情報を保存しますか？',
  Cargo_InvoiceRepeat: '請求書番号重複',
  Cargo_TurnOffAutomaticAllocation: 'このマスターチケットの自動仮想割り当て料金をオフにして、手動割り当てに変更します！',
  Cargo_RemainingAmountNotEnough: '残高が足りませんので、チャージしてください',
  Cargo_RemainingAmountNotEnough2: 'Insufficient balance, cannot generate business again.',
  Cargo_ExpandAll: 'てんかい>',
  Cargo_PackUp: '<やめる',
  Cargo_OcrTip: 'お知らせ：リスト情報とは業務中に書き込まれたデータのことで、その中で赤のフォント表示の誤りはプラットフォームとマッピングできず、修正後にリストを書き込む必要がある',
  Cargo_OcrTip2: 'ヒント：入力情報は業務に書き込まれるデータであり、赤い文字はエラーを示し、プラットフォームにマッピングできません。',
  Cargo_BillStatusDoesNotMeetPaymentRequestRequirements: '請求書の状態が請求要件を満たしていません。',
  Cargo_ClaimSettlement: '賠償請求',
  Cargo_GetReceiptSettings: '領収書設定の取得',
  Cargo_AddEditReadReceiptMethod: '読取り領収書の新規作成/編集',
  Cargo_ReadReceiptMethod: '読み取りレシート方式',
  Cargo_DeleteReceiptTip: '本当にこの構成を削除しますか？削除後はこのルールに従って領収書を読み込まなくなります',
  Cargo_PleaseInputTitleOrContentTip: 'タイトルまたは本文を入力してください',
  Cargo_BookingState: '船室予約状態',
  Cargo_BookingChannelConfig: '予約チャネル構成',
  Cargo_BookingMode: '船室予約モード',
  Cargo_RpaSupplier: 'RPAベンダー',
  Cargo_BookingChannel: '船腹予約ルート',
  Cargo_ConfirmRejectQuote: '見積もりを拒否しますか？',
  Cargo_MainlineRejectReason: '干線拒否理由',
  Cargo_PortRejectReason: '港前拒否理由',
  Cargo_EndlineRejectReason: '最終区間拒否理由',
  Cargo_WebSite: 'ウェブサイト',
  Cargo_CompanyCode: '会社コード',
  Cargo_ReceiptConfig: '領収書の設定',
  Cargo_EditBookingChannelConfig: '船腹予約チャネル設定の編集',
  Cargo_AddBookingChannelConfig: '新規船腹予約チャネルの設定',
  Cargo_ReceiptConfigCannotBeEmpty: '領収書構成を空にすることはできません',
  Cargo_IndiaLineInfo: 'インド線',
  Cargo_CargoAmount: '商品価値金額',
  Cargo_CargoCurrency: '商品価値通貨',
  Cargo_YdShipCode: '壱束船公司',
  Cargo_SendThisPageEDI: 'このページを送信EDI',
  Cargo_SendAllEDI: 'すべて送信EDI',
  Cargo_SendEDI: '送信するかどうかEDI?',
  Cargo_IsSendAllEDI: 'すべてを送信するかどうかEDI?',
  Cargo_SendEDISucceeded: 'エディ送信成功',
  Cargo_FailedToSendEDI: 'エディの送信に失敗しました',
  Cargo_CheckCanSendEDI: '予約中または予約済みで再送信できません',
  Cargo_OneKeyBooking: 'ワンクリック予約',
  Cargo_OneKeyBookingTip1: '条件を満たした船腹予約業務の開始：<span style="color: blue">{0}</span>バー，【確認】をクリックすると、直接船室予約が開始されます。予約処理状況を表示するには、エディまたは船便の船室予約ページのくじを使用します',
  Cargo_OneKeyBookingTip2: '暖かいヒント：以下の条件を満たす注文はワンクリックで予約を開始します<br/>1）出航日>当日<br/>2）予約状態は“請求済み、未予約”<br/>3）貨物種別：普通品<br/>4）丸綴りタイプ：まるまると太った',
  Cargo_CanNotBooking: '【予約可能条件】に該当する業務がありません',
  Cargo_CurrentlyBooking: '2ヶ月近く船室を予約しています：',
  Cargo_SendSuccess2: '送信成功：',
  Cargo_CallEdiFail: '呼び出し例外：',
  Cargo_ValidFail: '検証エラー：',
  Cargo_TemplateMatchFail: 'テンプレートの一致に失敗しました：',
  Cargo_BookingSendMethod: 'ブッキング送信方式',
  Cargo_BookingSendChannel: '船腹予約配送ルート',
  Cargo_BookingSendDate: '予約発送時間',
  Cargo_BookingReceiptDate: '予約受領時間',
  Cargo_OriginBookingState: '予約元の状態',
  Cargo_NotBooking: '船室を予約しない',
  Cargo_ContinueBooking: '船室の予約を続ける',
  Cargo_ChangeInfo: '情報の変更',
  Cargo_BookingTransportMode: '船腹予約伝送方式',
  Cargo_EdiBookingExportState: 'エクスポート処理状況',
  Cargo_OneKeyBookingTip3: '予約を開始しています。後で特定の予約処理状況を確認できます',
  Cargo_BookingInProgress: '船室を予約しています',
  Cargo_NewSpaceCarrier: '新規空運会社',
  Cargo_AlreadyExistsCheck: '同じデータが既に存在し、保存する必要はありません。',
  Cargo_portOfLoadingSeaport: '荷物情報の積込港（海港）',
  Cargo_portOfDestinationSeaport: '荷物情報の到着港（海港）',
  Cargo_portOfLoadingAirport: '荷物情報の積込空港（空港）',
  Cargo_portOfDestinationAirport: '荷物情報の到着空港（空港）',
  Cargo_shippingCarrier: '輸送業者',
  Cargo_shippingAirline: '航空路線 - 荷物情報',
  Cargo_newEventRecord: 'イベント記録が追加されました',
  Cargo_SelectInquiryToCopy: 'コピーする問い合わせを選択してください',
  Cargo_VerifyStateReceivableDomestic: '国内売掛消込状況',
  Cargo_VerifyStateReceivableOversea: '国外売掛消込状況',
  Cargo_ReturnActualAmountNo: '関連水番号',
  Cargo_ReturnAmount: '返品済金額',
  Cargo_ReturnApplyAmount: '払戻中の金額',
  Cargo_ReturnApplyState: '払戻処理状況',
  Cargo_ReturnApply: '払い戻し',
  Cargo_ReturnApplyCancel: '返金の取り消し',
  Cargo_ReturnApplyAudit: '返金同意',
  Cargo_ReturnApplyReject: '返金拒否',
  Cargo_RemainingClaimedAmount: '残存引受金額',
  Cargo_RefundAmount: '払戻金額',
  Cargo_ReturnApplyCheck: '承認保留中の払戻レコードが存在し、新しい払戻申請を開始できません！',
  Cargo_RemainingClaimedAmountZero: '残りの受領金額は0で、返金はできません！',
  Cargo_ReturnApplyAmountZero: '返金金額は0で返金できません！',
  Cargo_ReturnApplyAuditCheck: '処理状況が承認中のレコードのみを再チェックしてください！',
  Cargo_WaterRefundedNoWriteOff: '請求書返金の記録、受領操作はサポートされていません！',
  Cargo_WaterRefundingNoWriteOff: '返金処理状況は承認中のレコードで、認知操作はサポートされていません！',
  Cargo_WaterRefundedNoCancel: '請求書返金の記録、受領取り消し操作はサポートされていない！',
  Cargo_khEntryActTime: 'カーゴ入国（実際の時間）',
  Cargo_transferDeclareCompletedActTime: '中継先の申告が完了しました（実際の時間）',
  Cargo_khExitActTime: 'カード航空出国（実際の時間）',
  Cargo_khDeclareActTime: 'カード航空通関（実際の時間）',
  Cargo_khReplacementActTime: 'カーポートの交換（実際の時間）',
  Cargo_arrivePodActTime: '目的地に到着（実際の時間）',
  Cargo_arriveClearActTime: 'クリア地点に到達（実際の時間）',
  Cargo_khUnloadingActTime: '荷降ろし（実際の時間）',
  Cargo_CustomerReserveVoyage: 'お客様のスケジュール',
  Cargo_CustomsDeclarationInformation: '請求情報',
  Cargo_CustomsDeclarationCommissionNumber: '通関依頼書番号',
  Cargo_CustomsDeclarationNotExist: '少なくとも1つの【請求情報】を維持してください',
  Cargo_QuantityWeightCubageChange: '件毛体情報の変更、上書きしますか？',
  Cargo_ReferenceNoRepeat: 'VGMにおける参照番号の重複はできません',
  Cargo_CustomerDemandClearanceNumber: '顧客需要関数',
  Cargo_Empty2: '(空)',
  Cargo_QuantityWeightCubage: 'そもうたい',
  Cargo_CustomsDeclarationDeleteTip: '前関数番号は関連通関依頼済みで、削除できません',
  Cargo_CustomsDeclarationValidTip: '請求情報の毛体を0にしてはいけません',
  Cargo_CustomsDeclarationSoNoRepeat: '同一票事業における発注情報の「発注番号」の重複は認められない',
  Cargo_AuditCancel: '本当にレビューをキャンセルしますか',
  Cargo_AuditCancelReason: 'キャンセル理由（レビュー）',
  Cargo_NuoNuoTipOne: '請求ルート=諾の場合、赤沖が自動的に発行されない場合はこの構成項目に1を記入し、自動発行の場合は構成する必要はありません。',
  Cargo_DestinationVehicleNumberOne: '目的地配送車の先頭番号',
  Cargo_DestinationVehicleRegister: '目的地配達車書留',
  Cargo_ConfirmLockLabelBuyingPrice: '購入価格をロックしてもよろしいですか?',
  Cargo_ConfirmLockLabelSellingPrice: '売価をロックしてよろしいですか?',
  Cargo_ConfirmUnlockLabelBuyingPrice: 'ロック解除買取価格が確定しているか',
  Cargo_ConfirmUnlockLabelSellingPrice: '売価ロック解除を確定するかどうか',
  Cargo_PurchasePriceLockedStatus: '買値ロック状態',
  Cargo_SellingPriceLockedStatus: '売価ロック状態',
  Cargo_BatchPurchasePriceLock: '一括買値ロック',
  Cargo_BatchPurchasePriceUnLock: '一括売価ロック',
  Cargo_BatchSellingPriceUnLock: '一括売価ロック',
  Cargo_BatchSellingPriceLock: '一括売価ロック',
  Cargo_NotActiveCompanyCleared: 'このチケットの業務には未アクティブなパートナーが含まれています：{0}。システムは自動的にそれらをクリアしましたので、再度選択して入力してください。',
  Cargo_FBA_SE: 'FBA海上輸送',
  Cargo_FBA_AE: 'FBA航空貨物',
  Cargo_FBA_RE: 'FBA鉄道',
  Cargo_SyncCreditTip: 'この【同期】ボタンをクリックすると、現在のページが要求を満たす一時的な信用制御が直ちに有効になります。限度額、帳簿期間の再計算には一部の遅延がある可能性がありますので、お待ちください。',
  Cargo_SyncTempCreditTip: '一時的なシグナル制御承認フローが存在する場合は、すぐに同期しない。',
  Cargo_OperationInstructions: 'オペレーション指示',
  Cargo_InstructionName: '指示名',
  Cargo_InstructionType: '指示タイプ',
  Cargo_RuleCode: 'ルールコード',
  Cargo_CodeParameterValues: 'コードパラメータ値',
  Cargo_InstructionCode: '指示コード',
  Cargo_CommandDisplayName: 'コマンド表示名',
  Cargo_InstructionDescription: '指示説明',
  Cargo_InstructionRuleSetting: '指示ルール設定',
  Cargo_IfAllowedSendMultipleTimes: '複数回送信が許可される場合',
  Cargo_CanOnlyBeSentOnce: '一度だけ送信可能',
  Cargo_CanBeSentMultipleTimes: '複数回送信可能',
  Cargo_TemplateMatching: 'テンプレートマッチング',
  Cargo_UnifiedBusinessScenario: 'プッシュリングを選択した場合、異なる支社に独立したメンテナンステンプレートがある場合、対応するマッチング支社テンプレート',
  Cargo_SelectEmailTemplate: 'メールテンプレートを選択',
  Cargo_SelectOperationInstruction: '操作指示を選択',
  Cargo_SelectSpecificBusinessRule: '特定のビジネス・ルールの選択',
  Cargo_SelectThePushLink: 'プッシュリンクを選択',
  Cargo_OperationButtonSettingsAndTip: '操作ボタン設定（最大5つの操作指示）',
  Cargo_SelectInstruction: '指示を選択',
  Cargo_SetParameters: 'パラメーターを設定',
  Cargo_SetParameterValues: 'パラメーター値を設定',
  Cargo_CheckRuleNameExist: '既存の【{0}】ルール名',
  Cargo_LatestInstructionRecord: '最近の操作命令実行状況',
  Cargo_InstructionRecords: '操作命令ログ',
  Cargo_QueryInstructionRecords: 'ディレクティブ実行ログの表示',
  Cargo_ExecuteResult: '実行結果',
  Cargo_OperationInstructionsManagement: 'オペレーション命令管理',
  Cargo_PlatformInstructionDisabled: 'このコマンドは使用できません。構成が正しいかどうかを確認してください。',
  Cargo_NotMatchInstruction: 'コマンド条件に該当するサービスがありません',
  Cargo_SelectJobCount: '選択したビジネス・エントリ数',
  Cargo_MatchInstructionTip: '選択{0}バー，操作命令条件に合致する{1}バー',
  Cargo_OperationInstructionSetTip: '操作コマンド設定時、【選択コマンド】の値を空にすることはできません！',
  Cargo_OperationInstructionRepeatTip: '操作コマンド設定時に、選択したコマンドを繰り返してはいけません！',
  Cargo_OperationInstructionBatchTip: 'メールを一括送信するたびに、30を超えるビジネスデータを選択しないでください。',
  Cargo_CurrentUserRole: '現在のユーザー役割',
  Cargo_DisabledUnableToSave: '\'{0}\' has been disabled and cannot be saved. Please remove the relevant fees and save again.',
  Cargo_CompanyDateOfCreation: ' 委託先単位作成時刻',
  Cargo_BringInBusinessInformation: '補充オーダー情報',
  Cargo_LclSendDestinationPortAgentTip: '送信先ポートエージェントに対してマスターチケット業務を1つだけ選択可能',
  Cargo_LclSendPackageAgentTip: '1つのマスターチケットサービスのみを選択してシングルポートエージェントを送信することができます',
  Cargo_SetUploadFileType: 'アップロードファイルの種類の設定',
  Cargo_PillReportData: 'データソースを手動で生成して置換する',
  Cargo_CanOnlyPrintOnce: '1回のみ印刷可能',
  Cargo_CanPrintMultipleTimes: '複数回印刷可能',
  Cargo_IfSelectTemplateType: '異なる支社に独立したメンテナンステンプレートがある場合に一致する支社テンプレートに対応するテンプレートファイルタイプを選択します',
  Cargo_PrintMode: '印刷モード',
  Cargo_SingleJobPrint: '単票業務印刷',
  Cargo_BatchJobPrint: '一括ビジネス印刷',
  Cargo_SinglePrintFileType: 'シングルチケット印刷ファイルタイプ',
  Cargo_CabinRetrievalSuccessful: 'ハッチ回収成功',
  Cargo_CabinRetrievalAndReturnSuccessful: '回収と退室に成功しました',
  Cargo_revokeCabinSpace: 'チェックした注文は、船室を取り下げるプロセスを実行します',
  Cargo_CancelCabinAtTheSameTime: '同時退室',
  Cargo_CabinFlowExitAndNo: 'ハッチ流水とハッチ流水のないデータが存在し、一括して操作することはできない',
  Cargo_BatchPrintFileType: '一括印刷ファイルタイプ',
  Cargo_SinglePrintFileTemplate: '単票印刷ファイルテンプレート',
  Cargo_BatchPrintFileTemplate: '一括印刷ファイルテンプレート',
  Cargo_SelectPrintFileTemplate: '印刷ファイルテンプレートの選択',
  Cargo_SelectPrintFileType: '印刷ファイルタイプの選択',
  Cargo_SelectPrintFileTypeTip: '選択した印刷テンプレートにファイルタイプが設定されていません！まず印刷テンプレートに対応するファイルタイプを設定してください',
  Cargo_DeleteConfigTip: '削除しますか？削除すると、既存の機能設定は使用できなくなります！',
  Cargo_PreviewVoucher: '資格証明のプレビュー',
  Cargo_InvoiceNotVoucher: 'この請求書は買掛伝票を生成していません。もう一度選択してください。',
  Cargo_BankSlipNotVoucher: 'この請求書には証明書が生成されていません。もう一度選択してください。',
  Cargo_PleaseChooseDataThatHasVouchered: '証明書が生成されたデータを選択してください。',
  Cargo_ExportVoucherSuccessfully: 'エントリ資格証明のエクスポートに成功しました。',
  Cargo_ExportVoucherFailedByBankSlip: '水番号{0}のエクスポートに失敗しました。理由{1}、再試行してください。',
  Cargo_ExportVoucherFailedByInvoice: '請求書のエクスポートに失敗しました。理由{1}、再試行してください。',
  Cargo_UpdatePaidOffFlag: 'リフレッシュが消込済かどうか',
  Cargo_CheckMblSame: 'MB/L NOと基本ページ署名が一致しない',
  Cargo_IfExistMblNumberRange: 'マスター番号セグメントがあるかどうか',
  Cargo_UserName_Password_Maintained: '管理者に「基本設定-解決チャネル設定」メンテナンスに問い合わせてください',
  Cargo_ShipCompany_Maintained: '管理者からパートナーメンテナンス関連船会社に連絡してください',
  Cargo_ShippingCompanyCode_Maintained: '未保守マッピング船会社は、プラットフォームカスタマーサービスメンテナンスに連絡してください',
  Cargo_ShippingCompanyCode_MaintainedTip: 'プラットフォームカスタマーサービスメンテナンスにお問い合わせください',
  Cargo_BookingChannelConfig_Maintained: '予約チャネル設定に一致していません。管理者に連絡して、「基本構成-予約チャネル構成」メンテナンスに行ってください',
  Cargo_BookingChannelConfig_MaintainedTip: '管理者に「基本構成-予約チャネル構成」メンテナンスに問い合わせてください',
  Cargo_ErrorMsg: '例外の原因',
  Cargo_SelectJumpErrorTip: '【{0}】ジャンプ可能なページではありません。ページを選択してください, 例えば:【基本】',
  Cargo_SelectJumpPage: 'ジャンプするページの選択',
  Cargo_JumpSet: 'ジャンプ設定',
  Cargo_ClickJobNoJumpPage: '業務番号ジャンプページをクリック',
  Cargo_JumpPage: 'ジャンプするページ',
  Cargo_TabNotExistTip: 'ページにアクセスできません。アクセス権があるか、文書にページが含まれているかを確認してください。',
  Cargo_CargoValue: 'システム値',
  Cargo_YdValue: '領収書情報',
  Cargo_ConfirmReplace: '上書きの確認',
  Cargo_NotReplace: 'すべて上書きしない',
  Cargo_ReplaceSystemValue: 'システム情報の上書き',
  Cargo_PleaseSelectDataToReplace: '上書きするフィールド情報を選択してください',
  Cargo_YdBookingResultTip: '領収書の情報がシステムに入力されたデータからずれていることが検出されました、確認してください',
  Cargo_NoMappingValuesTip: '{0}はシステム値と一致しません。変更が必要な場合は手動で選択してください',
  Cargo_NonReplaceDataTip: '上書きする必要のないデータ',
  Cargo_JobNotFound: 'ビジネスに問い合せられていません【{0}】',
  Cargo_AE_IDENTIFICATION_SUPPLIER: '空出し預託書による仕入先の識別',
  Cargo_AIR_BILL_SUPPLIER: '航空船荷証券識別仕入先',
  Cargo_LoadingDate: 'ゲートポイントサービス-集荷時間',
  Cargo_DoorAddr: 'ゲートポイントサービス-ゲートポイントアドレス',
  Cargo_DoorMan: 'ゲートポイントサービス-連絡先',
  Cargo_DriverTel: 'ゲートポイントサービス-連絡先電話',
  Cargo_aeFile: '空けられた預託書類',
  Cargo_aiFile: '空の船荷証券ファイル',
  Cargo_carrierType: '船積キャリアタイプ',
  Cargo_DeclaredValue: '価値の宣言',
  Cargo_DeclaredValueForCustoms: '税関声明の価値',
  Cargo_RateLevel: 'レート等級',
  Cargo_PleaseSelectOperateType: 'ページ目[{0}]依頼書は操作モードを選択してください',
  Cargo_BaoDiCreditInfoNote: '注意：システムで構成されている日付タイプが空の場合は、事業内の日付タイプに値がある場合は料金支払期日が再計算される保証期間（Uniform Month Close Processing）が使用されます',
  Cargo_BottomLineCreditControl: 'ほしょうしんせいぎょ',
  Cargo_ProfitShareConfig: '利益分配',
  Cargo_CreateRule: '規則の作成',
  Cargo_EditRule: 'ルールの編集',
  Cargo_CopyRule: '規則のコピー',
  Cargo_RuleName: '分岐ルール名',
  Cargo_RuleConfig: 'ルール構成',
  Cargo_RuleRole: '役割',
  Cargo_ShareMode: '分潤モード',
  Cargo_ShareModeJob: '満票利益で分ける',
  Cargo_ShareModeCurrency: '通貨利潤別',
  Cargo_UsdRatio: '分潤率',
  Cargo_NonUsdRatio: '非米ドル比率',
  Cargo_ShareModeTip: 'パターン＃パターン＃：',
  Cargo_ShareModeJobTip: 'チケット枚',
  Cargo_BankSlipDateCreated: '水リストの作成日です',
  Cargo_ShareRatio: '分潤：',
  Cargo_PleaseSelectSalesBranch: '販売子会社を選択してください',
  Cargo_RuleConfigSubCountNotNull: '規則構成分岐数を空にすることはできません',
  Cargo_SetUpConfigSubTriggerCondition: 'トリガ条件を設定してください。',
  Cargo_ConfigSubRuleError: '分岐規則条件変化、トリガ条件配置エラー',
  Cargo_AddRuleConfigSub: '+分岐構成の追加',
  Cargo_AreYouSureModifyRuleConfigTips: '変更を確認するかどうか？',
  Cargo_ProfitShare: '分潤に関与するかどうか',
  Cargo_ProfitShareColumn: '分潤しているかどうか',
  Cargo_ProfitShareAdjust: '分潤調整',
  Cargo_ProfitShareReset: '再分潤',
  Cargo_NonProfitShareBranch: '分潤に関与していない支社',
  Cargo_ProfitShareRatioSumExceed: '現在の分潤割合は100%を超えているので、再調整して確認してください。',
  Cargo_UsdProfit: 'ドル利益',
  Cargo_NonUsdProfit: '非米ドル利益',
  Cargo_JobProfit: '正札利潤',
  Cargo_ShareBranchId: '分潤方',
  Cargo_UsdRatioColumn: 'ドル分潤比率',
  Cargo_UsdProfitColumn: 'ドルの利益予想',
  Cargo_UsdProfitColumn2: '利益を見込む',
  Cargo_NonUsdRatioColumn: '非米ドル分潤比率',
  Cargo_NonUsdProfitColumn: '非ドル利益予想',
  Cargo_CheckProfitShareResetTip: '後続の財務操作内容（請求、支払、請求書、消込…）を行うために費用を分散し、再分散を行うことはできません。対応する財務操作内容をキャンセルしてから再試行してください。',
  Cargo_AdjustColumn: 'へんどう',
  Cargo_UsdProfitAdjustColumn: 'ドルは追加利益を見込んでいる',
  Cargo_UsdProfitAdjustColumn2: '追加利益の見通し',
  Cargo_NonUsdProfitAdjustColumn: 'ドル以外の追加利益の見通し',
  Cargo_JobProfitShare: '分潤が完了しているか',
  Cargo_ReceivableFeeLockTime: '未収費用ロック時刻',
  Cargo_ReceivableFeeLockTime2: '未収ロック時間',
  Cargo_PayableFeeLockTime: '未払費用ロック時刻',
  Cargo_PayableFeeLockTime2: '未払ロック時間',
  Cargo_PayableFeeLockPerson: '未払費用ロック担当者',
  Cargo_RpaAccount: 'RPA管理アカウント',
  Cargo_WechatGroupName: '企業ウィーチャットグループ名',
  Cargo_TabEnterpriseWechat: '企業マイクロアカウント管理',
  Cargo_LoginEnterpriseWechat: '登録企業マイクロ',
  Cargo_LoginEnterpriseWechatTip: '企業のWeChatスキャンコードを使用して企業のWeChatにログインしてください',
  Cargo_RpaAccountSummary: 'RPAマネージドアカウント情報',
  Cargo_RpaAccountSummaryTip: '調整が必要な場合は、［パートナー-連絡先］ページに署名して調整します。',
  Cargo_RpaAccountColumn: '企業のウィーチャットアカウント',
  Cargo_RpaAccountEnabled: 'アカウント処理状況',
  Cargo_BatchEditEnterpriseWechat: '連絡先企業マイクログループチャットの一括修正',
  Cargo_EditEnterpriseWechatButton: '企業マイクログループチャット名を一括修正',
  Cargo_RpaAccountColumn2: 'RPA管理アカウント',
  Cargo_EditEnterpriseWechatTitle: '連絡先企業マイクログループチャットの修正',
  Cargo_RpaAccountWechatGroupNameCanTBeEmpty: 'RPAホスティングアカウント/エンタープライズ微信グループチャットフィールドに記入して保存してください。',
  Cargo_EnterpriseWechat: '企業のウィーチャット',
  Cargo_MessageContent: 'メッセージの内容',
  Cargo_PushFiles: 'ファイルのプッシュ',
  Cargo_PushFilesTip: 'ファイルはZIPファイルに圧縮され、ダウンロードリンクアドレスを介して企業の微信グループに送信されます',
  Cargo_EnterpriseWechat2DataServiceReminder: '（船舶計画変更のみ）',
  Cargo_EnterpriseWechatSopTip: 'グループチャットの名前を正確に記入してください。そうしないとプッシュできません。複数ある場合は「、」で区切って記入してください。',
  Cargo_PleaseInputVerificationCode: '認証コードを入力してください',
  Cargo_InputVerificationCodeTip1: 'このデバイスは初回ログインのため、認証コードを入力する必要があります。この企業のマイクロアカウントの携帯クライアントが受信した認証コードを入力してください',
  Cargo_InputVerificationCodeTip2: '検証に失敗しました、検証コードが無効または期限切れです、再入力してください',
  Cargo_CaptchaUsing: '検証中、後で処理状況を更新してください...',
  Cargo_LoginSuccess: 'アカウント:{0}、ログインに成功しました。',
  Cargo_PushEnterpriseWechat: '企業が微プッシュするかどうか',
  Cargo_PushEnterpriseWechatTip: 'この連絡先は企業マイクロアカウントとグループチャット名を設定していないため、メッセージのプッシュに失敗します',
  Cargo_ServiceProductID: 'サービス製品ID',
  Cargo_ServiceProductName: 'サービス製品名',
  Cargo_ForceRoutingBooking: '強制航路予約',
  Cargo_UsedAsRoutingProduct: '航路製品として使用',
  Cargo_AirServiceProduct: '航空サービス製品',
  Cargo_AddBasicAirFreightServiceProduct: '基本航空貨物サービス製品を追加',
  Cargo_DeleteServiceProductWarning: '【{0}】個のサービス製品情報を削除しようとしています。慎重に操作してください。',
  Cargo_RouteProductName: '路線製品名',
  Cargo_ServiceProduct: 'サービス製品',
  Cargo_PurchaseMethod: '購入方法',
  Cargo_Airline2: '航空会社',
  Cargo_PurchaseSource: '調達元',
  Cargo_OriginPort: '発着港',
  Cargo_RouteOfficer: '路線担当者',
  Cargo_IsEffective: '有効かどうか',
  Cargo_BaseWeight: '基本重量',
  Cargo_LimitWeight: '制限重量',
  Cargo_SellableSpace: '販売可能なスペース',
  Cargo_LengthLimit: '長さ制限',
  Cargo_HeightLimit: '高さ制限',
  Cargo_TheoreticalVolume: '理論体積',
  Cargo_SellableVolume: '販売可能体積',
  Cargo_Box: '板箱',
  Cargo_PayingParty: '支払対象者',
  Cargo_UnitPrice_TotalPrice: '単価/総額',
  Cargo_RouteProductCode: '路線製品コード',
  Cargo_BoardCount: 'プレート数',
  Cargo_EffectiveDateMustBeLessThanTheExpirationDate2: '有効日は有効日以下でなければなりません',
  Cargo_AirlineProductCode: '航路製品',
  Cargo_NotAssemblyQuantity: '組立可能数量',
  Cargo_NotAssemblyGrossWeight: '組立可能総重量',
  Cargo_NotAssemblyVolume: '組立可能体積',
  Cargo_NotAssemblyChargeableWeight: '組立可能計量重量',
  Cargo_Density_Weight: '密度/貨物質量',
  Cargo_PreWarehouseStatus: '前倉庫処理状況',
  Cargo_DeliveryStation2: '納品貨物ステーション',
  Cargo_DeliveryStatus: '納品処理状況',
  Cargo_PreAssemblyPlanProductionPlan: '事前組立計画 - 制作計画',
  Cargo_ShipmentOrder: '出荷指示',
  Cargo_GenerateAssemblyPlan: '組立計画の生成',
  Cargo_AssemblyPlanNumber: '組立計画番号',
  Cargo_AssemblyPlanStatus: '組立計画の状態',
  Cargo_AssemblyItemCount: '組立品目数',
  Cargo_AssemblyGrossWeight: '組立総重量',
  Cargo_AssemblyVolume: '組立体積',
  Cargo_AssemblyChargeableWeight: '組立請求重量',
  Cargo_ContainerGroup: 'コンテナグループ',
  Cargo_LoadingPool: '積載プール',
  Cargo_MergeGroup: 'マージグループ',
  Cargo_DeleteGroup: '削除グループ',
  Cargo_AssemblyPlan: '組立計画',
  Cargo_PlanIssued: '計画の発行',
  Cargo_CancelPlanIssued: '計画の発行取消',
  Cargo_PlanPrint: '計画の印刷',
  Cargo_AssemblyCompleted: '組立完了',
  Cargo_CancelAssemblyCompleted: '組立完了取消',
  Cargo_ConfirmCompleted: '完了確認',
  Cargo_CancelConfirmCompleted: '完了確認取消',
  Cargo_ImportAssemblyPlan: '組立計画のインポート',
  Cargo_UnifiedError: '【{0}】が統一されていません、続行しますか？',
  Cargo_JoinExistingAssemblyPlan: '既存の組立計画に統合しますか？',
  Cargo_ExistingPlanIssued: '既に組立計画が発行されていますので、統合はできません。発行を取り消してから再試行してください。',
  Cargo_CostAllocated: '既にコストが分配されています。ユーザーに分配されたコストを手動で削除してください。続行しますか？',
  Cargo_MaintainAtLeastOneGroup: '少なくとも1つのコンテナグループを維持してください',
  Cargo_FieldsCannotBeEmpty: '【件/毛/体/計】0より大きい必要があります。確認してください。',
  Cargo_AssemblyPlanExceedsContainerGroup: '【組立計画-コンテナグループ】の数量が【航路製品-航次-パレット】の数量を超えています。続行しますか？',
  Cargo_PlanIssuedTip: '組立計画は既に指示されており、操作できません。指示を取り消してから再試行してください。',
  Cargo_PieceWeightVolumeUnit: '件毛体計',
  Cargo_EstimatedAmazonArrivalTime: 'Amazon倉庫到着予定時間',
  Cargo_SelectCommonShipper: 'よく使う出荷者を選択',
  Cargo_SaveAsCommonShipper: 'よく使う出荷者として保存',
  Cargo_SelectCommonConsignee: 'よく使う荷受人を選択',
  Cargo_SaveAsCommonConsignee: 'よく使う荷受人として保存',
  Cargo_SelectCommonNotifier: 'よく使う通知先を選択',
  Cargo_SaveAsCommonNotifier: 'よく使う通知先として保存',
  Cargo_BoxQuantity: '箱数量',
  Cargo_OutboundMode: '出庫モード',
  Cargo_PalletQuantity: 'パレット数',
  Cargo_InventoryAge: '在庫期間（日/週）',
  Cargo_OutboundOperator: '出庫作業者',
  Cargo_RemainingBoxes: '在庫残箱数',
  Cargo_Goods: '商品',
  Cargo_InventoryInfo: '在庫情報',
  Cargo_OutboundByPallet: 'パレットごとに出庫',
  Cargo_OutboundByBox: '箱ごとに出庫',
  Cargo_Outbound: '出庫済み',
  Cargo_NotOutbound: '未出庫',
  Cargo_OutboundBatch: '出庫ロット',
  Cargo_BoxesInStock: '在庫箱数',
  Cargo_PalletsInStock: '在庫パレット数',
  Cargo_PromptWord: '##添付概要：\n' +
    'これは消費請求書です。請求書の言語に従って通貨を判断してください。次のフィールドを抽出してください：課金主体（サービス提供者）、消費金額、消費税（税額）、税率、通貨。\n' +
    '##出力要件：\n' +
    '1、JSON形式で返却してください。JSON内のフィールド名はすべて中国語で表示すること。。\n' +
    '2、JSON形式の例：\n' +
    '      { \n' +
    '        "data": {\n' +
    '          "受取人": "",\n' +
    '          ……\n' +
    '        }\n' +
    '      }\n' +
    '##各フィールドの定義とルールは以下の通り：\n' +
    '#1、課金主体（サービス提供者）\n' +
    '#2、消費金額\n' +
    '#3、消费税（税额）\n' +
    '#4、税率\n' +
    '#5、通貨',
  Cargo_BusinessManager: 'ビジネス担当者です',
  Cargo_AirlinePersonSetting: '航路担当者設置します',
  Cargo_PrePortFreightRateOfficer: '港前運賃担当者です',
  Cargo_PersonChargeTrunkLineFreightRates: '幹線運賃担当者です',
  Cargo_PersonChargeLastMileFreightRates: '後程運賃担当です',
  Cargo_NamePersonResponsible: '担当者名です',
  Cargo_ResponsiblePortDeparture: '出港港を担当します',
  Cargo_OnlyOneFullPerson: '港が空の全量担当者は一人しかいません',
  Cargo_OnlyOneFullPersonSameType: '同じ担当者は1人しかいません',
  Cargo_AdministrativeDivision: '行政区画です',
  Cargo_StreetTownship: '街道/郷級',
  Cargo_PostalCodeManagement: '郵便番号管理です',
  Cargo_UsPostalCode: 'アメリカ郵便番号です',
  Cargo_preportAudit: '港前審査です',
  Cargo_TrunkLineAudit: '幹線審査です',
  Cargo_TailEndAudit: '最終審査です',
  Cargo_preportAuditStatus: '港前審査状態です',
  Cargo_TrunkLineAuditStatus: '幹線査定状態です',
  Cargo_TailEndAuditStatus: '最終審査の状態です',
  Cargo_NoReviewRequired: '審査不要です',
  Cargo_HasBeenReviewed: 'すでに審査済み',
  Cargo_NoAuthorityReview: '権限審査はありません',
  CargoMsg_AIAddressRecognition: 'AIスマート住所認識',
  Cargo_ContainerGroupHasOrder: 'コンテナグループに注文があります。削除は禁止されています。注文を移動してから削除してください。',
  Cargo_WarehouseStorageLocation: '倉庫ロケーション',
  Cargo_TransportationType: '輸送モード',
  Cargo_HSCode: 'HSコード',
  ChargeHasUpdate: '料金が{1}で{0}によって変更されました。データを再度確認してから操作してください！',
  Cargo_QuickSearchCustomPage: 'クイック検索:フォーム名',
  Cargo_ApplicationScene: 'アプリケーションシーン',
  Cargo_FormId: 'フォームID',
  Cargo_FormType: 'フォームタイプ',
  Cargo_AddSelectedElements: '選択された要素を追加',
  Cargo_ElementsAddedSuccessfully: '要素が正常に追加されました',
  Cargo_SelectPagePart: 'ページの部分を選択',
  Cargo_AddPagePart: 'ページパーツを追加',
  Cargo_ChatUser: 'ユーザー',
  Cargo_ChatAI: 'AIアシスタント',
  Cargo_ChatInputPlaceholder: 'メッセージを送信... (Enterで改行、Ctrl+Enterで送信)',
  Cargo_ChatThinking: '考え中...',
  Cargo_ChatCopySuccess: 'クリップボードにコピーしました',
  Cargo_ChatConfirmTitle: '確認',
  Cargo_ChatDeleteConfirm: 'このメッセージを削除してもよろしいですか？',
  Cargo_ChatCopyFailed: 'コピーに失敗しました',
  Cargo_ChatDeleteSuccess: '削除しました',
  Cargo_ChatNoResponse: '応答がありません',
  Cargo_ChatConnectionError: '申し訳ありませんが、接続エラーが発生しました。もう一度お試しください。',
  Cargo_Debug: 'デバッグ',
  Cargo_DebugAndConfig: 'デバッグと設定',
  Cargo_EnterValue: '値を入力してください',
  Cargo_CreateForm: 'フォーム作成',
  Cargo_ConfigForm: 'フォーム設定',
  Cargo_Branch: 'アプリケーション会社',
  Cargo_FormNamePlaceholder: 'フォーム名を入力してください',
  Cargo_BranchPlaceholder: 'アプリケーション会社を選択してください',
  Cargo_ApplicationScenePlaceholder: 'アプリケーションシーンを選択してください',
  Cargo_BusinessTypePlaceholder: 'ビジネスタイプを選択してください',
  Cargo_RemarksPlaceholder: '備考を入力してください',
  Cargo_APIApplication: 'APIアプリケーション',
  Cargo_BusinessSingleMode: 'ビジネス単体モード',
  Cargo_BusinessBatchMode: 'ビジネス一括モード',
  Cargo_ConfirmMessageNotEditableAfterCreate: '作成後は変更できません。次に進みますか？',
  Cargo_Tip2: 'ヒント',
  Cargo_SelectDeleteTip4: '削除するデータを選択してください',
  Cargo_SelectDeleteTip5: '選択したデータを削除してもよろしいですか？この操作は元に戻せません。',
  Cargo_FormDisableWarning: '無効化されたフォームは使用できなくなります。このフォームを使用しているモジュールを早急に調整してください！',
  Cargo_ElementSettings: '要素設定',
  Cargo_ElementRules: '要素ルール',
  Cargo_IsReadOnly: '読み取り専用',
  Cargo_IsRequired: '必須',
  Cargo_FormInfo: 'フォーム情報',
  Cargo_InputOutputConfig: '入出力設定',
  Cargo_FormInputConfigDescription: 'フォーム読み込み（リクエストパラメータ）：フォーム読み込み時に、インターフェースを順番にリクエストし、フォームフィールドを処理します',
  Cargo_FormInputAPI: '入力インターフェース',
  Cargo_FormInputAPIPlaceholder: '入力インターフェースリストを入力してください',
  Cargo_FormOutputConfigDescription: 'フォーム送信（関数呼び出し）：フォーム送信時に、アプリケーションインターフェースを順番にリクエストします',
  Cargo_FormOutputAPI: '出力インターフェース',
  Cargo_FormOutputAPIPlaceholder: '出力インターフェースリストを入力してください',
  Cargo_SaveDraft: '下書きを保存',
  Cargo_PublishForm: 'フォームを公開',
  Cargo_LastOperateTime: '最終操作時間',
  Cargo_Draft: '下書き',
  Cargo_Published: '公開済み',
  Cargo_ConfigPagePart: 'エリア設定',
  Cargo_ConfigName: '設定名',
  Cargo_PagePartFunction: 'エリア機能',
  Cargo_PleaseSelectFunction: '機能を選択してください',
  Cargo_BusinessElements: '業務フィールド',
  Cargo_ConsigneeShipperAndNotifyInfo: '荷受人/荷送人/通知先情報',
  Cargo_AccountsReceivable: '売掛金',
  Cargo_AccountsPayable: '買掛金',
  Cargo_UploadFile: 'ファイルアップロード',
  Cargo_UploadInstruction: 'アップロード指示',
  Cargo_InstructionParameter: '指示パラメータ',
  Cargo_FormPreviewInListViewIsReadOnly: 'デバッグデータを編集するには、「編集」をクリックして詳細ページに移動してください。',
  Cargo_BPM: 'BPM',
  Cargo_OCR: 'OCR',
  Cargo_PublishSuccess: '公開成功',
  Cargo_PublishFailed: '公開失敗',
  Cargo_ValueRequired: 'この値は必須です',
  Cargo_FixFormErrors: 'フォームの入力内容を確認してください',
  Cargo_ValidationFailed: '検証に失敗しました。入力値を確認してください',
  Cargo_ToggleStatusFailed: 'フォームの状態切り替えに失敗しました',
  Cargo_CopySucceed: 'コピーに成功しました',
  Cargo_CopyFailed: 'コピーに失敗しました',
  Cargo_CopyFormConfirm: 'このフォームとそのすべてのブロック、要素レイアウト、その他の設定情報をコピーしてもよろしいですか？',
  Cargo_CannotDeleteEnabledForm: '有効なフォームは削除できません。先に無効化してください',
  Cargo_GetFormConfigFailed: 'フォーム設定の取得に失敗しました',
  Cargo_ConfirmChangeBlockType: 'エリア機能を変更します。元のエリアの設定内容をクリアしますか？',
  Cargo_CopyOne: 'コピーするレコードを1つ選択してください！',
  Cargo_ConfirmDeleteBlock: 'このエリアを削除し、選択したフィールドのチェックを外してもよろしいですか？',
  Carog_ConfirmSaveBeforeGoBack: '現在の設定を保存しますか？',
  Cargo_FormValidation: 'フォーム検証',
  Cargo_Problem: '問題',
  Cargo_Description: '説明',
  Cargo_ValidationSucceed: '検証成功',
  Cargo_NoChanges: 'データ変更なし',
  Cargo_JobUuidRequired: '業務フォームUUIDは必須です',
  Cargo_LoadFormDataFailed: 'フォームデータの読み込みに失敗しました',
  Cargo_SyncRuleExecutionFailed: 'データ関連ルールの実行に失敗しました',
  Cargo_PreviewRevision: 'このバージョンをプレビュー',
  Cargo_Current: '現在',
  Cargo_FormPreviewInRevisionViewIsReadOnly: '現在のプレビューは履歴バージョンで、読み取り専用モードのみです。',
  Cargo_VisualizationView: 'ビジュアルレイアウト',
  Cargo_CodeView: 'コードビュー',
  Cargo_ChatView: 'AIアシスタント',
  Cargo_RestoreRevision: 'このバージョンに復元',
  Cargo_RestoreSucceed: '復元成功',
  Cargo_RestoreFailed: '復元失敗',
  Cargo_ConfirmRestoreRevision: 'このバージョンに復元してもよろしいですか？',
  Cargo_NeedAtLeastOnePagePart: '少なくとも1つの情報領域が必要です',
  Cargo_DataFill: 'データ入力',
  Cargo_CSNInfo_BASIC: 'CSN情報（基本タブ）',
  Cargo_CSNInfo_MBL: 'CSN情報（MBL）',
  Cargo_CSNInfo_HBL: 'CSN情報（HBL）',
  Cargo_CSNInfo_HBL2: 'CSN情報（分割B/L）',
  Cargo_ReadOnly: '読み取り専用',
  Cargo_Notify: '通知先',
  Cargo_AlsoNotify: '第二通知先',
  Cargo_AgentParty: '代理店情報',
  Cargo_ShippingExchangeRateBatchConfig: '海運取引所運賃バッチ設定',
  Cargo_DeclarationScope: '申告範囲',
  Cargo_DeclarationBusiness: '申告業務',
  Cargo_DeclarationFee: '申告費用',
  Cargo_SetBranch: '支社を設定',
  Cargo_FollowHQ: 'HQに従う',
  Cargo_FreightRate: '運賃',
  Cargo_ContainerLock: 'コンテナロック料金',
  Cargo_OtherAdditionalCharges: 'その他の追加料金',
  Cargo_UpperLimit: '上限',
  Cargo_LowerLimit: '下限',
  Cargo_AlertNotification: 'アラート通知',
  Cargo_RPASettings: 'RPA設定',
  Cargo_UnregisteredShippingRate: '作成した業務運賃が海運取引所に申告されていない場合',
  Cargo_ExceedMaintainedLimit: '作成した業務運賃が維持済みの限界を超えた場合',
  Cargo_RPAPaused: 'RPAが一時停止した場合',
  Cargo_RPACompleted: 'RPAが完了した場合',
  Cargo_ProhibitSaving: '保存禁止',
  Cargo_RecordOnly: '記録のみで警告なし',
  Cargo_NoRecordNoAlert: '記録なし警告なし',
  Cargo_NotifyRoleByEmail: '指定役割へのメール通知',
  Cargo_NotifyPersonByEmail: '指定者へのメール通知',
  Cargo_NotifyPositionByEmail: '指定役職へのメール通知',
  Cargo_RPAService: 'RPAサービス',
  Cargo_EnableRPAService: 'RPAサービスを有効にする',
  Cargo_ShippingExchangeAccount: '海運取引所アカウント',
  Cargo_ShippingExchangePassword: '海運取引所パスワード',
  Cargo_RPASubmission: 'ロボットが{0}でデータを代行提出',
  Cargo_WarningReason: '警告理由',
  Cargo_WarningMessage: '警告メッセージ',
  Cargo_UnregisteredRateSaveError: '当社は海運取引所の運賃公開機能を有効にしました。現在の業務運賃は海運取引所に申告されていないため、保存できません。業務を入力する必要がある場合は、登録責任者に連絡してください：<br/>{0}',
  Cargo_UnregisteredRateWarning: '当社は海運取引所の運賃公開機能を有効にしました。現在の業務運賃は海運取引所に申告されていません。違反操作を避けるため、登録責任者に至急連絡してください：<br/>{0}',
  Cargo_ExceedDeclaredLimitSaveError: '当社は海運取引所の運賃公開機能を有効にしました。現在の業務運賃は申告済みの限界を超えているため、保存できません。業務を入力する必要がある場合は、登録責任者に連絡してください：<br/>{0}',
  Cargo_ExceedDeclaredLimitWarning: '当社は海運取引所の運賃公開機能を有効にしました。現在の業務運賃は申告済みの限界を超えています。違反操作を避けるため、登録責任者に至急連絡してください：<br/>{0}',
  Cargo_GoToProcess: ' 処理に行く ',
  Cargo_GoToDeclare: ' 申告に行く ',
  Cargo_CheckWarningToProcess: ' 処理が必要な警告情報をチェックしてください ',
  Cargo_SelectedWarningMarkedProcessed: ' 選択された警告情報は「処理済み」としてマークされました ',
  Cargo_SelectInfoToDeclare: ' 申告が必要な情報を選択してください ',
  Cargo_SureSaveUnControlledProduct: '保存を確認しますか？保存するとビジネスはロックされ、再操作できず、撤回できません！',
  Cargo_ScmNeedAllowProduct: '規制対象製品を輸出する際には、事前に許可を取得する必要があります。詳細はSCM推進室に連絡してください。',
  Cargo_SureSave: '保存の確認',
  Cargo_DataLoadingPleaseWait: 'データ読み込み中、お待ちください。',
  Cargo_RuleID: 'ルールID',
  Cargo_ValidationRule: '検証ルール',
  Cargo_TriggerElement: 'トリガーフィールド',
  Cargo_RelatedElements: '関連フィールド',
  Cargo_TriggerCondition: 'トリガー条件',
  Cargo_FunctionCode: '関数コード',
  Cargo_AddedValidationRules: '以下の検証ルールを追加しました',
  Cargo_AddedSyncRules: '以下の同期ルールを追加しました',
  Cargo_AddedVisibilityRules: '以下の可視性ルールを追加しました',
  Cargo_NoRuleDetected: '申し訳ございませんが、有効なデータ検証またはデータ関連編集機能が検出されませんでした。クエリを調整して再試行してください。',
  Cargo_ConnectionError: '申し訳ございませんが、接続に問題が発生しました。再試行してください。',
  Cargo_OperationArea: '操作エリア',
  Cargo_BlDataNotFound: '船荷証券データが見つかりません',
  Cargo_SelectBlDocument: '船荷証券書類を選択してください',
  Cargo_SelectHblDocument: 'HBL書類を選択してください',
  Cargo_SelectHawb2Document: '形式分書類を選択してください',
  Cargo_AIChangRulesNumber: '{0} 件のルールを正常に更新しました',
  Cargo_AIDeleteRulesNumber: '{0} 件のルールを正常に削除しました',
  Cargo_AIAddRulesNumber: '{0} 件のルールを正常に追加しました',
  Cargo_UnknownIntent: 'あなたの問い合わせには具体的な規則が含まれていません',
  Cargo_AIDeleteUnexistRulesNumber: '削除しようとするルールが存在しません',
  CanNotEditCustomer: 'trustFromEditSales パラメータが有効になっていないため、交叉委託業務では委託単位の変更が許可されていません！',
  CustomerRefreshChargeTips: '委託単位にすでに費用が存在しています。費用を更新しますか？',
  BookingAgentRefreshChargeTips: 'ブッキングエージェントにすでに費用が存在しています。費用を更新しますか？',
  refreshCargoSourceForNc: '営業貨物の種類を指定貨物に切り替えますか？',
  Cargo_FilingBatchNo: '届出ロット',
  Cargo_FilingState: 'ロット・ステータス',
  Cargo_SubmitDate: '送信日',
  Cargo_DeclareFinal: '申告明細数/最終明細数',
  Cargo_FiletotalRecordPass: 'ファイル総記録/入庫数/検査合格数',
  Cargo_StartRPA: 'RPAの起動',
  Cargo_SuspendRPA: 'RPAの一時停止',
  Cargo_SuspendRPA2: '一時停止',
  Cargo_RpaState: 'RPAステータス',
  Cargo_ImportFinalResult: '最終結果のインポート',
  Cargo_ManuallyExportFile: 'ファイルの手動エクスポート',
  Cargo_FilingBatchInfo: 'ロット情報',
  Cargo_FilingDate: '届出日',
  Cargo_OpenPriceInfo: '運賃の申告',
  Cargo_Past6MonthPort: '6ヶ月近くの事業を獲得した港',
  Cargo_Past1MonthPrice: '1ヶ月近くの船出運賃を取得',
  Cargo_CompanyCode2: '会社コード',
  Cargo_Lane: '航路名称',
  Cargo_DepartureDay: '週番',
  Cargo_CargoType2: '品目',
  Cargo_EqSize: 'サイズ',
  Cargo_Cost2: '運賃',
  Cargo_CostRange: '運賃区間',
  Cargo_CostMin: '運賃下限',
  Cargo_CostMax: '運賃上限',
  Cargo_EqDeduct: 'ホック',
  Cargo_BatchReturnPreApproval: '一括で事前審査/リモート予約に戻す',
  Cargo_ReturnPreApprovalRemoteBooking: '事前審査に戻す/リモート予約',
  Cargo_ConfirmReturnResubmit: '予約事前承認/リモート予約に戻して再提出しますか？',
  Cargo_ReturnModuleSelection: '返却モジュールの選択',
  Cargo_ReturnModule: '返却モジュール',
  Cargo_ReturnReason: '返却理由',
  Cargo_MasterTicketRelationError: 'マスターチケット関係が存在するため返却不可',
  Cargo_CostStatusReturnError: '費用が既に{0}のため返却不可',
  Cargo_RouteManagerEmptyError: '業務番号：{0} ルート責任者が空のため返却不可',
  Cargo_FOBReturnRestriction: 'FOB業務はリモート予約にのみ返却可能',
  Cargo_SelectedBusiness: '選択された業務',
  Cargo_RemoteBooking: 'リモート予約',
  Cargo_RemoteBookingExportOnly: 'リモート予約は輸出業務の返品のみ対応',
  Cargo_ReturnResult: '成功{0}件、失敗{1}件を返却しました',
  Cargo_MasterTicketRelationAlert: '【{0}】マスターチケット関係が存在します',
  Cargo_NotFromRemoteBookingError: '【{0}】リモート予約からの注文でないため返却不可',
  Cargo_NotFromPreApprovalError: '【{0}】予約事前審査からの注文でないため返却不可',
  Cargo_CostStatusAlert: '【{0}】費用は既に{1}です',
  Cargo_ReturnCurrentOperationOnly: '現在操作中の業務の返品のみ対応',
  Cargo_MixedBusinessTypeError: '選択された業務にFOBと非FOBが混在するため一括返却不可',
  Cargo_CollabBatchRejectError: '{0}は協業業務を含むため、一括拒否はサポートされていません',
  Cargo_OtherSurcharge: 'その他の追加料金',
  Cargo_MoreDetails: '詳細',
  Cargo_SureToStartRPA: '【{0}】RPAが起動すると、自動的にデータが航空取引所のWebサイトに転送されます。起動前に、データが完全に書き込まれていることを確認してください。',
  Cargo_SureToSuspendRPA: '【{0}】RPAが一時停止した後、再起動すると、システムは航交所のデータ状態を航交し、もしすでに装填を確認していなければ、システムはスケジュールを再作成してアップロードします。重大な問題がなければ、できるだけRPAを一時停止しないでください。',
  Cargo_SureToDeleteOpenPrice: 'ロットのデータが削除されていることを確認してください？',
  Cargo_SureToImportFinalResult: '最終結果を手動でインポートすることは、ロットが完了し、RPAが実行されなくなることを確認することを意味します。',
  Cargo_SureToExportFile: '【{0}】ロットのデータがエクスポートされていることを確認してください。',
  FileBeLargerThan10MB: 'ファイルサイズは10 MBより大きくすることはできません',
  FileBeLargerThan5MB: 'ファイルサイズは5 MBより大きくすることはできません',
  Cargo_DeclareFile: '申告書類',
  Cargo_ImportFinalFile: '最終インポート結果',
  Cargo_FinalPriceInfo: '最終運賃',
  Cargo_DeclareNumLabel: '合計運賃:{0}エントリ',
  Cargo_DeclareFinalLabel: '申告明細数/最終明細数:{0}',
  Cargo_QuerySuccess: 'データの取得に成功しました',
  HasDeletedForDeleteJob: '現在選択されているビジネスが削除されました！',
  HasSlaveJobForDeleteJob: '[{0}]まずレシートを外してください！',
  HasChargeForDeleteJob: '[{0}]費用が入力されました！',
  HasMergeForDeleteJob: '[{0}]注文はすでに合算されています！',
  refreshCargoSourceForSc: '営業貨物の種類を自社営業貨物に切り替えますか？',
  Cargo_ArCustomerPaidOff: '委託先費用消込ステータス',
  Cargo_InterestAmountCurrency: '超過利息',
  Cargo_CheckRuleResult: '検証結果',
  Cargo_ContainsAdvancePayment: '立替費用が含まれているかどうか',
  Cargo_JdySendStatus: '簡道雲送信状態',
  Cargo_JdySendTime: '簡道雲送信時間',
  Cargo_DetailsLockedStatus: '貨物詳細ロック状態',
  BatchProcessingIsNotSupported: '一括処理はサポートされていません',
  BatchFillingIsNotConfigured: '一括入力フォームは設定されていません',
  SingleEntryIsNotSupported: '単票業務の入力はサポートされていません',
  SingleFormIsNotConfigured: '単票入力フォームが設定されていません',
  TheFormDoesNotExist: 'フォームは存在しません。',
  DataHasModified: 'データは [{0}] により {1} に変更されました。更新してください！',
  Cargo_CheckNeedSynccloud: '同期するクラウドプラットフォームの請求書を選択してください',
  Cargo_CheckJingdiesynccloud: '海外の請求書および代収代付請求書のみをKingdeeに連携できます',
  DisplayReceiptsOnly: 'レシートのみを表示',
  AssignedWorkResponsibleForNode: '指定された職位（ポジション設定ノードの業務責任者に基づく）',
  Cargo_CheckZySave: '注文書内の貨物が『中華人民共和国輸出規制法』『中華人民共和国両用物項輸出規制条例』及び『中華人民共和国両用物項輸出規制リスト』に関連しているかどうかを確認してください。その場合は、輸出通関に付随する材料として「両用品目輸出許可証」を提供してください。貨物品名とHSCODEを通じて注文内の貨物を検索することができ、検索データベースは以下のページを参照することができる：',
  Cargo_HasVerified: 'チェック済み',
  Cargo_ContainSensitiveWord: '感応語を含むかどうか',
  Cargo_VoiceRecording: '録音中... 残り{0}秒',
  Cargo_VoiceRecordingInput: '音声認識のため録音中、話してください...',
  Cargo_VoiceRecognizing: '認識中...',
  Cargo_VoiceStopRecording: '録音停止',
  Cargo_VoiceStartRecording: '録音開始',
  Cargo_VoiceNotInitialized: '音声認識機能が初期化されていません',
  Cargo_VoiceStartRecordingTip: '録音を開始します、話してください...（最大60秒）',
  Cargo_VoiceRecordingEnd: '録音終了',
  Cargo_VoiceRecognitionError: '音声認識エラー',
  Cargo_VoiceTimeLimitReached: '録音時間が60秒の上限に達しました、自動的に停止しました',
  Cargo_VoiceBrowserNotSupported: '現在のブラウザは音声認識をサポートしていません',
  Cargo_JobsSavedSuccessfully: '{0}件のタスクが正常に保存されました',
  Cargo_JobsFailedToSave: '{0}件のタスクの保存に失敗しました',
  Cargo_BatchSaveFailed: 'バッチ保存に失敗しました',
  Cargo_BatchFill: '一括入力',
  Cargo_PleaseAddGoods: '',
  confirmLock: '',
  confirmUnLock: '',
  Cargo_PleaseselectedGoods: '',
  Cargo_PleaseAddCheck: '',
  PriorityDisplay: '優先順位表示',
  WhenTheNodeAllDisplayed: 'ノードに優先順位が設定されていない場合、すべてのノードデータが表示されます！',
  DefaultDisplay: 'デフォルト表示：',
  PrioritizationSettings: '優先順位の設定',
  Cargo_OperationProvince: 'オペレーション会社の所在地',
  Cargo_SalesProvince: '販売会社所在省',
  Cargo_PushTime: 'プッシュ時間',
  CargoMsg_CheckSecondCustomJobType: 'カスタム業務タイプが二級の場合、上位のカスタム業務タイプを空にすることはできません！',
  Cargo_EnterpriseWechatApprovalPayCompany: 'WeCom承認支払会社',
  // 海外輸出予約リストのカスタム部署ヘッダー（業務役職で命名）
  Cargo_UserDefinedRoleHeader1: 'サイドライン予約担当者',
  Cargo_UserDefinedRoleHeader2: '幹線予約担当者',
  Cargo_UserDefinedRoleHeader3: '保険担当者',
  Cargo_UserDefinedRoleHeader4: '海外ドキュメント担当',
  Cargo_UserDefinedRoleHeader5: 'カスタマーサービスアシスタント'
}
